import tenantTheme from '@theme';
import chroma from 'chroma-js';
import React from 'react';

export const LogoProfolio = (props) => {
  return (
    <svg width={126.73} height={34.17} viewBox="0 0 126.73 34.17" {...props}>
      <path
        style={{ fill: tenantTheme['primary-color'] }}
        d="M26.44 1.8a30.51 30.51 0 00-20.65 0A8.75 8.75 0 000 10v14.1a8.77 8.77 0 005.79 8.24 30.51 30.51 0 0020.65 0A8.89 8.89 0 0028.92 31c-12.31-2.25-14-2.08-16.73-4.79a9.56 9.56 0 0113.53-13.53c2.71 2.7 2.55 4.41 4.79 16.66a8.72 8.72 0 001.72-5.2V10a8.77 8.77 0 00-5.79-8.2z"
      />
      <circle style={{ fill: tenantTheme['primary-color'] }} cx={18.96} cy={19.44} r={3.99} />
      <path
        d="M51.32 11.69c-2-1.06-7.56-.47-9.77-.61v15.84h3.31V21.3c1.9-.06 4.71.28 6.46-.61 3.61-1.54 3.61-7.47 0-9zm-1.39 6.36c-1.19 1-3.65.54-5.07.64v-5c1.43.1 3.86-.36 5.07.63a2.71 2.71 0 010 3.73zm13.73-3.3a2.11 2.11 0 01.55.19l-.38 2.76c-6-1.55-4.13 5.86-4.42 9.22h-3.28v-12H59l.22 2.35a3.84 3.84 0 014.46-2.52zm10.43.67c-7.65-3.79-13.12 6.51-6.4 11 7.58 3.83 13.13-6.55 6.4-11zm-.7 7.58a2.76 2.76 0 01-4 1.26c-1.62-1.23-1.48-3.71-1-5.48a2.75 2.75 0 014-1.26c1.61 1.26 1.51 3.74 1 5.48zm9.67-9.31v1.2h3.79v2.45H83.2v9.55h-3.28v-9.52h-2.09v-2.45h2.09a8.09 8.09 0 01.33-3.22c1-2.43 4.59-2.86 6.7-1.66l-.45 2.19c-1.25-.81-3.64-.33-3.44 1.49zm13.63 1.7c-7.65-3.8-13.13 6.51-6.4 11 7.57 3.83 13.13-6.55 6.4-11zM96 23a2.76 2.76 0 01-4 1.26c-1.62-1.24-1.48-3.72-1-5.49a2.75 2.75 0 014-1.23c1.62 1.24 1.49 3.72 1 5.46zm11 1.64l.67-.18-.28 2.16c-2.43 1.36-6 .11-5.59-3.07V9.65h3.2v13.57c-.19 1.18.88 1.78 1.92 1.46zm1.9-9.76h3.29v12h-3.29zm3.7-3.48c.21 2.36-4.28 2.36-4.07 0-.23-2.39 4.31-2.39 4.07 0zm13.32 6.12c-4.73-6.77-14.56-.84-10.74 6.72 4.68 6.83 14.5.88 10.69-6.69zM123 23a2.76 2.76 0 01-4 1.26c-1.62-1.24-1.48-3.72-1-5.49a2.75 2.75 0 014-1.26c1.64 1.27 1.51 3.75 1 5.49z"
        style={{ fill: '#434651' }}
      />
    </svg>
  );
};

export const IconFeaturesAmenities = (props) => {
  return (
    <svg width={props.size || 52} height={props.size || 52} viewBox="0 0 52 52" {...props}>
      <path
        d="M42 0H10C4.477 0 0 4.477 0 10v32c0 5.523 4.477 10 10 10h32c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10z"
        fill="#F7F7F7"
      />
      <path
        d="M37.871 18.501a1.885 1.885 0 11-.003-3.77 1.885 1.885 0 01.003 3.77zm0-2.5a.623.623 0 10-.077 1.244.623.623 0 00.077-1.244z"
        fill="#BDBDBD"
      />
      <path
        d="M36.112 23.363l-3.55-3.388v-6.787h-3.75v3.213l-4.687-4.463-11.988 11.425a.605.605 0 00-.2.45.618.618 0 00.625.625h3.125v8.75a1.876 1.876 0 001.875 1.875h13.75a1.25 1.25 0 001.25-1.25v-9.375h3.125a.618.618 0 00.625-.625.606.606 0 00-.2-.45z"
        fill="#F3F3F1"
      />
      <path d="M32.875 40.065a7.188 7.188 0 100-14.376 7.188 7.188 0 000 14.376z" fill="#E7F3EF" />
      <path
        d="M31.625 16.401v-3.213h-2.813v.535l2.813 2.678zM14.75 23.813a.604.604 0 01.2-.45l10.582-10.085-1.407-1.34-11.988 11.425a.605.605 0 00-.2.45.618.618 0 00.625.625h2.813a.618.618 0 01-.625-.625zm3.75 9.375v-8.75h-2.813v8.75a1.876 1.876 0 001.875 1.875h2.813a1.876 1.876 0 01-1.875-1.875z"
        fill="#E8E8E8"
      />
      <path
        d="M32.875 41.002A8.125 8.125 0 1141 32.877a8.134 8.134 0 01-8.125 8.125zm0-14.375a6.25 6.25 0 100 12.503 6.25 6.25 0 000-12.504v.001z"
        fill={tenantTheme['primary-color']}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.876 29.938a.938.938 0 11-1.876 0 .938.938 0 011.876 0zm-.001 2.499H32v4.375h1.875v-4.375z"
        fill={tenantTheme['primary-color']}
      />
      <path
        d="M21.313 36.001h-3.75a2.815 2.815 0 01-2.813-2.812v-7.813h-2.187A1.565 1.565 0 0111 23.814a1.544 1.544 0 01.511-1.148L23.478 11.26a.94.94 0 011.294 0l3.1 2.954v-1.026a.938.938 0 01.938-.938h3.75a.938.938 0 01.938.938v6.388l1.148 1.1-1.3 1.355-1.438-1.375a.938.938 0 01-.289-.678v-5.852H29.75v2.275a.938.938 0 01-1.584.679l-4.041-3.847-10.772 10.268h2.335a.938.938 0 01.938.938v8.75a.938.938 0 00.938.938h3.75l-.001 1.874zm-8.519-11.967l-.009.009a.064.064 0 00.009-.009z"
        fill="#D6D6D6"
      />
    </svg>
  );
};

export const IconPriceArea = (props) => {
  return (
    <svg width={52} height={52} viewBox="0 0 52 52" {...props}>
      <path
        d="M42 0H10C4.477 0 0 4.477 0 10v32c0 5.523 4.477 10 10 10h32c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10z"
        fill="#F7F7F7"
      />
      <path
        d="M12.8 16.4a1.807 1.807 0 11.005-3.615 1.807 1.807 0 01-.005 3.614zm0-2.4a.6.6 0 10-.074 1.198.6.6 0 00.074-1.199z"
        fill="#A4AFC1"
      />
      <path
        d="M38.973 25.916A3.591 3.591 0 0040.1 23.3v-8.4a2.4 2.4 0 00-2.4-2.4h-8.4a3.6 3.6 0 00-2.616 1.126L13.756 27.05a2.4 2.4 0 00.047 3.346l8.4 8.4a2.4 2.4 0 003.346.047l13.424-12.927z"
        fill="#F3F3F1"
      />
      <path d="M35 19.1a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" fill="#2FDF84" />
      <path d="M33.2 39.5a6.9 6.9 0 100-13.8 6.9 6.9 0 000 13.8z" fill="#E7F3EF" />
      <path
        d="M24.903 38.797l-8.855-8.855c-.442-.442-.821-.585-.83-1.21-.009-.624.282-.732 1.238-1.681l12.928-13.425A3.588 3.588 0 0132 12.5h-2.7a3.6 3.6 0 00-2.616 1.126L13.756 27.05a2.4 2.4 0 00.047 3.346l8.4 8.4a2.388 2.388 0 003.043.284 2.429 2.429 0 01-.343-.283z"
        fill="#E6E6E6"
      />
      <path d="M36.2 17.6c.002-.22.054-.435.15-.631a1.5 1.5 0 100 1.262 1.468 1.468 0 01-.15-.631z" fill="#00B871" />
      <path
        d="M33.2 40.4a7.8 7.8 0 117.8-7.8 7.809 7.809 0 01-7.8 7.8zm0-13.8a6 6 0 106 6 6.007 6.007 0 00-6-6z"
        fill={tenantTheme['primary-color']}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.1 29.3h-1.8v2.4h-2.4v1.8h2.4v2.4h1.8v-2.4h2.4v-1.8h-2.4v-2.4z"
        fill={tenantTheme['primary-color']}
      />
      <path
        d="M23.9 40.4a3.238 3.238 0 01-2.338-.98l-8.39-8.392A3.225 3.225 0 0112.2 28.7c.001-.847.328-1.66.913-2.272L26.035 13a4.465 4.465 0 013.265-1.4h8.4a3.3 3.3 0 013.3 3.3v8.4c.004.39-.048.778-.156 1.153l-1.727-.506a2.28 2.28 0 00.083-.647v-8.4a1.5 1.5 0 00-1.5-1.5h-8.4a2.682 2.682 0 00-1.963.848L14.408 27.68A1.47 1.47 0 0014 28.7a1.447 1.447 0 00.436 1.048l8.408 8.408a1.49 1.49 0 001.58.343l.68 1.667a3.205 3.205 0 01-1.2.234H23.9z"
        fill="#BDBDBD"
      />
      <path d="M35 20a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0-3a.6.6 0 100 1.199.6.6 0 000-1.2z" fill="#BDBDBD" />
    </svg>
  );
};

export const IconAdInformation = (props) => {
  return (
    <svg width={52} height={52} viewBox="0 0 52 52" {...props}>
      <path
        d="M42 0H10C4.477 0 0 4.477 0 10v32c0 5.523 4.477 10 10 10h32c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10z"
        fill="#F7F7F7"
      />
      <path
        d="M29.053 19.677h-2.409v1.2a1.2 1.2 0 01-1.2 1.2h-6.628a1.2 1.2 0 01-1.2-1.2v-1.2h-2.413a2.416 2.416 0 00-2.409 2.409v15.055a2.417 2.417 0 002.409 2.409h13.85a2.416 2.416 0 002.409-2.409V22.086a2.416 2.416 0 00-2.409-2.409z"
        fill="#F3F3F1"
      />
      <path
        d="M26.645 18.473v2.409a1.2 1.2 0 01-1.2 1.2h-6.629a1.2 1.2 0 01-1.2-1.2v-2.409h2.108a2.409 2.409 0 014.818 0h2.103z"
        fill="#A8E1C4"
      />
      <path d="M32.968 43.162a6.925 6.925 0 100-13.85 6.925 6.925 0 000 13.85z" fill="#E7F3EF" />
      <path
        d="M15.504 37.141V22.086a2.41 2.41 0 012.108-2.379v-.03h-2.409a2.416 2.416 0 00-2.409 2.409v15.055a2.417 2.417 0 002.409 2.409h2.71a2.416 2.416 0 01-2.409-2.409zm13.85-16.26v-1.174c-.1-.017-.2-.027-.3-.03h-2.41v1.2a1.2 1.2 0 01-1.2 1.2h2.71a1.2 1.2 0 001.2-1.196z"
        fill="#D5DBE1"
      />
      <path
        d="M20.322 20.882v-2.409h2.108a2.41 2.41 0 011.054-1.987 2.389 2.389 0 00-3.056.286 2.416 2.416 0 00-.708 1.701h-2.108v2.409a1.2 1.2 0 001.2 1.2h2.71a1.2 1.2 0 01-1.2-1.2zm12.646 23.184a7.83 7.83 0 117.829-7.829 7.838 7.838 0 01-7.829 7.829zm0-13.851a6.022 6.022 0 106.022 6.022 6.029 6.029 0 00-6.022-6.021v-.001z"
        fill={tenantTheme['primary-color']}
      />
      <path
        d="M31.763 39.549a.902.902 0 01-.638-.265l-2.409-2.409 1.278-1.278 1.726 1.73 3.579-4.09 1.36 1.19-4.213 4.814a.906.906 0 01-.65.308h-.033z"
        fill={tenantTheme['primary-color']}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.817 22.989h6.624a2.11 2.11 0 002.102-2.108v-.3h1.511a1.508 1.508 0 011.505 1.505v3.722h1.806v-3.722a3.316 3.316 0 00-3.312-3.312h-1.51v-.302a.9.9 0 00-.9-.9h-1.33a3.312 3.312 0 00-6.374 0h-1.33a.9.9 0 00-.9.9v.302h-1.506a3.317 3.317 0 00-3.312 3.312v15.055a3.316 3.316 0 003.312 3.312h7.756v-1.807h-7.756a1.508 1.508 0 01-1.505-1.505V22.086a1.508 1.508 0 011.505-1.505h1.506v.3a2.11 2.11 0 002.108 2.108zm-.301-2.108v-1.505l1.213-.001a.9.9 0 00.9-.9 1.506 1.506 0 013.011 0 .9.9 0 00.9.9h1.2v1.506a.3.3 0 01-.3.3h-6.624a.301.301 0 01-.3-.3z"
        fill="#D0D0D0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.407 24.795h11.442v1.807H16.407v-1.807zm0 3.614h8.635v1.807h-8.635v-1.807zm6.55 3.613h-6.55v1.807h6.55v-1.807z"
        fill="#D0D0D0"
      />
      <path
        d="M42.302 31.118a1.807 1.807 0 110-3.614 1.807 1.807 0 010 3.614zm0-2.409a.6.6 0 100 1.2.6.6 0 000-1.2z"
        fill="#A4AFC1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.876 7.934h-1.2v2.409h1.2V7.934zm-5.415 3.914h2.409v1.2h-2.409v-1.2zm6.925 0h2.409v1.2h-2.409v-1.2z"
        fill="#A4AFC1"
      />
    </svg>
  );
};

export const SvgRenewInfo = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 52 52" fill="none" {...props}>
    <path
      d="M42 0H10C4.477 0 0 4.477 0 10v32c0 5.523 4.477 10 10 10h32c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z"
      fill="#F7F7F7"
    />
    <path
      d="M26.548 16.422h-2.393v1.192a1.192 1.192 0 0 1-1.192 1.192H16.38a1.192 1.192 0 0 1-1.192-1.192v-1.192H12.79a2.4 2.4 0 0 0-2.393 2.393v14.953a2.4 2.4 0 0 0 2.393 2.393h13.757a2.4 2.4 0 0 0 2.392-2.393V18.815a2.4 2.4 0 0 0-2.392-2.393Z"
      fill="#F3F3F1"
    />
    <path
      d="M24.155 15.22v2.394a1.192 1.192 0 0 1-1.191 1.191h-6.585a1.192 1.192 0 0 1-1.192-1.191V15.22h2.094a2.393 2.393 0 0 1 4.786 0h2.088Z"
      fill="#E8E8E8"
    />
    <path d="M30.433 39.749a6.877 6.877 0 1 0 0-13.755 6.877 6.877 0 0 0 0 13.755Z" fill="#E7F3EF" />
    <path
      d="M13.09 33.768V18.815a2.394 2.394 0 0 1 2.094-2.363v-.03H12.79a2.4 2.4 0 0 0-2.393 2.393v14.953a2.4 2.4 0 0 0 2.393 2.393h2.692a2.4 2.4 0 0 1-2.393-2.393Zm13.757-16.15v-1.166a2.163 2.163 0 0 0-.298-.03h-2.394v1.192a1.192 1.192 0 0 1-1.192 1.192h2.692a1.192 1.192 0 0 0 1.192-1.188Z"
      fill="#E8E8E8"
    />
    <path
      d="m15.529 17.615.425-1.931 1.917-.462 1.063-2.021c0-.39.81.343.993 0-.318-.905.763.266 1.085.047a2.372 2.372 0 0 0-3.035.284 2.4 2.4 0 0 0-.704 1.69H15.18v2.393a1.192 1.192 0 0 0 1.192 1.192h2.691c-.316 0-.619-.126-.842-.35-.224-.223-2.692-.526-2.692-.842Zm14.903 23.027a7.777 7.777 0 1 1 7.776-7.776 7.785 7.785 0 0 1-7.776 7.776Zm0-13.757a5.981 5.981 0 1 0 5.981 5.981 5.988 5.988 0 0 0-5.981-5.981Z"
      fill={tenantTheme['primary-color']}
    />
    <path
      d="M33.99 30.58v1.247a.438.438 0 0 1-.438.437h-1.247a.438.438 0 0 1 0-.875h.335a2.608 2.608 0 0 0-2.15-1.116 2.61 2.61 0 0 0-2.446 1.67.438.438 0 0 1-.815-.32 3.494 3.494 0 0 1 3.26-2.225 3.48 3.48 0 0 1 1.996.625c.234.162.445.35.63.56v-.003a.438.438 0 0 1 .875 0Zm-.278 2.653a.437.437 0 0 0-.567.248 2.61 2.61 0 0 1-2.446 1.67 2.608 2.608 0 0 1-2.119-1.073h.304a.437.437 0 1 0 0-.875h-1.247a.438.438 0 0 0-.438.438v1.247a.438.438 0 0 0 .875 0v-.047c.185.21.396.398.63.56a3.48 3.48 0 0 0 1.995.624 3.496 3.496 0 0 0 3.26-2.225.438.438 0 0 0-.248-.567Z"
      fill={tenantTheme['primary-color']}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.38 19.712h6.579a2.096 2.096 0 0 0 2.087-2.093v-.298h1.501a1.498 1.498 0 0 1 1.495 1.494v3.697h1.794v-3.697a3.294 3.294 0 0 0-3.29-3.29h-1.5v-.3a.894.894 0 0 0-.894-.893h-1.32a3.29 3.29 0 0 0-6.332 0h-1.32a.894.894 0 0 0-.894.894v.3H12.79a3.294 3.294 0 0 0-3.29 3.29v14.953a3.294 3.294 0 0 0 3.29 3.29h7.703v-1.795H12.79a1.498 1.498 0 0 1-1.495-1.495V18.815a1.498 1.498 0 0 1 1.495-1.494h1.496v.298a2.096 2.096 0 0 0 2.093 2.093Zm-.3-2.093v-1.495l1.205-.001a.894.894 0 0 0 .894-.894 1.496 1.496 0 0 1 2.99 0 .894.894 0 0 0 .895.894h1.192v1.496a.298.298 0 0 1-.299.297h-6.579a.299.299 0 0 1-.298-.297Z"
      fill="#D0D0D0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.984 21.5H25.35v1.795H13.984V21.5Zm0 3.59h8.577v1.794h-8.577V25.09Zm6.506 3.588h-6.506v1.795h6.506v-1.795Z"
      fill="#D0D0D0"
    />
    <path
      d="M29.705 14.785a1.795 1.795 0 1 1 0-3.59 1.795 1.795 0 0 1 0 3.59Zm0-2.393a.596.596 0 1 0 0 1.192.596.596 0 0 0 0-1.192Z"
      fill="#ACC9CB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m40.313 21.791-.927-.75-1.505 1.86.926.75 1.506-1.86Zm-6.627-.364 1.86 1.506-.75.927-1.86-1.506.75-.927Zm5.346 4.33 1.86 1.505-.75.926-1.86-1.506.75-.926Z"
      fill="#ACC9CB"
    />
  </svg>
);

export const IconLocationPurpose = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 52 52" fill="none" {...props}>
    <g>
      <path
        d="M42 0H10C4.477 0 0 4.477 0 10v32c0 5.523 4.477 10 10 10h32c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m19.72 7.846.923.834-1.667 1.844-.922-.833 1.665-1.845Zm-4.79 5.303.923.834-1.665 1.844-.923-.833 1.666-1.845Zm.491-3.323L13.577 8.16l-.833.923 1.844 1.665.833-.922Zm19.515 26.433a1.795 1.795 0 1 0 2.538-2.538 1.795 1.795 0 0 0-2.538 2.538Zm.848-1.692a.596.596 0 1 1 .842.843.596.596 0 0 1-.842-.843Z"
        fill="#ACC9CB"
      />
      <path
        d="M37.047 21.547C37.047 15.73 32.316 11 26.5 11c-5.816 0-10.547 4.731-10.547 10.547 0 2.3.728 4.487 2.105 6.323l5.628 7.504A3.535 3.535 0 0 0 26.5 36.78c1.1 0 2.152-.526 2.814-1.407l5.628-7.504a10.46 10.46 0 0 0 2.105-6.323Z"
        fill="#F3F3F1"
      />
      <path
        d="m28.14 34.67-5.629-7.503a9.333 9.333 0 0 1-1.87-5.62c0-4.577 3.28-8.387 7.617-9.21a9.375 9.375 0 0 0-11.133 9.21c0 2.108.696 4.054 1.87 5.62l5.629 7.504a2.34 2.34 0 0 0 3.634.144 2.362 2.362 0 0 1-.118-.144Z"
        fill="#E8E8E8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5 11c5.816 0 10.547 4.731 10.547 10.547 0 2.3-.728 4.487-2.105 6.323l-5.628 7.504A3.535 3.535 0 0 1 26.5 36.78c-1.1 0-2.152-.526-2.814-1.407l-5.628-7.504a10.46 10.46 0 0 1-2.105-6.323C15.953 15.73 20.685 11 26.5 11Zm.939 22.967 5.628-7.503a8.132 8.132 0 0 0 1.636-4.917c0-4.523-3.68-8.203-8.203-8.203s-8.203 3.68-8.203 8.203c0 1.79.566 3.49 1.636 4.917l5.628 7.504c.224.298.567.47.939.47s.715-.172.939-.47Zm3.748 4.69a1.172 1.172 0 0 1 0 2.343h-9.375a1.172 1.172 0 1 1 0-2.344h9.375Z"
        fill="#D0D0D0"
      />
      <path
        d="M26.5 25.063a3.52 3.52 0 0 0 3.516-3.516A3.52 3.52 0 0 0 26.5 18.03a3.52 3.52 0 0 0-3.516 3.516 3.52 3.52 0 0 0 3.516 3.515Zm0-4.688c.646 0 1.172.526 1.172 1.172 0 .646-.526 1.172-1.172 1.172a1.173 1.173 0 0 1-1.172-1.172c0-.646.526-1.172 1.172-1.172Z"
        fill={tenantTheme['primary-color']}
      />
    </g>
  </svg>
);

export const IconImagesPost = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 52 52" fill="none" {...props}>
    <g>
      <path
        d="M42 0H10C4.477 0 0 4.477 0 10v32c0 5.523 4.477 10 10 10h32c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m44.313 9.791-.927-.75-1.505 1.86.926.75 1.506-1.86Zm-6.627-.364 1.86 1.506-.75.927-1.86-1.506.75-.927Zm5.346 4.33 1.86 1.505-.75.926-1.86-1.506.75-.926Z"
        fill="#ACC9CB"
      />
      <path
        d="m38.436 25.795-3.524 12.88c-.38 1.388-1.852 2.2-3.28 1.81l-17.844-4.883a3.05 3.05 0 0 1-.327-.114c-1.169-.476-1.85-1.698-1.617-2.91.007-.07.026-.138.044-.205l3.524-12.878c.379-1.388 1.851-2.202 3.279-1.81l17.844 4.882c1.428.39 2.28 1.84 1.9 3.228Z"
        fill="#F3F3F1"
      />
      <path
        d="M41 16.313v14.375a2.817 2.817 0 0 1-2.813 2.812H18.814a3.45 3.45 0 0 1-.363-.025 2.797 2.797 0 0 1-2.438-2.563c-.012-.075-.012-.15-.012-.224V16.313a2.817 2.817 0 0 1 2.813-2.813h19.375A2.817 2.817 0 0 1 41 16.313Z"
        fill="#F1F1F1"
      />
      <path d="M22.25 21.625a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" fill="#E7F3EF" />
      <path
        d="m31.166 32.24-11.96.313a2.16 2.16 0 0 1-.263-.018 2.029 2.029 0 0 1-1.77-1.86l5.558-4.62a1.599 1.599 0 0 1 2.25 0l6.185 6.186Z"
        fill="#E8E8E8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.188 33.5H18.811c-1.1 0-2.055-.635-2.517-1.558a.936.936 0 0 1-.259-.802 2.824 2.824 0 0 1-.036-.453V16.313a2.815 2.815 0 0 1 2.813-2.812h19.375A2.815 2.815 0 0 1 41 16.313v14.375a2.815 2.815 0 0 1-2.813 2.812Zm-20.313-4.454V16.313c0-.518.42-.938.938-.938h19.375c.517 0 .937.42.937.938v9.914l-4.575-5.338c-.419-.491-.981-.807-1.676-.769a2.188 2.188 0 0 0-1.67.79l-4.643 5.572-1.51-1.512a2.194 2.194 0 0 0-3.1 0l-4.076 4.076Zm.312 2.34 5.088-5.088c.159-.159.29-.159.449 0l2.237 2.237a.935.935 0 0 0 1.383-.063l5.3-6.362a.314.314 0 0 1 .24-.113.416.416 0 0 0 .044.01c.056.01.132.024.196.1l6.001 7.002v1.578c0 .518-.42.938-.938.938H18.814a.929.929 0 0 1-.626-.24ZM33.128 41a2.83 2.83 0 0 1-.716-.092l-19.33-5.176a2.838 2.838 0 0 1-1.99-3.444l2.125-8.149a.937.937 0 1 1 1.814.474l-2.125 8.15a.954.954 0 0 0 .667 1.159l19.319 5.173a.931.931 0 0 0 1.139-.657l.66-2.663a.938.938 0 0 1 1.82.45l-.663 2.675a2.815 2.815 0 0 1-2.72 2.1Z"
        fill="#D6D6D6"
      />
      <path
        d="M22.25 22.25a2.502 2.502 0 0 1-2.5-2.5c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5Zm0-3.125a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25Z"
        fill={tenantTheme['primary-color']}
      />
    </g>
  </svg>
);

export const IconPlatformSelection = (props) => {
  return (
    <svg width={52} height={52} viewBox="0 0 52 52" {...props}>
      <path
        d="M42 0H10C4.477 0 0 4.477 0 10v32c0 5.523 4.477 10 10 10h32c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.466 9.836l.835-.835 1.67 1.67-.835.835-1.67-1.67zm4.591 1.253l1.67-1.67.835.835-1.67 1.67-.835-.835zm1.043 2.714l-.835.835 1.67 1.67.835-.835-1.67-1.67z"
        fill="#A4AFC1"
      />
      <path
        d="M39.456 19.441v17.713a2.369 2.369 0 01-2.362 2.362H15.248a2.37 2.37 0 01-2.362-2.362V19.441h26.57z"
        fill="#F3F3F1"
      />
      <path
        d="M39.456 17.67v1.771h-26.57V17.67a2.37 2.37 0 012.362-2.362h21.846a2.369 2.369 0 012.362 2.362z"
        fill={tenantTheme['primary-color']}
      />
      <path
        d="M18.946 34.984a.59.59 0 00.435.99h1.771v4.723a1.181 1.181 0 001.181 1.181h7.676a1.18 1.18 0 001.181-1.181v-4.723h1.771a.59.59 0 00.435-.99l-7.225-7.867-7.225 7.867z"
        fill="#E7F3EF"
      />
      <path
        d="M15.543 37.154V19.441h-2.657v17.713a2.369 2.369 0 002.362 2.362h2.657a2.37 2.37 0 01-2.362-2.362z"
        fill="#D5DBE1"
      />
      <path
        d="M17.905 15.308h-2.657a2.37 2.37 0 00-2.362 2.362v1.771h2.657V17.67a2.37 2.37 0 012.362-2.362z"
        fill={tenantTheme['primary-color']}
      />
      <path
        d="M30.004 42.764h-7.672a2.069 2.069 0 01-2.067-2.067v-3.838h-.886a1.476 1.476 0 01-1.088-2.474l7.225-7.867a.91.91 0 011.3 0l7.225 7.867a1.475 1.475 0 01-1.086 2.474h-.886v3.838a2.069 2.069 0 01-2.065 2.067zm-9.956-7.676h1.1a.886.886 0 01.886.886v4.724a.3.3 0 00.3.3h7.67a.3.3 0 00.3-.3v-4.724a.886.886 0 01.886-.886h1.1l-6.118-6.663-6.124 6.663z"
        fill={tenantTheme['primary-color']}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.094 40.401h-1.772V38.63h1.771a1.478 1.478 0 001.476-1.476V20.327H13.771v16.827a1.478 1.478 0 001.476 1.476h1.771v1.771h-1.771A3.25 3.25 0 0112 37.154V17.669a3.25 3.25 0 013.247-3.247h21.847a3.25 3.25 0 013.247 3.247v19.485a3.25 3.25 0 01-3.247 3.247zM13.771 18.556h24.798v-.887a1.478 1.478 0 00-1.476-1.476H15.247a1.478 1.478 0 00-1.476 1.476v.887zm17.713 10.037h-1.771v2.952h1.771v-2.952z"
        fill="#D0D0D0"
      />
    </svg>
  );
};

export const IconContactInfo = (props) => {
  return (
    <svg width={52} height={52} viewBox="0 0 52 52" {...props}>
      <path
        d="M42 0H10C4.477 0 0 4.477 0 10v32c0 5.523 4.477 10 10 10h32c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10z"
        fill="#F7F7F7"
      />
      <path
        d="M33.717 35.854v4.52a1.433 1.433 0 01-1.571 1.406A21.228 21.228 0 0112.59 22.238a1.43 1.43 0 011.406-1.552l4.414-.032a1.417 1.417 0 011.38 1.067l.922 3.662a1.406 1.406 0 01-.522 1.471l-2.256 1.68a17.756 17.756 0 007.807 7.852l1.734-2.3a1.425 1.425 0 011.48-.522l3.689.916a1.413 1.413 0 011.073 1.374z"
        fill="#F3F3F1"
      />
      <path
        d="M32.996 41.582a1.4 1.4 0 01-.845.2 21.25 21.25 0 01-19.562-19.55 1.422 1.422 0 011.4-1.541l4.424-.037a.484.484 0 01.186.025l-2.125.012a1.421 1.421 0 00-1.4 1.541 21.226 21.226 0 0017.922 19.35z"
        fill="#D5DBE1"
      />
      <path
        d="M32.264 42.713c-.063 0-.127 0-.189-.007a22.263 22.263 0 01-20.41-20.4 2.4 2.4 0 01.625-1.8 2.306 2.306 0 011.7-.752l4.414-.031a2.35 2.35 0 012.288 1.772l.922 3.664a2.327 2.327 0 01-.872 2.445l-1.614 1.2a16.94 16.94 0 006.348 6.38l1.251-1.657a2.353 2.353 0 012.448-.865l3.689.916a2.34 2.34 0 011.783 2.273v4.521a2.3 2.3 0 01-.739 1.706 2.43 2.43 0 01-1.639.635h-.005zM18.413 21.586l-4.405.031a.457.457 0 00-.345.153.523.523 0 00-.135.4 20.387 20.387 0 0018.691 18.676.535.535 0 00.418-.139.45.45 0 00.148-.337v-4.52a.48.48 0 00-.368-.464l-3.689-.914a.485.485 0 00-.511.179l-1.735 2.3a.936.936 0 01-1.168.268 18.793 18.793 0 01-8.217-8.266.933.933 0 01.277-1.164l2.256-1.68a.473.473 0 00.179-.493l-.922-3.664a.486.486 0 00-.473-.362l-.001-.004zm14.372 1.864h1.864v5.592h-1.864V23.45z"
        fill="#D0D0D0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.96 11.167l-.88-.88-1.757 1.758.879.879 1.757-1.757zm-5.053 5.053l-.879-.88-1.757 1.758.879.879 1.757-1.757zm-1.977-5.931l1.757 1.757-.879.879-1.757-1.757.879-.88z"
        fill="#A4AFC1"
      />
      <path d="M33.717 29.553a7.707 7.707 0 100-15.414 7.707 7.707 0 000 15.414z" fill="#E7F3EF" />
      <path
        d="M33.717 30.556a8.713 8.713 0 118.712-8.712 8.722 8.722 0 01-8.712 8.712zm0-15.413a6.7 6.7 0 106.7 6.7 6.71 6.71 0 00-6.7-6.7z"
        fill={tenantTheme['primary-color']}
      />
      <path
        d="M32.377 25.532a1 1 0 01-.71-.295l-2.681-2.68 1.422-1.422 1.921 1.921 3.987-4.552 1.513 1.324-4.691 5.361a1.01 1.01 0 01-.724.343h-.037z"
        fill={tenantTheme['primary-color']}
      />
    </svg>
  );
};

// Icons for Property Types
//
export const IconFarmHouses = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M19.529 14.135c-.088 0-.178 0-.268.012-.912.078-2.02.2-3.261.385V13h2.652a2 2 0 001.761-2.948L16.761 3.27A1.979 1.979 0 0015 2.219a1.979 1.979 0 00-1.761 1.051l-3.652 6.782A2 2 0 0011.348 13H14v1.87a44.517 44.517 0 00-10.761 3.393C1.053 19.3 1.943 22 4.479 22h15.042A2.278 2.278 0 0022 20v-3.863a2.275 2.275 0 00-2.471-2.002zM11.348 11l3.642-6.78H15L18.652 11zM20 19.872a.856.856 0 01-.479.128H4.479a1.327 1.327 0 01-.2-.015 46.743 46.743 0 0115.154-3.846h.1a.846.846 0 01.467.122z" />
      <path d="M5.5 9A3.5 3.5 0 009 5.5 3.5 3.5 0 005.5 2 3.5 3.5 0 002 5.5 3.5 3.5 0 005.5 9zm0-5A1.5 1.5 0 017 5.5 1.5 1.5 0 015.5 7 1.5 1.5 0 014 5.5 1.5 1.5 0 015.5 4z" />
    </svg>
  );
};

export const IconFlats = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M19.862 8H14V4a2 2 0 00-2-2H4a2 2 0 00-2 2v16a2 2 0 002 2h15.862a2 2 0 002-2V10a2 2 0 00-2-2zM12.25 20.25H9.5V18h-3v2.25H4a.25.25 0 01-.25-.25V4A.25.25 0 014 3.75h8a.25.25 0 01.25.25zm7.862-.25a.25.25 0 01-.25.25H18.5V18h-3v2.25h-1.488V9.75h5.85a.25.25 0 01.25.25z" />
      <path d="M6.5 6.5h3v3h-3z" />
      <path d="M6.5 11.5h3v3h-3z" />
    </svg>
  );
};

export const IconPropertyBuy = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M10.183 19.646H6.804a1.172 1.172 0 0 1-1.17-1.171V9.134l5.64-4.513a1.162 1.162 0 0 1 1.461 0l5.641 4.513v1.409l1.821 1.82V10.59l1.642 1.314 1.138-1.422-9.104-7.284a2.975 2.975 0 0 0-3.737 0l-9.104 7.284 1.138 1.422 1.641-1.314v7.885a2.995 2.995 0 0 0 2.991 2.99h3.379l.002-1.818Z" />
      <path d="m15.058 21.467-5.73-5.66.02-5.41 5.406-.021 5.732 5.661-5.428 5.43Zm-4.166-6.31 4.159 4.109 3.221-3.222-4.156-4.105-3.213.012-.011 3.207Z" />
      <path d="M12.713 14.546a.851.851 0 1 0 0-1.703.851.851 0 0 0 0 1.703Z" />
    </svg>
  );
};

export const IconPropertyRent = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M11 19.16H7.752a1.127 1.127 0 0 1-1.125-1.126V9.055l5.422-4.338a1.117 1.117 0 0 1 1.406 0l5.422 4.338v2.5l1.75 1.75v-2.85l1.573 1.263 1.1-1.367-8.75-7a2.86 2.86 0 0 0-3.593 0l-8.751 7L3.3 11.718l1.578-1.263v7.58a2.879 2.879 0 0 0 2.875 2.874H11v-1.75Z" />
      <path d="M17 15a2.97 2.97 0 0 0-1.515.424l-.673-.672.97-.97-1.06-1.06-.97.969-.879-.878 1.47-1.47-1.061-1.061-1.47 1.47-1.282-1.282-1.06 1.06 4.954 4.955A2.97 2.97 0 0 0 14 18a3 3 0 1 0 3-3Zm0 4.5a1.5 1.5 0 0 1-1.5-1.5c.002-.229.056-.454.159-.659l.682-.682c.204-.103.43-.157.659-.159a1.5 1.5 0 1 1 0 3Z" />
    </svg>
  );
};

export const IconLowerPortions = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M18.875 20V8h1.256a1 1 0 00.833-1.555l-2.667-4A1 1 0 0017.465 2H6.535a1 1 0 00-.832.445l-2.667 4A1 1 0 003.869 8h1.256v12H2v2h20v-2zM10 18v-2h4v2zM6.937 3.75h10.126l1.667 2.5H5.27zM17.125 8v6H6.875V8z" />
      <path d="M10 10h4v2h-4z" />
    </svg>
  );
};

export const IconPenthouse = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M18 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2zm.25 18.25H13.5V19h-3v1.25H5.75V10h12.5zm0-14.891H9v1.335h9.25V8.25H5.75V6.694H7V5.359H5.75V3.75h12.5z" />
      <path d="M8.75 11.45h1.7v1.7h-1.7z" />
      <path d="M13.15 11.45h1.7v1.7h-1.7z" />
      <path d="M8.75 14.85h1.7v1.7h-1.7z" />
      <path d="M13.15 14.85h1.7v1.7h-1.7z" />
    </svg>
  );
};

export const IconRooms = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M20 20.5V2H6v18.5H2V22h20v-1.5zM7.75 3.75h10.5v16.5H7.75z" />
      <circle cx={1.5} cy={1.5} r={1.5} transform="translate(13.5 10.5)" />
    </svg>
  );
};

export const IconUpperPortions = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M18.875 20V8h1.256a1 1 0 00.833-1.555l-2.667-4A1 1 0 0017.465 2H6.535a1 1 0 00-.832.445l-2.667 4A1 1 0 003.869 8h1.256v12H2v2h20v-2zM14 10v2h-4v-2zm3.125 4v5.625H6.875V14zM6.937 3.75h10.126l1.667 2.5H5.27z" />
      <path d="M10 16h4v2h-4z" />
    </svg>
  );
};

export const IconAgriculturalLand = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M20.136 15.029h-.059a55.154 55.154 0 00-8.327.873v-2.178a5.519 5.519 0 004.145-1.8 4.626 4.626 0 00.837-3.63L16.6 7.7H16a21.094 21.094 0 00-2.142.1 3.687 3.687 0 00.392-1.623c0-2.342-2.791-3.79-2.91-3.85L11 2.158l-.34.174c-.119.06-2.91 1.508-2.91 3.85A3.687 3.687 0 008.142 7.8 21.094 21.094 0 006 7.7h-.6l-.129.589a4.626 4.626 0 00.837 3.63 5.519 5.519 0 004.145 1.8V16.2a36.882 36.882 0 00-7.161 2.265A1.848 1.848 0 003.848 22h16.3A1.848 1.848 0 0022 20.152v-3.273a1.858 1.858 0 00-1.864-1.85zm-4.825-5.815a2.876 2.876 0 01-.594 1.779 4.057 4.057 0 01-2.967 1.23V9.8a4.871 4.871 0 01.718-.239 12.964 12.964 0 012.843-.347zM11 3.868c.591.379 1.753 1.257 1.753 2.314a2.982 2.982 0 01-1.024 2.027 5.253 5.253 0 01-.465.4h-.524a5.237 5.237 0 01-.463-.4A2.994 2.994 0 019.25 6.182c0-.99 1.061-1.876 1.75-2.314zm-3.717 7.125a2.874 2.874 0 01-.594-1.779 12.964 12.964 0 012.843.345 4.871 4.871 0 01.718.239v2.425a4.057 4.057 0 01-2.967-1.23zm12.967 9.159a.1.1 0 01-.1.1H3.848a.1.1 0 01-.1-.1.092.092 0 01.054-.088 44.062 44.062 0 0116.327-3.285h.006a.109.109 0 01.113.1z" />
    </svg>
  );
};

export const IconBuildings = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M17 3.75a.25.25 0 01.25.25v16a.25.25 0 01-.25.25H7a.25.25 0 01-.25-.25V4A.25.25 0 017 3.75h10M17 2H7a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V4a2 2 0 00-2-2z" />
      <path d="M8.75 6h2.167v2.167H8.75z" />
      <path d="M13.083 6h2.167v2.167h-2.167z" />
      <path d="M8.75 9.75h2.167v2.167H8.75z" />
      <path d="M13.083 9.75h2.167v2.167h-2.167z" />
      <path d="M8.75 13.5h2.167v2.167H8.75z" />
      <path d="M13.083 13.5h2.167v2.167h-2.167z" />
      <path d="M10.5 18h3v4h-3z" />
    </svg>
  );
};

export const IconCommercialPlots = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M12.103 4.125v11.657H5.997V4.125h6.106m-8.049-.833v13.324a1.111 1.111 0 001.11 1.11h7.772a1.111 1.111 0 001.11-1.11V3.292a1.111 1.111 0 00-1.11-1.11H5.164a1.111 1.111 0 00-1.11 1.11z" />
      <path d="M7.94 5.513h2.221v2.221H7.94z" />
      <path d="M7.94 8.844h2.221v2.221H7.94z" />
      <path d="M7.94 14.395h2.221v2.221H7.94z" />
      <path d="M15.162 15.505v1.665h4.4l-3.855 3.335H4.09l1.929-1.665H3.47l-2.05 1.765a.888.888 0 00.581 1.56h13.994a.885.885 0 00.581-.217l5.657-4.885a.888.888 0 00-.581-1.558z" />
    </svg>
  );
};

export const IconFactory = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M20.742 3.213l-4 1.066a1 1 0 00-.742.966v7.23l-6.562-3.2a1 1 0 00-1.438.9v2.385l-4.608-1.966a1 1 0 00-1.392.92V21a1 1 0 001 1h18a1 1 0 001-1V4.179a1 1 0 00-1.258-.966zM3.75 20.25v-7.6l3.563 1.52 2.437 1.039v-3.837l6.25 3.05v5.828zm16.5 0h-2.5V5.822l2.5-.667z" />
      <path d="M6 16.336h2v2H6z" />
      <path d="M10.679 16.336h2v2h-2z" />
    </svg>
  );
};

export const IconIndustrialLand = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M10.25 16.2a36.882 36.882 0 00-7.161 2.265A1.848 1.848 0 003.848 22h16.3A1.848 1.848 0 0022 20.152v-3.273a1.858 1.858 0 00-1.864-1.85h-.059a55.154 55.154 0 00-8.327.873zm10 3.95a.1.1 0 01-.1.1H3.848a.1.1 0 01-.1-.1.092.092 0 01.054-.088 44.062 44.062 0 0116.327-3.285h.006a.109.109 0 01.113.1z" />
      <path d="M14.332 13.41z" />
      <path d="M19.767 4.125H14.35l-1.1 5.669-.8-2.669H7.278l-1.753 9.063 1.83-.717 1.351-6.6h2.443l1.383 4.629.071.239 1.729-.328 1.461-7.535h2.432l1 7.863 1.789.2z" />
      <path d="M10.593 3H9.1a3.4 3.4 0 001.147 2.529H12A2.987 2.987 0 0110.593 3z" />
      <path d="M7.686 3H6.2a3.4 3.4 0 001.144 2.529h1.739A2.989 2.989 0 017.686 3z" />
    </svg>
  );
};

export const IconOffices = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M5 6h2v2H5z" />
      <path d="M5 10h2v2H5z" />
      <path d="M9 6h2v2H9z" />
      <path d="M9 10h2v2H9z" />
      <path d="M21 14h-1.5v-2.5a1 1 0 00-1-1h-5.167a1 1 0 00-1 1V14H11a1 1 0 00-1 1v6a1 1 0 001 1h10a1 1 0 001-1v-6a1 1 0 00-1-1zm-7.167-2H18v2h-4.167zm6.417 8.25h-8.5v-4.5h8.5z" />
      <path d="M9 20.25H4a.25.25 0 01-.25-.25V4A.25.25 0 014 3.75h8a.25.25 0 01.25.25v5H14V4a2 2 0 00-2-2H4a2 2 0 00-2 2v16a2 2 0 002 2h5z" />
    </svg>
  );
};

export const IconPlotFiles = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M8.283 10.75l1.488 1.487.512.513h9.967v6.5H3.75v-8.5h4.533M3.5 9A1.5 1.5 0 002 10.5v9A1.5 1.5 0 003.5 21h17a1.5 1.5 0 001.5-1.5v-7a1.5 1.5 0 00-1.5-1.5h-9.492l-2-2z" />
      <path d="M9 6.25h5v1.5H9z" />
      <path d="M7.75 8V4.75h6.65l1.85 1.439V10H18V5.822a1 1 0 00-.386-.789l-2.343-1.822A1 1 0 0014.657 3H7a1 1 0 00-1 1v4z" />
    </svg>
  );
};

export const IconPlotForms = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M8 6.375h6v1.25H8z" />
      <path d="M8 11.875h5v1.25H8z" />
      <path d="M8 9.125h6v1.25H8z" />
      <path d="M18.077 11.33l-6.357 6.357a1.2 1.2 0 00-.343.7l-.269 2.244a.448.448 0 00.5.5l2.788-.335a1.2 1.2 0 00.706-.343l6.05-6.053a1.2 1.2 0 000-1.7l-1.378-1.37a1.2 1.2 0 00-1.697 0zm2.091 2.226l-1.221 1.221-1.247-1.243 1.221-1.221zm-5.961 5.961l-1.684.2.136-1.14 4.129-4.129 1.243 1.243z" />
      <path d="M9.763 19.25H6.75V4.75h7.221l2.708 2.106V10.9l1.75-1.75V6.587a1.2 1.2 0 00-.464-.947L14.9 3.253A1.2 1.2 0 0014.16 3H6.2A1.2 1.2 0 005 4.2v15.6A1.2 1.2 0 006.2 21h3.363z" />
    </svg>
  );
};

export const IconResidentialPlots = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M11.734 4.361l8.9 5.3-8.9 5.2-8.9-5.2 8.9-5.3m-11 6.4l10.6 6.3c.4.2.8.2 1.2 0l10.6-6.3c.6-.3.7-1 .4-1.6-.1-.2-.2-.3-.4-.4l-10.6-6.4c-.4-.2-.8-.2-1.2 0l-10.6 6.4c-.6.3-.7 1.1-.4 1.6l.4.4z" />
      <path d="M22.8 18.4l1.2-3.1h-3.2l.7 1.1-5.5 3.4-.6-1-1.2 3.1h3.2l-.6-1 5.5-3.4.5.9zM9.9 21.8l-1.2-3.1-.6.9-5.5-3.4.6-1H0l1.2 3.1.6-1 5.5 3.4-.7 1.1h3.3z" />
    </svg>
  );
};

export const IconShops = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M4.748 20.5a1.76 1.76 0 01-1.75-1.751V11.7l-.08-.074a3.5 3.5 0 01-.261-.27 3.1 3.1 0 01-.566-2.657l1.05-4.37A1.708 1.708 0 014.8 3h13.888a1.707 1.707 0 011.666 1.327l1.051 4.371a3.1 3.1 0 01-.574 2.678 3.454 3.454 0 01-.25.247l-.083.075v7.052a1.761 1.761 0 01-1.751 1.75zm-.25-1.5H19.01v-6.587l-.3.061a1.451 1.451 0 01-.195.027 2.888 2.888 0 01-2.045-.875l-.179-.185-.179.184a2.951 2.951 0 01-2.064.875 3.013 3.013 0 01-2.114-.859l-.176-.173-.175.175a2.9 2.9 0 01-2.054.857 3 3 0 01-2.132-.876l-.179-.182-.178.184a2.891 2.891 0 01-2.061.874 1.43 1.43 0 01-.179-.026l-.3-.061zm-.954-9.947a1.576 1.576 0 00.311 1.386 1.4 1.4 0 001.12.561 1.512 1.512 0 001.462-1.367L7.05 4.5H4.599zm4.446.187a1.677 1.677 0 00.388 1.262 1.456 1.456 0 001.077.5 1.536 1.536 0 001.543-1.565V4.5H8.566zm8.457-4.739l.613 5.138A1.5 1.5 0 0018.51 11a1.432 1.432 0 001.147-.571 1.61 1.61 0 00.292-1.38l-1.094-4.563zM12.498 9.44a1.527 1.527 0 001.46 1.56h.005a1.474 1.474 0 001.144-.5 1.593 1.593 0 00.389-1.266L14.93 4.5h-2.432z" />
    </svg>
  );
};

export const IconWarehouses = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M14.134 14h6.681v2h-6.681z" />
      <path d="M14.134 17h6.681v2h-6.681z" />
      <path d="M14.134 20h6.681v2h-6.681z" />
      <path d="M12 20.25H4.934v-9.334L12 6.107l7.066 4.809v1.074h1.75v-2L12 3.99l-8.816 6V22H12z" />
    </svg>
  );
};

export const IconCommercialOthers = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M7 12a2 2 0 11-2-2 2 2 0 012 2zm5-2a2 2 0 102 2 2 2 0 00-2-2zm7 0a2 2 0 102 2 2 2 0 00-2-2z" />
    </svg>
  );
};

export const IconZameen = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M4 9l16-2v15H4V9z" fill="#fff" />
      <path
        d="M21.29 8.64V4.938h-5.194L12.002 2 1 9.899v5.24L3 14v8h3.431c-.212-.57-.185-.976.145-1.543l4.31-7.526-3.972.987a1.947 1.947 0 11-.944-3.779l8.417-2.09.069-.018.037-.01c.052-.012.103-.013.155-.021.063-.01.124-.024.188-.027.12-.009.238-.004.355.01.013.001.026 0 .04.002.088.012.172.035.257.059.182.047.362.11.533.209a2.107 2.107 0 01.768 2.885l-4.114 7.184 4.41-1.126a1.947 1.947 0 11.944 3.779L13.042 22h7.957L21 14l2 1.138v-5.24L21.29 8.64z"
        style={{ fill: '#00A651' }}
      />
    </svg>
  );
};

export const IconOLX = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 568 326" {...props}>
      <path
        d="M373.01 325.02h-77V.49h77v324.53zM268.25 162.76a133.73 133.73 0 11-267.46 0 133.73 133.73 0 01267.46 0zm-93.21 0a40.529 40.529 0 00-69.192-28.655A40.526 40.526 0 00112 196.464a40.527 40.527 0 0022.52 6.826 40.521 40.521 0 0040.52-40.53zm392.73-81.27h-51.2l-30 30-30-30h-51.2v52l29.59 29.59-29.59 29.6v51.29h51.86l29.31-29.31 29.31 29.31h51.92v-51.25l-29.6-29.6 29.6-29.63v-52z"
        style={{ fill: '#3A77FF' }}
      />
    </svg>
  );
};

export const LogoZameen = (props) => {
  return (
    <svg width={135} height={27} viewBox="0 0 135 27" {...props}>
      <path
        d="M132.2 16.7v-5.1c0-1.4-.4-2.1-1.4-2.1-.7 0-1.1.5-1.3 1-.1.2-.1.5-.1.7v5.5h-2.8v-5.2c0-1.2-.4-2-1.3-2-.7 0-1.2.6-1.4 1.1-.1.2-.1.5-.1.7v5.4H121v-6.4c0-1.2 0-2.2-.1-3h2.4l.1 1.3h.1c.4-.6 1.2-1.5 2.8-1.5 1.2 0 2.2.6 2.6 1.6.3-.5.8-.9 1.2-1.1.5-.3 1.1-.5 1.8-.5 1.8 0 3.2 1.3 3.2 4v5.5h-2.9zm-18-7.5c-1.4 0-1.9 1.4-1.9 2.8 0 1.6.7 2.8 1.9 2.8 1.1 0 1.9-1.1 1.9-2.8 0-1.4-.6-2.8-1.9-2.8zm0 7.7c-2.7 0-4.8-1.8-4.8-4.8s2-4.9 5-4.9c2.9 0 4.8 2 4.8 4.8-.1 3.4-2.5 4.9-5 4.9zm-6.4-7.2c-.3-.2-.9-.3-1.6-.3-1.5 0-2.5 1.1-2.5 2.6 0 1.7 1.1 2.6 2.6 2.6.7 0 1.2-.1 1.7-.3l.3 2.1c-.5.2-1.5.4-2.6.4-3 0-4.9-1.8-4.9-4.8 0-2.7 1.9-5 5.3-5 .8 0 1.6.1 2.2.4l-.5 2.3zm-10 7.2c-1 0-1.7-.7-1.7-1.8 0-1 .7-1.8 1.7-1.8s1.7.7 1.7 1.8-.7 1.8-1.7 1.8zm-6.7-.2v-5.2c0-1.2-.4-2-1.5-2-.8 0-1.3.6-1.5 1.1-.1.2-.1.5-.1.7v5.4h-2.9v-6.4c0-1.2 0-2.2-.1-3h2.5l.1 1.3h.1c.4-.6 1.3-1.5 2.9-1.5 1.9 0 3.3 1.3 3.3 4v5.5h-2.8zM79 9.1c-1.2 0-1.7 1.1-1.8 1.9h3.4c.1-.7-.2-1.9-1.6-1.9zm4.3 3.9h-6c.1 1.2 1.3 1.8 2.6 1.8 1 0 1.8-.1 2.6-.4l.4 2c-1 .4-2.1.6-3.4.6-3.2 0-5-1.8-5-4.8 0-2.4 1.5-5 4.7-5 3 0 4.2 2.3 4.2 4.7 0 .4-.1.9-.1 1.1zM68.9 9.1c-1.2 0-1.7 1.1-1.8 1.9h3.4c.1-.7-.2-1.9-1.6-1.9zm4.3 3.9h-6c.1 1.2 1.3 1.8 2.6 1.8 1 0 1.8-.1 2.6-.4l.4 2c-1 .4-2.1.6-3.4.6-3.2 0-5-1.8-5-4.8 0-2.4 1.5-5 4.7-5 3 0 4.2 2.3 4.2 4.7 0 .4-.1.9-.1 1.1zm-13.4 3.7v-5.1c0-1.4-.4-2.1-1.4-2.1-.7 0-1.1.5-1.3 1-.1.2-.1.5-.1.8v5.5h-2.8v-5.2c0-1.2-.4-2-1.3-2-.7 0-1.2.6-1.4 1.1-.1.2-.1.5-.1.7v5.4h-2.8v-6.4c0-1.2 0-2.2-.1-3h2.4l.1 1.2h.1c.4-.6 1.2-1.5 2.8-1.5 1.2 0 2.2.6 2.6 1.6.3-.5.8-.9 1.2-1.1.5-.3 1.1-.5 1.8-.5 1.8 0 3.2 1.3 3.2 4v5.5h-2.9zm-16.4-4.4c-1.5 0-2.7.3-2.7 1.5 0 .7.5 1.1 1.1 1.1.7 0 1.3-.5 1.5-1.1 0-.2.1-.3.1-.5v-1zm.3 4.4l-.2-.9h-.1c-.6.7-1.6 1.1-2.7 1.1-1.9 0-3-1.4-3-2.9 0-2.4 2.2-3.6 5.5-3.6v-.1c0-.5-.3-1.2-1.7-1.2-1 0-2 .3-2.6.7L38.5 8c.6-.4 1.9-.8 3.6-.8 3.1 0 4.1 1.8 4.1 4v3.2c0 .9 0 1.8.1 2.3h-2.6zm-6.9-2.3v2.3h-8.1V15l2.9-3.7c.5-.6 1-1.1 1.5-1.7H29V7.4h7.6v1.7l-2.8 3.5c-.5.6-1 1.2-1.5 1.7h4.5z"
        style={{ fill: '#231f20' }}
      />
      <path
        d="M135 25.1h-1v-4.3h1v4.3zm-1.1-5v-.9h1.1v.9h-1.1zm-2.1 3.2c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-5 0v-2.4H124v2.4h-1v-5.7h1v2.4h2.7v-2.4h1v5.7h-.9zm-8.5-1.8c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-4.8-3.5v2.1c0 .4.2.5.5.5.2 0 .4 0 .6-.1v.9a2 2 0 0 1-.9.2c-.7 0-1.2-.3-1.2-1.3v-2.3h-.5v-.9h.5v-1.2h1v1.2h1.2v.9h-1.2zm-3.3 1.7c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-5.8-4.8h-1.2v2.1h1.2c.8 0 1.2-.4 1.2-1 .1-.8-.4-1.1-1.2-1.1zm0 3h-1.1v1.8h-1v-5.7h2.3c1.3 0 2.2.8 2.2 1.9-.1 1.3-1.1 2-2.4 2zm-6.9 1.8v-2.5c0-.7-.3-1.1-.9-1.1-.6 0-1 .4-1 1.1V25h-1v-4.3h1v.7c.3-.4.7-.8 1.4-.8 1 0 1.5.7 1.5 1.7v2.8h-1zm-4.2 0h-1v-4.3h1v4.3zm-1-5v-.9h1.1v.9h-1.1zm-2.2 3.2c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-4.8 0v-2.5c0-.7-.3-1.1-.9-1.1-.5 0-.9.4-.9 1.1V25h-1v-2.5c0-.7-.3-1-.9-1s-.9.4-.9 1.1V25h-1v-4.3h1v.7c.3-.4.7-.7 1.3-.7.6 0 1.1.3 1.3.8.4-.5.8-.8 1.5-.8.9 0 1.5.6 1.5 1.7v2.8h-1zm-7.8 0v-.7c-.3.4-.7.8-1.4.8-1 0-1.5-.7-1.5-1.7v-2.8h1v2.5c0 .7.3 1.1.9 1.1.6 0 1-.4 1-1.1v-2.4h1v4.3h-1zm-5.2 0v-2.4h-2.7v2.4h-1v-5.7h1v2.4h2.7v-2.4h1v5.7h-1zm-8.8 1.2l-.1-.4c.5-.1.7-.4.7-.8h-.4V24h1.1v1c0 .8-.4 1.2-1.3 1.3zm-1.9-3c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.4-.9c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-.9zm-4.8-3.5v2.1c0 .4.2.5.5.5.2 0 .4 0 .6-.1v.9a2 2 0 0 1-.9.2c-.7 0-1.2-.3-1.2-1.3v-2.3h-.5v-.9h.5v-1.2h1v1.2H58v.9h-1.2zm-3.3 1.7c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-5.7-4.8h-1.2v2.1h1.2c.8 0 1.2-.4 1.2-1 0-.8-.5-1.1-1.2-1.1zm-.1 3h-1.1v1.8h-1v-5.7h2.3c1.3 0 2.2.8 2.2 1.9-.1 1.3-1.1 2-2.4 2zm-5.6-1.6c-.9 0-1.5.6-1.5 1.7V25h-1v-4.3h1v1c.3-.6.8-1.1 1.5-1.1v1.1zm-4.6 1.6c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-5 0v-2.4h-2.7v2.4h-1v-5.7h1v2.4h2.7v-2.4h1v5.7h-1z"
        style={{ fill: '#f37a20' }}
      />
      <path style={{ fill: '#fff' }} d="M3.7 7.7h18.5v17.4H3.7z" />
      <path
        d="M23.8 8.5V4.2h-6.1L12.9.8 0 10v6.1l2-1.5v10.5h4.4c-.2-.7-.2-1.4.2-2.1l5-8.8-4.7 1.2c-1.2.3-2.5-.4-2.8-1.7-.3-1.2.4-2.5 1.7-2.8l9.9-2.4h.9c.1 0 .2 0 .3.1.2.1.4.1.6.2 1.2.7 1.6 2.2.9 3.4l-4.8 8.4 5.2-1.3c1.2-.3 2.5.4 2.8 1.7.3 1.2-.4 2.5-1.7 2.8l-5.8 1.5h9.7V14.8l2 1.5V10l-2-1.5z"
        style={{ fill: '#00A551' }}
      />
    </svg>
  );
};

export const ImageNetworkError = (props) => {
  return (
    <svg width="392" height="202" viewBox="0 0 392 202">
      <path d="M117.304 112.272h130.644v89.005H117.304v-89.005Z" fill="#009f2b" />
      <path
        d="M255.234 101.862H126.675a1.57 1.57 0 0 0-1.104.458 1.57 1.57 0 0 0-.458 1.104v86.92a1.564 1.564 0 0 0 1.562 1.562h128.559c.414 0 .812-.165 1.105-.457.292-.293.457-.691.457-1.105v-86.92a1.57 1.57 0 0 0-.458-1.104 1.57 1.57 0 0 0-1.104-.458Zm.521 88.484a.528.528 0 0 1-.152.369.522.522 0 0 1-.369.152H126.675a.531.531 0 0 1-.369-.152.522.522 0 0 1-.152-.369v-86.922a.52.52 0 0 1 .521-.521h128.559a.52.52 0 0 1 .521.521v86.922Z"
        fill="#3F3D56"
      />
      <path
        d="M188.694 163.281h-54.816a2 2 0 0 0-2 2v2.766a2 2 0 0 0 2 2h54.816a2 2 0 0 0 2-2v-2.766a2 2 0 0 0-2-2Zm55.609-5.725h-18.735a1.564 1.564 0 0 0-1.562 1.562v14.573c0 .414.165.812.457 1.105.293.292.691.457 1.105.457h18.735a1.563 1.563 0 0 0 1.562-1.562v-14.573a1.56 1.56 0 0 0-1.562-1.562Zm.521 16.135a.52.52 0 0 1-.521.521h-18.735a.518.518 0 0 1-.521-.521v-14.573a.531.531 0 0 1 .152-.369.522.522 0 0 1 .369-.152h18.735a.531.531 0 0 1 .369.152.522.522 0 0 1 .152.369v14.573Z"
        fill="#3F3D56"
      />
      <path
        d="M240 160.919h-10.13a1.32 1.32 0 0 0-1.321 1.321v.001c0 .73.591 1.321 1.321 1.321H240a1.32 1.32 0 0 0 1.321-1.321v-.001a1.32 1.32 0 0 0-1.321-1.321Zm0 4.164h-10.13a1.32 1.32 0 0 0-1.321 1.321v.001c0 .73.591 1.321 1.321 1.321H240a1.32 1.32 0 0 0 1.321-1.321v-.001a1.32 1.32 0 0 0-1.321-1.321Zm0 4.163h-10.13a1.32 1.32 0 0 0-1.321 1.321v.001c0 .73.591 1.321 1.321 1.321H240a1.32 1.32 0 0 0 1.321-1.321v-.001a1.32 1.32 0 0 0-1.321-1.321Zm-81.495-61.137h-23.066a2 2 0 0 0-2 2v7.451a2 2 0 0 0 2 2h23.066a2 2 0 0 0 2-2v-7.451a2 2 0 0 0-2-2Z"
        fill="#3F3D56"
      />
      <path
        d="M149.054 113.834c0 2.012-.932 3.643-2.082 3.643s-2.082-1.631-2.082-3.643c0-2.012 2.082-3.643 2.082-3.643s2.082 1.631 2.082 3.643Z"
        fill="#6C63FF"
      />
      <path
        d="M343.836 61.512h-.76v84.993h-86.28v.76h87.04V61.512Zm-226.532 85.753h-87.04V61.512h.76v84.993h86.28v.76Z"
        fill="#3F3D56"
      />
      <path
        d="M391.483 14.371h-.487v-.853h.365a.245.245 0 0 0 .244-.244V8.89a.245.245 0 0 0-.244-.244h-.365v-2.49a5.3 5.3 0 0 0-5.3-5.3h-.543V.247a.245.245 0 0 0-.244-.244h-4.384a.245.245 0 0 0-.244.244v.61h-79.219a5.3 5.3 0 0 0-5.3 5.299v112.885a5.3 5.3 0 0 0 5.3 5.3h84.629a5.3 5.3 0 0 0 5.3-5.3v-99.8h.487a.241.241 0 0 0 .225-.15.231.231 0 0 0 .019-.094v-4.384a.249.249 0 0 0-.071-.173.249.249 0 0 0-.173-.07l.005.001Z"
        fill="#3F3D56"
      />
      <path
        d="M385.438 4.322h-83.391a1.905 1.905 0 0 0-1.905 1.905v111.891c0 1.052.853 1.905 1.905 1.905h83.391a1.905 1.905 0 0 0 1.905-1.905V6.227a1.905 1.905 0 0 0-1.905-1.905Z"
        fill="#fff"
      />
      <path
        d="M346.688 61.026h-10.959a2 2 0 0 0-2 2v.433a2 2 0 0 0 2 2h10.959a2 2 0 0 0 2-2v-.433a2 2 0 0 0-2-2Zm19.134-34.513h-49.228a.95.95 0 1 0 0 1.9h49.228a.95.95 0 1 0 0-1.9Zm0 6.017h-49.228a.95.95 0 1 0 0 1.9h49.228a.95.95 0 1 0 0-1.9Zm0 6.015h-49.228a.95.95 0 1 0 0 1.9h49.228a.95.95 0 1 0 0-1.9Zm0 6.016h-49.228a.95.95 0 1 0 0 1.9h49.228a.95.95 0 1 0 0-1.9Zm0 6.016h-49.228a.95.95 0 1 0 0 1.9h49.228a.95.95 0 1 0 0-1.9Z"
        fill="#3F3D56"
      />
      <path
        d="M339.399 115.455c8.77 0 15.88-7.11 15.88-15.88s-7.11-15.88-15.88-15.88-15.88 7.11-15.88 15.88 7.11 15.88 15.88 15.88Z"
        fill="#009f2b"
      />
      <path
        d="M344.079 111.823a19.913 19.913 0 0 1-18.394-12.29 19.91 19.91 0 1 1 18.394 12.29Zm0-39.1a19.184 19.184 0 0 0-18.817 22.929 19.188 19.188 0 0 0 15.074 15.074 19.18 19.18 0 0 0 19.696-8.158 19.186 19.186 0 0 0-15.953-29.845ZM60.096 33.419h-.651V15.574A10.326 10.326 0 0 0 49.119 5.248H11.326A10.326 10.326 0 0 0 .996 15.574v97.875a10.333 10.333 0 0 0 3.026 7.303 10.329 10.329 0 0 0 7.304 3.023h37.8a10.328 10.328 0 0 0 10.326-10.326V46.114h.651l-.007-12.695Z"
        fill="#3F3D56"
      />
      <path
        d="M57.248 16.18v97.733a7.708 7.708 0 0 1-4.76 7.126 7.722 7.722 0 0 1-2.951.587H11.56a7.71 7.71 0 0 1-7.71-7.711V16.18a7.711 7.711 0 0 1 7.709-7.71h4.609a3.663 3.663 0 0 0 3.392 5.046h21.654a3.663 3.663 0 0 0 3.392-5.046h4.934a7.711 7.711 0 0 1 7.71 7.709l-.003.001Z"
        fill="#fff"
      />
      <path
        d="M34.129 66.049h-7.158a1.508 1.508 0 1 0 0 3.015h7.158a1.508 1.508 0 1 0 0-3.015Zm13.163-23.475H13.809a.646.646 0 1 0 0 1.292h33.483a.646.646 0 0 0 0-1.292Zm0 4.092H13.809a.646.646 0 1 0 0 1.292h33.483a.646.646 0 0 0 0-1.292Zm0 4.092H13.809a.646.646 0 1 0 0 1.292h33.483a.646.646 0 0 0 0-1.292Zm0 4.092H13.809a.646.646 0 1 0 0 1.292h33.483a.646.646 0 0 0 0-1.292Zm0 4.092H13.809a.646.646 0 1 0 0 1.292h33.483a.646.646 0 0 0 0-1.292Z"
        fill="#3F3D56"
      />
      <path
        d="M27.558 108.388c6.048 0 10.951-4.903 10.951-10.951 0-6.048-4.903-10.951-10.95-10.951-6.049 0-10.952 4.903-10.952 10.951 0 6.048 4.903 10.951 10.951 10.951Z"
        fill="#009f2b"
      />
      <path
        d="M30.786 105.884a13.73 13.73 0 1 1-.001-27.46 13.73 13.73 0 0 1 .001 27.46Zm0-26.962a13.231 13.231 0 1 0 0 26.463 13.231 13.231 0 0 0 0-26.463Z"
        fill="#3F3D56"
      />
      <path d="M57.065 142.605h10.642v10.642H57.065v-10.642Z" fill="#D0CDE1" />
      <path d="M74.169 147.166H61.246v-12.923h12.923v12.923Zm-12.361-.562h11.8v-11.8h-11.8v11.8Z" fill="#3F3D56" />
      <path d="M295.38 142.605h10.642v10.642H295.38v-10.642Z" fill="#D0CDE1" />
      <path d="M312.484 147.166h-12.923v-12.923h12.923v12.923Zm-12.361-.562h11.8v-11.8h-11.8v11.8Z" fill="#3F3D56" />
      <path
        d="m196.364 71.397-2.1-2.1-8.377 8.381-8.381-8.377-2.1 2.1 8.381 8.377-8.377 8.381 2.1 2.1 8.377-8.381 8.381 8.381 2.1-2.1-8.381-8.381 8.377-8.381Z"
        fill="#F00F0F"
      />
    </svg>
  );
};

export const IllustrationEmptyCart = (props) => {
  return (
    <svg width={112} height={112} viewBox="0 0 112 112" {...props}>
      <g id="ic_noCartItems" transform="translate(-0.077 -0.077)" opacity="0.6">
        <g
          id="Boundary"
          transform="translate(0.077 0.077)"
          fill="#bdbdbd"
          stroke="rgba(0,0,0,0)"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="112" height="112" stroke="none" />
          <rect x="0.5" y="0.5" width="111" height="111" fill="none" />
        </g>
        <path
          id="Path_cart-off"
          data-name="Path / cart-off"
          d="M106.067,101.411,5.926,1.27,0,7.2,20.486,27.682,30.8,49.427,24.5,60.86a9.022,9.022,0,0,0-1.167,4.48,9.333,9.333,0,0,0,9.333,9.333H67.476l6.44,6.44A9.3,9.3,0,0,0,79.329,98a9.218,9.218,0,0,0,7.56-3.92l13.253,13.253,5.926-5.926M34.625,65.34a1.167,1.167,0,0,1-1.167-1.167l.14-.56,4.2-7.606H48.811l9.333,9.333H34.625m37.938-9.333A9.289,9.289,0,0,0,80.729,51.2L97.434,21.009a5.2,5.2,0,0,0,.56-2.333,4.666,4.666,0,0,0-4.666-4.666H30.518l42.044,42m-39.9,23.332A9.333,9.333,0,1,0,42,88.672,9.333,9.333,0,0,0,32.665,79.339Z"
          transform="translate(4.666 3.394)"
          fill="#bdbdbd"
          style={{ fill: '#bdbdbd' }}
        />
      </g>
    </svg>
  );
};

export const IconImageBank = (props) => {
  return (
    <svg width={51} height={51} viewBox="0 0 51 51" {...props}>
      <path
        d="M51 25.5C51 11.417 39.583 0 25.5 0S0 11.417 0 25.5 11.417 51 25.5 51 51 39.583 51 25.5z"
        style={{ fill: '#E7F3EF' }}
      />
      <path
        d="M28.545 11.329l1.413-1.875.937.705-1.413 1.876-.937-.706zm-4.324-1.048l-.708.938 1.873 1.415.709-.937-1.874-1.415zm5.39 4.07l-.709.937 1.873 1.415.709-.937-1.874-1.415zm-1.33 22.687a1.761 1.761 0 101.957-2.928 1.761 1.761 0 00-1.957 2.928zm.652-1.952a.587.587 0 11.652.977.587.587 0 01-.652-.977z"
        style={{ fill: '#A4AFC1' }}
      />
      <path
        d="M39.424 16.639v15.849a3.225 3.225 0 01-3.228 3.228H22.765l-.986.986-4.626 4.626a.873.873 0 01-.963.188.87.87 0 01-.54-.81v-4.989h-1.174a3.314 3.314 0 01-1.667-.458 3.24 3.24 0 01-1.561-2.771V16.639a3.483 3.483 0 013.522-3.228h21.425a3.226 3.226 0 013.229 3.228z"
        style={{ fill: '#F3F3F1' }}
      />
      <path
        d="M18.879 35.717h-1.174a3.314 3.314 0 01-1.667-.458 3.24 3.24 0 01-1.561-2.771V16.639a3.484 3.484 0 013.521-3.228H14.77a3.483 3.483 0 00-3.522 3.228v15.849a3.24 3.24 0 001.561 2.771c.505.297 1.08.456 1.667.458h1.172v4.994a.87.87 0 00.54.81.873.873 0 00.963-.188l1.726-1.726.002-3.89z"
        style={{ fill: '#D5DBE1' }}
      />
      <path
        d="M19.466 19.281a2.348 2.348 0 11-4.696 0 2.348 2.348 0 014.696 0zm9.98.2c.545 0 1.068.215 1.455.599l8.52 8.523v3.89a3.225 3.225 0 01-3.228 3.228h-13.43l-.986.986-4.626 4.626a.873.873 0 01-.963.188.87.87 0 01-.54-.81v-4.993h-1.172a3.314 3.314 0 01-1.667-.458 3.24 3.24 0 01-1.561-2.771v-1.538l6.764-6.762a2.069 2.069 0 012.911 0l1.479 1.479 5.588-5.588a2.07 2.07 0 011.456-.599z"
        style={{ fill: '#7ED8AA' }}
      />
      <path
        d="M14.183 33.737v1.095c0 .29.039.577.115.856a3.34 3.34 0 01-1.489-.433 3.24 3.24 0 01-1.561-2.771v-1.1c0-.277.11-.544.306-.74l5.717-5.718a3.115 3.115 0 014.391 0l.445.92c.271.272.458-.043.672-.405.109-.183.225-.378.362-.515l4.109-4.109a3.115 3.115 0 014.391 0l1.038 1.038a2.056 2.056 0 00-1.754.571l-4.849 4.849a1.046 1.046 0 01-1.479 0 3.115 3.115 0 00-4.391 0l-5.717 5.722a1.047 1.047 0 00-.306.74zm4.402 4.328v1.831l-1.432 1.432a.873.873 0 01-.963.188.87.87 0 01-.54-.81v-3.174c.016.01.031.024.046.037.015.014.03.027.048.038.505.297 1.08.456 1.667.458h1.174z"
        style={{ fill: '#00A651' }}
      />
      <path
        d="M16.54 41.587a.88.88 0 01-.88-.88v-4.99h-1.176a3.231 3.231 0 01-3.228-3.228v-15.85a3.483 3.483 0 013.522-3.228h21.425a3.231 3.231 0 013.228 3.228v15.849a3.23 3.23 0 01-3.228 3.228h-13.43l-5.612 5.612a.875.875 0 01-.622.258v.001zm-1.762-26.415a1.772 1.772 0 00-1.76 1.467v12.544l4.999-5a2.061 2.061 0 012.911 0l1.479 1.479 5.588-5.588a2.061 2.061 0 012.911 0l6.764 6.764V16.64a1.47 1.47 0 00-1.467-1.467H14.778zM37.67 29.33v3.156a1.47 1.47 0 01-1.467 1.467H22.41a.88.88 0 00-.622.258l-4.368 4.368v-3.744a.882.882 0 00-.88-.88h-2.055a1.47 1.47 0 01-1.467-1.467v-.81l6.241-6.248a.3.3 0 01.423 0l2.1 2.1a.881.881 0 001.246 0l6.21-6.21a.3.3 0 01.423 0l8.01 8.01zm-20.544-7.697a2.348 2.348 0 11-.006-4.696 2.348 2.348 0 01.006 4.696zm0-2.935a.587.587 0 10.543.361.59.59 0 00-.543-.365v.004z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const IconSuperHot = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="1 1 22 22" {...props}>
      <path
        d="M11.996 22.005c-1.855-.003-3.632-.793-4.944-2.196-1.31-1.402-2.049-3.304-2.052-5.288a8.036 8.036 0 0 1 .939-3.764 7.404 7.404 0 0 1 2.554-2.776l1.09-.687S9.5 8 9.5 8.5s-.021 1.293.283 1.773c.098-2.114.676-5.956 3.504-7.697l.924-.57v1.142c0 2.01.974 3.279 2.103 4.748 1.651 1.761 2.612 4.13 2.686 6.622-.003 1.986-.741 3.89-2.055 5.294-1.313 1.403-3.093 2.192-4.95 2.193Z"
        fill="currentColor"
        opacity={0.5}
      />
      <path
        d="M13.114 8.514c-2.54 1.565-2.236 5.977-2.236 5.977a2.05 2.05 0 0 1-.891-.902 2.246 2.246 0 0 1-.226-1.29 4.719 4.719 0 0 0-1.637 1.775 5.122 5.122 0 0 0-.599 2.409c0 1.268.471 2.484 1.31 3.38.837.898 1.974 1.401 3.16 1.401 1.185 0 2.322-.503 3.16-1.4a4.954 4.954 0 0 0 1.31-3.381c0-3.889-3.352-4.682-3.352-7.97Z"
        fill={`color-mix(in srgb, ${props.color || 'currentColor'} 8%, #fff)`}
      />
    </svg>
  );
};

export const IconSuperHotAlt = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="1 1 22 22" {...props}>
      <path
        d="M11.996 22.005c-1.855-.003-3.632-.793-4.944-2.196-1.31-1.402-2.049-3.304-2.052-5.288a8.036 8.036 0 0 1 .939-3.764 7.404 7.404 0 0 1 2.554-2.776l1.09-.687S9.5 8 9.5 8.5s-.021 1.293.283 1.773c.098-2.114.676-5.956 3.504-7.697l.924-.57v1.142c0 2.01.974 3.279 2.103 4.748 1.651 1.761 2.612 4.13 2.686 6.622-.003 1.986-.741 3.89-2.055 5.294-1.313 1.403-3.093 2.192-4.95 2.193Z"
        fill="currentColor"
      />
      <path
        d="M13.114 8.514c-2.54 1.565-2.236 5.977-2.236 5.9color-mix77a2.05 2.05 0 0 1-.891-.902 2.246 2.246 0 0 1-.226-1.29 4.719 4.719 0 0 0-1.637 1.775 5.122 5.122 0 0 0-.599 2.409c0 1.268.471 2.484 1.31 3.38.837.898 1.974 1.401 3.16 1.401 1.185 0 2.322-.503 3.16-1.4a4.954 4.954 0 0 0 1.31-3.381c0-3.889-3.352-4.682-3.352-7.97Z"
        fill={`(in srgb, ${props.color} 72%, #fff)`}
        opacity={0.7}
      />
    </svg>
  );
};

export const IconHot = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M13.75 2.002c-3.975 2.456-3.498 9.376-3.498 9.376a3.313 3.313 0 0 1-1.406-1.434 3.447 3.447 0 0 1-.343-2.006 7.6 7.6 0 0 0-2.577 2.814 7.868 7.868 0 0 0-.92 3.749 7.4 7.4 0 0 0 .448 2.846 7.239 7.239 0 0 0 1.497 2.438 7 7 0 0 0 2.305 1.638 6.827 6.827 0 0 0 5.488 0 6.998 6.998 0 0 0 2.305-1.638 7.239 7.239 0 0 0 1.497-2.438 7.4 7.4 0 0 0 .448-2.846c0-6.1-5.246-7.344-5.246-12.501l.001.002Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const IconF = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path d="M19 7.164V3H5v19h4.658v-6.706h8.046v-4.108H9.659V7.162L19 7.164Z" fill="currentColor" />
    </svg>
  );
};

export const IconS = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M12.562 3C8.448 3 5.713 5.148 5.713 8.472c0 2.684 1.566 4.423 5.15 5.097l2.921.537c1.939.332 2.39 1.124 2.39 1.89 0 1.23-1.142 1.919-3.133 1.919-2.496 0-4.17-1.124-4.46-2.94H5c.265 3.733 3.373 6.035 7.832 6.035 4.247 0 7.057-2.149 7.057-5.445 0-2.865-2.016-4.168-5.545-4.855l-2.125-.41c-1.724-.345-2.682-.882-2.682-2.144 0-1.432 1.3-2.185 3.292-2.185 2.284 0 3.345.998 3.584 2.607H20C19.574 4.151 15.62 3 12.562 3Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const IconPremiumCredits = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M12.14 22c-.248 0-.488-.09-.676-.252a31.678 31.678 0 0 1-5.596-6.136c-1.237-1.893-1.865-3.669-1.865-5.277C4 10.238 4 10.14 4 10.035A8.085 8.085 0 0 1 12.083 2h.1a8.084 8.084 0 0 1 8.083 8.335c-.003 1.606-.632 3.381-1.868 5.275a31.769 31.769 0 0 1-5.582 6.138 1.032 1.032 0 0 1-.676.252Zm2.166-10.568a.753.753 0 0 1 .158 1.49l-1.933.495h3.195V9.949l.661.49V8.41l-.661-.49V6.483h-2.01L12.13 5.348 7.882 8.411v2.025l.654-.486v3.467h1.438a.807.807 0 0 1 .056-.694l1.67-2.915-1.538.393a.756.756 0 1 1-.364-1.464l3.257-.81h.325a.76.76 0 0 1 .1.023.723.723 0 0 1 .205.08.815.815 0 0 1 .298 1.117l-1.592 2.746 1.707-.436a.753.753 0 0 1 .21-.025Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const IconBasicCredits = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.477 11.907a4.388 4.388 0 0 0 3.961-2.127 4.366 4.366 0 0 0 0-4.492A4.386 4.386 0 0 0 5.29 7.534a4.38 4.38 0 0 0 4.187 4.373Zm1.426-9.716a5.524 5.524 0 0 1 .535 10.5 5.538 5.538 0 0 1-6.283-1.7l-.026.017-3.04 1.753a.479.479 0 0 1-.659-.178l-.365-.632a.48.48 0 0 1 .178-.658l3.039-1.744.026-.018a5.52 5.52 0 0 1 1.037-5.695 5.538 5.538 0 0 1 5.557-1.646ZM9.477 7.528a.93.93 0 0 0-.927.926V9.61a.346.346 0 0 1-.1.24.333.333 0 0 1-.239.098H6.973a.419.419 0 0 1-.42-.419V7.021c0-.623 0-.685.241-.818L8.97 4.948c.195-.116.338-.196.516-.196.179 0 .321.08.517.196l2.174 1.255c.241.142.241.195.241.818v2.51a.425.425 0 0 1-.26.387.409.409 0 0 1-.159.03H10.76a.331.331 0 0 1-.238-.097.342.342 0 0 1-.1-.24V8.452a.962.962 0 0 0-.945-.925Z"
      fill="currentColor"
    />
  </svg>
);

export const IconStoryAd = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22.01 21.997" {...props}>
      <path
        d="M18756.637,16365.118a10.673,10.673,0,0,1-4.941-1.22,1.27,1.27,0,0,1-.527-1.691,1.126,1.126,0,0,1-.311.235v.142l-.584,0a1.273,1.273,0,0,1-.867-.344,10.449,10.449,0,0,1-2.99-5.139,1.266,1.266,0,0,1,2.459-.607,7.927,7.927,0,0,0,2.27,3.9.831.831,0,1,0,.781,1.173,1.224,1.224,0,0,1,.961.094,8.062,8.062,0,0,0,5.586.726,1.265,1.265,0,0,1,.957.155,1.266,1.266,0,0,1-.377,2.3,10.639,10.639,0,0,1-2.369.269Zm4.762-1.3a1.263,1.263,0,0,1-.654-2.346,7.97,7.97,0,0,0-4.074-14.822,1.262,1.262,0,1,1-.01-2.524,10.5,10.5,0,0,1,5.383,19.513,1.21,1.21,0,0,1-.641.18Zm-6.734-13.192,2.73,1.822,3.27,2.176-6,4Zm-7.24,4.342h-.066a1.274,1.274,0,0,1-1.191-1.38,10.626,10.626,0,0,1,.928-3.391,1.267,1.267,0,0,1,2.3,1.068,7.9,7.9,0,0,0-.707,2.563,1.261,1.261,0,0,1-1.256,1.14Zm2.883-5.8a1.269,1.269,0,0,1-.891-.367,1.253,1.253,0,0,1-.371-.895,1.272,1.272,0,0,1,.287-.8l.2-.235a1.272,1.272,0,0,1,.9-.415,1.221,1.221,0,0,1,.9.344,1.277,1.277,0,0,1,.121,1.715l-.187.212a1.248,1.248,0,0,1-.957.442Z"
        transform="translate(-18745.654 -16343.621)"
        fill="currentColor"
      />
    </svg>
  );
};

export const IconEnlargeImage = (props) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28">
      <circle cx="14" cy="14" r="14" opacity="0.8" />
      <path
        d="M4.147,2.557,7.011,5.421,8.284,4.147,4.147,0,0,4.147,1.283,5.421Zm0,11.148L1.283,10.841.009,12.115l4.138,4.147,4.147-4.147L7.011,10.841Z"
        transform="translate(16.867 5.369) rotate(45)"
        fill="#fff"
      />
    </svg>
  );
};

export const IconStoryAdCredits = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M14.632 19.55a1.193 1.193 0 0 0-.907-.149 7.675 7.675 0 0 1-5.32-.691 1.193 1.193 0 0 0-.918-.09c-.25.08-.466.243-.612.461a1.191 1.191 0 0 0-.13-1.575 7.556 7.556 0 0 1-2.163-3.717 1.199 1.199 0 0 0-1.46-.88 1.209 1.209 0 0 0-.883 1.458 9.954 9.954 0 0 0 2.85 4.893c.224.212.52.33.828.33l.55-.007v-.132c.11-.059.21-.134.297-.224a1.204 1.204 0 0 0 .504 1.607 10.101 10.101 0 0 0 4.702 1.162h.044c.76 0 1.516-.085 2.256-.255a1.203 1.203 0 0 0 .362-2.19ZM3.14 12.328h.067a1.201 1.201 0 0 0 1.199-1.084 7.52 7.52 0 0 1 .673-2.443 1.207 1.207 0 0 0-1.91-1.395 1.182 1.182 0 0 0-.277.38 9.89 9.89 0 0 0-.885 3.225 1.213 1.213 0 0 0 1.134 1.317Zm2.807-5.521h.003a1.197 1.197 0 0 0 .913-.42l.178-.205a1.212 1.212 0 0 0-.115-1.63 1.143 1.143 0 0 0-.863-.328 1.212 1.212 0 0 0-.856.392l-.19.224a1.211 1.211 0 0 0-.182 1.225 1.196 1.196 0 0 0 .652.651c.146.06.302.091.46.09ZM19.061 4.92A9.939 9.939 0 0 0 11.996 2a1.209 1.209 0 0 0-1.126 1.67 1.198 1.198 0 0 0 1.137.736 7.628 7.628 0 0 1 6.526 3.71 7.597 7.597 0 0 1-2.644 10.406 1.206 1.206 0 0 0-.586 1.035 1.205 1.205 0 0 0 1.205 1.2h.005a1.19 1.19 0 0 0 .612-.172A10.046 10.046 0 0 0 22 11.986a9.93 9.93 0 0 0-2.94-7.066Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SideMenuDashboard = (props) => {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" {...props}>
      <g transform="translate(0.407 0.407)">
        <path
          d="M14.343,1.75H4.123A2.375,2.375,0,0,0,1.75,4.123V14.343a2.375,2.375,0,0,0,2.373,2.373H14.343a2.375,2.375,0,0,0,2.373-2.373V4.123A2.375,2.375,0,0,0,14.343,1.75ZM4.123,3.575H14.343a.548.548,0,0,1,.548.548V6.13H3.575V4.123A.548.548,0,0,1,4.123,3.575ZM3.575,14.343V7.955H6.13v6.935H4.123A.548.548,0,0,1,3.575,14.343Zm10.768.548H7.955V7.955h6.935v6.388A.549.549,0,0,1,14.343,14.891Z"
          transform="translate(0.36 0.36)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const SideMenuPostList = (props) => {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" {...props}>
      <g transform="translate(0.407 0.407)">
        <path
          d="M16.836,1V3.407h2.407v1.6H16.836V7.418h-1.6V5.011H12.824v-1.6h2.407V1Zm-6.418,9.627a1.6,1.6,0,1,1,1.6-1.6A1.609,1.609,0,0,1,10.418,10.627Zm.8-7.974v1.62a5.239,5.239,0,0,0-.8-.064A4.776,4.776,0,0,0,5.6,9.183c0,1.877,1.564,4.364,4.813,7.332,3.249-2.968,4.813-5.447,4.813-7.332v-.16h1.6v.16q0,4-6.418,9.466Q4,13.174,4,9.183A6.381,6.381,0,0,1,10.418,2.6a6.628,6.628,0,0,1,.8.048Z"
          transform="translate(-1.529 -0.233)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const SideMenuProperty = (props) => {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" {...props}>
      <g transform="translate(-0.343 -0.343)">
        <path
          d="M15.514,5.949v4.692H14.063V5.949L10.434,3.423,6.806,5.949V7.032H5.354V5.949a1.4,1.4,0,0,1,.581-1.155L9.563,2.2a1.422,1.422,0,0,1,1.669,0l3.629,2.6A1.385,1.385,0,0,1,15.514,5.949Zm-1.451,6.136H12.611a2.113,2.113,0,0,0-1.379-1.949L6.806,8.476H2.016A.989.989,0,0,0,1,9.486v5.847a1.009,1.009,0,0,0,1.016,1.083h2.25a1.009,1.009,0,0,0,1.089-1.011h0l4.79,1.3a.805.805,0,0,0,.581,0l5.515-1.732V14.25A2.133,2.133,0,0,0,14.063,12.085ZM2.451,14.972V9.919H3.9v5.053Zm7.983.289-5.08-1.371V9.919H6.515l4.209,1.588a.717.717,0,0,1,.435.577s-1.451-.072-1.669-.072l-1.742-.577-.435,1.371,1.742.577a3.023,3.023,0,0,0,1.161.217h3.846a.7.7,0,0,1,.653.433Z"
          transform="translate(1.723 1.001)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const SideMenuQuota = (props) => {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" {...props}>
      <g transform="translate(-0.343 -0.343)">
        <path
          d="M11.179,4A5.817,5.817,0,1,0,17,9.817,5.815,5.815,0,0,0,11.179,4Zm0,10.179a4.362,4.362,0,1,1,4.362-4.362A4.366,4.366,0,0,1,11.179,14.179ZM2.454,9.817a4.353,4.353,0,0,1,2.5-3.938.69.69,0,0,0,.413-.617V5.13a.672.672,0,0,0-.963-.6A5.811,5.811,0,0,0,4.4,15.1a.672.672,0,0,0,.963-.6v-.132a.69.69,0,0,0-.413-.617A4.353,4.353,0,0,1,2.454,9.817Z"
          transform="translate(1.345 0.526)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const SideMenuAgency = (props) => {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" {...props}>
      <g transform="translate(-0.152 -0.154)">
        <path
          d="M20629.537,21052.744v-1.311a1.8,1.8,0,0,0-1.348-1.738.818.818,0,0,1,.408-1.584,3.431,3.431,0,0,1,2.572,3.322v1.311a.816.816,0,0,1-1.633,0Zm-3.926,0v-1.307a1.8,1.8,0,0,0-1.8-1.8h-5.23a1.8,1.8,0,0,0-1.8,1.8v1.307a.818.818,0,0,1-1.637,0v-1.307a3.437,3.437,0,0,1,3.434-3.434h5.23a3.438,3.438,0,0,1,3.436,3.434v1.307a.819.819,0,0,1-1.639,0Zm-7.846-9.152a3.435,3.435,0,1,1,3.434,3.43A3.437,3.437,0,0,1,20617.766,21043.588Zm1.639,0a1.8,1.8,0,1,0,1.795-1.8A1.8,1.8,0,0,0,20619.4,21043.588Zm5.584,2.736a.813.813,0,0,1,.586-.992,1.8,1.8,0,0,0,0-3.482.819.819,0,0,1,.408-1.586,3.434,3.434,0,0,1,0,6.652.957.957,0,0,1-.207.027A.815.815,0,0,1,20624.988,21046.324Z"
          transform="translate(-20613.01 -21036.703)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const SideMenuInbox = (props) => {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" {...props}>
      <g transform="translate(-0.152 -0.154)">
        <path
          d="M14.531,2.8H3.089A2.259,2.259,0,0,0,.8,5.089V13.67a2.3,2.3,0,0,0,2.289,2.289H14.531A2.3,2.3,0,0,0,16.82,13.67V5.089A2.259,2.259,0,0,0,14.531,2.8ZM3.089,4.516H14.531a.546.546,0,0,1,.358.143L8.81,8.95,2.731,4.659A.546.546,0,0,1,3.089,4.516Zm11.443,9.726H3.089a.564.564,0,0,1-.572-.572V6.8l5.721,4a.681.681,0,0,0,.5.143,1.326,1.326,0,0,0,.5-.143l5.721-4V13.67C15.1,13.956,14.817,14.243,14.531,14.243Z"
          transform="translate(1.343 0.773)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const SideMenuReports = (props) => {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" {...props}>
      <g transform="translate(-0.152 -0.154)">
        <path
          d="M8.242,15.753A7.5,7.5,0,0,1,5.252,1.374.834.834,0,1,1,5.919,2.9a5.836,5.836,0,1,0,7.709,7.621.834.834,0,1,1,1.535.65A7.516,7.516,0,0,1,8.242,15.753Zm7.515-7.5a7.512,7.512,0,0,0-7.5-7.5.834.834,0,0,0-.834.834v6.67a.834.834,0,0,0,.834.834h6.67A.834.834,0,0,0,15.756,8.253ZM9.087,2.477A5.85,5.85,0,0,1,14.03,7.42H9.087Z"
          transform="translate(1.9 1.901)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const SideMenuUser = (props) => {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" {...props}>
      <g id="ic_account" transform="translate(1.029 1.357)">
        <path
          d="M20624.7,20915.518v-1.338a1.873,1.873,0,0,0-1.879-1.879h-5.365a1.873,1.873,0,0,0-1.879,1.879v1.338a.8.8,0,1,1-1.605,0v-1.338a3.5,3.5,0,0,1,3.484-3.49h5.365a3.509,3.509,0,0,1,3.49,3.49v1.338a.776.776,0,0,1-.8.809A.819.819,0,0,1,20624.7,20915.518Zm-8.047-9.385a3.485,3.485,0,1,1,3.486,3.484A3.508,3.508,0,0,1,20616.654,20906.133Zm1.605,0a1.88,1.88,0,0,0,3.76,0,1.88,1.88,0,0,0-3.76,0Z"
          transform="translate(-20611.17 -20900.842)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const SideMenuSetting = (props) => {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" {...props}>
      <g transform="translate(-0.152 -0.154)">
        <path
          d="M3.527,4.078v-1.1a.332.332,0,0,1,.331-.331h1.1a.332.332,0,0,1,.331.331v1.1a.332.332,0,0,1-.331.331h-1.1A.332.332,0,0,1,3.527,4.078Zm3.857.331h1.1a.332.332,0,0,0,.331-.331v-1.1a.332.332,0,0,0-.331-.331h-1.1a.332.332,0,0,0-.331.331v1.1A.332.332,0,0,0,7.384,4.408ZM3.857,7.053h1.1a.332.332,0,0,0,.331-.331V5.62a.332.332,0,0,0-.331-.331h-1.1a.332.332,0,0,0-.331.331v1.1A.332.332,0,0,0,3.857,7.053Zm3.527,0h1.1a.332.332,0,0,0,.331-.331V5.62a.332.332,0,0,0-.331-.331h-1.1a.332.332,0,0,0-.331.331v1.1A.332.332,0,0,0,7.384,7.053ZM5.29,9.367v-1.1a.332.332,0,0,0-.331-.331h-1.1a.332.332,0,0,0-.331.331v1.1a.332.332,0,0,0,.331.331h1.1A.332.332,0,0,0,5.29,9.367ZM7.384,9.7h1.1a.332.332,0,0,0,.331-.331v-1.1a.332.332,0,0,0-.331-.331h-1.1a.332.332,0,0,0-.331.331v1.1A.332.332,0,0,0,7.384,9.7Zm4.959,3.416v.992H0v-.992a.332.332,0,0,1,.331-.331H.868V.661A.66.66,0,0,1,1.529,0h9.285a.66.66,0,0,1,.661.661V12.784h.537A.332.332,0,0,1,12.343,13.114ZM2.19,12.756h3.1V10.91a.332.332,0,0,1,.331-.331h1.1a.332.332,0,0,1,.331.331v1.846h3.1V1.35L2.2,1.322Z"
          transform="translate(3.981 3.099)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const SideMenuPropShop = (props) => {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" {...props}>
      <g transform="translate(-0.152 -0.154)">
        <path
          d="M14.881,4.713H13.4a3.713,3.713,0,0,0-7.426,0H4.485A1.49,1.49,0,0,0,3,6.2v8.911a1.49,1.49,0,0,0,1.485,1.485h10.4a1.49,1.49,0,0,0,1.485-1.485V6.2A1.49,1.49,0,0,0,14.881,4.713Zm-5.2-2.228a2.225,2.225,0,0,1,2.228,2.228H7.455A2.225,2.225,0,0,1,9.683,2.485Zm5.2,12.624H4.485V6.2h10.4Zm-5.2-5.941A2.225,2.225,0,0,1,7.455,6.941H5.97a3.713,3.713,0,0,0,7.426,0H11.911A2.225,2.225,0,0,1,9.683,9.168Z"
          transform="translate(0.469 1.46)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const IconSwitch = (props) => {
  return (
    <svg width={props.size || '12px'} height={props.size || '12px'} viewBox="0 0 15.486 15.486" {...props}>
      <path
        d="M13644.452,21314.986a2.518,2.518,0,0,1-2.515-2.52v-8.9a2.523,2.523,0,0,1,2.515-2.52h4.819a.775.775,0,1,1,0,1.551h-4.819a.969.969,0,0,0-.969.969v8.906a.967.967,0,0,0,.969.963h8.906a.967.967,0,0,0,.969-.963v-5.547a.773.773,0,1,1,1.546,0v5.547a2.513,2.513,0,0,1-2.515,2.514Zm3.905-6.424a.775.775,0,0,1,0-1.092l6.424-6.424H13652a.773.773,0,1,1,0-1.547h4.644a.773.773,0,0,1,.775.771v4.648a.775.775,0,0,1-1.551,0v-2.777l-6.419,6.42a.772.772,0,0,1-1.1,0Z"
        transform="translate(-13641.938 -21299.5)"
        fill={props.color || 'currentColor'}
      />
    </svg>
  );
};

export const IconPropertyPosted = (props) => {
  return (
    <svg width={props.size || 62} height={props.size || 62} viewBox="0 0 62 62" {...props}>
      <mask
        id="prefix__a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={62}
        height={62}
      >
        <path
          d="M31 62c17.12 0 31-13.88 31-31C62 13.88 48.12 0 31 0 13.88 0 0 13.88 0 31c0 17.12 13.88 31 31 31z"
          fill="url(#prefix__prefix__Frame__a)"
        />
      </mask>
      <g mask="url(#prefix__a)">
        <path
          d="M31 62c17.12 0 31-13.88 31-31C62 13.88 48.12 0 31 0 13.88 0 0 13.88 0 31c0 17.12 13.88 31 31 31z"
          fill="url(#prefix__prefix__Frame__c)"
        />
        <path opacity={0.7} d="M20.961 2.657h-6.51v12.84h6.51V2.658z" fill="url(#prefix__prefix__Frame__d)" />
        <path d="M20.782 2.835h-6.154v12.664h6.154V2.835z" fill="#7ED8AA" />
        <path
          opacity={0.7}
          d="M50.61 62.807H10.934V14.612l20.011-.442 19.665.442v48.195z"
          fill="url(#prefix__prefix__Frame__e)"
        />
        <path d="M50.173 62.807H11.55V14.823L30.862 1.249l19.311 13.574v47.984z" fill="#fff" />
        <path
          d="M35.695 46.622H26.02v16.181h9.675v-16.18zM52.74 19.136L30.913 2.356 9.789 19.126 8.13 17.062 30.888-1l23.479 18.051-1.626 2.085z"
          fill="#7ED8AA"
        />
        <path d="M33.14 56.003a1.287 1.287 0 100-2.573 1.287 1.287 0 000 2.573z" fill="#fff" />
        <path
          d="M31.164 41.743c7.297 0 13.213-5.915 13.213-13.213 0-7.297-5.916-13.213-13.213-13.213-7.298 0-13.214 5.916-13.214 13.213 0 7.298 5.916 13.213 13.214 13.213z"
          fill="#E7F3EF"
        />
        <path
          d="M28.62 34.013l-5.03-5.03a.774.774 0 010-1.093l1.095-1.095a.774.774 0 011.094 0l3.387 3.388 7.256-7.256a.774.774 0 011.094 0l1.094 1.095a.774.774 0 010 1.093l-8.897 8.898a.773.773 0 01-1.093 0z"
          fill="#7ED8AA"
        />
      </g>
      <defs>
        <linearGradient
          id="prefix__prefix__Frame__a"
          x1={30.256}
          y1={20.274}
          x2={31}
          y2={62}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E7F3EF" />
          <stop offset={1} stopColor="#93D5AD" />
        </linearGradient>
        <linearGradient
          id="prefix__prefix__Frame__c"
          x1={30.256}
          y1={20.274}
          x2={31}
          y2={62}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E7F3EF" />
          <stop offset={1} stopColor="#93D5AD" />
        </linearGradient>
        <linearGradient
          id="prefix__prefix__Frame__d"
          x1={17.706}
          y1={15.498}
          x2={17.706}
          y2={2.657}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.251} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.122} />
          <stop offset={1} stopColor="gray" stopOpacity={0.102} />
        </linearGradient>
        <linearGradient
          id="prefix__prefix__Frame__e"
          x1={30.772}
          y1={62.807}
          x2={30.772}
          y2={14.17}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.251} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.122} />
          <stop offset={1} stopColor="gray" stopOpacity={0.102} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const IconAdSubmit = (props) => {
  return (
    <svg width="68" height="68" viewBox="0 0 68 68" {...props}>
      <g transform="translate(-124.804 -58.07)">
        <path
          d="M32.15,0A32.15,32.15,0,1,0,64.3,32.15,32.18,32.18,0,0,0,32.15,0Z"
          transform="translate(126.795 59.779)"
          fill="#ffa900"
          fillRule="evenodd"
          opacity="0.107"
        />
        <path
          d="M23.124,0A23.124,23.124,0,1,0,46.248,23.124,23.145,23.145,0,0,0,23.124,0Z"
          transform="translate(135.821 68.805)"
          fill="#ffa900"
          fillRule="evenodd"
          opacity="0.107"
        />
        <path
          d="M24.831,20.033,15.618,5.266a2.492,2.492,0,0,0-4.237-.007L2.154,20.05a2.492,2.492,0,0,0,2.127,3.727H22.714a2.493,2.493,0,0,0,2.117-3.744ZM13.5,20.555a1.021,1.021,0,1,1,.908-.543,1.021,1.021,0,0,1-.908.543Zm.977-7.854-.293,3.37a2.652,2.652,0,0,1-.205.922A.583.583,0,0,1,12.95,17a3.1,3.1,0,0,1-.2-.947l-.219-3.274c-.043-.659-.268-1.723.235-2.259.383-.412,1.289-.483,1.564.088A4.012,4.012,0,0,1,14.48,12.7Z"
          transform="translate(145.448 76.486)"
          fill="#ffa900"
        />
      </g>
    </svg>
  );
};

export const IconZoneFactor = (props) => {
  return (
    <svg width={props.size || '16px'} height={props.size || '16px'} viewBox="0 0 16 16">
      <g fill="#e4f3fc" stroke="rgba(0,0,0,0)" strokeWidth="1">
        <rect width="16" height="16" rx="8" stroke="none" />
        <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="none" />
      </g>
      <path
        d="M6.94,13.94,6,13l4-4,4,4-.94.94L10,10.887,6.94,13.94m0-4L6,9l4-4,4,4-.94.94L10,6.887Z"
        transform="translate(-2 -1.666)"
        fill="#0793ea"
      />
    </svg>
  );
};

export const IconGraph = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20">
      <path
        d="M8.242,15.753A7.5,7.5,0,0,1,5.252,1.374.834.834,0,1,1,5.919,2.9a5.836,5.836,0,1,0,7.709,7.621.834.834,0,1,1,1.535.65A7.516,7.516,0,0,1,8.242,15.753Zm7.515-7.5a7.512,7.512,0,0,0-7.5-7.5.834.834,0,0,0-.834.834v6.67a.834.834,0,0,0,.834.834h6.67A.834.834,0,0,0,15.756,8.253ZM9.087,2.477A5.85,5.85,0,0,1,14.03,7.42H9.087Z"
        transform="translate(1.747 1.748)"
        fill="#bdbdbd"
      />
    </svg>
  );
};

export const IconAreaSize = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="m13.453 20 1.045-2.764.529.854 4.782-3.001-.58-.93H22l-1.046 2.764-.507-.811-4.782 3.001.554.887h-2.766Zm-5.67 0 .58-.93-4.782-3.009-.535.862L2 14.159h2.775l-.554.88 4.782 3 .507-.803L10.557 20H7.784Zm3.73-3.719-8.62-5.187a.96.96 0 0 1-.345-.35.986.986 0 0 1 .332-1.32l8.629-5.283A.938.938 0 0 1 12 4c.174 0 .344.05.493.141l8.63 5.283a.96.96 0 0 1 .342.354.984.984 0 0 1-.342 1.316l-8.63 5.187a.936.936 0 0 1-.973 0h-.007Zm-6.739-6.028 7.227 4.345 7.226-4.345-7.226-4.429-7.227 4.429Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  );
};

export const IconInstAvb = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M7.78 13.31a2.686 2.686 0 0 0 2.531 2.814 2.686 2.686 0 0 0 2.531-2.813 2.686 2.686 0 0 0-2.531-2.812A2.686 2.686 0 0 0 7.78 13.31Zm3.938 0A1.568 1.568 0 0 1 10.312 15a1.568 1.568 0 0 1-1.406-1.688 1.568 1.568 0 0 1 1.406-1.687 1.568 1.568 0 0 1 1.406 1.687Zm9.281-.983a2.672 2.672 0 0 0-2.531-2.665v-.851a.563.563 0 0 0-.562-.562H16.5V6.562A.563.563 0 0 0 15.937 6H3.562A.563.563 0 0 0 3 6.563v.563a.562.562 0 1 0 1.124 0h11.25v1.126H3.562A.563.563 0 0 0 3 8.815v9a.563.563 0 0 0 .562.563h10.687a.562.562 0 1 0 .001-1.125H6.887a3.378 3.378 0 0 0-2.762-2.761V12.14a3.377 3.377 0 0 0 2.762-2.762h7.7c.045.271.122.536.231.788a.56.56 0 0 0 .739.294.563.563 0 0 0 .295-.74v-.004a2.258 2.258 0 0 1-.112-.338h1.613v.472a2.666 2.666 0 0 0-1.467 3.539 2.676 2.676 0 1 0 3.778 1.259 2.67 2.67 0 0 0 1.335-2.321ZM5.738 17.249H4.124v-1.613a2.254 2.254 0 0 1 1.614 1.613Zm-1.614-6.261V9.374h1.614a2.254 2.254 0 0 1-1.614 1.613Zm13.807 6.082c-.224.12-.475.181-.729.18a1.544 1.544 0 0 1-.662-2.942 2.658 2.658 0 0 0 2.029.679 1.54 1.54 0 0 1-.638 2.082Zm.4-3.2a1.547 1.547 0 1 1 1.43-.953 1.547 1.547 0 0 1-1.434.957l.004-.004Zm-3.516-.563a.562.562 0 1 1-.166-.394.562.562 0 0 1 .162.398l.004-.004Zm-7.875 0a.561.561 0 1 1-.165-.394.564.564 0 0 1 .162.398l.003-.004Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  );
};

export const IconAdvAmount = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="m10.552 21.462-7-6.928a1.856 1.856 0 0 1 0-2.643l.63-.624 1.166 1.16-.793.784 7.332 7.262 6.919-6.845.559-7.822-4.336.31-1.545-1.53 5.493-.39a1.896 1.896 0 0 1 1.56.638c.328.374.493.862.459 1.357l-.547 7.464a1.83 1.83 0 0 1-.547 1.188l-6.674 6.611a1.886 1.886 0 0 1-1.337.546 1.886 1.886 0 0 1-1.339-.538Zm-1.065-7.803L5.019 9.231a.42.42 0 0 1-.093-.458.42.42 0 0 1 .093-.136l.881-.872a.43.43 0 0 1 .606 0l2.358 2.333V3.424A.434.434 0 0 1 9.29 3h1.244a.434.434 0 0 1 .426.424v6.57l2.065-2.044a.43.43 0 0 1 .606 0l.882.872a.425.425 0 0 1 0 .601l-4.282 4.234a.505.505 0 0 1-.368.153.532.532 0 0 1-.379-.155l.003.004Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  );
};

export const IconMonthlyInstal = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M5.752 20.99a2.554 2.554 0 0 1-1.864-.644A2.683 2.683 0 0 1 3 18.548V8.358c.055-.695.375-1.34.89-1.796a2.552 2.552 0 0 1 1.862-.641h3.856v1.968H5.752c-.497 0-.826.282-.826.469v3.461h2.2c-.007.008-.027.017-.033.028l-.807.823a1.211 1.211 0 0 0-.337.84.956.956 0 0 0 .054.277H4.927v4.766c0 .191.329.469.826.469h12.5c.498 0 .828-.278.828-.47v-4.76h-.996a1.205 1.205 0 0 0-.322-.938l-.8-.822a1.13 1.13 0 0 0-.296-.208h2.415V8.363c0-.188-.33-.47-.827-.47H14.8V5.927h3.455a2.544 2.544 0 0 1 1.86.64c.513.457.831 1.102.885 1.797v10.19a2.678 2.678 0 0 1-.884 1.798 2.546 2.546 0 0 1-1.861.643L5.752 20.99Zm5.994-2.996-4.093-4.2a.403.403 0 0 1-.116-.284.402.402 0 0 1 .116-.287l.807-.827a.388.388 0 0 1 .552 0l2.165 2.213V3.393a.397.397 0 0 1 .241-.364.378.378 0 0 1 .15-.028h1.137a.378.378 0 0 1 .275.113.393.393 0 0 1 .115.28V14.52l1.897-1.945a.38.38 0 0 1 .552 0l.807.828a.4.4 0 0 1 .086.435.4.4 0 0 1-.086.13l-3.922 4.021a.457.457 0 0 1-.679 0l-.004.005Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  );
};

export const IconAddCircle = (props) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14">
      <g transform="translate(-20 -16)">
        <circle cx="7" cy="7" r="7" transform="translate(20 16)" fill="#e7f3ef" />
        <path
          d="M-.669-.646V-7.368H.669V-.646Zm-2.69-2.695V-4.678H3.363v1.337Z"
          transform="translate(27 27)"
          fill="#00a651"
        />
      </g>
    </svg>
  );
};

export const IconRemoveCircle = (props) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14">
      <g transform="translate(-20 -16)">
        <circle cx="7" cy="7" r="7" transform="translate(20 16)" fill="#fceaea" />
        <path d="M-3.358-3.341V-4.678H3.363v1.337Z" transform="translate(27 27)" fill="#e83a3a" />
      </g>
    </svg>
  );
};

export const EmptyListingWidget = (props) => {
  return (
    <svg width={518.97} height={89.03} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M315.239 11.407l4.323-4.323-.073 3.281a.948.948 0 00.916.915.845.845 0 00.873-.815v-.057l.081-5.5a.87.87 0 00-.269-.635l-.009-.01a.876.876 0 00-.636-.269l-5.5.083a.842.842 0 00-.872.872.944.944 0 00.915.916l3.28-.076-4.323 4.324a.897.897 0 00.028 1.265.884.884 0 001.251.042l.015-.013zM304.884.956H156.281v13.673h148.603V.956zM87.037 1.76H30.284v13.673h56.753V1.76zm29.074 43.86H18.229v10.581h97.882V45.62zM65.425 64.422H0v21.453h65.425V64.422zm148.554 0h-46.653v21.453h46.653V64.422zm11.508-18.802h-40.692v10.581h40.692V45.62zm96.191 18.802h-46.653v21.453h46.653V64.422zm14.176-18.802h-40.692v10.581h40.692V45.62zm81.239 18.802h-27.581v21.453h27.581V64.422zm38.286-18.802h-44.928v10.581h44.928V45.62zm46.61 18.802h-21.453v21.453h21.453V64.422zm16.986-18.802h-18.318v10.581h18.318V45.62z"
        opacity={0.1}
        style={{ fill: 'currentcolor' }}
      />
      <g opacity={0.5} style={{ fill: '#7690BF' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.095 4.403V1.945h-3.44L10.936 0 3.664 5.242v3.467l1.122-.834v5.939h2.46a1.386 1.386 0 01.1-1.19l2.857-4.986-2.633.676a1.3 1.3 0 01-.624-2.5l5.579-1.387h.3c.077-.007.155-.007.232 0h.023c.058.009.116.022.172.04.124.027.242.073.352.136a1.4 1.4 0 01.515 1.906v.006l-2.727 4.7 2.924-.746a1.292 1.292 0 011.609 1.42 1.29 1.29 0 01-.949 1.075l-.033.009-3.309.847h5.469V7.879l1.133.838V5.246l-1.141-.843z"
        />
        <path d="M280.089 56.018h-1.87a.65.65 0 01-.647-.648v-5.165l3.119-2.495a.639.639 0 01.809 0l3.118 2.495v1.434l1.007 1.007v-1.641l.908.726.629-.786-5.034-4.028a1.64 1.64 0 00-2.066 0l-5.037 4.031.629.787.908-.726v4.36a1.66 1.66 0 001.022 1.53c.201.082.417.125.634.125h1.87l.001-1.006z" />
        <path d="M283.54 53.624a1.7 1.7 0 00-.871.243l-.387-.386.558-.558-.61-.61-.558.558-.506-.505.846-.845-.611-.611-.845.845-.738-.737-.609.61 2.849 2.849a1.703 1.703 0 00-.243.871 1.726 1.726 0 001.727 1.727 1.725 1.725 0 000-3.451h-.002zm0 2.59a.853.853 0 01-.863-.818.853.853 0 01.091-.424l.392-.392a.85.85 0 01.379-.092.863.863 0 110 1.725l.001.001zm-111.031.189h-1.914a.666.666 0 01-.663-.67v-5.346l3.195-2.584a.654.654 0 01.828 0l3.2 2.584v.806l1.031 1.042v-1.017l.929.752.645-.814-5.156-4.17a1.669 1.669 0 00-2.116 0l-5.157 4.17.645.814.93-.752v4.513a1.698 1.698 0 001.694 1.712h1.914l-.005-1.04z" />
        <path d="M175.27 57.445l-3.245-3.24.011-3.099 3.062-.012 3.249 3.239-3.077 3.112zm-2.363-3.61l2.356 2.35 1.824-1.844-2.353-2.35-1.82.008-.007 1.836z" />
        <path d="M173.943 53.486a.485.485 0 00.483-.488.485.485 0 00-.483-.488.485.485 0 00-.483.488c0 .27.216.488.483.488zm-168.35-8.91a3.962 3.962 0 00-3.964 3.959v.006c0 2.972 3.964 7.361 3.964 7.361s3.964-4.389 3.964-7.361a3.963 3.963 0 00-3.959-3.965h-.005zM2.762 48.54a2.833 2.833 0 115.663 0c0 1.631-1.631 4.072-2.831 5.595-1.179-1.512-2.832-3.982-2.832-5.595z" />
        <path d="M5.593 49.957a1.416 1.416 0 100-2.832 1.416 1.416 0 000 2.832z" />
        <path
          opacity={0.4}
          d="M396.719 57.845a4.357 4.357 0 01-4.353-4.352 4.438 4.438 0 012.174-3.8l.678-.4-.1.777a1.39 1.39 0 00.227.95c.06-1.23.421-3.465 2.177-4.477l.576-.332v.665a4.196 4.196 0 001.308 2.763 5.693 5.693 0 011.669 3.853 4.356 4.356 0 01-4.356 4.353z"
        />
        <path d="M397.415 49.998c-1.58.91-1.391 3.477-1.391 3.477a1.234 1.234 0 01-.7-1.275 2.83 2.83 0 00-1.391 2.433 2.783 2.783 0 002.781 2.78 2.782 2.782 0 002.781-2.78c0-2.261-2.086-2.722-2.086-4.635h.006zm91.038-5.18c-2.339 1.348-2.059 5.147-2.059 5.147a1.827 1.827 0 01-1.029-1.886 4.178 4.178 0 00-2.059 3.6 4.117 4.117 0 008.234 0c0-3.349-3.088-4.032-3.088-6.863l.001.002z" />
      </g>
    </svg>
  );
};

export const NoRecord = (props) => {
  return (
    <svg width={130} height={122} viewBox="0 0 130 122" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M65 122c33.69 0 61-27.31 61-61S98.69 0 65 0 4 27.31 4 61s27.31 61 61 61z" fill="url(#emptyListing__a)" />
      <path d="M112.601 83.766H17.4V112h95.201V83.766z" fill="#F5F5F5" />
      <path d="M70.553 89.601H59.448V112h11.105V89.601z" fill="#E6E6E6" />
      <path d="M107.048 50.749H22.953v25.975h84.095V50.749z" fill="#F5F5F5" />
      <path
        d="M115.578 52.669H14.422a.847.847 0 01-.587-1.458l27.646-26.585v-11.58a.848.848 0 01.847-.847h5.456a.848.848 0 01.847.847v4.7l2.088-2.008a18.756 18.756 0 0125.546-.425l39.882 35.879a.848.848 0 01-.566 1.477h-.003z"
        fill="#E6E6E6"
      />
      <path
        d="M45.149 57.339a5.365 5.365 0 015.364 5.365v7.247H39.785v-7.247a5.363 5.363 0 015.364-5.365zm19.852.094a5.365 5.365 0 015.365 5.364v7.247h-10.73v-7.247a5.365 5.365 0 015.365-5.364zm19.85.093a5.363 5.363 0 015.364 5.364v7.247H79.487v-7.248a5.365 5.365 0 015.364-5.363zm7.902 31.792a5.365 5.365 0 015.365 5.365v7.247H87.389v-7.247a5.365 5.365 0 015.364-5.365zm-53.06 0a5.365 5.365 0 015.365 5.365v7.247h-10.73v-7.247a5.365 5.365 0 015.365-5.365z"
        fill="#fff"
      />
      <path
        d="M126.515 84.207l-17.86-7.906a.755.755 0 00-.3-.064h-85.12a.751.751 0 00-.284.055L3.51 84.198a.752.752 0 00.283 1.45h5.044v25.975h-.565v2.635h113.459v-2.635h-.941V85.648h5.42a.752.752 0 00.3-1.441h.005zm-7.23 27.417H10.339V85.648h108.946v25.976zM51.833 68.877H38.092v2.259h13.741v-2.259z"
        fill="#E6E6E6"
      />
      <path d="M71.965 68.877H58.224v2.259h13.741v-2.259z" fill="#CACACA" />
      <path
        d="M92.098 68.877H78.357v2.259h13.741v-2.259zm7.526 32.3H85.883v2.259h13.741v-2.259zm-53.248 0H32.635v2.259h13.741v-2.259z"
        fill="#E6E6E6"
      />
      <path
        d="M96.042 50.381v.445c0 .178-.007.353-.014.531a24.568 24.568 0 01-.247 2.67c-.016.101-.032.227-.051.34-.037.24-.078.48-.125.72-.023.12-.046.24-.071.36-.048.238-.1.477-.157.715l-.014.058c-.028.118-.055.233-.085.351-.009.035-.016.067-.028.1-.021.088-.044.175-.067.263a16.42 16.42 0 01-.1.364 60.414 60.414 0 01-.186.625 21.652 21.652 0 01-.567 1.617 24.336 24.336 0 01-.754 1.744v.01c-.067.142-.138.285-.21.426a.017.017 0 010 .012 16.13 16.13 0 01-.214.413l-.118.224-.014.025c-.148.274-.3.547-.461.816a5.54 5.54 0 00-.1.178c-.031.058-.071.12-.108.178a2.235 2.235 0 01-.076.125l-.148.238-.03.048-.263.406a26.13 26.13 0 01-.332.487l-2.5 4.01-.108-.09-.03-.029-.1-.083-.272-.23-.247.239c-.032.032-.067.062-.1.095l-.074.069a24.154 24.154 0 01-16.141 6.862h-.007a26.364 26.364 0 01-13.419-3.245 25.215 25.215 0 01-1.545-.91h-.007a25.844 25.844 0 01-1.716-1.33 25.355 25.355 0 01-8.977-21.18 22.98 22.98 0 01.238-2.129h49.31a25.234 25.234 0 01.235 3.462z"
        fill="#F0F0F0"
      />
      <path
        d="M95.808 47.22a24.933 24.933 0 00-49.377.461c-.076.553-.133 1.11-.171 1.668h49.748a25.238 25.238 0 00-.2-2.129zM72.77 72.587H58.484V61.159c.264-5.223 4.727-5.645 8.922-5.364a5.365 5.365 0 015.364 5.365v11.427z"
        fill="#BDBDBD"
      />
      <path
        d="M52.714 47.22c-.009.058-.021.115-.03.173.009-.058.021-.115.032-.173h-.002zm-.286 2.129c-.007.088-.014.175-.018.263.005-.087.012-.175.021-.263a.35.35 0 010-.048.13.13 0 010 .048h-.003zm.286-2.129c-.009.058-.021.115-.03.173.009-.058.021-.115.032-.173h-.002zm-.3 2.392c.005-.087.012-.175.021-.263a.32.32 0 010-.048v.048a2.103 2.103 0 00-.021.263zm71.259 42.432a1.643 1.643 0 00-.143-.134l-11.422-9.639-.3-.249-1.123-.948-.281-.238-1.6-1.352-.438-.369-.906-.766-.464-.392-4.373-3.688-2.509-2.118-.337-.284-7.388-6.235c.113-.161.224-.323.332-.487l.263-.406.03-.048c.051-.078.1-.159.148-.238a1.49 1.49 0 00.076-.125c.037-.058.074-.118.109-.178s.069-.118.1-.178c.162-.27.314-.542.461-.817l.014-.025.118-.224c.074-.136.145-.274.214-.413a.017.017 0 000-.012c.072-.141.143-.284.21-.427v-.009c.085-.178.168-.355.249-.537.021-.042.039-.083.058-.125.076-.175.152-.353.226-.53a28.752 28.752 0 00.431-1.107 28.693 28.693 0 00.376-1.121c.058-.189.113-.376.168-.565.035-.122.067-.242.1-.364.023-.088.046-.175.067-.263.012-.035.018-.067.028-.1.03-.118.058-.233.085-.351l.014-.058c.055-.238.108-.477.157-.715l.072-.36a25.811 25.811 0 00.176-1.059l.044-.3a28.076 28.076 0 00.203-2.371c.007-.178.012-.353.014-.53v-.445a25.783 25.783 0 00-.235-3.462 25.384 25.384 0 10-39.803 24.169h.007c.2.138.392.274.591.408.316.208.634.411.955.6l.076.044a24.96 24.96 0 004.062 1.965 25.461 25.461 0 0010.2 1.6h.007a25.318 25.318 0 0011.512-3.407 24.1 24.1 0 001.5-.948c.122-.083.247-.168.367-.254a9.762 9.762 0 00.478-.346l.3-.226a1.278 1.278 0 00.094-.074c.058-.042.113-.088.171-.131.058-.043.113-.09.171-.136a.222.222 0 00.028-.021l.194-.157c.067-.053.132-.108.194-.161l.191-.161c.064-.055.113-.095.168-.145.018-.014.035-.03.053-.046a6.966 6.966 0 00.247-.218l.053-.048c.113-.1.226-.2.337-.309l.078-.072.074-.069c.032-.032.067-.062.1-.095.083-.078.164-.159.247-.24l.272.231.1.083.03.028.108.09 1.61 1.361.035.03.028.021.182.155.365.309.364.307.053.044 1.7 1.43.235.2 1.635 1.379 8.465 7.143.3.249 11.586 9.775 2.971 2.507 1.1.932a2.34 2.34 0 002.586.294 2.338 2.338 0 001.104-1.226 2.325 2.325 0 00-.506-2.503l.001.001zM56.859 38.575a19.017 19.017 0 0129.066 24.528c-.032.037-.065.076-.1.113-.3.36-.625.706-.955 1.036l-.007.009c-.113.113-.228.228-.344.334a14.63 14.63 0 01-.72.653 18.314 18.314 0 01-1.91 1.447c-.263.175-.531.344-.8.5-.134.081-.272.159-.408.235-.136.076-.274.152-.413.224-.139.072-.277.145-.417.214-.279.141-.561.272-.846.394a5.716 5.716 0 01-.429.18c-.09.037-.178.074-.268.106a.868.868 0 01-.108.042c-.049.02-.097.039-.145.055a7.204 7.204 0 01-.348.126c-.145.053-.291.1-.438.148-.147.048-.293.095-.441.136-.148.041-.3.088-.445.127-.145.039-.3.081-.447.115-.147.034-.318.078-.48.113-.141.032-.279.06-.42.085-.141.025-.265.051-.4.074a16.932 16.932 0 01-.983.143 8.73 8.73 0 01-.385.044l-.1.009c-.141.014-.284.025-.424.037-.3.021-.6.035-.9.042h-.459c-.152 0-.3 0-.457-.007a.04.04 0 01-.023 0c-.108 0-.217 0-.323-.012-.078 0-.159 0-.24-.012a7.628 7.628 0 01-.325-.021c-.035 0-.069 0-.1-.007a.35.35 0 01-.048 0c-.111-.009-.224-.018-.335-.03-.055 0-.113-.009-.168-.016a15.172 15.172 0 01-.5-.062 9.74 9.74 0 01-.565-.085 5.135 5.135 0 01-.258-.044c-.113-.019-.226-.04-.339-.062a8.862 8.862 0 01-.353-.074c-.094-.021-.191-.042-.286-.065-.046-.009-.092-.021-.136-.032a15.85 15.85 0 01-.72-.189 15.447 15.447 0 01-1.28-.414c-.078-.03-.154-.055-.233-.085-.079-.03-.143-.053-.212-.081a17.289 17.289 0 01-1.031-.436c-.129-.062-.258-.122-.385-.185a17.344 17.344 0 01-1.839-1.031 14.22 14.22 0 01-.678-.45 16.688 16.688 0 01-.648-.473c-.256-.194-.508-.4-.754-.6l-.351-.3c-.048-.042-.1-.085-.145-.129-.045-.044-.111-.1-.164-.152a8.377 8.377 0 01-.24-.224 9.913 9.913 0 01-.357-.353c-.115-.12-.235-.24-.348-.36-.113-.12-.226-.242-.334-.367-.108-.125-.219-.247-.325-.374-.106-.127-.205-.245-.3-.367a17.293 17.293 0 01-.959-1.305c-.092-.14-.194-.288-.284-.434-.09-.146-.185-.293-.272-.443a20.198 20.198 0 01-1.158-2.293 18.804 18.804 0 01-.835-2.411v-.014a10.87 10.87 0 01-.122-.48 17.699 17.699 0 01-.246-1.153l-.037-.21-.035-.212a16.249 16.249 0 01-.122-.922c-.021-.2-.039-.4-.055-.6-.012-.136-.018-.275-.025-.413-.007-.138-.014-.254-.016-.381a.033.033 0 010-.021v-.152c-.005-.15-.007-.3-.007-.45v-.406a26.6 26.6 0 01.021-.567c0-.042 0-.081.007-.122.007-.041 0-.081.007-.122.005-.087.012-.175.021-.263a.35.35 0 010-.048 15.157 15.157 0 01.092-.9c.014-.1.025-.2.042-.3.009-.069.021-.141.032-.212.011-.071.021-.143.035-.215.016-.095.032-.191.051-.288.009-.058.021-.115.032-.173.044-.23.092-.461.145-.692.053-.233.113-.464.178-.694.065-.23.131-.466.205-.7.035-.118.072-.233.113-.348.076-.233.157-.464.247-.692a21.653 21.653 0 01.422-1.021c.051-.113.1-.226.157-.339.1-.224.212-.448.33-.667.118-.219.235-.443.36-.66.125-.217.254-.434.39-.648.062-.106.131-.215.2-.318.138-.212.284-.424.431-.632.268-.435.584-.848.927-1.249h.002zm-4.426 10.774c-.007.088-.014.175-.018.263.005-.087.012-.175.021-.263a.32.32 0 010-.048c-.002.015-.002.032-.005.048h.002zm.286-2.129c-.009.058-.021.115-.03.173.009-.058.021-.115.032-.173h-.002z"
        fill="#707070"
      />
      <defs>
        <linearGradient id="emptyListing__a" x1={65} y1={0} x2={65} y2={122} gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset={1} stopColor="#F2F2F2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const IconZAMEENNotAllowed = (props) => {
  return (
    <svg width={28} height={28} viewBox="0 0 28 28" fill="none" {...props}>
      <path
        d="M24.385 19.787l-.656-.664a.476.476 0 00-.679 0l-2.132 2.158-2.132-2.158a.476.476 0 00-.68 0l-.655.664a.49.49 0 000 .687l2.132 2.158-2.132 2.158a.49.49 0 000 .686l.656.664a.479.479 0 00.679 0l2.132-2.158 2.132 2.158a.478.478 0 00.679 0l.656-.664a.489.489 0 000-.686l-2.132-2.158 2.132-2.158a.49.49 0 000-.687z"
        fill="#E83A3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.602 14.807l3.456-.871a1.541 1.541 0 011.506.388 1.494 1.494 0 01.378 1.49c-.01.032-.029.059-.042.09.466-.216.953-.38 1.454-.491v-4.5l1.339.978V7.838l-1.339-.978V3.991h-4.065l-3.216-2.27-8.6 6.118v4.048l1.324-.973v6.933h2.912a1.6 1.6 0 01.114-1.39l3.377-5.82-3.113.788a1.529 1.529 0 01-1.849-1.1 1.507 1.507 0 011.09-1.821l.024-.006 6.6-1.619h.351a1.62 1.62 0 01.274 0h.032c.068.011.134.027.2.047.145.032.285.085.415.157a1.633 1.633 0 01.772.994 1.613 1.613 0 01-.171 1.24l-3.223 5.49zm3.573 2.208l-3.286.83h2.467c.25-.297.524-.575.819-.83z"
        fill="#A3A3A3"
      />
    </svg>
  );
};

export const IconOLXNotAllowed = (props) => {
  return (
    <svg width={28} height={28} viewBox="0 0 28 28" fill="none" {...props}>
      <path
        d="M7.887 5.666a5.456 5.456 0 00-.015 10.911h.015a5.455 5.455 0 000-10.911zm.135 7.232a1.777 1.777 0 01-.038-3.553h.038a1.777 1.777 0 010 3.553zm10.924.697c.154-.01.307-.023.462-.023a7.064 7.064 0 011.616.192h.042l1.2-1.2 1.2 1.2h2.119v-2.105l-1.208-1.205 1.208-1.209V7.106h-2.094l-1.222 1.225-1.227-1.229h-2.085v2.127l1.208 1.22-1.208 1.209-.011 1.937zm-1.343.217V3.802h-3.128v11.765a7.093 7.093 0 013.128-1.755z"
        fill="#A3A3A3"
      />
      <path
        d="M22.784 17.95l-.639-.64a.468.468 0 00-.661 0l-2.076 2.076-2.076-2.076a.468.468 0 00-.661 0l-.639.64a.467.467 0 000 .66l2.076 2.076-2.076 2.076a.468.468 0 000 .661l.639.639a.468.468 0 00.661 0l2.076-2.076 2.076 2.076a.468.468 0 00.661 0l.639-.639a.468.468 0 000-.661l-2.076-2.076 2.076-2.076a.467.467 0 000-.66z"
        fill="#E83A3A"
      />
    </svg>
  );
};

export const NetworkError = (props) => {
  return (
    <svg width={props.size || '170px'} height={props.size || '170px'} viewBox="0 0 170 170" fill="none" {...props}>
      <path
        d="M85.838 135.509c30.327 0 54.913-24.586 54.913-54.913 0-30.328-24.586-54.913-54.913-54.913-30.328 0-54.913 24.585-54.913 54.913 0 30.327 24.585 54.913 54.913 54.913z"
        fill="#F9F9F9"
      />
      <path
        d="M55.438 74.19h-6.913a.952.952 0 010-1.903h6.913a.952.952 0 010 1.904zm8.774-8.774a.951.951 0 01-.952-.951v-6.91a.951.951 0 011.903 0v6.914a.951.951 0 01-.951.947zm-6.344 2.431a.947.947 0 01-.673-.278l-4.75-4.749a.952.952 0 011.346-1.346l4.749 4.75a.951.951 0 01-.673 1.624h.001zm56.139 27.755h6.913a.953.953 0 01.952.951.953.953 0 01-.952.952h-6.913a.95.95 0 01-.951-.952.948.948 0 01.951-.951zm-8.774 8.774a.952.952 0 01.951.952v6.913c0 .252-.1.494-.279.672a.947.947 0 01-1.345 0 .947.947 0 01-.279-.672v-6.913a.95.95 0 01.952-.952zm6.343-2.431a.938.938 0 01.673.279l4.749 4.749a.951.951 0 11-1.345 1.346l-4.75-4.748a.954.954 0 01.673-1.625v-.001z"
        fill="#FFA900"
      />
      <path
        d="M155.439 1.594a1.596 1.596 0 01-1.593 1.593H95.857a9.235 9.235 0 00-9.234 9.235v41.871h-3.187V12.422A12.422 12.422 0 0195.856 0h57.986a1.592 1.592 0 011.597 1.594z"
        fill="#046F38"
      />
      <path
        d="M90.208 50.709v-6.35a2.745 2.745 0 00-2.745-2.745h-4.868a2.736 2.736 0 00-2.088.965 2.732 2.732 0 00-.656 1.78v6.35h10.357z"
        fill="#1E814E"
      />
      <path
        d="M95.62 65.51V52.828a3.547 3.547 0 00-3.548-3.547H77.99a3.547 3.547 0 00-3.546 3.547V65.51h21.175z"
        fill="#228652"
      />
      <path d="M74.11 68.302h21.84a1.396 1.396 0 100-2.792H74.11a1.396 1.396 0 100 2.792z" fill="#046F38" />
      <path
        d="M95.62 65.51V52.828a3.547 3.547 0 00-3.548-3.547H77.99a3.547 3.547 0 00-3.546 3.547C89.652 53.884 91.048 65.51 91.048 65.51h4.571z"
        fill="#1E814E"
      />
      <path d="M95.618 64.487H74.441v1.023h21.177v-1.023z" fill="#036734" />
      <path
        d="M95.618 60.148v-7.324a3.548 3.548 0 00-3.547-3.546h-9.887c9.984.007 13.434 10.87 13.434 10.87z"
        fill="#046F38"
      />
      <path d="M90.208 48.617H79.85v.663h10.357v-.663z" fill="#05582E" />
      <path
        d="M90.208 49.28v-4.92a2.745 2.745 0 00-2.745-2.746h-4.868a2.736 2.736 0 00-2.088.965c7.587-.93 8.75 6.7 8.75 6.7l.95.002zM14 168.407a1.594 1.594 0 011.593-1.594h57.99a9.233 9.233 0 009.234-9.234v-41.871h3.187v41.871A12.421 12.421 0 0173.583 170h-57.99A1.592 1.592 0 0114 168.407z"
        fill="#046F38"
      />
      <path
        d="M79.232 119.293v6.349a2.747 2.747 0 002.745 2.745h4.868a2.75 2.75 0 002.088-.964 2.734 2.734 0 00.656-1.781v-6.349H79.232z"
        fill="#1E814E"
      />
      <path
        d="M73.822 104.495v12.683a3.547 3.547 0 003.547 3.547H91.45a3.547 3.547 0 003.547-3.547v-12.683H73.822z"
        fill="#228652"
      />
      <path d="M95.33 101.699H73.491a1.396 1.396 0 100 2.792h21.84a1.396 1.396 0 100-2.792z" fill="#046F38" />
      <path
        d="M73.822 104.495v12.683a3.547 3.547 0 003.547 3.547H91.45a3.547 3.547 0 003.547-3.547c-15.208-1.056-16.604-12.683-16.604-12.683H73.82z"
        fill="#1E814E"
      />
      <path d="M94.999 104.491H73.822v1.023h21.177v-1.023z" fill="#036734" />
      <path
        d="M73.825 109.857v7.322a3.547 3.547 0 003.548 3.547h9.887c-9.988-.006-13.435-10.869-13.435-10.869z"
        fill="#046F38"
      />
      <path d="M89.59 120.722H79.231v.663H89.59v-.663z" fill="#05582E" />
      <path
        d="M79.231 120.722v4.922a2.746 2.746 0 002.745 2.745h4.868a2.725 2.725 0 002.088-.964c-7.586.93-8.75-6.701-8.75-6.701l-.95-.002z"
        fill="#046F38"
      />
      <path
        d="M81.032 101.699h-3.805v-9.101a1.903 1.903 0 013.806 0l-.001 9.101zm8.604-11.003a1.903 1.903 0 011.902 1.903v9.1h-3.804v-9.1a1.903 1.903 0 011.902-1.903z"
        fill="#5D5D5D"
      />
      <path d="M81.032 100.366h-3.805v1.332h3.805v-1.332zm10.506 0h-3.805v1.332h3.805v-1.332z" fill="#242424" />
    </svg>
  );
};

export const IconPossession = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708z" />
    </svg>
  );
};

export const CheckoutSuccessful = (props) => {
  return (
    <svg width="134" height="158.5" viewBox="0 0 134 158.5" {...props}>
      <g transform="translate(-305.126 -271.672)">
        <g transform="translate(305.126 272.172)">
          <ellipse cx="67" cy="67.587" rx="67" ry="67.587" transform="translate(0 6.983)" fill="#e7f3ef" />
          <rect width="82.607" height="105.592" rx="10" transform="translate(25.697 6.017)" fill="#7ed8aa" />
          <path
            d="M1094.045,1247.237h14.522l-11.211-11.309Z"
            transform="translate(-1017.977 -1142.188)"
            fill="#e7f3ef"
          />
          <path
            d="M708.672,401.471v81.164a11.26,11.26,0,0,1-11.211,11.309h0a11.26,11.26,0,0,1-11.211-11.309V469.719H639.07V401.471Z"
            transform="translate(-606.871 -388.895)"
            fill="#fff"
          />
          <rect width="47.18" height="24.225" transform="translate(32.199 80.824)" fill="#fff" />
          <path
            d="M-3194.789-6179.846a11.26,11.26,0,0,1-11.21-11.31v-6.9h67.8v18.208Zm28.871-36.887a22.01,22.01,0,0,1,0-30.934,21.552,21.552,0,0,1,30.667,0,22.01,22.01,0,0,1,0,30.934,21.522,21.522,0,0,1-15.333,6.407A21.522,21.522,0,0,1-3165.918-6216.732Z"
            transform="translate(3217.584 6284.895)"
            fill="#e7f3ef"
          />
          <path
            d="M-3152.464-6200.872l-7.68-7.746a2.641,2.641,0,0,1,0-3.711,2.586,2.586,0,0,1,3.68,0l5.839,5.89,13.181-13.3a2.586,2.586,0,0,1,3.68,0,2.641,2.641,0,0,1,0,3.711l-15.022,15.154a2.583,2.583,0,0,1-1.839.769A2.58,2.58,0,0,1-3152.464-6200.872Zm-47.326-8.382a4.589,4.589,0,0,0-3.079-3.106l-3.133-.94,3.133-.938a4.592,4.592,0,0,0,3.079-3.107l.932-3.159.931,3.159a4.592,4.592,0,0,0,3.079,3.107l3.133.938-3.133.94a4.589,4.589,0,0,0-3.079,3.106l-.931,3.159ZM-3176-6220a2.473,2.473,0,0,0-1.655-1.671l-1.683-.5,1.683-.5a2.473,2.473,0,0,0,1.655-1.671l.5-1.7.5,1.7a2.473,2.473,0,0,0,1.655,1.671l1.683.5-1.683.5A2.473,2.473,0,0,0-3175-6220l-.5,1.7Zm-20.864-10.4a5.734,5.734,0,0,0-3.846-3.879l-3.911-1.174,3.911-1.173a5.733,5.733,0,0,0,3.846-3.879l1.163-3.945,1.163,3.945a5.734,5.734,0,0,0,3.844,3.879l3.912,1.173-3.912,1.174a5.735,5.735,0,0,0-3.844,3.879l-1.163,3.945Zm74.931-2.058a2.466,2.466,0,0,0-1.655-1.671l-1.683-.5,1.683-.5a2.467,2.467,0,0,0,1.655-1.671l.5-1.7.5,1.7a2.473,2.473,0,0,0,1.655,1.671l1.685.5-1.685.5a2.472,2.472,0,0,0-1.655,1.671l-.5,1.7Zm-38.877-13.2a5.95,5.95,0,0,1-5.924-5.976h17.058a6.022,6.022,0,0,1-3.243-5.355,5.991,5.991,0,0,1,5.965-6.017,5.991,5.991,0,0,1,5.963,6.017,6.023,6.023,0,0,1-3.242,5.355h17.057a5.949,5.949,0,0,1-5.923,5.976Z"
            transform="translate(3213.954 6263)"
            fill="#7ed8aa"
            stroke="rgba(0,0,0,0)"
            strokeWidth="1"
          />
        </g>
        <ellipse cx="47.825" cy="4.994" rx="47.825" ry="4.994" transform="translate(324.301 420.184)" fill="#f4f5f7" />
      </g>
    </svg>
  );
};

export const EmptyNoImage = (props) => {
  return (
    <svg width={props.size || '160'} height={props.size || '160'} viewBox="0 0 160 160" fill="none" {...props}>
      <path
        opacity={0.6}
        d="M135.701 129.673H63.823a4.986 4.986 0 01-4.982-4.982v-56.22a4.988 4.988 0 014.982-4.983H135.7a4.986 4.986 0 014.982 4.982v56.222a4.985 4.985 0 01-4.982 4.981z"
        fill="url(#NoImage__a)"
      />
      <path
        d="M107.828 113.215H71.743a.764.764 0 01-.135-.011l17.067-29.562a1.195 1.195 0 012.08 0l11.454 19.838.549.949 5.07 8.786z"
        fill="#fff"
      />
      <path opacity={0.2} d="M107.826 113.213h-12.32l6.048-8.785.435-.633.217-.317.549.949 5.071 8.786z" fill="#000" />
      <path
        d="M127.918 113.213H96.712l6.048-8.785.435-.633 7.881-11.448a1.594 1.594 0 012.367-.142c.041.045.079.092.114.142l14.361 20.866zm-1.46-29.689a5.346 5.346 0 100-10.693 5.346 5.346 0 000 10.693z"
        fill="#fff"
      />
      <path
        d="M112.654 109.19H21.983a2.67 2.67 0 01-2.667-2.667V32.995a2.67 2.67 0 012.667-2.667h90.671a2.67 2.67 0 012.667 2.667v73.528a2.671 2.671 0 01-2.667 2.667z"
        fill="url(#NoImage__b)"
      />
      <path
        d="M77.662 91.092h-46.29a.955.955 0 01-.173-.014l21.893-37.922a1.533 1.533 0 012.668 0l14.693 25.449.7 1.218 6.509 11.269z"
        fill="#fff"
      />
      <path opacity={0.2} d="M77.664 91.092h-15.8l7.758-11.27.559-.812.279-.406.7 1.218 6.504 11.27z" fill="#000" />
      <path
        d="M103.437 91.093H63.399l7.758-11.269.558-.812 10.11-14.686a2.048 2.048 0 013.037-.181c.052.058.101.118.146.182l18.429 26.766z"
        fill="#fff"
      />
      <path d="M100.689 52.233a6.857 6.857 0 100-13.714 6.857 6.857 0 000 13.714z" fill="#00A651" />
      <defs>
        <linearGradient id="NoImage__a" x1={99.762} y1={63.488} x2={99.762} y2={129.673} gradientUnits="userSpaceOnUse">
          <stop stopColor="#E2E2E2" /> <stop offset={1} stopColor="#CCC" />
        </linearGradient>
        <linearGradient id="NoImage__b" x1={67.318} y1={30.328} x2={67.318} y2={109.19} gradientUnits="userSpaceOnUse">
          <stop stopColor="#E2E2E2" /> <stop offset={1} stopColor="#CCC" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const NoImage = (props) => {
  return (
    <svg width={props.size || '130'} height={props.size || '130'} viewBox="0 0 130 130" {...props}>
      <circle cx="69.063" cy="62.992" r="51.982" fill="#f2f2f2" />
      <path
        d="M82.507 100.673a7.25 7.25 0 0 1-5.035 5.294l-43.843 12.738c-3.846 1.117-7.87-1.095-8.987-4.941l-15.4-53.01c-1.117-3.846 1.094-7.869 4.94-8.987l27.42-7.966 16.423-4.771a7.25 7.25 0 0 1 8.987 4.941l15.4 53.009c.352 1.202.384 2.475.095 3.693z"
        fill="#7ed8aa"
      />
      <path
        d="M82.507 100.672l-36.781-2.11a7.25 7.25 0 0 1-6.825-7.655l2.7-47.109 16.423-4.771a7.25 7.25 0 0 1 8.987 4.941l15.4 53.009c.352 1.202.385 2.476.096 3.695z"
        fill="#b2b2b2"
      />
      <circle cx="69.31" cy="62.774" r="34.482" fill="#fff" />
      <path
        d="M84.177 77.287l.451.537q-.089.091-.18.182-.6.6-1.272 1.164-.672.564-1.366 1.053l-.317.218-.107.071-.433-.517-.248-.3-.247-.295.318-.217q.7-.5 1.366-1.053.666-.553 1.272-1.164l.27-.275.249.3zm8.438 10.055l-.513.431-2.714 2.278-1.671-1.989-.246-.294-.246-.295-2.4-2.855.1-.074.312-.224q.69-.506 1.357-1.063.667-.557 1.282-1.154l.184-.178 2.383 2.841.245.294.247.292 1.239 1.477z"
        fill="#e6e6e6"
      />
      <path
        d="M101.21 108.457l-14.911-17.77a1.48 1.48 0 0 1 .183-2.087l5.211-4.373a1.48 1.48 0 0 1 2.087.183l14.911 17.77a3.47 3.47 0 0 1-.427 4.886l-2.167 1.819a3.47 3.47 0 0 1-4.887-.428zM88.645 82.606l-.184.178q-.618.594-1.282 1.154-.664.56-1.357 1.063l-.312.224-.1.074-1.256-1.5-.247-.294-.248-.3-2.267-2.7.107-.071.318-.218q.7-.5 1.366-1.053.666-.553 1.272-1.164l.181-.182 2.251 2.681.246.295.249.3z"
        fill="#b2b2b2"
      />
      <g fill="#e6e6e6">
        <path d="M88.695 46.479c-8.799-10.485-24.329-12.1-35.097-3.649s-12.89 23.92-4.797 34.958 23.485 13.667 34.783 5.939l.316-.219.312-.224q.691-.506 1.358-1.064.667-.558 1.282-1.153l.275-.268.271-.272c9.124-9.328 9.685-24.054 1.297-34.049zm-32.314.958a20.04 20.04 0 0 1 27.566 28.979l-.266.279-.27.275q-.6.6-1.272 1.164-.672.564-1.366 1.053l-.317.218-.321.213A20.04 20.04 0 0 1 56.38 47.437z" />
        <path d="M84.906 49.664c-7.042-8.39-19.449-9.729-28.119-3.035s-10.514 19.036-4.179 27.971S71.2 85.882 80.386 79.917l.321-.214.316-.219q.7-.492 1.367-1.052.667-.56 1.27-1.168l.271-.274.266-.279c7.03-7.544 7.335-19.145.709-27.047zm-.955 26.756l-.266.279-.27.275q-.6.6-1.272 1.164-.672.564-1.366 1.053l-.317.218-.321.213a20.05 20.05 0 0 1-23.773-32.19 20.05 20.05 0 0 1 27.585 28.99z" />
      </g>
      <path
        d="M83.947 76.416l-.266.279-.27.275q-.6.6-1.272 1.164-.672.564-1.366 1.053l-.317.218-.321.213a20.05 20.05 0 1 1 3.812-3.2zm20.814 25.623a.67.67 0 0 1-.507-.232L92.109 87.781a.67.67 0 0 1 1.013-.877l12.145 14.027a.67.67 0 0 1-.506 1.109zM50.888 48.871a.49.49 0 0 1-.385-.792 23.85 23.85 0 0 1 27.622-7.42.49.49 0 1 1-.364.909c-9.431-3.736-20.196-.845-26.486 7.114a.49.49 0 0 1-.387.189zm-3.298 5.735a.49.49 0 0 1-.455-.672 24.04 24.04 0 0 1 1.843-3.666.49.49 0 0 1 .834.514c-.688 1.119-1.279 2.294-1.767 3.513a.49.49 0 0 1-.455.311z"
        fill="#fff"
      />
      <path
        d="M71.977 67.119q-1.19.82-2.444-.643l-1.883-2.377c-.357-.385-.542-.899-.512-1.423.083-.526.325-1.014.692-1.4a4.72 4.72 0 0 0 1.2-2.28c.123-.793-.081-1.603-.566-2.243-.445-.727-1.152-1.256-1.976-1.475a3.29 3.29 0 0 0-3.731 3.2 3.74 3.74 0 0 1-.254 1.645c-.239.396-.601.703-1.031.874a2.23 2.23 0 0 1-1.625.16c-.526-.185-.887-.673-.909-1.231a6.66 6.66 0 0 1 .543-3.8 7.64 7.64 0 0 1 2.716-3.137 8.2 8.2 0 0 1 3.479-1.439 5.96 5.96 0 0 1 3.359.461c1.134.538 2.096 1.38 2.779 2.433a5.26 5.26 0 0 1 .99 4.012 8.07 8.07 0 0 1-2.014 3.919l1.4 2.263q.949 1.68-.213 2.481zm4.074 5.969c-.551.39-1.237.538-1.9.412a2.4 2.4 0 0 1-1.634-1.038 2.44 2.44 0 0 1-.407-1.924c.118-.665.501-1.253 1.061-1.629.557-.4 1.253-.555 1.928-.431a2.44 2.44 0 0 1 1.653 1.065 2.4 2.4 0 0 1 .388 1.9c-.125.674-.518 1.268-1.089 1.646z"
        fill="#f2f2f2"
      />
    </svg>
  );
};

export const SvgRegaIconTiny = (props) => {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 42 42" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m21.924 6.817-1.012-1.012L19.9 6.817 6.175 20.542l-1.013 1.013 1.013 1.012L19.9 36.292l1.012 1.013 1.012-1.013L35.65 22.567l1.012-1.012-1.012-1.013L21.924 6.817ZM9.212 21.555l11.7-11.7 11.7 11.7-11.7 11.7-11.7-11.7Zm14.092.002-2.393-2.393-2.393 2.393 2.393 2.394 2.393-2.394Z"
        fill="#73CCC3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m21.928 6.81-1.012-1.013-1.012 1.012-4.419 4.418-1.012 1.013 1.012 1.012 4.419 4.419 1.012 1.012 1.012-1.012 4.419-4.419 1.012-1.012-1.012-1.013-4.419-4.418Zm-3.405 5.43 2.393-2.393 2.393 2.393-2.393 2.393-2.393-2.393Zm-5.901 3.874-1.013-1.013-1.012 1.013-4.418 4.418-1.013 1.013 1.013 1.012 4.418 4.418 1.012 1.013 1.013-1.013 4.418-4.418 1.012-1.012-1.012-1.013-4.418-4.418Zm-3.406 5.43 2.393-2.393 2.394 2.394-2.394 2.393-2.393-2.393Zm12.712 3.883-1.012-1.013-1.012 1.012-4.419 4.419-1.012 1.012 1.012 1.013 4.419 4.418 1.012 1.012 1.012-1.012 4.419-4.418 1.012-1.013-1.012-1.012-4.419-4.418Zm-3.405 5.43 2.393-2.393 2.393 2.393-2.393 2.393-2.393-2.393ZM30.22 15.102l1.012 1.012 4.418 4.418 1.013 1.013-1.013 1.012-4.418 4.418-1.012 1.013-1.013-1.013-4.418-4.418-1.012-1.012 1.012-1.013 4.418-4.418 1.013-1.013Zm0 4.05-2.394 2.393 2.394 2.393 2.393-2.393-2.393-2.394Z"
        fill="#1169B0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m19.479 1.668-.42.42L1.462 19.686l-.417.416h4.05L19.478 5.718v-4.05Zm0 36.037L4.741 22.967H.691l.77.77 17.515 17.515.503.503v-4.05Zm2.864 4.23v-4.05L37.26 22.967h4.05l-.686.686-17.6 17.599-.682.683Zm0-36.565V1.32l.766.767 17.516 17.516.5.5h-4.05L22.344 5.37Z"
        fill="#0D2F5A"
      />
    </svg>
  );
};

export const SvgArrowPointRight = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="m31.414 11.068-6.661 6.662a1.987 1.987 0 1 1-2.81-2.811l2.024-2.025c-13.59-.667-22.426 8.454-22.508 17.803-.002.338-.477.407-.582.096-3.282-9.72 2.686-21.927 18.285-24.134a77.455 77.455 0 0 1 4.578-.454l-1.798-1.798a1.987 1.987 0 1 1 2.81-2.81l6.662 6.661a1.986 1.986 0 0 1 0 2.81Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);

export const IconBedroom = (props) => {
  return (
    <svg
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 19 19"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M3.733 15.922l-.7-2.058h-1.3v-4.79a1.744 1.744 0 011.736-1.7h.371V3.931a1.745 1.745 0 011.736-1.7h8.435a1.747 1.747 0 011.745 1.7V7.37h.363a1.748 1.748 0 011.747 1.7v4.789h-1.3l-.7 2.058h-.542l-.7-2.058H4.969l-.7 2.058zm-.617-3.408h13.367v-3.8H3.116zm7.376-5.146h3.883V3.573h-3.883zm-5.268 0h3.887V3.573H5.223z" />
      <path d="M3.752 15.899l-.7-2.058H1.756V9.076a1.721 1.721 0 011.712-1.677h.394V3.932a1.721 1.721 0 011.713-1.683h8.439a1.724 1.724 0 011.721 1.681v3.463h.387a1.724 1.724 0 011.722 1.681v4.764h-1.291l-.7 2.058h-.507l-.7-2.058H4.952l-.7 2.061zm-.66-3.359h13.414V8.696H3.092zm7.376-5.146H14.4V3.55h-3.932zm-5.268 0h3.932V3.55H5.199z" />
    </svg>
  );
};

export const IconBathroom = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 14 13" fill="none" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M11.986 5.876V2.248A2.3 2.3 0 0 0 11.229.69 2.192 2.192 0 0 0 9.62.134a2.044 2.044 0 0 0-1.44.552 2.144 2.144 0 0 0-.673 1.417H6.7a.476.476 0 0 0-.325.152.5.5 0 0 0 0 .68.476.476 0 0 0 .325.152h2.562a.476.476 0 0 0 .325-.152.5.5 0 0 0 0-.68.476.476 0 0 0-.325-.152H8.47c.044-.284.188-.541.405-.723.217-.181.491-.275.77-.262.328-.033.655.066.913.276.257.21.425.515.467.85v3.632H.937c-.17 0-.333.07-.453.193a.665.665 0 0 0-.187.464v3.281c0 .697.27 1.364.75 1.856a2.53 2.53 0 0 0 1.811.769h7.686c.68 0 1.331-.277 1.811-.769s.75-1.16.75-1.856V6.533a.665.665 0 0 0-.187-.464.634.634 0 0 0-.452-.192l-.48-.001ZM3.819 7.024h3.203v1.8H3.819v-1.8Zm8.166 2.79c-.001.39-.153.766-.423 1.043-.27.276-.637.432-1.019.432H2.857c-.382 0-.748-.156-1.018-.433a1.497 1.497 0 0 1-.422-1.043V7.024h1.441V8.5a1.34 1.34 0 0 0 .375.93 1.279 1.279 0 0 0 .907.383H6.7a1.253 1.253 0 0 0 .907-.384 1.314 1.314 0 0 0 .375-.929V7.024h4.003l-.001 2.79Z"
    />
  </svg>
);

export const LangAr = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} fill="none" viewBox="0 0 18 18" {...props}>
    <path
      fill="#ECEAEC"
      d="M9.141.266H2.048a.851.851 0 0 0-.85.85V8.21c0 .47.38.852.85.852h.284v1.584c0 .253.306.38.484.2l1.786-1.784h2.304l3.086-.852V1.117a.851.851 0 0 0-.85-.851Z"
    />
    <path
      fill="#DBD8DB"
      d="M3.183 8.21a1.135 1.135 0 0 1-1.135-1.135V.265a.851.851 0 0 0-.85.852v7.092c0 .47.38.852.85.852h.284v1.584c0 .253.306.38.484.2l1.786-1.784H9.14c.47 0 .851-.382.851-.852H3.183Z"
    />
    <path
      fill="#006169"
      d="M8.857 7.078h7.093c.47 0 .85.381.85.851v7.093a.85.85 0 0 1-.85.851h-.284v1.585c0 .253-.306.38-.484.2l-1.786-1.785H8.857a.851.851 0 0 1-.851-.851V7.929c0-.47.38-.85.851-.85Z"
    />
    <path
      fill="#005158"
      d="M9.992 15.022a1.135 1.135 0 0 1-1.135-1.135V7.078a.851.851 0 0 0-.851.851v7.093c0 .47.38.851.851.851h4.54l1.785 1.785a.284.284 0 0 0 .484-.2v-1.585h.284a.85.85 0 0 0 .85-.851H9.993Z"
    />
    <path
      fill="#000"
      d="M6.871 8.795h-2.27a.264.264 0 0 0-.186.077L2.63 10.658c-.004.004-.01.009-.022.004-.012-.005-.012-.012-.012-.019V9.06a.264.264 0 0 0-.264-.264h-.284a.588.588 0 0 1-.587-.587V1.115c0-.324.263-.588.587-.588h7.093c.324 0 .587.264.587.588v4.823a.264.264 0 0 0 .528 0V1.115C10.256.5 9.756 0 9.14 0H2.048C1.434 0 .934.5.934 1.115v7.092c0 .615.5 1.115 1.114 1.115h.02v1.321a.546.546 0 0 0 .935.387L4.71 9.322h2.16a.264.264 0 0 0 0-.527Z"
    />
    <path
      fill="#A6C8CA"
      d="M15.95 6.813H8.857c-.615 0-1.115.5-1.115 1.114v7.093c0 .615.5 1.115 1.115 1.115h4.43l1.708 1.708a.546.546 0 0 0 .935-.387v-1.321h.02c.614 0 1.114-.5 1.114-1.115V7.927c0-.614-.5-1.114-1.114-1.114Zm.587 8.207a.588.588 0 0 1-.587.587h-.284a.264.264 0 0 0-.264.264v1.585c0 .006 0 .013-.012.018-.012.006-.018 0-.022-.004l-1.785-1.785a.264.264 0 0 0-.187-.078H8.857a.588.588 0 0 1-.587-.587V7.927c0-.324.263-.587.587-.587h7.093c.324 0 .587.263.587.587v7.093Z"
    />
    <path
      fill="#767676"
      d="M5.944 2.223a.372.372 0 0 0-.348-.238.372.372 0 0 0-.345.231l-.003.006-1.81 4.755a.264.264 0 1 0 .492.188l.386-1.015h2.546l.169.447a.264.264 0 1 0 .493-.186l-1.58-4.188Zm-1.427 3.4 1.078-2.83 1.068 2.83H4.517Z"
    />
    <path
      fill="#CCDFE1"
      d="M13.66 13.564a1.582 1.582 0 0 1-2.553-1.246c0-.872.71-1.58 1.58-1.58h.71a.264.264 0 0 0 0-.528h-.851a.588.588 0 1 1 .438-.979.264.264 0 1 0 .393-.352 1.116 1.116 0 0 0-1.946.744c0 .312.13.595.338.798a2.11 2.11 0 0 0-1.189 1.897 2.11 2.11 0 0 0 3.405 1.661.264.264 0 1 0-.325-.415Z"
    />
  </svg>
);

export const LangEn = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} fill="none" viewBox="0 0 18 18" {...props}>
    <path
      fill="#006169"
      d="M9.141.266H2.048a.851.851 0 0 0-.85.85V8.21c0 .47.38.852.85.852h.284v1.584c0 .253.306.38.484.2l1.786-1.784h2.304l3.086-.852V1.117a.851.851 0 0 0-.85-.851Z"
    />
    <path
      fill="#005158"
      d="M3.183 8.21a1.135 1.135 0 0 1-1.135-1.135V.265a.851.851 0 0 0-.85.852v7.092c0 .47.38.852.85.852h.284v1.584c0 .253.306.38.484.2l1.786-1.784H9.14c.47 0 .851-.382.851-.852H3.183Z"
    />
    <path
      fill="#ECEAEC"
      d="M8.857 7.078h7.093c.47 0 .85.381.85.851v7.093a.85.85 0 0 1-.85.851h-.284v1.585c0 .253-.306.38-.484.2l-1.786-1.785H8.857a.851.851 0 0 1-.851-.851V7.929c0-.47.38-.85.851-.85Z"
    />
    <path
      fill="#DBD8DB"
      d="M9.992 15.022a1.135 1.135 0 0 1-1.135-1.135V7.078a.851.851 0 0 0-.851.851v7.093c0 .47.38.851.851.851h4.54l1.785 1.785a.284.284 0 0 0 .484-.2v-1.585h.284a.85.85 0 0 0 .85-.851H9.993Z"
    />
    <path
      fill="#A6C8CA"
      d="M6.871 8.795h-2.27a.264.264 0 0 0-.186.077L2.63 10.658c-.004.004-.01.009-.022.004-.012-.005-.012-.012-.012-.019V9.06a.264.264 0 0 0-.264-.264h-.284a.588.588 0 0 1-.587-.587V1.115c0-.324.263-.588.587-.588h7.093c.324 0 .587.264.587.588v4.823a.264.264 0 0 0 .528 0V1.115C10.256.5 9.756 0 9.14 0H2.048C1.434 0 .934.5.934 1.115v7.092c0 .615.5 1.115 1.114 1.115h.02v1.321a.546.546 0 0 0 .935.387L4.71 9.322h2.16a.264.264 0 0 0 0-.527Z"
    />
    <path
      fill="#000"
      d="M15.95 6.813H8.857c-.615 0-1.115.5-1.115 1.114v7.093c0 .615.5 1.115 1.115 1.115h4.43l1.708 1.708a.546.546 0 0 0 .935-.387v-1.321h.02c.614 0 1.114-.5 1.114-1.115V7.927c0-.614-.5-1.114-1.114-1.114Zm.587 8.207a.588.588 0 0 1-.587.587h-.284a.264.264 0 0 0-.264.264v1.585c0 .006 0 .013-.012.018-.012.006-.018 0-.022-.004l-1.785-1.785a.264.264 0 0 0-.187-.078H8.857a.588.588 0 0 1-.587-.587V7.927c0-.324.263-.587.587-.587h7.093c.324 0 .587.263.587.587v7.093Z"
    />
    <path
      fill="#CCDFE1"
      d="M5.944 2.223a.372.372 0 0 0-.348-.238.372.372 0 0 0-.345.231l-.003.006-1.81 4.755a.264.264 0 1 0 .492.188l.386-1.015h2.546l.169.447a.264.264 0 1 0 .493-.186l-1.58-4.188Zm-1.427 3.4 1.078-2.83 1.068 2.83H4.517Z"
    />
    <path
      fill="#767676"
      d="M13.66 13.564a1.582 1.582 0 0 1-2.553-1.246c0-.872.71-1.58 1.58-1.58h.71a.264.264 0 0 0 0-.528h-.851a.588.588 0 1 1 .438-.979.264.264 0 1 0 .393-.352 1.116 1.116 0 0 0-1.946.744c0 .312.13.595.338.798a2.11 2.11 0 0 0-1.189 1.897 2.11 2.11 0 0 0 3.405 1.661.264.264 0 1 0-.325-.415Z"
    />
  </svg>
);

export const LogoNafaz = (props) => (
  <svg width={props.width || 150} height={props.height || 'auto'} viewBox="0 0 255 110" {...props}>
    <path
      d="M191.612 90.075c.706.094 1.13.189 1.554.189 10.028 0 20.103.047 30.132-.047 5.979-.047 9.416-3.202 9.604-9.134.283-9.887.283-19.774.283-29.661 0-1.836.517-2.872 2.212-3.72 5.132-2.542 10.123-5.273 15.208-7.91.612-.329 1.271-.611 2.118-.988.047.66.141 1.13.141 1.648 0 13.7.236 27.401-.094 41.102-.235 10.263-4.425 18.691-13.7 24.011-4.755 2.731-10.029 3.719-15.396 3.719-15.113.095-30.179.095-45.292 0-3.86-.047-7.721-.847-11.582-.988-2.589-.094-5.178.518-7.815.659-4.379.188-8.804.329-13.183.376-12.382.048-24.764.142-37.147-.047-3.672-.047-7.485-.565-11.017-1.6-10.687-3.296-16.43-10.97-18.267-21.752-.377-2.307-.47-4.66-.47-7.015-.048-20.01 0-40.019-.048-60.028 0-1.695.424-2.637 1.978-3.39 5.178-2.59 10.263-5.32 15.395-7.957.612-.33 1.271-.612 2.26-1.082v70.15c0 1.741.094 3.53.33 5.272.706 5.226 3.578 8.24 8.804 8.334 10.64.188 21.233.047 31.873.047.189 0 .424-.142.895-.283-.471-.941-.895-1.836-1.365-2.683-7.533-13.089-5.415-30.697 3.295-41.055 5.179-6.215 11.912-9.605 19.916-10.31 8.145-.707 15.96.423 22.646 5.696 7.25 5.697 10.969 13.324 12.146 22.364 1.225 8.992-.423 17.325-5.084 25.094-.047.14-.095.423-.33.988Zm-12.9-22.646c-.377-1.506-.706-4.331-1.836-6.78-2.307-4.99-6.545-7.014-12.006-6.732-4.896.283-8.427 2.778-10.122 7.392-3.484 9.275.706 21.045 9.133 26.13 1.507.894 2.731.941 4.191-.047 6.685-4.426 10.31-10.593 10.64-19.963ZM28.053 53.023c3.201-5.509 6.403-10.923 9.651-16.479 6.356 3.814 12.006 8.192 16.526 13.842 8.522 10.546 11.44 22.693 10.028 36.017-.33 3.249-1.036 6.544-2.166 9.604-2.825 7.816-8.85 12.383-16.855 12.759-14.407.66-28.813.377-43.267.518-.047 0-.141-.047-.377-.188.189-.471.33-1.036.565-1.507 2.684-5.178 5.462-10.357 8.098-15.583.66-1.272 1.413-1.742 2.872-1.742 7.25.094 14.501-.189 21.752.094 8.521.33 10.169-4.755 9.98-10.829-.329-11.11-5.696-19.256-14.877-25.141-.518-.424-1.13-.847-1.93-1.365ZM243.448.951c6.309 0 10.311 3.955 10.311 10.217 0 6.78-3.484 10.405-10.122 10.499-6.309.094-10.358-3.955-10.405-10.405 0-6.262 3.954-10.31 10.216-10.31ZM48.015 11.262c0 6.968-3.437 10.499-10.122 10.405-6.356-.095-10.358-4.238-10.311-10.594C27.676 4.86 31.725.951 38.081.951c6.215.047 9.934 3.908 9.934 10.31Z"
      fill="#0a9a8f"
    />
    <path
      d="M176.028 13.475c-.047 6.92-3.201 10.17-10.028 10.17-6.544 0-10.311-3.814-10.311-10.406 0-6.45 3.908-10.17 10.546-10.122 6.262.047 9.793 3.86 9.793 10.358Z"
      fill="#0a9a8f"
    />
  </svg>
);

export const LogoBayutKsa = (props) => (
  <svg width={props.size || 153} height={props.size || 28} viewBox="0 0 153 28" fill="none" {...props}>
    <path
      d="M104.148 4v-.1h-1.154l-.024.066-1.152 3.216-.001.004-.32 1.027-.313-1.034-.002-.005-1.16-3.208-.023-.066h-1.155v5.48h.808V5.955l-.04-.76 1.519 4.12.024.065h.683l.024-.065 1.518-4.12-.04.76V9.38h.808V4ZM97.92 4v-.1H93.4v.8h1.84v4.68h.84V4.7h1.84V4Z"
      fill="#222"
      stroke="#222"
      strokeWidth={0.2}
    />
    <path
      d="M18.974 5.055a17.826 17.826 0 0 0-12.085 0A5.122 5.122 0 0 0 3.5 9.873v8.254a5.122 5.122 0 0 0 3.389 4.818 17.827 17.827 0 0 0 12.085 0 5.126 5.126 0 0 0 1.454-.811c-7.206-1.318-8.208-1.22-9.794-2.803a5.596 5.596 0 1 1 7.921-7.907c1.584 1.578 1.488 2.58 2.802 9.747a5.11 5.11 0 0 0 1.006-3.044V9.873a5.122 5.122 0 0 0-3.389-4.818Z"
      fill="#28B16D"
    />
    <path d="M14.595 17.715a2.334 2.334 0 1 0 0-4.668 2.334 2.334 0 0 0 0 4.668Z" fill="#28B16D" />
    <path
      d="M36.504 9.175a5.487 5.487 0 0 0-2.358-.462h-5.024v11.97h2.503V16.44h2.521a5.487 5.487 0 0 0 2.358-.462 3.485 3.485 0 0 0 1.515-1.324 4.299 4.299 0 0 0 0-4.154 3.489 3.489 0 0 0-1.515-1.324Zm-1.052 4.807a2.54 2.54 0 0 1-1.687.48h-2.14V10.69h2.14c.6-.045 1.197.122 1.687.472a2.05 2.05 0 0 1 0 2.82Zm10.373-2.494c.145.028.286.077.417.145l-.29 2.086a1.94 1.94 0 0 0-.444-.11 5.15 5.15 0 0 0-.677-.035 2.262 2.262 0 0 0-1.052.263c-.347.183-.636.46-.834.798-.232.412-.345.88-.327 1.353v4.698h-2.482v-9.069h2.158l.164 1.778a3.122 3.122 0 0 1 1.06-1.45 2.9 2.9 0 0 1 1.75-.508 2.7 2.7 0 0 1 .56.052l-.003-.001Zm7.881.508a5.477 5.477 0 0 0-4.834 0 4.019 4.019 0 0 0-1.641 1.615 5.746 5.746 0 0 0 0 5.069c.376.69.947 1.255 1.641 1.624a5.477 5.477 0 0 0 4.834 0 4.02 4.02 0 0 0 1.633-1.624 5.744 5.744 0 0 0 0-5.07 4.034 4.034 0 0 0-1.63-1.614h-.003Zm-.535 5.75a1.98 1.98 0 0 1-.734.952 2.042 2.042 0 0 1-1.152.317 2.073 2.073 0 0 1-1.17-.317 1.976 1.976 0 0 1-.734-.952 5.144 5.144 0 0 1 0-3.193 1.98 1.98 0 0 1 .734-.952c.35-.22.757-.33 1.17-.317.407-.011.808.099 1.152.317.337.234.594.566.734.952a5.142 5.142 0 0 1 0 3.193Zm7.31-7.038v.907h2.866v1.85H60.59v7.216h-2.486v-7.216h-1.578v-1.85h1.578v-1.088c-.009-.46.078-.918.255-1.343.157-.371.4-.7.707-.961a3.025 3.025 0 0 1 1.079-.572c.439-.13.895-.194 1.353-.19.388-.004.775.042 1.151.136.277.06.539.174.771.335l-.344 1.654a1.734 1.734 0 0 0-.45-.199 2.197 2.197 0 0 0-.602-.075 1.82 1.82 0 0 0-1.128.317 1.272 1.272 0 0 0-.413 1.079h-.002Zm10.294 1.288a5.477 5.477 0 0 0-4.834 0 4.02 4.02 0 0 0-1.642 1.615 5.746 5.746 0 0 0 0 5.069c.376.69.947 1.255 1.642 1.624a5.476 5.476 0 0 0 4.834 0 4.021 4.021 0 0 0 1.632-1.624 5.744 5.744 0 0 0 0-5.07 4.037 4.037 0 0 0-1.63-1.614h-.002Zm-.535 5.75c-.14.386-.397.718-.735.952a2.041 2.041 0 0 1-1.151.317 2.073 2.073 0 0 1-1.17-.317 1.978 1.978 0 0 1-.735-.952 5.145 5.145 0 0 1 0-3.193 1.98 1.98 0 0 1 .734-.952c.35-.22.758-.33 1.17-.317.408-.012.809.099 1.152.317.338.234.594.566.735.952a5.144 5.144 0 0 1 0 3.193Zm8.29 1.242a8.42 8.42 0 0 0 .507-.136l-.217 1.633c-.24.134-.5.229-.771.28a4.35 4.35 0 0 1-.916.1 2.548 2.548 0 0 1-1.932-.643 2.932 2.932 0 0 1-.608-2.06V7.64h2.485v10.249c-.03.312.047.625.218.888a.91.91 0 0 0 .726.254c.17.005.342-.01.51-.042h-.003Zm1.432-7.373h2.485v9.069h-2.485v-9.069Zm2.793-2.63a1.25 1.25 0 0 1-.381.988 2.176 2.176 0 0 1-2.322 0 1.247 1.247 0 0 1-.381-.989 1.271 1.271 0 0 1 .381-1.006 2.18 2.18 0 0 1 2.322 0 1.273 1.273 0 0 1 .382 1.007Zm10.058 4.624a4.038 4.038 0 0 0-1.633-1.614 5.476 5.476 0 0 0-4.834 0 4.018 4.018 0 0 0-1.642 1.614 5.744 5.744 0 0 0 0 5.07c.376.69.947 1.255 1.642 1.623a5.476 5.476 0 0 0 4.834 0 4.022 4.022 0 0 0 1.633-1.623 5.746 5.746 0 0 0 0-5.07Zm-2.168 4.134a1.98 1.98 0 0 1-.734.953 2.041 2.041 0 0 1-1.151.317 2.073 2.073 0 0 1-1.17-.317 1.977 1.977 0 0 1-.735-.953 5.143 5.143 0 0 1 0-3.192 1.98 1.98 0 0 1 .734-.952c.35-.22.758-.33 1.17-.318.407-.01.808.1 1.152.318.338.233.594.566.734.952a5.145 5.145 0 0 1 0 3.192Z"
      fill="#222"
    />
    <path d="M111 6v16" stroke="#DEDEDE" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M135.298 9.719c1.009 0 1.882.192 2.618.578.737.374 1.36.93 1.87 1.666l-1.224 1.173c-.43-.658-.918-1.128-1.462-1.411-.532-.295-1.167-.442-1.904-.442-.544 0-.991.073-1.343.22-.351.148-.612.346-.782.596-.158.238-.238.51-.238.816 0 .351.119.657.357.918.25.26.709.464 1.377.612l2.278.51c1.088.238 1.859.6 2.312 1.088.454.487.68 1.105.68 1.853 0 .691-.187 1.292-.561 1.802-.374.51-.895.9-1.564 1.173-.657.272-1.433.408-2.329.408-.793 0-1.507-.102-2.142-.306a5.746 5.746 0 0 1-1.666-.833 4.928 4.928 0 0 1-1.173-1.207l1.258-1.258c.238.396.539.753.901 1.07.363.307.782.545 1.258.715a4.88 4.88 0 0 0 1.615.255c.522 0 .969-.063 1.343-.187.386-.125.675-.306.867-.544.204-.25.306-.544.306-.884 0-.329-.113-.618-.34-.867-.215-.25-.623-.442-1.224-.578l-2.465-.561c-.68-.148-1.241-.357-1.683-.63-.442-.271-.77-.6-.986-.985a2.738 2.738 0 0 1-.323-1.326c0-.635.17-1.207.51-1.717.352-.522.856-.935 1.513-1.241.658-.318 1.44-.476 2.346-.476ZM151.58 21.11h-1.921l-1.071-2.941h-4.709l-1.071 2.94h-1.87l4.233-11.22h2.176l4.233 11.22Zm-7.191-4.42h3.689l-1.836-5.236-1.853 5.236Zm-18.936-2.21 4.244-4.59h-2.227l-5.151 5.585V9.89H120.5v11.22h1.819v-3.456l1.816-1.954 3.522 5.41h2.142l-4.346-6.63Z"
      fill="#767676"
    />
  </svg>
);

export const LogoBayutKsaArabic = (props) => (
  <svg width={props.size || 160} height={props.size || 28} viewBox="0 0 160 28" fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.927 15.598c.014 0 .026.002.035.005h1.336V8h1.77v9.031h-3.256a.076.076 0 0 1-.03-.005h-3.871c-.67 0-1.291-.298-1.864-.894-.445.596-1.106.894-1.985.894h-4.66l-.014-.001h-1.384c-.372 0-.759-.062-1.161-.186a4.103 4.103 0 0 1-1.039-.481c-.727.444-1.464.667-2.211.667h-2.746c0 .906-.274 1.609-.824 2.108-.546.499-1.317.748-2.316.748a6.711 6.711 0 0 1-1.399-.127 3.659 3.659 0 0 1-1.131-.447l.69-1.294a3.765 3.765 0 0 0 1.805.453c.45 0 .796-.125 1.04-.372.243-.244.365-.58.365-1.01v-.058h-1.178c-.848 0-1.5-.24-1.956-.72-.457-.48-.685-1.163-.685-2.049 0-.627.157-1.176.47-1.648.314-.476.757-.84 1.33-1.091.572-.252 1.234-.377 1.984-.377h1.805v4.457h2.56c.178 0 .373-.022.586-.065.217-.042.393-.096.528-.162-.236-.182-.485-.468-.748-.86a7.357 7.357 0 0 1-.685-1.282 5.995 5.995 0 0 1-.395-1.34 5.36 5.36 0 0 1 1.596-.912 4.988 4.988 0 0 1 1.741-.336c1.134 0 2.129.238 2.984.713 0 .86-.174 1.647-.523 2.363-.348.716-.82 1.263-1.416 1.642.294.159.652.238 1.074.238h1.372l.007.001h1.36V12.07h1.77v3.53h1.01c.394 0 .683-.11.864-.326.186-.22.28-.57.28-1.05V12.07h1.77v2.293c0 .193-.012.371-.035.534.193.26.387.44.58.545.193.105.443.157.749.157h.737v-4.457h1.77v4.457h1.544ZM54.217 8h-1.77v9.031h1.77V8Zm-21.892 4.283c-.07 1.014-.569 1.798-1.498 2.35-.31-.204-.586-.498-.83-.881a4.46 4.46 0 0 1-.534-1.23c.17-.125.403-.231.697-.32.294-.09.569-.134.824-.134.55 0 .996.072 1.34.215Zm-8.248 3.315v-3.03h-.383c-.507 0-.903.144-1.19.43-.282.286-.424.69-.424 1.213 0 .476.097.826.29 1.05.194.225.49.337.889.337h.818Zm-7.249.003h-3.97v1.427h5.764v-1.38c-.287-1.444-.75-2.609-1.393-3.495-.639-.89-1.488-1.548-2.548-1.973l-.668 1.665c.523.217.964.49 1.324.819.363.325.661.714.893 1.166.237.45.436 1.04.598 1.77Zm-9.392 0H6.089v-5.039H4.302v.58H3.97c-.716 0-1.335.125-1.857.372A2.724 2.724 0 0 0 .918 12.56c-.279.452-.418.97-.418 1.555 0 .916.304 1.632.911 2.147.608.51 1.46.766 2.56.766h3.604c.008 0 .014 0 .02-.002h3.712V11.14h-1.77v4.457h-2.08c-.008 0-.015 0-.022.002Zm.98 4.396c-.244 0-.437-.077-.58-.232-.143-.15-.215-.358-.215-.62 0-.268.07-.479.209-.633.143-.151.338-.227.586-.227.244 0 .435.076.575.227.139.15.209.361.209.632s-.072.48-.215.627a.747.747 0 0 1-.569.226Zm2.02 0c-.244 0-.437-.077-.58-.232-.144-.15-.215-.358-.215-.62 0-.268.07-.479.209-.633.143-.151.338-.227.586-.227.248 0 .441.076.58.227.14.154.21.365.21.632 0 .264-.074.47-.221.621a.738.738 0 0 1-.57.232Zm-6.117-7.426v3.03h-.337c-.537 0-.95-.128-1.236-.384-.286-.255-.43-.619-.43-1.09 0-.504.146-.889.436-1.156.294-.267.712-.4 1.254-.4h.313ZM2.63 9.587c.143.151.337.227.58.227a.758.758 0 0 0 .57-.22c.142-.152.214-.363.214-.633 0-.271-.07-.482-.209-.633-.14-.151-.33-.226-.575-.226-.247 0-.443.077-.586.232-.139.15-.209.36-.209.627 0 .263.072.472.215.626Zm2.02 0c.143.151.336.227.58.227a.748.748 0 0 0 .569-.227c.147-.154.22-.363.22-.626 0-.267-.069-.476-.208-.627-.14-.155-.333-.232-.58-.232-.248 0-.444.077-.587.232-.14.15-.209.36-.209.627 0 .263.072.472.215.626Z"
        fill="#767676"
      />
      <path d="M60.717 6v16" stroke="#DEDEDE" />
      <path
        d="M78.613 4v-.1H77.46l-.024.066-1.152 3.216-.001.004-.32 1.027-.313-1.034-.002-.005-1.16-3.208-.024-.066H73.31v5.48h.807V5.955l-.04-.76 1.518 4.12.025.065h.683l.024-.065 1.518-4.12-.04.76V9.38h.808V4Zm-6.228 0v-.1h-4.52v.8h1.84v4.68h.84V4.7h1.84V4Z"
        fill="#222"
        stroke="#222"
        strokeWidth={0.2}
      />
      <path
        d="M142.184 5.055a17.828 17.828 0 0 1 12.086 0 5.124 5.124 0 0 1 3.388 4.818v8.254a5.121 5.121 0 0 1-3.388 4.818 17.828 17.828 0 0 1-12.086 0 5.147 5.147 0 0 1-1.454-.811c7.206-1.318 8.208-1.22 9.794-2.803a5.596 5.596 0 1 0-7.921-7.907c-1.584 1.578-1.488 2.58-2.802 9.747a5.11 5.11 0 0 1-1.005-3.044V9.873a5.121 5.121 0 0 1 3.388-4.818Z"
        fill="#28B16D"
      />
      <path d="M146.563 17.715a2.333 2.333 0 1 1 0-4.667 2.333 2.333 0 0 1 0 4.667Z" fill="#28B16D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.656 15.24h1.768a.085.085 0 0 1 .041-.008h1.609V7h1.916v9.777h-3.36a.075.075 0 0 1-.038.009h-7.326c0 .98-.297 1.74-.892 2.28-.59.541-1.427.811-2.507.811a7.26 7.26 0 0 1-1.515-.138 3.959 3.959 0 0 1-1.225-.484l.748-1.401a4.08 4.08 0 0 0 1.954.49c.486 0 .86-.134 1.125-.402.264-.264.396-.628.396-1.093v-.063h-1.276c-.917 0-1.623-.26-2.118-.78-.494-.519-.741-1.258-.741-2.218 0-.678.17-1.273.509-1.784.34-.515.819-.91 1.439-1.181.62-.273 1.336-.409 2.149-.409h1.954v4.826h3.474v-4.826h1.917v4.826Zm20.434-3.281v3.28h-.364c-.582 0-1.029-.139-1.339-.415-.305-.277-.458-.67-.458-1.181 0-.55.159-.966.477-1.25.319-.29.767-.434 1.345-.434h.339Zm-4.134 1.583c0 .64.207 1.207.622 1.697h-3.326v-4.825h-1.954c-.812 0-1.529.136-2.149.409-.62.272-1.1.666-1.439 1.18-.34.512-.509 1.107-.509 1.785 0 .96.247 1.7.742 2.218.494.52 1.2.78 2.117.78h1.276v.063c0 .465-.132.829-.396 1.093-.264.268-.639.402-1.125.402a4.075 4.075 0 0 1-1.954-.49l-.748 1.401c.394.235.802.396 1.226.484.427.092.932.138 1.514.138 1.081 0 1.916-.27 2.507-.81.595-.54.892-1.301.892-2.281h1.609a.1.1 0 0 0 .017-.002h7.129v-6.371h-2.294c-1.181 0-2.103.282-2.764.848-.662.561-.993 1.322-.993 2.281Zm2.984-4.48c.155.163.367.245.635.245a.803.803 0 0 0 .61-.245c.159-.168.238-.394.238-.679 0-.293-.077-.521-.232-.685-.151-.163-.356-.245-.616-.245-.272 0-.486.084-.641.251-.151.164-.226.39-.226.68 0 .284.077.51.232.678Zm7.742 10.815a7.256 7.256 0 0 1-1.514-.138 3.965 3.965 0 0 1-1.226-.484l.748-1.401a4.075 4.075 0 0 0 1.954.49c.486 0 .861-.134 1.125-.402.264-.264.396-.628.396-1.093v-.063h-1.276c-.917 0-1.623-.26-2.117-.78-.494-.519-.742-1.258-.742-2.218 0-.678.17-1.273.509-1.784.34-.515.819-.91 1.439-1.181.62-.273 1.337-.409 2.149-.409h1.955v6.41c0 .975-.298 1.727-.893 2.255-.59.532-1.426.798-2.507.798Zm1.483-4.637v-3.28h-.415c-.548 0-.978.155-1.288.465-.306.31-.459.748-.459 1.313 0 .515.105.895.315 1.138.209.242.53.364.961.364h.886Zm7.553 1.546h5.077v-6.372h-1.917v4.826h-3.16v-4.826h-1.917V16.9c0 .398-.105.727-.314.986-.21.264-.486.396-.83.396-.243 0-.452-.027-.628-.081a2.676 2.676 0 0 1-.597-.296l-.773 1.25c.407.273.792.461 1.156.566a4.43 4.43 0 0 0 1.213.157c.817 0 1.468-.26 1.954-.779.49-.52.736-1.221.736-2.105v-.207Zm3.374 2.966c.155.167.367.25.635.25a.791.791 0 0 0 .609-.25c.159-.164.239-.388.239-.673 0-.293-.077-.521-.232-.685-.151-.163-.356-.245-.616-.245-.273 0-.486.082-.641.245-.151.168-.226.396-.226.685 0 .285.077.51.232.673Zm-27.756-4.512v-3.28h-.415c-.549 0-.978.155-1.288.465-.306.31-.459.748-.459 1.313 0 .515.105.895.315 1.138.209.242.529.364.961.364h.886Zm-13.867 4.763c-.264 0-.473-.084-.628-.251-.155-.164-.233-.388-.233-.673 0-.289.076-.517.227-.685.155-.163.366-.245.634-.245.264 0 .471.082.622.245.151.164.226.392.226.685 0 .293-.077.52-.232.679a.81.81 0 0 1-.616.245Zm2.187 0c-.264 0-.474-.084-.629-.251-.154-.164-.232-.388-.232-.673 0-.289.075-.517.226-.685.155-.163.367-.245.635-.245s.477.082.628.245c.151.168.226.396.226.685 0 .285-.08.51-.238.673a.8.8 0 0 1-.616.25Zm-7.307-8.043v3.28h-.886c-.432 0-.752-.122-.962-.364-.21-.243-.314-.623-.314-1.138 0-.565.153-1.003.459-1.313.31-.31.74-.465 1.288-.465h.415Z"
        fill="#222"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.5)" d="M0 0h159v28H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const IconBasic = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m4.309 9.896 7.333 4.666a.668.668 0 0 0 .716 0l7.333-4.666a.668.668 0 0 0 0-1.125l-7.333-4.667a.668.668 0 0 0-.716 0L4.309 8.771a.666.666 0 0 0 0 1.125Z" />
    <path d="m19.691 14.1-2.065-1.314-4.552 2.897a2.004 2.004 0 0 1-2.146 0l-4.555-2.897L4.31 14.1a.668.668 0 0 0 0 1.124l7.333 4.668a.667.667 0 0 0 .716 0l7.333-4.668a.666.666 0 0 0 0-1.124Z" />
  </svg>
);

export const IconForSale = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 18 18" {...props}>
    <path
      fillOpacity={0.8}
      fillRule="evenodd"
      d="M3.154 9.068 9.13 4.221a.237.237 0 0 1 .3-.003l5.98 4.85.903-1.114L9.282 2.25 2.25 7.954l.904 1.114Zm1.024-.22 5.104-4.14 5.103 4.14v6.235a.428.428 0 0 1-.427.427H11.29v-4.171a.458.458 0 0 0-.458-.458H7.731a.46.46 0 0 0-.458.458v4.171H4.605a.428.428 0 0 1-.427-.427V8.848Z"
      clipRule="evenodd"
    />
  </svg>
);

export const IconForRent = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 16 16" {...props}>
    <path d="M10.728 7.842a3.05 3.05 0 0 0-1.555.435l-.69-.69.995-.996-1.087-1.088-.996.996-.902-.902L8 4.09 6.91 3 5.404 4.508 4.088 3.193 3 4.28l5.084 5.084a3.05 3.05 0 0 0-.434 1.555 3.081 3.081 0 1 0 6.162 0 3.081 3.081 0 0 0-3.084-3.077Zm0 4.622a1.54 1.54 0 0 1-1.54-1.54c0-.236.057-.467.162-.677l.7-.7a1.54 1.54 0 0 1 .676-.163 1.54 1.54 0 0 1 1.089 2.628 1.54 1.54 0 0 1-1.087.452Z" />
  </svg>
);

export const SvgLicense = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 117 116"
    fill="none"
    {...props}
  >
    <g clipPath="url(#aSvgLicense)">
      <rect width={116} height={116} x={0.5} fill="#D8E7E8" rx={58} />
      <g clipPath="url(#bSvgLicense)">
        <path fill="#006169" d="M37.017 102.61v12.646h-9.033V93.578h9.033z" />
        <path fill="#fff" stroke="#006169" strokeWidth={3} d="M6 92.083V66.18h51.194v25.903H6Z" />
        <path
          fill="#B3D0D2"
          d="M111.079 54.292 73.144 32.163l-37.936 22.13-5.419 3.16v-7.225l43.355-25.29 43.355 25.29v7.226z"
        />
        <path fill="#F5F7FA" d="M103.854 66.484H85.789v5.42h18.065z" />
        <path fill="#006169" d="M103.854 71.906H85.789v12.645h18.065z" />
        <path fill="#B3D0D2" d="M78.5 79h-11v38h11z" />
        <path fill="#006169" d="M73.144 59.256a7.226 7.226 0 1 0 0-14.451 7.226 7.226 0 0 0 0 14.451" />
        <path
          fill="#fff"
          d="M111.082 54.293v64.323H78.566V79.132H67.727v39.484h-30.71V93.583h21.678V64.68H35.21V54.293l37.935-22.129zm-7.226 30.258V66.486H85.792v18.065zm-30.71-25.29a7.224 7.224 0 0 0 7.226-7.226 7.224 7.224 0 0 0-7.226-7.226 7.224 7.224 0 0 0-7.225 7.226 7.224 7.224 0 0 0 7.225 7.226"
        />
        <path
          fill="#B3D0D2"
          d="M103.855 50.078v52.537h7.226V54.293zm5.418 3.156 1.807 1.053 5.419 3.161v-7.226l-7.226-4.214z"
        />
        <path fill="#fff" d="M95.462 84.551h-5.419l4.14-12.645h5.42z" />
        <path
          fill="#F5F7FA"
          d="M80.37 52.03c0-.628-.107-1.226-.257-1.806H74.95v-5.163c-.58-.15-1.178-.256-1.806-.256s-1.227.106-1.807.256v5.163h-5.163c-.15.58-.256 1.178-.256 1.807 0 .628.106 1.226.256 1.806h5.163V59c.58.15 1.178.256 1.807.256.628 0 1.226-.106 1.806-.256v-5.163h5.163c.15-.58.257-1.178.257-1.806"
        />
        <path
          fill="#006169"
          d="M38.823 117.066H26.177a1.804 1.804 0 0 1-1.806-1.806c0-.999.808-1.807 1.806-1.807h12.646c.999 0 1.806.808 1.806 1.807s-.807 1.806-1.806 1.806"
        />
        <path
          fill="#B3D0D2"
          d="M24.1 71h-7.71a.877.877 0 0 0-.89.863c0 .476.398.862.89.862h7.71c.492 0 .89-.386.89-.862A.877.877 0 0 0 24.1 71m0 15h-7.71a.877.877 0 0 0-.89.863c0 .476.398.862.89.862h7.71c.492 0 .89-.386.89-.862A.877.877 0 0 0 24.1 86m18.492-10H17.408c-1.054 0-1.908.648-1.908 1.447v2.895c0 .8.854 1.448 1.908 1.448h25.184c1.054 0 1.908-.649 1.908-1.448v-2.895c0-.799-.854-1.447-1.908-1.447"
        />
        <path
          fill="#B3D0D2"
          d="M42.601 76.29H17.417c-.843 0-1.526.517-1.526 1.157v2.895c0 .64.683 1.158 1.526 1.158H42.6c.843 0 1.526-.519 1.526-1.158v-2.895c0-.64-.683-1.158-1.526-1.158"
        />
      </g>
    </g>
    <defs>
      <clipPath id="aSvgLicense">
        <rect width={116} height={116} x={0.5} fill="#fff" rx={58} />
      </clipPath>
      <clipPath id="bSvgLicense">
        <path fill="#fff" d="M4.5 15h112v112H4.5z" />
      </clipPath>
    </defs>
  </svg>
);

export const IllustrationGraph = (props) => (
  <svg width={props.size || 160} height={props.size || 103} fill="none" viewBox="0 0 160 103" {...props}>
    <path
      fill={props.color ? chroma.mix(props.color, '#fff', 0.8).desaturate(0.12) : tenantTheme['primary-light-3']}
      fillOpacity={0.7}
      d="M11.527.797H160v5.187H11.527zm0 5.803v14.048H160V6.601zm0 14.665H160v14.04H11.527zm0 14.655v14.05H160V35.92zm0 14.665H160v14.04H11.527zm0 14.656V79.29H160V65.241zm0 14.664H160v14.048H11.527z"
    />
    <path
      fill={tenantTheme['primary-color']}
      d="M52.237 81.311 35.842 42.534 19.777 80.52h-8.25v-1.835h7.037l17.278-40.853L52.788 77.9l15.916-18.218 16.635-2.931 16.901-22.278 17.492 8.314 15.831 16.13 16.369-37.292h8.062v1.829h-6.868l-16.973 38.68-17.504-17.836-15.851-7.53L86.364 58.43l-16.707 2.945z"
    />
    <rect width={7} height={3} y={5} fill="#D9D9D9" rx={1} />
    <rect width={7} height={3} y={20} fill="#D9D9D9" rx={1} />
    <rect width={7} height={3} y={34} fill="#D9D9D9" rx={1} />
    <rect width={7} height={3} y={49} fill="#D9D9D9" rx={1} />
    <rect width={7} height={3} y={64} fill="#D9D9D9" rx={1} />
    <rect width={7} height={3} y={78} fill="#D9D9D9" rx={1} />
    <rect width={5} height={3} x={16} y={99} fill="#D9D9D9" rx={1} />
    <rect width={5} height={3} x={33} y={99} fill="#D9D9D9" rx={1} />
    <rect width={5} height={3} x={50} y={99} fill="#D9D9D9" rx={1} />
    <rect width={5} height={3} x={67} y={99} fill="#D9D9D9" rx={1} />
    <rect width={5} height={3} x={84} y={99} fill="#D9D9D9" rx={1} />
    <rect width={5} height={3} x={101} y={99} fill="#D9D9D9" rx={1} />
    <rect width={5} height={3} x={118} y={99} fill="#D9D9D9" rx={1} />
    <rect width={5} height={3} x={135} y={99} fill="#D9D9D9" rx={1} />
    <rect width={5} height={3} x={152} y={99} fill="#D9D9D9" rx={1} />
  </svg>
);

export const SvgShareLicenses = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 94 94" fill="none" {...props}>
    <path d="M47 94c25.957 0 47-21.043 47-47S72.957 0 47 0 0 21.043 0 47s21.043 47 47 47Z" fill="#EDF4F5" />
    <path
      d="M57.267 69.406h-8.45V36.711h8.366a1.816 1.816 0 1 0 0-3.633H36.817a1.816 1.816 0 0 0 0 3.633h8.367v32.695h-8.451a1.817 1.817 0 0 0 0 3.633h20.534a1.816 1.816 0 0 0 0-3.633Z"
      fill="#005EDF"
    />
    <path
      d="M57.267 69.406h-8.45V36.711h8.366a1.816 1.816 0 0 0 0-3.633H47V73.04h10.267a1.816 1.816 0 0 0 0-3.633Z"
      fill="#3630A2"
    />
    <path
      d="M17.816 41.43h19.375a1.816 1.816 0 0 0 1.817-1.817v-2.422c0-5.007-4.074-9.082-9.082-9.082h-4.844c-5.008 0-9.082 4.075-9.082 9.082v2.422c0 1.003.813 1.817 1.816 1.817ZM39.13 59.719h15.74a1.817 1.817 0 0 0 1.816-1.817V47.61a1.816 1.816 0 0 0-1.816-1.816h-6.998l-1.877-2.346a1.816 1.816 0 0 0-1.418-.681h-5.45a1.816 1.816 0 0 0-1.816 1.816v13.32c0 1.004.814 1.817 1.817 1.817Z"
      fill="#FFEF4A"
    />
    <path
      d="M37.191 41.43h-9.687V28.11h2.422c5.008 0 9.082 4.074 9.082 9.081v2.422a1.816 1.816 0 0 1-1.817 1.817Zm10.682 4.356h6.998c1.003 0 1.816.814 1.816 1.817v10.293a1.816 1.816 0 0 1-1.816 1.816H47V44.695l.873 1.091Z"
      fill="#FFCB00"
    />
    <path
      d="M76.184 41.43H56.809a1.816 1.816 0 0 1-1.817-1.817v-2.422c0-5.007 4.074-9.082 9.082-9.082h4.844c5.008 0 9.082 4.075 9.082 9.082v2.422a1.816 1.816 0 0 1-1.816 1.817Z"
      fill="#00EC89"
    />
    <path
      d="M66.496 41.43h9.688A1.816 1.816 0 0 0 78 39.613v-2.422c0-5.007-4.074-9.082-9.082-9.082h-2.422v13.32Z"
      fill="#00CB75"
    />
    <path
      d="M37.191 78H17.816A1.816 1.816 0 0 1 16 76.184v-2.422c0-5.008 4.074-9.082 9.082-9.082h4.844c5.008 0 9.082 4.074 9.082 9.082v2.422A1.816 1.816 0 0 1 37.19 78Z"
      fill="#FF8493"
    />
    <path
      d="M27.504 78h9.687a1.816 1.816 0 0 0 1.817-1.816v-2.422c0-5.008-4.074-9.082-9.082-9.082h-2.422V78Z"
      fill="#FF1F3D"
    />
    <path
      d="M76.184 78H56.809a1.816 1.816 0 0 1-1.817-1.816v-2.422c0-5.008 4.074-9.082 9.082-9.082h4.844c5.008 0 9.082 4.074 9.082 9.082v2.422A1.816 1.816 0 0 1 76.184 78Z"
      fill="#BCEAF9"
    />
    <path
      d="M66.496 78h9.688A1.816 1.816 0 0 0 78 76.184v-2.422c0-5.008-4.074-9.082-9.082-9.082h-2.422V78Z"
      fill="#7DD5F4"
    />
    <path
      d="M20.238 23.266c0 4.006 3.26 7.265 7.266 7.265s7.265-3.26 7.265-7.265c0-4.007-3.259-7.266-7.265-7.266s-7.266 3.26-7.266 7.266Zm38.992 0c0 4.006 3.26 7.265 7.266 7.265s7.266-3.26 7.266-7.265c0-4.007-3.26-7.266-7.266-7.266s-7.265 3.26-7.265 7.266ZM27.504 67.102c-4.006 0-7.266-3.26-7.266-7.266s3.26-7.266 7.266-7.266 7.265 3.26 7.265 7.266-3.259 7.266-7.265 7.266Zm31.726-7.266c0 4.006 3.26 7.266 7.266 7.266s7.266-3.26 7.266-7.266-3.26-7.266-7.266-7.266-7.265 3.26-7.265 7.266Z"
      fill="#FFD7AA"
    />
    <path
      d="M34.77 23.266c0 4.006-3.26 7.265-7.266 7.265V16c4.006 0 7.265 3.26 7.265 7.266Zm38.992 0c0 4.006-3.26 7.265-7.266 7.265V16c4.006 0 7.266 3.26 7.266 7.266ZM27.504 52.57v14.532c4.006 0 7.265-3.26 7.265-7.266s-3.259-7.266-7.265-7.266Zm38.992 14.532V52.57c4.006 0 7.266 3.26 7.266 7.266s-3.26 7.266-7.266 7.266Z"
      fill="#FFC58F"
    />
  </svg>
);

export const SvgShareAgancyLicense = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 80 80" fill="none" {...props}>
    <g>
      <path
        d="M78.36.04 14.444 15.8c-1.84.453-2.369 2.815-.898 4.01l13.37 10.858c.294.239.519.544.663.884L55.844 18.21 79.357.19a1.306 1.306 0 0 0-.998-.15Z"
        fill="#FFE28F"
      />
      <path
        d="M79.357.188 27.58 31.55c.135.317.2.665.182 1.02l-.948 17.823c-.036.685.23 1.31.678 1.752l36.021-30.303L79.6.375a1.342 1.342 0 0 0-.242-.188ZM49.572 51.915c.343.148.65.377.888.677L61.028 65.86c1.193 1.499 3.59.961 4.03-.904l14.906-63.33a1.305 1.305 0 0 0-.16-.993l-16.29 21.211-13.942 30.071Z"
        fill="#FFC263"
      />
      <path
        d="m79.599.375-52.107 51.77a2.285 2.285 0 0 0 1.742.662l19.302-1.079c.36-.02.714.047 1.036.186L79.804.63A1.341 1.341 0 0 0 79.6.375Z"
        fill="#FFA85A"
      />
      <path
        d="M2.344 67.066A2.344 2.344 0 0 1 .69 63.06l15.987-15.917a2.343 2.343 0 1 1 3.307 3.322L3.998 66.383a2.337 2.337 0 0 1-1.654.683Zm14.237-6.875L4.228 72.494a2.344 2.344 0 0 0-.007 3.314l8.814-6.429 6.86-9.181a2.344 2.344 0 0 0-3.314-.007Z"
        fill="#C9F7F6"
      />
      <path
        d="M15.379 80.003a2.344 2.344 0 0 1-1.654-4.005l15.987-15.917a2.343 2.343 0 1 1 3.307 3.322L17.033 79.32a2.336 2.336 0 0 1-1.654.683Zm-9.497-3.508a2.34 2.34 0 0 0 1.654-.683l12.353-12.303c.917-.913.92-2.397.007-3.315l-.034-.03-15.64 15.64c.457.46 1.058.69 1.66.69Z"
        fill="#8BEAE7"
      />
    </g>
  </svg>
);

export const BayutAppStoreArabicIcon = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} fill="none" viewBox="0 0 135 40" {...props}>
    <path
      fill="#A6A6A6"
      d="M130.2 40H4.73A4.74 4.74 0 0 1 0 35.27V4.73C0 2.12 2.12 0 4.73 0H130.2a4.802 4.802 0 0 1 4.8 4.73v30.54a4.798 4.798 0 0 1-4.8 4.73"
    />
    <path
      fill="#000"
      d="M134.03 35.27a3.831 3.831 0 0 1-3.83 3.83H4.73a3.832 3.832 0 0 1-3.84-3.83V4.72A3.84 3.84 0 0 1 4.73.9H130.2a3.828 3.828 0 0 1 3.83 3.84v30.54z"
    />
    <path
      fill="#fff"
      d="M30.13 19.78c-.03-3.22 2.64-4.79 2.76-4.86a5.94 5.94 0 0 0-4.68-2.53c-1.96-.2-3.87 1.18-4.87 1.18-1.03 0-2.57-1.16-4.23-1.12a6.23 6.23 0 0 0-5.24 3.2c-2.27 3.91-.58 9.68 1.6 12.85 1.08 1.55 2.35 3.29 4 3.23 1.63-.07 2.24-1.04 4.2-1.04 1.95 0 2.52 1.04 4.2 1 1.75-.03 2.85-1.56 3.9-3.13a12.833 12.833 0 0 0 1.78-3.62 5.6 5.6 0 0 1-3.42-5.16m-3.2-9.48a5.7 5.7 0 0 0 1.3-4.08 5.81 5.81 0 0 0-3.75 1.94 5.43 5.43 0 0 0-1.34 3.94 4.8 4.8 0 0 0 3.79-1.8m26.72 21.2h-2.28l-1.24-3.9h-4.32l-1.19 3.9h-2.21l4.28-13.3h2.65l4.3 13.3zm-3.9-5.55-1.12-3.47c-.12-.35-.34-1.2-.67-2.5h-.04c-.13.56-.34 1.4-.63 2.5l-1.1 3.48h3.57zm14.91.64c0 1.63-.44 2.92-1.32 3.87a3.872 3.872 0 0 1-2.94 1.26c-1.27 0-2.17-.45-2.73-1.36h-.04v5.05H55.5V25.07c0-1.03-.03-2.08-.08-3.16h1.88l.12 1.52h.04a3.551 3.551 0 0 1 3.23-1.72c1.14 0 2.08.45 2.84 1.34.75.9 1.13 2.08 1.13 3.54m-2.17.08c0-.94-.21-1.7-.63-2.31A2.18 2.18 0 0 0 60 23.4c-.52 0-1 .17-1.43.52-.43.35-.7.8-.84 1.37-.06.27-.1.48-.1.65v1.6c0 .7.22 1.3.65 1.77.43.47.98.72 1.66.72.8 0 1.43-.3 1.88-.92.45-.62.67-1.44.67-2.45zm13.21-.08c0 1.63-.44 2.92-1.33 3.87a3.862 3.862 0 0 1-2.94 1.26c-1.26 0-2.17-.45-2.72-1.36h-.04v5.05h-2.13V25.07c0-1.03-.03-2.08-.08-3.16h1.87l.12 1.52h.04a3.55 3.55 0 0 1 3.24-1.72c1.13 0 2.08.45 2.84 1.34a5.3 5.3 0 0 1 1.13 3.54m-2.17.08c0-.94-.21-1.7-.64-2.31a2.18 2.18 0 0 0-1.85-.95c-.53 0-1 .17-1.43.52-.43.35-.71.8-.84 1.37-.07.27-.1.48-.1.65v1.6c0 .7.21 1.3.64 1.77.43.48.98.72 1.67.72.8 0 1.43-.3 1.88-.92.44-.62.67-1.44.67-2.45m14.51 1.1c0 1.13-.4 2.05-1.18 2.77a5.24 5.24 0 0 1-3.63 1.16 6.35 6.35 0 0 1-3.45-.83l.5-1.78c.93.57 1.96.85 3.08.85.8 0 1.43-.18 1.88-.54.44-.36.67-.85.67-1.45 0-.54-.19-1-.56-1.37a5.14 5.14 0 0 0-1.83-1.03c-2.33-.87-3.5-2.14-3.5-3.81 0-1.1.41-2 1.23-2.7.81-.69 1.9-1.04 3.26-1.04 1.2 0 2.21.21 3.02.63l-.54 1.74c-.75-.4-1.6-.61-2.54-.61-.75 0-1.34.18-1.76.55-.36.33-.53.73-.53 1.2 0 .53.2.97.6 1.31.36.32 1 .66 1.94 1.03 1.15.46 1.99 1 2.53 1.62.54.61.8 1.38.8 2.3zm7.05-4.27h-2.35v4.67c0 1.18.41 1.77 1.24 1.77.38 0 .7-.03.95-.1l.06 1.62c-.42.16-.97.24-1.66.24-.84 0-1.5-.26-1.98-.77-.47-.51-.7-1.38-.7-2.59v-4.83h-1.4v-1.6h1.4v-1.76l2.09-.63v2.39h2.35v1.6zm10.61 3.13c0 1.47-.43 2.68-1.27 3.63a4.513 4.513 0 0 1-3.52 1.46c-1.4 0-2.53-.47-3.36-1.4-.83-.93-1.26-2.11-1.26-3.53 0-1.5.43-2.7 1.3-3.66a4.469 4.469 0 0 1 3.48-1.42c1.4 0 2.54.47 3.4 1.4.81.91 1.22 2.08 1.22 3.52zm-2.22.07c0-.89-.19-1.65-.57-2.28a2.098 2.098 0 0 0-1.92-1.15c-.85 0-1.5.38-1.95 1.15a4.4 4.4 0 0 0-.57 2.32c0 .88.18 1.64.57 2.27.46.77 1.1 1.15 1.93 1.15.82 0 1.46-.39 1.92-1.17.4-.64.59-1.41.59-2.3zm9.14-2.92a3.696 3.696 0 0 0-.67-.06c-.75 0-1.33.29-1.74.85a3.201 3.201 0 0 0-.53 1.9v5.03h-2.13l.02-6.57c0-1.1-.03-2.11-.08-3.02h1.85l.08 1.83h.06c.23-.63.58-1.13 1.07-1.52.47-.34.98-.5 1.54-.5.2 0 .37 0 .53.03zm9.54 2.47c.005.325-.022.65-.08.97h-6.4c.03.95.34 1.67.93 2.17.54.45 1.24.67 2.1.67.94 0 1.8-.15 2.58-.45l.33 1.48a7.999 7.999 0 0 1-3.21.6 4.657 4.657 0 0 1-3.5-1.32 4.86 4.86 0 0 1-1.28-3.53c0-1.44.4-2.65 1.18-3.6a4.09 4.09 0 0 1 3.36-1.55c1.38 0 2.43.52 3.14 1.54.56.82.85 1.82.85 3.02m-2.04-.55a2.906 2.906 0 0 0-.41-1.64c-.37-.6-.94-.89-1.7-.89-.7 0-1.26.29-1.7.87a3.182 3.182 0 0 0-.63 1.66z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M97.315 11.29h-.005c-.27 0-.51-.04-.62-.1-.03.3-.18.69-.33.92a2.48 2.48 0 0 1-2.25 1.17c-1.5 0-2.3-1-2.3-2.29 0-.59.18-1.16.38-1.57h.01l.69.1-.012.046c-.096.363-.188.712-.188 1.154 0 .9.62 1.46 1.54 1.46.44 0 1.1-.16 1.49-.7.11-.15.22-.39.22-.5 0-.22 0-.36-.05-.55-.197-.777-.51-1.38-.653-1.656l-.007-.014.88-.37c.13.23.46.98.58 1.64.16.08.38.1.62.1h.02c.42 0 .58-.2.77-.7.45-1.1.83-1.56 1.57-1.56 1 0 1.55 1.17 1.55 2.1 0 .73-.44 1.32-1.16 1.32a2.8 2.8 0 0 1-1.63-.61c-.25.37-.48.61-1.1.61zm3.155-1.41c0 .23-.17.3-.4.3v-.01c-.38 0-.92-.23-1.23-.5.22-.68.46-.85.78-.85.45 0 .85.59.85 1.06"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M110.16 10.13c-.36 0-.83-.07-.94-.82h-.01l-.17-4.62-.92.07.26 6.41c.02.22 0 .36-.08.5-.26.39-.89.64-1.54.64-.87 0-1.57-.5-1.57-1.5 0-.29.06-.61.17-.99l-.7-.11a3.78 3.78 0 0 0-.32 1.45c0 1.39.96 2.19 2.25 2.19a2.8 2.8 0 0 0 2.33-1.1c.2-.27.34-.68.34-1.35.24.32.62.39.9.39h.11c1.35 0 1.76-.25 2-.47.1-.24.14-.57.14-.85 0-.8-.32-1.82-.66-2.47l-.88.33a4.56 4.56 0 0 1 .7 2v.13c-.19.12-.58.17-1.18.17zM94.04 6.7c-.33 0-.56.24-.56.6s.23.58.56.58c.34 0 .57-.21.57-.58s-.23-.6-.57-.6m17.15 6.41c0 .35-.23.56-.54.56-.31 0-.56-.2-.56-.56 0-.35.24-.56.56-.56.32 0 .54.21.54.56m1.37 0c0 .35-.23.56-.55.56-.32 0-.54-.2-.54-.56 0-.35.22-.56.54-.56.32 0 .55.21.55.56m2.04-6.36c0-.36.24-.6.57-.6.34 0 .57.24.57.6s-.23.6-.58.6c-.32 0-.56-.23-.56-.6m2.96-.39c0-.37.23-.6.56-.6.35 0 .57.23.57.6s-.22.58-.57.58c-.33 0-.56-.22-.56-.58m-3.08 5.94c.7 0 1.45-.58 1.45-1.28 0-.4-.29-1.17-.85-2.06l.86-.32c.3.54.61.69 1.04.69.57 0 .99-.29 1.06-.82l.76-.08a4.6 4.6 0 0 0-.08.72c0 .75.42.97.999.98h.221c.6 0 .99-.05 1.19-.17v-.13a4.561 4.561 0 0 0-.72-2l.89-.33c.34.65.67 1.67.67 2.47 0 .28-.05.61-.15.85-.24.22-.65.47-2 .47h-.11c-.9 0-1.57-.45-1.66-1.38-.23.3-.71.45-1.12.45-.081 0-.188-.02-.258-.032a2.951 2.951 0 0 0-.042-.008c.057.242.084.491.08.74 0 1.14-.85 2.33-2.16 2.33-.5 0-1.05-.15-1.36-.53l.15-.85c.31.2.7.28 1.14.28zm5.29-6.87c-.32 0-.55.21-.55.57s.23.56.55.56c.33 0 .55-.2.55-.56 0-.36-.22-.57-.55-.57m1.37 0c-.31 0-.53.21-.53.57s.22.56.53.56c.33 0 .54-.2.54-.56 0-.36-.21-.57-.54-.57"
    />
  </svg>
);

export const BayutPlayStoreArabicIcon = (props) => (
  <svg viewBox="0 0 135 40" {...props}>
    <style>{'.st9{fill:#fff;stroke:#fff;stroke-width:.2;stroke-miterlimit:10}'}</style>
    <path
      fill="#a6a6a6"
      d="M130.2 40H4.7A4.7 4.7 0 0 1 0 35.3V4.7C0 2.1 2.1 0 4.7 0h125.5c2.6 0 4.8 2.1 4.8 4.7v30.5c0 2.7-2.2 4.8-4.8 4.8z"
    />
    <path d="M134 35.3c0 2.1-1.7 3.8-3.8 3.8H4.7a3.8 3.8 0 0 1-3.8-3.8V4.7C.9 2.6 2.6.9 4.7.9h125.5c2.1 0 3.8 1.7 3.8 3.8v30.6z" />
    <path
      fill="#fff"
      d="M68.1 21.8a4.25 4.25 0 1 0 .2 0c-.1-.1-.1-.1-.2 0zm0 6.8c-1.4.1-2.7-1-2.8-2.4-.1-1.4 1-2.7 2.4-2.8 1.4-.1 2.7 1 2.8 2.4v.2c.1 1.4-.9 2.5-2.4 2.6.1 0 .1 0 0 0zm-9.3-6.8a4.25 4.25 0 1 0 .2 0c-.1-.1-.1-.1-.2 0zm0 6.8c-1.4.1-2.7-1-2.8-2.4s1-2.7 2.4-2.8c1.4-.1 2.7 1 2.8 2.4v.2c.1 1.4-1 2.5-2.4 2.6.1 0 0 0 0 0zm-11.1-5.5v1.8H52c-.1.8-.4 1.6-1 2.3-.9.9-2.1 1.4-3.3 1.3-2.7 0-4.8-2.1-4.8-4.8s2.1-4.8 4.8-4.8c1.2 0 2.4.4 3.3 1.3l1.3-1.3a6.36 6.36 0 0 0-4.5-1.9c-3.6-.1-6.7 2.7-6.9 6.3-.1 3.6 2.7 6.7 6.3 6.9h.5c1.7.1 3.4-.6 4.6-1.8 1-1.2 1.6-2.7 1.6-4.2 0-.4 0-.8-.1-1.1h-6.1zm45.4 1.4c-.5-1.6-2-2.6-3.6-2.7-2.2 0-4 1.8-4 4v.3c0 2.3 1.8 4.2 4.1 4.2h.2c1.4 0 2.8-.7 3.5-1.9l-1.4-1c-.4.7-1.2 1.2-2.1 1.2s-1.7-.5-2.1-1.3l5.7-2.3-.3-.5zm-5.9 1.4c-.1-1.3.9-2.4 2.2-2.5.7 0 1.3.3 1.6.9l-3.8 1.6zM82.6 30h1.9V17.5h-1.9V30zm-3-7.3c-.6-.6-1.5-1-2.3-1a4.2 4.2 0 0 0-4 4.5c.1 2.2 1.9 3.9 4 4 .9 0 1.7-.4 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1 0-1.8-.6-2.1-1.5l-1.6.7c.6 1.5 2.1 2.5 3.8 2.5 2.2 0 4-1.3 4-4.4V22h-1.7l-.1.7zm-2.2 5.9c-1.4-.1-2.5-1.4-2.4-2.8.1-1.3 1.1-2.2 2.4-2.4 1.3.1 2.3 1.2 2.3 2.5v.1c.1 1.3-.9 2.5-2.2 2.6h-.1zm24.4-11.1h-4.5V30h1.9v-4.7h2.6c2.1.2 4-1.5 4.2-3.6s-1.5-4-3.6-4.2h-.6zm0 6h-2.6v-4.3h2.7c1.2 0 2.1 1 2.1 2.1s-1 2.2-2.2 2.2zm11.5-1.8c-1.4-.1-2.7.7-3.3 1.9l1.7.7c.3-.6 1-1 1.7-.9 1-.1 1.9.6 2 1.6v.1c-.6-.3-1.3-.5-1.9-.5-1.8 0-3.6 1-3.6 2.8.1 1.6 1.4 2.8 3 2.8h.1c1 .1 1.9-.4 2.4-1.2h.1v1h1.8v-4.8c-.1-2.2-1.8-3.5-4-3.5zm-.2 6.8c-.6 0-1.5-.3-1.5-1.1 0-1 1.1-1.3 2-1.3.6 0 1.2.1 1.7.4-.1 1.2-1 2.1-2.2 2zm10.6-6.5-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h1.9l5.1-11.8h-2zm-16.8 8h1.9V17.5h-1.9V30z"
    />
    <linearGradient
      id="SVGID_1_"
      x1={21.8}
      x2={5.01}
      y1={-1812.7}
      y2={-1829.48}
      gradientTransform="matrix(1 0 0 -1 0 -1804)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#00a0ff" />
      <stop offset={0.01} stopColor="#00a1ff" />
      <stop offset={0.26} stopColor="#00beff" />
      <stop offset={0.51} stopColor="#00d2ff" />
      <stop offset={0.76} stopColor="#00dfff" />
      <stop offset={1} stopColor="#00e3ff" />
    </linearGradient>
    <path fill="url(#SVGID_1_)" d="M10.4 7.5c-.3.4-.5.9-.4 1.4V31c0 .5.1 1 .5 1.4l.1.1L23 20.1v-.3L10.4 7.5z" />
    <linearGradient
      id="SVGID_2_"
      x1={33.83}
      x2={9.64}
      y1={-1824.05}
      y2={-1824.05}
      gradientTransform="matrix(1 0 0 -1 0 -1804)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#ffe000" />
      <stop offset={0.41} stopColor="#ffbd00" />
      <stop offset={0.78} stopColor="orange" />
      <stop offset={1} stopColor="#ff9c00" />
    </linearGradient>
    <path fill="url(#SVGID_2_)" d="m27 24.3-4.1-4.1v-.3l4.1-4.1h.1l4.9 2.8c1.4.8 1.4 2.1 0 2.9l-4.9 2.8H27z" />
    <linearGradient
      id="SVGID_3_"
      x1={24.82}
      x2={2.06}
      y1={-1826.28}
      y2={-1849.03}
      gradientTransform="matrix(1 0 0 -1 0 -1804)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#ff3a44" />
      <stop offset={1} stopColor="#c31162" />
    </linearGradient>
    <path fill="url(#SVGID_3_)" d="M27.1 24.2 22.9 20 10.4 32.5c.6.5 1.5.5 2.1.1l14.6-8.4" />
    <linearGradient
      id="SVGID_4_"
      x1={7.29}
      x2={17.45}
      y1={-1804.19}
      y2={-1814.35}
      gradientTransform="matrix(1 0 0 -1 0 -1804)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#32a071" />
      <stop offset={0.07} stopColor="#2da771" />
      <stop offset={0.48} stopColor="#15cf74" />
      <stop offset={0.8} stopColor="#06e775" />
      <stop offset={1} stopColor="#00f076" />
    </linearGradient>
    <path fill="url(#SVGID_4_)" d="M27.1 15.8 12.5 7.5c-.6-.5-1.5-.5-2.1 0L22.9 20l4.2-4.2z" />
    <path d="m27 24.1-14.5 8.2c-.6.4-1.4.4-2 0l-.1.1.1.1c.6.4 1.4.4 2 0l14.6-8.3-.1-.1z" opacity={0.2} />
    <path
      d="M10.4 32.3c-.3-.4-.5-.9-.5-1.4v.2c0 .5.1 1 .5 1.4v-.2zm21.6-11-5 2.8.1.1 4.9-2.8c.6-.3.9-.8 1-1.4-.1.6-.5 1-1 1.3z"
      style={{
        opacity: 0.12,
        enableBackground: 'new',
      }}
    />
    <path
      fill="#fff"
      d="M12.5 7.6 32 18.7c.5.3.9.7 1 1.3-.1-.6-.4-1.2-1-1.4l-19.5-11c-1.4-.9-2.5-.2-2.5 1.3V9c0-1.5 1.1-2.2 2.5-1.4z"
      opacity={0.25}
    />
    <path
      d="M70.4 14.5c-.5 0-1-.2-1.4-.5-.4-.4-.6-1-.5-1.5v-.6c0-.2.1-.5.2-.8l.4.1c-.1.3-.1.5-.1.8 0 .5.1.9.4 1.2s.7.5 1.1.5c.6 0 1.1-.1 1.6-.4.5-.2.8-.6 1.1-1-.4-.7-.6-1.4-.7-2.1 0-.2.1-.4.2-.5.2-.2.3-.4.6-.5 0 .3.1.7.2 1.4.2.1.5.2.8.2 0 0 .1 0 .1.1v.7s0 .1-.1.1c-.2 0-.5 0-.7-.1v.3c0 .5-.2.9-.4 1.3-.3.4-.7.8-1.2 1-.5.1-1 .3-1.6.3zm.9-6c-.2.3-.4.6-.7.8-.3-.2-.5-.5-.8-.7l.8-.8c.2.2.4.5.7.7z"
      className="st9"
    />
    <path
      d="M74.3 11.6c-.1 0-.1 0 0 0-.1 0-.1-.1 0 0l-.1-.8s0-.1.1-.1c.3 0 .5-.1.7-.2.2-.2.4-.4.5-.6l.2-.4c.2-.5.5-.9.8-1.3.2-.2.6-.4.9-.4s.5.2.6.4c.2.3.4.6.5 1s.2.8.2 1.2c0 .2 0 .4-.1.6-.1.2-.2.4-.4.5-.5 0-.9-.1-1.4-.2-.4-.1-.9-.2-1.3-.4-.2.5-.7.8-1.2.7zm3.7-.8c0-.4-.1-.9-.3-1.3-.2-.4-.3-.6-.5-.6-.1 0-.3 0-.4.1s-.3.2-.4.4c-.2.3-.3.6-.5.9.7.2 1.4.4 2.1.5zm6.8.4c-.3 0-.6-.1-.8-.1-.2 0-.3-.1-.5-.1-.2-.1-.3-.1-.5-.2-.1-.1-.3-.2-.4-.3s-.1-.2-.1-.2c0-.2.1-.3.2-.5s.1-.4.2-.5c.2-.3.4-.5.7-.7.4-.3.8-.5 1.2-.6v-.5c.2-.2.5-.4.8-.6l.1 3.6c.3.2.7.3 1.1.3 0 0 .1 0 .1.1v.7s0 .1-.1.1c-.4 0-.7-.1-1.1-.2-.3-.2-.4-.4-.5-.7v-.2l-.4.6zM83 9.7c.3.2.6.4 1 .5s.8.1 1.2.1l-.3-1.8c-.7.2-1.4.6-1.9 1.2z"
      className="st9"
    />
    <path
      d="M89.8 9.1c.1 0 .2 0 .3.1-.1.3-.2.6-.3.8-.1.1-.1.2-.2.4.2.1.4.3.7.3.2.1.5.1.7.1 0 0 .1 0 .1.1v.7s0 .1-.1.1c-.6 0-1.3-.2-1.7-.6l-.3.1c-.2.1-.5.2-.8.3-.4.1-.9.1-1.3.1 0 0-.1 0-.1-.1v-.7s0-.1.1-.1c.4 0 .8 0 1.2-.1.2 0 .5-.1.7-.2l.6-.9.2-.4c-.1.1 0 0 .2 0zm-1 3.9c-.2.3-.4.5-.7.8-.3-.2-.5-.4-.7-.7l.7-.7.7.6zm1.6-.1c-.2.3-.4.5-.7.8-.3-.2-.5-.4-.7-.7l.7-.7.7.6z"
      className="st9"
    />
    <path
      d="M91.1 11.6c-.1 0-.1 0 0 0-.1 0-.1-.1 0 0l-.1-.7s0-.1.1-.1c.4 0 .8-.1 1.2-.3a66 66 0 0 1-.3-4.2l-.1-1.5c.2-.2.5-.4.7-.6 0 1 .1 2.6.1 4.7v1.5c.3.2.7.3 1.1.3.1 0 .1 0 .1.1v.7c0 .1 0 .1-.1.1-.5 0-.9-.1-1.3-.4-.2.1-.5.2-.7.3-.2.1-.5.1-.7.1z"
      className="st9"
    />
    <path
      d="M93.9 11.6s-.1 0 0 0c-.1 0-.1-.1 0 0l-.1-.8s0-.1.1-.1h1.4c-.2-.1-.3-.3-.5-.5-.1-.2-.2-.4-.2-.6 0-.3.1-.7.2-1 .2-.3.4-.6.7-.8.2-.2.5-.3.8-.3s.5.1.7.2c.3.2.6.4.8.6l-.2.4c-.2-.1-.4-.2-.6-.2h-.4c-.5 0-1 .1-1.4.4 0 .6.3 1.2.9 1.5.3.2.7.3 1 .3.3-.1.5-.1.8-.2.3-.1.6-.2 1.1-.4.1.1.2.2.2.4v.1c0 .2-.2.4-.5.5-.9.2-1.5.4-2 .5s-.9.1-1.4.2c-.4-.2-.9-.2-1.4-.2zm13.4.6-.3-1.8-.6-3.9c-.1-.5-.1-1-.2-1.4 0-.2 0-.4.2-.6.1-.1.3-.2.6-.3v.1l.4 1.2-.3.2V6l.4 3.3c.1.5.1.9.2 1.4.2.1.5.2.8.2 0 0 .1 0 .1.1v.7s0 .1-.1.1c-.3 0-.5-.1-.8-.2v.4c0 .5-.1.9-.4 1.3-.3.4-.7.8-1.2 1a2.7 2.7 0 0 1-3-.1c-.4-.4-.6-1-.5-1.5v-.6c0-.2.1-.5.2-.8l.4.1c-.1.3-.1.5-.1.8 0 .5.1.9.4 1.2s.7.5 1.1.5.7-.1 1.1-.2c.4-.1.7-.3 1-.5.2-.5.5-.7.6-1z"
      className="st9"
    />
    <path
      d="M117.2 11.6c-.3 0-.6-.1-.9-.2-.3-.1-.5-.3-.8-.5-.4.2-.8.4-1.2.5-.5.1-.9.2-1.4.2s-1.1-.1-1.6-.2-.9-.2-1.3-.5l-.2.2c-.3.3-.8.4-1.2.4 0 0-.1 0-.1-.1v-.7s0-.1.1-.1c.3 0 .5 0 .8-.2.2-.2.5-.4.6-.7l.2-.3c.1-.1.2-.2.3-.2.1 0 .2 0 .3.1-.2.4-.3.6-.3.8.2.1.4.2.6.2 1.4-1.9 2.6-2.8 3.6-2.8.3 0 .5.1.8.2.3.2.6.4.8.6.2.2.3.4.4.7 0 .4-.1.9-.4 1.2.4.2.8.3 1.2.3.1 0 .1 0 .1.1v.7c-.3.3-.4.3-.4.3zm-4.2-.8c1 0 2.1-.4 2.9-.9-.2-.4-.5-.7-.8-.9a1.61 1.61 0 0 0-2.1.2c-.6.4-1.1.9-1.6 1.5.5 0 1.1.1 1.6.1z"
      className="st9"
    />
    <path
      d="M117.2 11.6c-.1 0-.1-.1 0 0l-.1-.8s0-.1.1-.1c.9 0 1.7-.1 2.5-.3l.6-.2 1.1-.3c-.3-.2-.6-.3-.9-.5-.2-.2-.5-.4-.7-.5s-.4-.1-.6-.1c-.3 0-.7.1-.9.3l-.3.2v-.5c0-.3.1-.5.4-.7s.6-.3 1-.2c.2 0 .4 0 .6.1.3.1.6.3.8.5.3.2.7.5 1 .6s.5.2.8.3c.4.1.8.1 1.2.1l-.4.8-.6-.1h-.3c-.2 0-.5 0-.7.1-.4.1-.7.3-1.1.5-.5.3-1 .4-1.5.6-.6.2-1.3.2-2 .2zm8-3.6v.7c0 .7 0 1.7-.1 2.9l-.5.1a56 56 0 0 0-.3-6.4v-.2c0-.2 0-.4.2-.6.1-.2.3-.3.6-.3v.1l.4 1.2-.3.2V8z"
      className="st9"
    />
  </svg>
);

export const IconLanguageSwitcher = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill={props.color || 'currentColor'}
    {...props}
  >
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm7 6h-3c-.3-1.3-.8-2.5-1.4-3.6A8 8 0 0 1 19 8zm-7-4a14 14 0 0 1 2 4h-4a14 14 0 0 1 2-4zM4.3 14a8.2 8.2 0 0 1 0-4h3.3a16.5 16.5 0 0 0 0 4H4.3zm.8 2h3c.3 1.3.7 2.4 1.3 3.6A8 8 0 0 1 5 16zm3-8H5a8 8 0 0 1 4.3-3.6C8.8 5.5 8.3 6.7 8 8zM12 20a14 14 0 0 1-2-4h4a14 14 0 0 1-2 4zm2.3-6H9.7a14.7 14.7 0 0 1 0-4h4.6a14.6 14.6 0 0 1 0 4zm.3 5.6c.6-1.2 1-2.4 1.4-3.6h3a8 8 0 0 1-4.4 3.6zm1.8-5.6a16.5 16.5 0 0 0 0-4h3.3a8.2 8.2 0 0 1 0 4h-3.3z" />
  </svg>
);

export const IconLogin = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 18 18"
    fill={props.color || 'currentColor'}
    {...props}
  >
    <path d="M9 1.5A7.5 7.5 0 1 0 16.5 9 7.5 7.5 0 0 0 9 1.5zm0 2.3A2.2 2.2 0 1 1 6.8 6 2.2 2.2 0 0 1 9 3.8zm0 10.6A5.4 5.4 0 0 1 4.5 12c0-1.5 3-2.3 4.5-2.3s4.5.8 4.5 2.3A5.4 5.4 0 0 1 9 14.4z" />
  </svg>
);

export const IconSettings = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill={props.color || 'currentColor'}
    {...props}
  >
    <path d="M14.4 9.7a5.3 5.3 0 0 0 0-.7 4.3 4.3 0 0 0 0-.7l1.5-1.2a.4.4 0 0 0 0-.4l-1.4-2.5a.4.4 0 0 0-.4-.2l-1.8.7A5.3 5.3 0 0 0 11 4l-.3-2a.4.4 0 0 0-.4-.2H7.6a.4.4 0 0 0-.4.3l-.3 2a5.4 5.4 0 0 0-1.2.6L4 4a.4.4 0 0 0-.4.2L2 6.7A.3.3 0 0 0 2 7l1.6 1.2a4.2 4.2 0 0 0 0 1.4L2 11a.4.4 0 0 0 0 .4l1.4 2.5a.4.4 0 0 0 .4.2l1.8-.7A5.3 5.3 0 0 0 7 14l.3 1.9a.4.4 0 0 0 .4.3h2.8a.3.3 0 0 0 .4-.3l.3-2a5.1 5.1 0 0 0 1.2-.6l1.8.7a.4.4 0 0 0 .4-.2l1.5-2.5a.3.3 0 0 0-.1-.4zm-5.4 2A2.7 2.7 0 1 1 11.7 9 2.7 2.7 0 0 1 9 11.7z" />
  </svg>
);

export const IconFavourite = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 18 18"
    fill={props.color || 'currentColor'}
  >
    <path d="M9 15.6l-1-1c-3.6-3.2-6-5.4-6-8a3.8 3.8 0 014-3.9 4.2 4.2 0 013 1.5 4.2 4.2 0 013.2-1.5 3.8 3.8 0 013.8 4c0 2.5-2.4 4.7-6 8z" />
  </svg>
);

export const IconPkgSilver = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="m11.695 2 3.54 5.965L22 9.485l-4.578 5.21.643 6.905-6.37-2.747L5.328 21.6l.643-6.905-4.58-5.21 6.768-1.52z"
    />
    <path
      fill="#DEDEDE"
      d="m11.695 18.122-5.593 2.411.566-6.066-4.022-4.572L8.588 8.56l3.107-5.239 3.107 5.239 5.944 1.336-4.024 4.572.566 6.066z"
    />
    <path fill="#fff" d="m6.669 14.456 5.027-2.542-5.592 8.608z" />
    <path fill="#fff" d="m2.646 9.891 9.049 2.03-3.107-3.366zm9.049-6.571v8.605l3.108-3.366z" />
    <path fill="#fff" d="m20.747 9.883-9.052 2.03 5.028 2.542zm-3.459 10.641-5.593-8.352v5.94z" />
  </svg>
);
export const IconPkgStarterPro = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#C6A6F2"
      d="m20.72 11.464-.056-.034-1.277-.688-7.084 3.75c-.188.1-.414.1-.602 0l-7.083-3.75-1.278.688a.637.637 0 0 0-.23.917l8.892 4.708 8.892-4.708a.636.636 0 0 0-.174-.883"
    />
    <path
      fill="#D4BDF5"
      d="M20.924 15.55a.64.64 0 0 0-.26-.26l-1.278-.688-7.083 3.75c-.189.1-.414.1-.602 0l-7.084-3.75-1.277.687a.643.643 0 0 0 0 1.132l8.357 4.5c.19.102.42.102.61 0l8.357-4.5a.643.643 0 0 0 .26-.871"
    />
    <path
      fill="#A97BEA"
      d="m20.72 7.61-.056-.033-8.357-4.5a.64.64 0 0 0-.61 0l-8.357 4.5a.636.636 0 0 0-.23.917l8.892 4.707 8.892-4.707a.636.636 0 0 0-.174-.883"
    />
  </svg>
);
export const IconPkgStarter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#FFA900"
        d="M7.054 20.08a2.193 2.193 0 1 0-3.1-3.102c-.61.61-.852 1.555-.927 2.411-.044.484-.04.972.008 1.456.013.12.13.148.15.152h.006c.049 0 .75.016.965-.668q.059-.193.17-.36a.237.237 0 0 1 .429.169c-.036.26.018.523.152.748a.145.145 0 0 0 .147.07c.734-.112 1.486-.363 2-.877"
      />
      <path
        fill="#00A651"
        d="M20.975 4.645c-.053-.918-.71-1.575-1.627-1.628-3.116-.185-6.588 1.136-9.296 3.843l-.722.723q-.39.39-.741.8H6.312c-.484.02-.911.298-1.153.707l-1.338 2.677q-.054.144-.075.298a.66.66 0 0 0 .653.65h1.69c-.22.739-.073 1.465.396 1.934l2.858 2.858c.469.47 1.195.615 1.934.396v1.692a.66.66 0 0 0 .65.65 1.4 1.4 0 0 0 .298-.074l2.677-1.338a1.41 1.41 0 0 0 .707-1.153v-2.276q.41-.352.8-.742l.723-.722c2.708-2.708 4.029-6.18 3.843-9.295"
      />
      <path
        fill="#7ED8AA"
        d="M9.336 7.575q-.39.39-.742.801H6.318a1.415 1.415 0 0 0-1.153.707L3.826 11.76a1.4 1.4 0 0 0-.074.297.66.66 0 0 0 .652.651h1.69c-.219.738-.072 1.465.397 1.934l2.316 2.316c4.654-.752 8.21-4.787 8.21-9.654a9.7 9.7 0 0 0-.848-3.984c-2.155.536-4.303 1.725-6.11 3.533z"
        opacity={0.54}
      />
      <path fill="#fff" d="M17.186 10.075a2.304 2.304 0 1 1-3.259-3.26 2.304 2.304 0 0 1 3.259 3.26" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2.998 3h18v18h-18z" />
      </clipPath>
    </defs>
  </svg>
);

export const IconPkgPlatinum = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path fill="#70B7F2" d="M3.002 9.922c.007.163.07.323.19.448l8.81 9.12-.53-6.516-2.215-3.052-2.632-.906z" />
    <path fill="#5C7BDD" d="m14.744 9.922-1.857 3.362L12 19.49l8.809-9.12a.68.68 0 0 0 .19-.448l-3.257-.906z" />
    <path fill="#70B7F2" d="M12 4.492 9.734 7.208l-.478 2.716 2.81 1.36 2.678-1.36-.403-2.566z" />
    <path fill="#5C7BDD" d="m12.066 11.284 2.678-1.36-.403-2.566L12 4.492v6.76z" />
    <path fill="#8DD1FF" d="M12 4.492H7.4L3.163 9.45a.68.68 0 0 0-.162.474h6.255z" />
    <path fill="#70B7F2" d="M21 9.924a.69.69 0 0 0-.163-.474L16.6 4.492H12l2.744 5.432z" />
    <path fill="#8DD1FF" d="M9.256 9.93 12 19.498l2.744-9.568z" />
    <path fill="#70B7F2" d="m12 19.498 2.744-9.568H12z" />
  </svg>
);

export const IconPkgGold = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#FF9633"
      fillRule="evenodd"
      d="M2.233 15.532 1.016 7.927a1.286 1.286 0 0 1 1.956-1.29l3.813 2.407 3.996-4.58a1.286 1.286 0 0 1 1.938 0l3.996 4.58 3.813-2.408a1.287 1.287 0 0 1 1.956 1.291l-1.217 7.605zm18.794 1.5-.355 2.217a1.82 1.82 0 0 1-1.798 1.534H4.626c-.894 0-1.657-.65-1.798-1.534l-.355-2.217z"
      clipRule="evenodd"
    />
    <path
      fill="#FEAF2B"
      fillRule="evenodd"
      d="m1.016 7.904 1.217 7.605h9.57V4.001L11.75 4c-.37 0-.725.161-.969.441l-3.996 4.58-3.813-2.408a1.287 1.287 0 0 0-1.956 1.291m10.787 9.105v3.751H4.626c-.894 0-1.657-.65-1.798-1.534l-.355-2.217z"
      clipRule="evenodd"
    />
    <path
      fill="#FFBB4B"
      fillRule="evenodd"
      d="M11.8 17.016H2.473l.355 2.217a1.82 1.82 0 0 0 1.798 1.534H11.8z"
      clipRule="evenodd"
    />
  </svg>
);

export const IconPkgPlatinumPlus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#DFBC21"
      d="m3.134 11.79-.564.238a.55.55 0 0 0 .162.391l8.878 8.847c.104.103.282.16.386.16a.63.63 0 0 0 .393-.16l8.877-8.853a.55.55 0 0 0 .162-.39l-.49-.234h-5.892l-3.305 1.067-2.795-1.067z"
    />
    <path
      fill="#DFBC21"
      d="M21.428 12.023a.55.55 0 0 1-.161.39l-8.877 8.853a.63.63 0 0 1-.39.16v-8.653l3.047-.984h5.892z"
    />
    <path fill="#F6D12C" d="M8.947 11.79 12 21.425l3.047-9.637z" />
    <path fill="#D3AE08" d="M15.047 11.79 12 21.425V11.79z" />
    <path
      fill="#FFDE47"
      d="M21.335 11.72 18.38 7.292a.6.6 0 0 0-.154-.153l-.268.129-5.448.034-.511-.255-.413.26-5.436.034-.38-.201a.6.6 0 0 0-.153.153l-2.954 4.432a.55.55 0 0 0-.093.306l18.857-.005a.55.55 0 0 0-.092-.306"
    />
    <path
      fill="#F6D12C"
      d="M21.428 12.026 12 12.03V7.047l.511.254 5.448-.033.268-.13q.091.062.154.154l2.955 4.427c.063.094.093.2.092.307"
    />
    <path
      fill="#DFBC21"
      d="M6.075 7.047a.55.55 0 0 0-.305.092l3.272 4.89 2.955-4.982zm8.881 4.981 3.271-4.89a.55.55 0 0 0-.305-.091H12l2.954 4.98z"
    />
    <path
      fill="#F0C91A"
      d="M8.7 15.884a1.677 1.677 0 0 1-1.674-1.675.553.553 0 0 0-1.105 0c0 .919-.747 1.675-1.675 1.675a.552.552 0 1 0 0 1.104c.923 0 1.675.752 1.675 1.675a.553.553 0 0 0 1.105 0c0-.919.746-1.675 1.674-1.675a.553.553 0 0 0 0-1.104m8.467-11.086a1.677 1.677 0 0 1-1.675-1.675.553.553 0 0 0-1.105 0c0 .923-.75 1.675-1.674 1.675a.552.552 0 0 0 0 1.105c.923 0 1.675.75 1.675 1.674a.552.552 0 1 0 1.104 0c0-.923.752-1.674 1.675-1.674a.553.553 0 0 0 0-1.105"
    />
  </svg>
);

export const IconPkgBronze = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M16.993 3.547h-9.95a.07.07 0 0 0-.059.034L2.01 12.198a.07.07 0 0 0 0 .067l4.975 8.617q.02.033.059.034h9.95a.07.07 0 0 0 .058-.034l4.975-8.617a.07.07 0 0 0 0-.067L17.051 3.58a.07.07 0 0 0-.058-.034"
      />
      <path
        fill="url(#c)"
        d="M16.817 3.844h-9.6a.07.07 0 0 0-.056.032l-4.8 8.314a.07.07 0 0 0 0 .065l4.8 8.315c.011.02.033.032.056.032h9.6a.07.07 0 0 0 .056-.032l4.8-8.315a.07.07 0 0 0 0-.065l-4.8-8.314a.07.07 0 0 0-.056-.032"
      />
      <path
        fill="#FFB88C"
        d="m21.406 11.723-4.26-7.379a1 1 0 0 0-.867-.5H7.76a1 1 0 0 0-.866.5l-.084.145a1 1 0 0 1 .593-.205h8.52a1 1 0 0 1 .867.5l4.26 7.379a1 1 0 0 1 0 1l-4.176 7.234a1 1 0 0 0 .273-.295l4.26-7.379a1 1 0 0 0 0-1"
        opacity={0.4}
      />
      <path
        fill="#000"
        d="M15.886 5.477H8.151a.05.05 0 0 0-.046.026l-3.868 6.699a.05.05 0 0 0 0 .052l3.868 6.7q.016.025.046.026h7.735q.03 0 .046-.027l3.867-6.699a.05.05 0 0 0 0-.052l-3.867-6.7a.05.05 0 0 0-.046-.025"
        opacity={0.3}
      />
      <path
        fill="url(#d)"
        d="M19.578 11.825 16.146 5.88a.8.8 0 0 0-.698-.403H8.583a.8.8 0 0 0-.699.403l-.029.05a.8.8 0 0 1 .687-.388h6.865c.288 0 .554.153.698.403l3.433 5.945a.8.8 0 0 1 0 .806l-3.404 5.895.012-.015 3.432-5.945a.8.8 0 0 0 0-.806"
        opacity={0.3}
      />
      <path
        fill="url(#e)"
        d="M15.783 5.672H8.255a.05.05 0 0 0-.045.025l-3.764 6.52a.05.05 0 0 0 0 .051l3.764 6.52a.05.05 0 0 0 .044.025h7.529a.05.05 0 0 0 .044-.025l3.764-6.52a.05.05 0 0 0 0-.05l-3.764-6.52a.05.05 0 0 0-.044-.026"
      />
      <path
        fill="#797EC2"
        d="M15.686 18.262H9.005c-.28 0-.54-.15-.68-.393l-3.34-5.786a.79.79 0 0 1 0-.784l3.073-5.322c-.02.026-.045.05-.061.079l-3.341 5.786a.78.78 0 0 0 0 .785l3.34 5.786c.14.242.4.392.68.392h6.681c.28 0 .54-.15.68-.392l.267-.464a.78.78 0 0 1-.618.313"
        opacity={0.1}
      />
      <path
        fill="#00051C"
        d="m19.377 11.85-3.34-5.786a.79.79 0 0 0-.68-.392h-6.68c-.281 0-.54.15-.68.392l-.34.59a.8.8 0 0 1 .394-.107h6.682c.28 0 .539.15.679.392l3.34 5.786c.14.243.14.542 0 .784l-3 5.197a.8.8 0 0 0 .285-.285l3.34-5.786a.79.79 0 0 0 0-.785"
        opacity={0.2}
      />
      <path
        fill="#000"
        d="m12.224 8.218 1.568 1.913a.5.5 0 0 0 .208.152l2.305.9a.51.51 0 0 1 .243.749l-1.335 2.082a.5.5 0 0 0-.08.245l-.144 2.47a.51.51 0 0 1-.637.463l-2.393-.627a.5.5 0 0 0-.258 0l-2.393.627a.51.51 0 0 1-.637-.463l-.144-2.47a.5.5 0 0 0-.08-.245l-1.335-2.082a.51.51 0 0 1 .243-.75l2.305-.9a.5.5 0 0 0 .208-.15l1.568-1.914a.51.51 0 0 1 .788 0"
        opacity={0.3}
      />
      <path
        fill="#000"
        d="m12.353 7.999 1.568 1.913a.5.5 0 0 0 .208.152l2.304.9a.51.51 0 0 1 .244.749l-1.335 2.082a.5.5 0 0 0-.08.246l-.144 2.47a.51.51 0 0 1-.637.462l-2.393-.626a.5.5 0 0 0-.258 0l-2.393.626a.51.51 0 0 1-.637-.463l-.144-2.47a.5.5 0 0 0-.08-.245l-1.335-2.082a.51.51 0 0 1 .243-.75l2.305-.899a.5.5 0 0 0 .208-.152L11.565 8a.51.51 0 0 1 .788 0"
        opacity={0.3}
      />
      <path
        fill="#F19E56"
        d="m12.388 7.82 1.568 1.913a.5.5 0 0 0 .208.151l2.305.9a.51.51 0 0 1 .243.75l-1.335 2.082a.5.5 0 0 0-.08.245l-.144 2.47a.51.51 0 0 1-.637.463l-2.393-.627a.5.5 0 0 0-.258 0l-2.393.627a.51.51 0 0 1-.637-.463l-.144-2.47a.5.5 0 0 0-.08-.245l-1.335-2.083a.51.51 0 0 1 .243-.749l2.305-.9a.5.5 0 0 0 .208-.151L11.6 7.819a.51.51 0 0 1 .788 0"
      />
      <path
        fill="#FFC496"
        d="M15.287 13.81a.5.5 0 0 0-.08.246l-.143 2.47c-.002.036-.02.065-.029.098a.5.5 0 0 0 .116-.277l.144-2.47c.003-.056.03-.106.051-.158zm1.18-3.018-2.305-.9a.5.5 0 0 1-.208-.151l-1.568-1.914a.51.51 0 0 0-.788 0L10.03 9.741a.5.5 0 0 1-.208.151l-2.305.9a.5.5 0 0 0-.302.353.5.5 0 0 1 .215-.174l2.305-.9a.5.5 0 0 0 .208-.152l1.568-1.913a.51.51 0 0 1 .788 0l1.568 1.913a.5.5 0 0 0 .208.152l2.305.9a.5.5 0 0 1 .278.65l.052-.08a.51.51 0 0 0-.243-.749"
        opacity={0.3}
      />
      <g fill="#000" opacity={0.3}>
        <path
          d="m14.618 16.497-2.393-.627a.5.5 0 0 0-.258 0l-2.393.627a.51.51 0 0 1-.637-.463l-.144-2.47a.5.5 0 0 0-.08-.245l-1.335-2.083a.5.5 0 0 1-.071-.275.5.5 0 0 0-.03.578l1.335 2.082a.5.5 0 0 1 .08.246l.144 2.47a.51.51 0 0 0 .637.462l2.393-.626a.5.5 0 0 1 .258 0l2.393.626a.51.51 0 0 0 .637-.463l.003-.044a.5.5 0 0 1-.54.204"
          opacity={0.3}
        />
        <path d="M15.478 13.312a.5.5 0 0 0-.08.245l-.002.027 1.316-2.052a.5.5 0 0 0 .073-.259z" />
      </g>
      <path
        fill="#4F0B0B"
        d="m12.215 8.649 1.316 1.606q.072.086.175.127l1.935.756c.252.098.35.402.204.629l-1.12 1.748a.43.43 0 0 0-.068.206l-.12 2.073a.427.427 0 0 1-.535.39l-2.01-.527a.4.4 0 0 0-.216 0l-2.01.526a.427.427 0 0 1-.534-.389l-.12-2.073a.4.4 0 0 0-.068-.206l-1.12-1.748a.427.427 0 0 1 .204-.63l1.934-.755a.4.4 0 0 0 .175-.127l1.317-1.606a.427.427 0 0 1 .661 0"
        opacity={0.3}
      />
      <path
        fill="url(#f)"
        d="m12.328 8.524 1.317 1.606q.07.086.175.128l1.934.755c.252.098.35.402.205.629l-1.121 1.748a.4.4 0 0 0-.067.206l-.121 2.074a.427.427 0 0 1-.535.388l-2.01-.526a.4.4 0 0 0-.216 0l-2.009.526a.427.427 0 0 1-.535-.388l-.12-2.074a.4.4 0 0 0-.067-.206l-1.121-1.748a.427.427 0 0 1 .204-.629l1.935-.755a.43.43 0 0 0 .175-.128l1.316-1.606a.427.427 0 0 1 .661 0"
      />
      <path
        fill="#000"
        d="M14.764 13.56a.4.4 0 0 0-.067.206l-.12 2.074c-.002.022-.014.04-.018.06a.4.4 0 0 0 .086-.22l.12-2.074c.002-.035.022-.065.032-.098zm.984-2.547-1.934-.755a.43.43 0 0 1-.176-.128l-1.316-1.606a.427.427 0 0 0-.661 0l-1.316 1.606a.43.43 0 0 1-.176.128l-1.934.755a.42.42 0 0 0-.256.318.4.4 0 0 1 .187-.157l1.935-.756a.4.4 0 0 0 .175-.127l1.316-1.607a.428.428 0 0 1 .661 0l1.317 1.607q.071.086.175.127l1.935.756a.42.42 0 0 1 .247.507l.026-.04a.428.428 0 0 0-.205-.628"
        opacity={0.3}
      />
      <path
        fill="#797EC2"
        d="M16.634 20.028h-8.52a1 1 0 0 1-.867-.5l-4.26-7.38a1 1 0 0 1 0-1L6.98 4.234c-.03.038-.064.073-.089.116l-4.26 7.378a1 1 0 0 0 0 1l4.26 7.38a1 1 0 0 0 .867.5h8.52a1 1 0 0 0 .866-.5l.269-.466a1 1 0 0 1-.778.386"
        opacity={0.2}
      />
    </g>
    <defs>
      <linearGradient id="b" x1={7.209} x2={15.32} y1={19.855} y2={6.996} gradientUnits="userSpaceOnUse">
        <stop stopColor="#B95B39" />
        <stop offset={0.319} stopColor="#99412F" />
        <stop offset={1} stopColor="#FFA14F" />
      </linearGradient>
      <linearGradient id="c" x1={6.953} x2={18.923} y1={21.505} y2={0.082} gradientUnits="userSpaceOnUse">
        <stop stopColor="#B95B39" />
        <stop offset={0.319} stopColor="#99412F" />
        <stop offset={1} stopColor="#E99247" />
      </linearGradient>
      <linearGradient id="d" x1={16.463} x2={5.772} y1={7.203} y2={19.253} gradientUnits="userSpaceOnUse">
        <stop stopColor="#941010" />
        <stop offset={1} stopColor="#FFA02B" />
      </linearGradient>
      <linearGradient id="e" x1={7.91} x2={17.258} y1={18.83} y2={3.843} gradientUnits="userSpaceOnUse">
        <stop stopColor="#B95B39" />
        <stop offset={0.319} stopColor="#99412F" />
        <stop offset={1} stopColor="#FFA14F" />
      </linearGradient>
      <linearGradient id="f" x1={9.696} x2={15.446} y1={15.935} y2={7.359} gradientUnits="userSpaceOnUse">
        <stop stopColor="#B95B39" />
        <stop offset={0.319} stopColor="#99412F" />
        <stop offset={1} stopColor="#FFA14F" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);

export const IconListings = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} fill="currentColor" viewBox="0 0 19 18" {...props}>
    <path d="M6.17 15.019V8.25h1.2c.088 0 .175.01.263.028.087.019.175.04.262.066l5.194 1.931a.827.827 0 0 1 .422.338.91.91 0 0 1 .159.506c0 .262-.09.475-.272.637a.913.913 0 0 1-.628.244h-1.969a.77.77 0 0 1-.14-.01.516.516 0 0 1-.122-.046l-1.2-.469-.244.731 1.444.507a.363.363 0 0 0 .112.028c.05.006.094.009.132.009h5.137c.4 0 .75.144 1.05.431.3.288.45.644.45 1.069l-5.981 2.25zM1.67 16.5V8.25h3v8.25zm13.144-6a3.261 3.261 0 0 0-.75-1.088 3.401 3.401 0 0 0-1.2-.73L7.67 6.75h-1.5V4.875l5.25-3.75 5.25 3.75V10.5z" />
  </svg>
);
export const IconWhatsapp = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill="#EDEDED"
        d="m.5 14.5.966-3.5A7.06 7.06 0 0 1 .5 7.452C.5 3.638 3.638.5 7.476.5S14.5 3.638 14.5 7.452 11.314 14.5 7.476 14.5c-1.207 0-2.366-.386-3.404-.966z"
      />
      <path
        fill="#55CD6C"
        d="m4.262 12.276.217.12c.893.555 1.931.893 3.017.893 3.162 0 5.793-2.63 5.793-5.841 0-3.21-2.63-5.745-5.817-5.745-3.186 0-5.769 2.559-5.769 5.745 0 1.11.314 2.196.893 3.114l.145.217-.555 2.028z"
      />
      <path
        fill="#FEFEFE"
        d="m5.617 4.22-.458-.025a.55.55 0 0 0-.386.145c-.218.193-.58.555-.676 1.038-.17.724.096 1.593.724 2.462.627.87 1.834 2.27 3.958 2.873.676.193 1.207.072 1.642-.193.338-.218.555-.556.627-.918l.073-.338A.24.24 0 0 0 11 9l-1.522-.7a.23.23 0 0 0-.29.072l-.603.773c-.048.048-.12.072-.193.048-.41-.145-1.786-.724-2.534-2.173-.024-.072-.024-.144.024-.193l.58-.651c.048-.073.072-.17.048-.242l-.7-1.569a.21.21 0 0 0-.194-.145"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5.5h14v14H.5z" />
      </clipPath>
    </defs>
  </svg>
);
export const IconConvertAgency = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#006169"
      fillOpacity={0.8}
      d="M7.817 13.217a2.33 2.33 0 0 1-1.375-2.127V7.645h.8c.504 0 .94-.548.722-.99-.638-1.288-1.567-2.591-2.367-3.872a.686.686 0 0 0-1.172 0c-.801 1.28-1.73 2.584-2.367 3.872-.218.442.217.99.721.99h.798v3.445a2.445 2.445 0 0 0 2.445 2.444H7.75c.179 0 .23-.244.068-.317"
    />
    <path
      fill="#006169"
      fillOpacity={0.8}
      d="M8.183 2.77a2.33 2.33 0 0 1 1.375 2.127v3.445h-.8c-.504 0-.938.548-.722.99.638 1.288 1.567 2.591 2.368 3.872a.685.685 0 0 0 1.171 0c.802-1.28 1.73-2.584 2.368-3.872.217-.442-.218-.99-.722-.99h-.798V4.898a2.445 2.445 0 0 0-2.445-2.445H8.25c-.179 0-.23.243-.068.317"
    />
    <path
      fill="#006169"
      d="M5.596 2.783a.686.686 0 0 0-1.171 0c-.801 1.28-1.73 2.584-2.367 3.872-.218.442.217.99.721.99h.799v3.445q0 .091.006.18a6.6 6.6 0 0 0 2.86-.085l-.003-.095V7.645h.801c.504 0 .939-.548.721-.99-.636-1.288-1.565-2.591-2.367-3.872"
    />
    <path
      fill="#006169"
      d="M8.251 2.453c-.178 0-.23.244-.068.317A2.33 2.33 0 0 1 9.56 4.897v3.445h-.801c-.504 0-.938.548-.721.99q.224.45.488.904a6.525 6.525 0 0 0 2.436-7.577 2.4 2.4 0 0 0-.983-.206z"
    />
  </svg>
);

export const IconPackageCredit = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={53} height={52} viewBox="0 0 52 52" fill="none" {...props}>
    <path
      fill="#F7F7F7"
      d="M42.5 0h-32C4.977 0 .5 4.477.5 10v32c0 5.523 4.477 10 10 10h32c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10"
    />
    <g clipPath="url(#IconPackageCredit)">
      <path
        fill="#E8E8E8"
        d="M31.75 13.167c-4.988 0-8.75 2.007-8.75 4.667v4.083a1.166 1.166 0 1 0 2.333 0v-.847c1.574.89 3.83 1.43 6.417 1.43s4.843-.54 6.417-1.43v1.43c0 .929-2.559 2.334-6.417 2.334-.74 0-1.466-.053-2.162-.157a1.173 1.173 0 0 0-1.326.983c-.095.637.345 1.23.982 1.326.808.12 1.652.181 2.505.181 2.586 0 4.843-.54 6.417-1.43v1.43c0 .929-2.559 2.333-6.417 2.333a1.166 1.166 0 1 0 0 2.334c2.586 0 4.843-.54 6.417-1.43v1.43c0 .928-2.559 2.333-6.417 2.333a1.166 1.166 0 1 0 0 2.333c2.586 0 4.843-.54 6.417-1.43v1.43c0 .929-2.559 2.334-6.417 2.334-.548 0-1.094-.03-1.625-.087a1.167 1.167 0 1 0-.25 2.32c.61.066 1.241.1 1.874.1 4.987 0 8.75-2.007 8.75-4.667V17.834c0-2.66-3.763-4.667-8.75-4.667zm0 7c-3.858 0-6.417-1.405-6.417-2.333S27.892 15.5 31.75 15.5s6.417 1.405 6.417 2.334c0 .928-2.559 2.333-6.417 2.333"
      />
      <path
        fill="#D6D6D6"
        d="M31.75 12C26.762 12 23 14.007 23 16.667v4.083a1.166 1.166 0 1 0 2.333 0v-.847c1.574.89 3.83 1.43 6.417 1.43s4.843-.54 6.417-1.43v1.43c0 .929-2.559 2.334-6.417 2.334-.74 0-1.466-.053-2.162-.157a1.173 1.173 0 0 0-1.326.983c-.095.637.345 1.23.982 1.326.808.12 1.652.181 2.505.181 2.586 0 4.843-.54 6.417-1.43V26c0 .929-2.559 2.333-6.417 2.333a1.166 1.166 0 1 0 0 2.334c2.586 0 4.843-.54 6.417-1.43v1.43c0 .928-2.559 2.333-6.417 2.333a1.166 1.166 0 1 0 0 2.333c2.586 0 4.843-.54 6.417-1.43v1.43c0 .929-2.559 2.334-6.417 2.334-.548 0-1.094-.03-1.625-.087a1.167 1.167 0 1 0-.25 2.32c.61.066 1.241.1 1.874.1 4.987 0 8.75-2.007 8.75-4.667V16.667c0-2.66-3.763-4.667-8.75-4.667zm0 7c-3.858 0-6.417-1.405-6.417-2.333s2.559-2.334 6.417-2.334 6.417 1.405 6.417 2.334c0 .928-2.559 2.333-6.417 2.333"
      />
      <path
        fill="#E7F3EF"
        d="m17.945 30.716 2.139-2.14zm2.139-2.14 2.139 2.14zm0 0v5.348zM26.5 31.25a6.416 6.416 0 1 0-12.832 0 6.416 6.416 0 0 0 12.832 0"
      />
      <path
        stroke="#006169"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="m17.945 30.716 2.139-2.14m0 0 2.139 2.14m-2.14-2.14v5.348M26.5 31.25a6.416 6.416 0 1 0-12.832 0 6.416 6.416 0 0 0 12.832 0"
      />
      <path
        fill="#ACC9CB"
        fillRule="evenodd"
        d="m21.34 19.681-.687-1.037-2.07 1.375.686 1.036zm-5.954 3.95-.687-1.036-2.07 1.374.686 1.036zm-.761-6.205 1.373 2.07-1.035.688-1.374-2.07z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="IconPackageCredit">
        <path fill="#fff" d="M12.5 12h28v28h-28z" />
      </clipPath>
    </defs>
  </svg>
);
export const IconCredit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      fill="#767676"
      d="M8.441 1c-2.052 0-3.6.825-3.6 1.92V4.6a.48.48 0 1 0 .96 0v-.348c.647.366 1.576.589 2.64.589s1.993-.223 2.64-.59v.59c0 .382-1.052.96-2.64.96q-.458 0-.89-.065a.48.48 0 0 0-.142.95q.502.075 1.032.075c1.064 0 1.993-.222 2.64-.589v.589c0 .382-1.052.96-2.64.96a.48.48 0 1 0 0 .96c1.064 0 1.993-.222 2.64-.588v.588c0 .383-1.052.96-2.64.96a.48.48 0 1 0 0 .961c1.064 0 1.993-.222 2.64-.589v.589c0 .382-1.052.96-2.64.96q-.34 0-.669-.035a.48.48 0 1 0-.103.954c.251.028.511.042.771.042 2.053 0 3.601-.826 3.601-1.921V2.92c0-1.095-1.548-1.92-3.6-1.92m0 2.88c-1.588 0-2.64-.578-2.64-.96s1.052-.96 2.64-.96 2.64.578 2.64.96-1.052.96-2.64.96"
    />
    <path
      stroke="#767676"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.823}
      d="m2.76 8.7.88-.88m0 0 .88.88m-.88-.88v2.201m2.641-1.1A2.64 2.64 0 1 0 1 8.92a2.64 2.64 0 0 0 5.281 0"
    />
  </svg>
);
export const IconCreditLimit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="currentColor"
    viewBox="0 0 16 17"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.5 5C7.433 5 9 4.552 9 4S7.433 3 5.5 3 2 3.448 2 4s1.567 1 3.5 1m0 2.243c1.933 0 3.5-.448 3.5-1V5.109c-1.102.59-2.998.634-3.5.634S3.102 5.7 2 5.109v1.134c0 .552 1.567 1 3.5 1m1.25 5.187v1.494c-.385.045-.81.07-1.25.07-1.935 0-3.5-.45-3.5-1V11.86c1.1.59 3 .635 3.5.635.215 0 .69-.01 1.25-.065m.055-2.256c-.015.045-.025.1-.035.15l-.02-.015v1.365c-.385.045-.81.07-1.25.07-1.935 0-3.5-.45-3.5-1V9.61c1.1.59 3 .635 3.5.635.22 0 .72-.01 1.305-.07M5.5 7.993c-.502 0-2.398-.043-3.5-.634v1.134c0 .552 1.567 1 3.5 1s3.5-.448 3.5-1V7.359c-1.102.59-2.998.634-3.5.634m5.25 3.507c1.795 0 3.25-.448 3.25-1s-1.455-1-3.25-1-3.25.448-3.25 1 1.455 1 3.25 1m0 1.75c1.795 0 3.25-.447 3.25-1v-.633c-1.023.591-2.784.634-3.25.634s-2.227-.043-3.25-.634v.634c0 .552 1.455 1 3.25 1m0 .742c-.466 0-2.227-.043-3.25-.634v.634c0 .552 1.455 1 3.25 1s3.25-.448 3.25-1v-.634c-1.023.59-2.784.634-3.25.634"
    />
  </svg>
);
export const IconUsedCredit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="currentColor"
    {...props}
  >
    <path
      fill="#006169"
      fillOpacity={0.6}
      d="M5.858 11.38a.24.24 0 0 1-.209-.12c-.803-1.368-2.946-4.283-2.967-4.313a.24.24 0 0 1 .025-.315l.658-.651a.24.24 0 0 1 .309-.026l2.134 1.49C7.235 5.613 8.56 4.348 9.434 3.601c.982-.84 1.608-1.218 1.634-1.234a.24.24 0 0 1 .124-.034h1.066a.242.242 0 0 1 .16.422c-3.026 2.696-6.317 8.444-6.35 8.502a.24.24 0 0 1-.209.122z"
    />
    <path
      fill="#006169"
      fillOpacity={0.6}
      d="M5.811 12.388a4.36 4.36 0 0 1-4.353-4.353 4.358 4.358 0 0 1 5.768-4.118.242.242 0 0 1-.157.457 3.874 3.874 0 0 0-5.127 3.66 3.874 3.874 0 0 0 3.869 3.87 3.874 3.874 0 0 0 3.791-4.649.242.242 0 1 1 .474-.096q.088.434.088.876c0 2.4-1.952 4.353-4.353 4.353"
    />
  </svg>
);

export const IconTotalCredit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path fill="#F7C562" d="M9 16.875a7.875 7.875 0 1 0 0-15.75 7.875 7.875 0 0 0 0 15.75" />
    <path
      fill="#fff"
      d="M11.169 5.478a7.02 7.02 0 0 0-4.757 0 2.02 2.02 0 0 0-1.334 1.896v3.25a2.02 2.02 0 0 0 1.334 1.895 7.02 7.02 0 0 0 4.757 0q.312-.112.572-.319c-2.836-.519-3.23-.48-3.855-1.103a2.203 2.203 0 1 1 3.118-3.113c.623.622.586 1.016 1.103 3.837.257-.346.396-.766.396-1.198V7.374a2.02 2.02 0 0 0-1.334-1.896"
    />
    <path fill="#fff" d="M9.446 10.455a.919.919 0 1 0 0-1.838.919.919 0 0 0 0 1.837" />
    <path
      fill="#fff"
      d="M9 1.5C4.867 1.5 1.5 4.865 1.5 9s3.367 7.5 7.5 7.5 7.5-3.365 7.5-7.5S13.133 1.5 9 1.5m0 14.558c-3.89 0-7.055-3.165-7.055-7.058S5.11 1.942 9 1.942 16.055 5.107 16.055 9 12.89 16.058 9 16.058"
      opacity={0.7}
    />
  </svg>
);

export const IllustrationHourglass = (props) => (
  <svg width={props.size || '96px'} height={props.size || '96px'} fill="none" viewBox="0 0 119 119" {...props}>
    <path
      fill="#ECF7F0"
      fillRule="evenodd"
      d="M59.029 3.941A55.559 55.559 0 1 0 114.588 59.5 55.612 55.612 0 0 0 59.029 3.94Z"
      clipRule="evenodd"
      opacity={0.587}
    />
    <mask
      id="a"
      width={80}
      height={81}
      x={19}
      y={19}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill="#000"
        d="M98.73 59.5c0-21.945-17.79-39.735-39.736-39.735-21.944 0-39.734 17.79-39.734 39.735s17.79 39.735 39.734 39.735c21.945 0 39.735-17.79 39.735-39.735Z"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#E6EFE9"
        d="M98.73 59.5c0-21.945-17.79-39.735-39.736-39.735-21.944 0-39.734 17.79-39.734 39.735s17.79 39.735 39.734 39.735c21.945 0 39.735-17.79 39.735-39.735Z"
      />
      <path
        fill="#37474F"
        d="M80.124 110.867c9.812-4.718 15.569-13.114 12.857-18.754-2.712-5.639-12.864-6.385-22.676-1.667-9.813 4.718-15.569 13.114-12.857 18.754 2.712 5.639 12.864 6.385 22.676 1.667"
      />
      <path
        fill="#253239"
        d="M92.98 92.113c2.708 5.63-3.054 14.041-12.856 18.754-9.802 4.713-19.969 3.963-22.676-1.668l1.374 2.859c2.708 5.631 12.875 6.381 22.677 1.668s15.564-13.123 12.857-18.754l-1.375-2.859Z"
      />
      <path
        fill="#FFB992"
        d="M79.535 109.642c-9.102 4.377-18.448 3.914-20.832-1.045-2.385-4.96 3.089-12.549 12.191-16.925 9.102-4.377 18.448-3.915 20.833 1.045 2.384 4.96-3.09 12.548-12.192 16.925m-8.5-17.679c-8.957 4.307-14.355 11.68-12.055 16.464 2.3 4.785 11.43 5.172 20.387.865 8.956-4.306 14.355-11.68 12.054-16.464-2.3-4.784-11.46-5.157-20.387-.865ZM53.556 55.614c-9.102 4.376-18.492 3.898-20.862-1.032-2.385-4.96 3.089-12.548 12.191-16.925 9.102-4.377 18.448-3.914 20.833 1.045 2.4 4.917-3.06 12.535-12.163 16.912Zm-8.501-17.68c-8.957 4.307-14.341 11.71-12.04 16.494 2.3 4.784 11.43 5.171 20.386.865 8.956-4.307 14.355-11.68 12.054-16.464-2.3-4.785-11.473-5.187-20.4-.895"
      />
      <path
        fill="#EC8934"
        d="m91.727 92.717-.321.154c-2.3-4.784-11.43-5.171-20.387-.865-8.956 4.307-14.354 11.68-12.054 16.464l-.292.141-4.545-9.453c-2.539-5.28-2.008-11.498 1.438-16.208l3.357-4.595c.607-.83.696-1.915.233-2.878-.463-.963-1.352-1.541-2.393-1.615l-5.686-.247a15.958 15.958 0 0 1-13.572-9.027l-4.629-9.627.32-.154.1.131c2.714 4.299 11.557 4.465 20.105.354 8.548-4.11 13.94-11.121 12.277-15.925l-.04-.16.32-.154 4.63 9.627c2.539 5.28 2.008 11.498-1.438 16.208l-3.357 4.596c-.607.83-.696 1.915-.233 2.878.463.962 1.352 1.54 2.393 1.615l5.686.247c5.871.481 11.059 3.95 13.558 8.997l4.559 9.482-.03.014ZM70.894 91.67c8.023-3.857 16.234-3.962 19.7-.564l-3.718-7.731c-2.457-4.96-7.53-8.34-13.286-8.806l-5.686-.246c-1.172-.048-2.175-.715-2.694-1.794-.519-1.08-.414-2.28.281-3.224l3.358-4.596c3.358-4.596 3.872-10.698 1.389-15.861l-3.984-8.285c.504 4.858-4.734 11.22-12.728 15.063-7.964 3.83-16.22 3.992-19.713.536l3.984 8.285c2.497 5.193 7.57 8.572 13.256 8.82l5.687.246c1.171.047 2.175.714 2.694 1.794.519 1.079.413 2.28-.282 3.224l-3.357 4.596c-3.315 4.61-3.843 10.683-1.36 15.847l3.718 7.731c-.49-4.829 4.718-11.177 12.741-15.035"
      />
      <path
        fill="#FFB992"
        d="M68.815 83.764a3.072 3.072 0 0 0-2.771 1.332c-2.666 3.868-9.518 14.419-7.806 17.978 2.118 4.405 10.452 4.78 18.591.866 8.169-3.928 13.05-10.657 10.932-15.063-1.755-3.574-14.26-4.78-18.946-5.113"
      />
      <path
        fill="#fff"
        d="M68.815 83.764a3.072 3.072 0 0 0-2.771 1.332c-2.666 3.868-9.518 14.419-7.806 17.978 2.118 4.405 10.452 4.78 18.591.866 8.169-3.928 13.05-10.657 10.932-15.063-1.755-3.574-14.26-4.78-18.946-5.113"
        opacity={0.2}
      />
      <path
        fill="#FFB992"
        d="M76.786 103.925c-8.169 3.928-16.473 3.539-18.592-.866l1.95 4.055c2.119 4.405 10.452 4.78 18.592.866 8.139-3.914 13.05-10.657 10.931-15.063l-1.935-4.026c2.104 4.376-2.807 11.12-10.946 15.034m-42.06-49.673 4.208 8.751c2.273 4.727 6.916 7.81 12.096 8.049l5.136.224c.072.001.145.002.231.032l.564.053c2.197.236 4.116 1.612 5.084 3.625l1.823 3.793c.183.38.615.53.994.348a.753.753 0 0 0 .348-.993l-1.823-3.793c-.968-2.013-.845-4.371.342-6.235l.311-.473a.676.676 0 0 0 .12-.2l3.032-4.153c3.047-4.195 3.538-9.747 1.265-14.473l-4.208-8.752zm31.789 26.595a.733.733 0 0 0-.993-.348.753.753 0 0 0-.349.994c.183.379.615.53.994.348a.753.753 0 0 0 .348-.994"
      />
      <path
        fill="#fff"
        d="m34.726 54.252 4.208 8.751c2.273 4.727 6.916 7.81 12.096 8.049l5.136.224c.072.001.145.002.231.032l.564.053c2.197.236 4.116 1.612 5.084 3.625l1.823 3.793c.183.38.615.53.994.348a.753.753 0 0 0 .348-.993l-1.823-3.793c-.968-2.013-.845-4.371.342-6.235l.311-.473a.676.676 0 0 0 .12-.2l3.032-4.153c3.047-4.195 3.538-9.747 1.265-14.473l-4.208-8.752z"
        opacity={0.1}
      />
      <path
        fill="#fff"
        d="M66.515 80.847a.733.733 0 0 0-.993-.348.753.753 0 0 0-.349.994c.183.379.615.53.994.348a.753.753 0 0 0 .348-.994"
        opacity={0.3}
      />
      <path
        fill="#FFB992"
        d="M53.317 55.118c8.153-3.92 13.047-10.664 10.932-15.063-2.115-4.398-10.438-4.786-18.591-.866-8.153 3.92-13.047 10.664-10.932 15.063 2.115 4.398 10.439 4.786 18.591.866"
      />
      <path
        fill="#fff"
        d="m62.262 76.857-1.695 3.796c-1.71 3.84-1.233 9.537 1.278 14.76l8.01 16.657c-1.088.128-2.145.17-3.13.14L59.25 96.66c-2.511-5.221-2.755-11.031-.607-15.08l2.132-4.007c.88-1.68-.424-4.394-2.272-4.726l-4.461-.837c-4.504-.85-8.89-4.669-11.401-9.89l-4.56-9.482 2.597-1.248 4.545 9.452c2.511 5.222 6.634 9.166 10.73 10.213l4.023 1.047c1.688.446 3.006 3.188 2.287 4.755Z"
        opacity={0.5}
      />
      <path
        fill="#FFA900"
        d="M54.144 56.839c9.812-4.718 15.568-13.115 12.857-18.754-2.712-5.639-12.864-6.386-22.677-1.667-9.812 4.718-15.568 13.114-12.856 18.753 2.711 5.64 12.864 6.386 22.676 1.668"
      />
      <path
        fill="#D78F00"
        d="M67 38.085c2.708 5.63-3.054 14.04-12.856 18.754-9.816 4.684-19.969 3.963-22.676-1.668l1.375 2.86c2.707 5.63 12.874 6.38 22.676 1.667 9.802-4.714 15.564-13.124 12.857-18.754z"
      />
    </g>
  </svg>
);

export const AgencyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#909CD1"
        fillRule="evenodd"
        d="M7.589 15.656V4.972l-2.22-.949-3.71 1.587v10.046z"
        clipRule="evenodd"
      />
      <path fill="#7986BF" fillRule="evenodd" d="M5.37 15.656h2.218V4.972L5.37 4.023z" clipRule="evenodd" />
      <path
        fill="#ADADDB"
        fillRule="evenodd"
        d="M14.342 15.656h-7.13V1.868L10.777.344l3.565 1.524z"
        clipRule="evenodd"
      />
      <path fill="#ADADDB" fillRule="evenodd" d="M10.777 15.656H7.212V1.868L10.777.344z" clipRule="evenodd" />
      <path
        fill="#F3F3FF"
        fillRule="evenodd"
        d="M13.263 2.746a.188.188 0 0 1 .375 0V13.91a.187.187 0 1 1-.375 0zm-1.782-.762a.187.187 0 1 1 .375 0V13.91a.188.188 0 0 1-.375 0zm.891.381a.188.188 0 0 1 .375 0V13.91a.187.187 0 1 1-.375 0zM4.211 15.656H2.817V12.25l1.394-.133z"
        clipRule="evenodd"
      />
      <path
        fill="#AEAED6"
        fillRule="evenodd"
        d="M9.07 10.1V8.73l.76-.117v1.415zm0-2.159V6.572l.76-.187v1.413zm0-2.158v-1.37l.76-.258V5.57zm0-2.158V2.34l.76-.325v1.326zM7.715 10.23V8.94l.674-.103v1.328zm0-2.032V6.906l.674-.167v1.332zm0-2.034V4.872l.674-.228v1.332zm0-2.035V2.923l.675-.29V3.88z"
        clipRule="evenodd"
      />
      <path
        fill="#F3F3FF"
        fillRule="evenodd"
        d="M9.293 10.081V8.698l.76-.117v1.428zm0-2.18V6.52l.76-.187v1.426zm0-2.179V4.34l.76-.258V5.51zm0-2.179V2.248l.76-.326V3.26zM7.937 10.21V8.908l.674-.103v1.34zm0-2.052V6.853l.674-.167v1.345zm0-2.054V4.799l.674-.228v1.344zm0-2.056v-1.22l.674-.288v1.258z"
        clipRule="evenodd"
      />
      <path fill="#AEAED6" fillRule="evenodd" d="M8.017 15.656v-3.973l.28-.027v4z" clipRule="evenodd" />
      <path fill="#F3F3FF" fillRule="evenodd" d="M9.692 15.656H8.298v-4l1.394-.133z" clipRule="evenodd" />
      <path
        fill="#AEAED6"
        fillRule="evenodd"
        d="M7.873 11.886a.187.187 0 1 1-.035-.372l2.105-.2a.187.187 0 0 1 .035.371z"
        clipRule="evenodd"
      />
      <path
        fill="#7986BF"
        fillRule="evenodd"
        d="M3.356 10.473V9.357l.632-.13v1.16zm0-1.76V7.596l.632-.2v1.162zm0-1.76V5.909l.632-.267V6.73zm-1.109 3.673V9.584l.548-.112v1.079zm0-1.639V7.946l.548-.173v1.08zm0-1.64v-.972l.549-.23v1.008z"
        clipRule="evenodd"
      />
      <path
        fill="#F3F3FF"
        fillRule="evenodd"
        d="M3.56 10.446v-1.13l.632-.131v1.174zm0-1.782V7.532l.632-.2v1.176zm0-1.782v-1.06l.632-.267v1.102zm-1.11 3.716V9.543L3 9.43v1.093zm0-1.66V7.881L3 7.709v1.094zm0-1.663V6.29L3 6.06v1.02z"
        clipRule="evenodd"
      />
      <path fill="#7986BF" fillRule="evenodd" d="M2.816 15.656h-.232v-3.384l.232-.022z" clipRule="evenodd" />
      <path fill="#E6B17C" d="M.36 14.875h15.28v.782H.36z" />
      <path fill="#D19458" d="M.36 15.266h15.28v.39H.36z" />
      <path
        fill="#3D4A75"
        fillRule="evenodd"
        d="M2.566 12.463a.187.187 0 1 1-.035-.372l1.931-.184a.187.187 0 1 1 .035.372z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const QualityIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox=" 0 0 19 18"
    fill="none"
    {...props}
  >
    <path fill="#C1BFBF" d="M1.483 13.725A9 9 0 0 1 9.257.001l-.046 3.6a5.4 5.4 0 0 0-4.664 8.234z" opacity={0.3} />
    <path
      fill={props.color || 'currentColor'}
      d="M9.144 0a9 9 0 1 1-7.601 13.821l3.04-1.928A5.4 5.4 0 1 0 9.143 3.6z"
    />
  </svg>
);
export const LowQualityIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || 'currentColor'}
      d="M9.956 1.91a8.09 8.09 0 0 1 6.66 12.68l-2.664-1.836a4.853 4.853 0 0 0-3.996-7.608z"
    />
    <path
      fill="#C1BFBF"
      d="M16.636 14.562a8.089 8.089 0 1 1-6.424-12.648L10.11 5.15a4.854 4.854 0 1 0 3.854 7.588z"
      opacity={0.3}
    />
  </svg>
);

export const MediumQualityIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || 'currentColor'}
      d="M9.956 1.91A8.09 8.09 0 1 1 2.95 14.047l2.802-1.619a4.854 4.854 0 1 0 4.204-7.282z"
    />
    <path
      fill="#C1BFBF"
      d="M2.926 14.005a8.09 8.09 0 0 1 7.08-12.095l-.02 3.236a4.854 4.854 0 0 0-4.248 7.257z"
      opacity={0.3}
    />
  </svg>
);

export const HighQualityIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || 'currentColor'}
      d="M18.045 10a8.09 8.09 0 1 1-16.18 0 8.09 8.09 0 0 1 16.18 0M5.1 10a4.854 4.854 0 1 0 9.708 0A4.854 4.854 0 0 0 5.1 10"
    />
  </svg>
);

export const DroneIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || 'currentColor'}
      d="m15.148 10.836-1.009 1.344.178.115c.224.146.282.45.136.674a.48.48 0 0 1-.403.215.47.47 0 0 1-.272-.084l-.22-.146-1.082 1.438a.51.51 0 0 1-.397.198.484.484 0 0 1-.387-.779l1.051-1.396-2.253-1.505a1.93 1.93 0 0 1-1.715 1.024H8.29c-.722 0-1.37-.392-1.71-1.02l-2.248 1.501 1.051 1.396a.484.484 0 0 1-.392.78.49.49 0 0 1-.387-.194l-1.082-1.438-.22.146a.48.48 0 0 1-.271.084.48.48 0 0 1-.403-.214.49.49 0 0 1 .136-.675l.178-.115-1.01-1.343a.484.484 0 1 1 .774-.586l1.046 1.386 2.546-1.7c0-.02-.005-.041-.005-.057V6.12q.001-.07.01-.141L4.174 4.02 2.857 5.466a.48.48 0 0 1-.36.157.482.482 0 0 1-.36-.81L3.462 3.36l-.24-.22a.48.48 0 0 1-.026-.684.48.48 0 0 1 .685-.026l.23.214L5.466 1.16a.48.48 0 0 1 .685-.03.48.48 0 0 1 .031.684l-1.36 1.49 1.825 1.689a1.95 1.95 0 0 1 1.584-.816h.591c.638 0 1.224.314 1.59.826l1.83-1.7-1.36-1.489a.48.48 0 0 1 .031-.685.486.486 0 0 1 .685.031l1.354 1.485.23-.214a.48.48 0 0 1 .685.026.48.48 0 0 1-.026.685l-.235.22 1.322 1.453a.482.482 0 0 1-.36.81.5.5 0 0 1-.361-.157L12.889 4.02l-2.122 1.966c.005.052.01.11.01.162V9.86c0 .026-.01.052-.01.078l2.551 1.705 1.046-1.386a.484.484 0 0 1 .68-.094.48.48 0 0 1 .104.674"
    />
  </svg>
);

export const CreditIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g opacity={0.8}>
      <path
        fill="#FE9923"
        fillRule="evenodd"
        d="M6.207 15.247c0-1.75 3.98-3.169 8.89-3.169s8.89 1.42 8.89 3.169v2.912c0 1.75-3.98 3.169-8.89 3.169s-8.89-1.42-8.89-3.17z"
        clipRule="evenodd"
      />
      <path
        fill="#FECD3D"
        fillRule="evenodd"
        d="M15.098 12.078c4.91 0 8.89 1.42 8.89 3.169s-3.98 3.168-8.89 3.168-8.891-1.418-8.891-3.168 3.98-3.169 8.89-3.169"
        clipRule="evenodd"
      />
      <path
        fill="#FEA832"
        fillRule="evenodd"
        d="M15.089 13.555c3.906 0 7.072.756 7.072 1.688s-3.166 1.687-7.072 1.687-7.073-.755-7.073-1.687 3.167-1.688 7.073-1.688"
        clipRule="evenodd"
      />
      <path
        fill="#C85929"
        d="m10.595 19.556.76.001v1.476q-.39-.064-.76-.142zm10.986-.781v1.55a9 9 0 0 0 .761-.331v-1.22zm-8.24 2.49q.375.027.76.042v-1.41l-.76.001zm-5.493-1.271q.35.174.76.331v-1.552l-.76.002zm8.24 1.313q.386-.016.76-.043v-1.366l-.76-.001zm2.747-.274q.39-.064.76-.142v-1.334l-.76-.001z"
      />
      <path
        fill="#FEA832"
        d="M2.64 18.766v.943h.943v.674H2.64v.943h-.673v-.943h-.944v-.674h.944v-.943zM19.874 8.43v.943h.943v.672h-.944v.944H19.2v-.944h-.942v-.672h.942V8.43zM3.094 2.828v.944h.942v.672h-.942v.943H2.42v-.943h-.943v-.672h.943v-.944z"
      />
      <path
        fill="#FE9923"
        fillRule="evenodd"
        d="M.194 13.6C-.68 12.084 2.057 8.865 6.31 6.41s8.408-3.216 9.284-1.701l1.456 2.52c.875 1.517-1.863 4.736-6.115 7.19-4.253 2.456-8.408 3.218-9.284 1.701z"
        clipRule="evenodd"
      />
      <path
        fill="#FECD3D"
        fillRule="evenodd"
        d="M6.31 6.41c4.252-2.455 8.407-3.216 9.283-1.701s-1.863 4.735-6.115 7.19c-4.251 2.455-8.408 3.215-9.284 1.7C-.68 12.085 2.057 8.866 6.31 6.41"
        clipRule="evenodd"
      />
      <path
        fill="#FEA832"
        fillRule="evenodd"
        d="M7.05 7.685c3.383-1.952 6.504-2.88 6.97-2.074.466.808-1.9 3.045-5.282 4.999-3.383 1.952-6.502 2.88-6.968 2.074-.467-.808 1.897-3.045 5.28-4.999"
        clipRule="evenodd"
      />
      <path
        fill="#C85929"
        d="m9.352 13.672.705 1.22q-.341.18-.68.344l-.683-1.184zm-5.977 2.154.61 1.055q.389-.023.823-.092l-.774-1.343zm2.77-.697.667 1.156q.358-.116.728-.256l-.737-1.279zm4.928-2.451.705 1.22q.325-.204.636-.416l-.683-1.182zm4.854-4.1-.659.382.776 1.342q.277-.341.492-.667zm-2.645 2.431.737 1.279q.307-.25.586-.502l-.666-1.155z"
      />
    </g>
  </svg>
);
export const CreditAvailableIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <g opacity={0.8}>
      <path
        stroke="#F0CA77"
        strokeWidth={2}
        d="M8.754 21.055c0-.138.075-.404.518-.777.437-.369 1.13-.746 2.072-1.082 1.878-.67 4.537-1.102 7.523-1.102s5.645.433 7.522 1.102c.943.336 1.635.713 2.073 1.082.442.373.517.64.517.777v3.64c0 .137-.075.404-.517.776-.438.369-1.13.746-2.073 1.082-1.877.67-4.537 1.102-7.522 1.102s-5.645-.433-7.523-1.102c-.943-.336-1.635-.713-2.072-1.082-.443-.372-.518-.639-.518-.776v-3.641Z"
      />
      <path
        fill="#F0CA77"
        fillRule="evenodd"
        d="M29.98 21.055c0-2.187-4.976-3.961-11.113-3.961-6.138 0-11.113 1.774-11.113 3.96 0 2.189 4.975 3.961 11.113 3.961 6.137 0 11.112-1.772 11.112-3.96m-2.284-.006c0-1.164-3.957-2.11-8.84-2.11-4.882 0-8.841.946-8.841 2.11 0 1.166 3.959 2.11 8.841 2.11 4.883 0 8.84-.944 8.84-2.11"
        clipRule="evenodd"
      />
      <path
        fill="#F0CA77"
        d="M3.295 23.453v1.18h1.177v.841H3.295v1.18h-.842v-1.18h-1.18v-.841h1.18v-1.18zM24.84 10.531v1.18h1.18v.84h-1.18v1.18h-.842v-1.18H22.82v-.84h1.178v-1.18zm-20.975-7v1.18h1.178v.84H3.865v1.18h-.842V5.55h-1.18v-.84h1.18V3.53z"
      />
      <path
        stroke="#F0CA77"
        strokeWidth={2}
        d="M8.382 8.873c2.586-1.493 5.106-2.448 7.066-2.807.985-.18 1.773-.2 2.336-.1.57.102.768.295.837.414l.866-.5-.866.5 1.82 3.151c.069.12.137.389-.06.933-.194.538-.605 1.21-1.254 1.973-1.291 1.518-3.378 3.223-5.963 4.715-2.586 1.493-5.106 2.448-7.066 2.807-.985.181-1.773.2-2.336.1-.57-.101-.768-.295-.837-.414L2 18.044l-.896-1.551c-.069-.12-.137-.389.06-.933.194-.538.605-1.21 1.254-1.973 1.291-1.518 3.378-3.223 5.963-4.715Z"
      />
      <path
        fill="#F0CA77"
        fillRule="evenodd"
        d="M19.487 5.88c-1.094-1.893-6.289-.942-11.605 2.127C2.567 11.075-.855 15.1.24 16.994c1.094 1.893 6.29.942 11.604-2.127 5.316-3.068 8.738-7.092 7.644-8.987M17.52 7.008C16.938 6 13.037 7.16 8.809 9.601c-4.229 2.442-7.184 5.239-6.6 6.247.582 1.01 4.481-.151 8.71-2.592 4.228-2.442 7.185-5.239 6.602-6.248"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export const CreditUsedIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || '#87B7E2'}
      d="M29.121 8.258h-3.633a.88.88 0 0 0-.879.879v.227L20.505 6.97a5.55 5.55 0 0 0-4.056-.616l-4.898 1.13a8 8 0 0 0-1.59-.348V4.449a2.64 2.64 0 0 0-2.637-2.636H2.637A2.64 2.64 0 0 0 0 4.449v21.094a2.64 2.64 0 0 0 2.637 2.637h4.687a2.64 2.64 0 0 0 2.637-2.637v-2.686a7.9 7.9 0 0 0 4.43-2.002l2.564.962a7.9 7.9 0 0 0 2.777.503h4.877v.88c0 .485.394.878.88.878h3.632A.88.88 0 0 0 30 23.2V9.137a.88.88 0 0 0-.879-.88M7.324 26.422H2.637a.88.88 0 0 1-.88-.879V4.449a.88.88 0 0 1 .88-.879h4.687a.88.88 0 0 1 .88.88v2.685a7.773 7.773 0 0 0-2.345.642v-1.57a.879.879 0 0 0-1.757 0v17.578a.879.879 0 0 0 1.757 0v-1.569a7.8 7.8 0 0 0 2.344.64v2.687a.88.88 0 0 1-.879.879m1.758-5.274a6.1 6.1 0 0 1-3.223-.918V9.763a6.1 6.1 0 0 1 3.223-.92 6.16 6.16 0 0 1 5.232 2.93h-1.716A2.64 2.64 0 0 0 9.96 14.41a2.64 2.64 0 0 0 2.637 2.637h2.28a6.12 6.12 0 0 1-5.796 4.101m10.65-.586c-.74 0-1.467-.131-2.16-.391l-1.953-.733a7.9 7.9 0 0 0 1.096-2.391h.715a4.82 4.82 0 0 0 3.726 1.758h.817a.879.879 0 0 0 0-1.758h-.817a3.06 3.06 0 0 1-2.554-1.367.88.88 0 0 0-.73-.39h-5.274a.88.88 0 0 1 0-1.759h5.273a.879.879 0 0 0 0-1.758H16.3a7.9 7.9 0 0 0-2.384-3.03l2.93-.676a3.8 3.8 0 0 1 2.774.422l4.99 2.91v9.164zm8.51 1.758h-1.875V10.016h1.875z"
    />
  </svg>
);
export const CreditTimeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <g fill="#6FC38A" clipPath="url(#creditTime)">
      <path d="M11.25 30h-10a1.25 1.25 0 0 1 0-2.5h10a1.25 1.25 0 0 1 0 2.5m-2.5-5h-7.5a1.25 1.25 0 0 1 0-2.5h7.5a1.25 1.25 0 0 1 0 2.5m-2.5-5h-5a1.25 1.25 0 0 1 0-2.5h5a1.25 1.25 0 0 1 0 2.5" />
      <path d="M16.249 29.944a1.251 1.251 0 1 1-.112-2.5 12.499 12.499 0 0 0 1.575-24.65A12.5 12.5 0 0 0 2.55 13.865a1.25 1.25 0 1 1-2.49-.226 15 15 0 0 1 29.939 1.363A14.917 14.917 0 0 1 16.36 29.939a1 1 0 0 1-.113.005" />
      <path d="M15 7.5a1.25 1.25 0 0 0-1.25 1.25V15c0 .332.132.65.366.884l3.75 3.75a1.25 1.25 0 0 0 1.768-1.768l-3.384-3.383V8.75A1.25 1.25 0 0 0 15 7.5" />
    </g>
  </svg>
);
export const TransactionIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || 'currentColor'}
      d="m11.994 11.437-1-1a.5.5 0 0 0-.71 0l-1 1a.502.502 0 1 0 .71.71l.145-.15v1.795a.5.5 0 1 0 1 0v-1.795l.145.15a.5.5 0 0 0 .82-.163.5.5 0 0 0-.11-.547m3 .997a.5.5 0 0 0-.71 0l-.145.15V10.79a.5.5 0 0 0-1 0v1.795l-.145-.15a.502.502 0 1 0-.71.71l1 1a.5.5 0 0 0 .71 0l1-1a.5.5 0 0 0 0-.71"
    />
    <path
      fill={props.color || 'currentColor'}
      d="M8.499 13.1a5 5 0 1 1 3.39-3.245.503.503 0 0 0 .697.608.5.5 0 0 0 .253-.289 6 6 0 1 0-5.7 4.115 5.7 5.7 0 0 0 1.64-.23.5.5 0 0 0-.28-.96"
    />
    <path
      fill={props.color || 'currentColor'}
      d="M5.485 6.928A.3.3 0 0 1 5.421 7a.14.14 0 0 1-.084.024.2.2 0 0 1-.1-.028l-.12-.066a1 1 0 0 0-.152-.064.6.6 0 0 0-.196-.03q-.19 0-.284.082a.27.27 0 0 0-.092.218q0 .088.056.146a.5.5 0 0 0 .146.1q.091.042.208.078.119.034.24.078.121.042.238.1a.8.8 0 0 1 .208.148.7.7 0 0 1 .148.22.8.8 0 0 1 .056.31q0 .202-.07.378a.89.89 0 0 1-.532.514q-.195.075-.442.074-.135 0-.278-.028a1.648 1.648 0 0 1-.52-.2 1 1 0 0 1-.202-.156l.2-.316a.176.176 0 0 1 .148-.08q.06 0 .12.038l.138.084q.078.046.178.084a.7.7 0 0 0 .236.038.45.45 0 0 0 .286-.08q.102-.082.102-.258a.24.24 0 0 0-.056-.166.4.4 0 0 0-.148-.106 1.3 1.3 0 0 0-.206-.074 8 8 0 0 1-.238-.07 2 2 0 0 1-.238-.096.8.8 0 0 1-.208-.15.7.7 0 0 1-.146-.232.93.93 0 0 1 .01-.664.8.8 0 0 1 .194-.278.9.9 0 0 1 .314-.194q.186-.075.426-.074a1.5 1.5 0 0 1 .502.084 1.2 1.2 0 0 1 .39.226zM8.741 9.25h-.524a.25.25 0 0 1-.146-.04.22.22 0 0 1-.078-.106l-.172-.508H6.713l-.172.508a.228.228 0 0 1-.22.146h-.528l1.128-2.914h.692zM6.87 8.136h.796l-.268-.798-.062-.178a6 6 0 0 1-.068-.224 4 4 0 0 1-.13.406zm2.785.036V9.25h-.676V6.336h.948q.316 0 .538.066a1 1 0 0 1 .364.18.7.7 0 0 1 .206.274q.064.158.064.344a1 1 0 0 1-.038.268.8.8 0 0 1-.298.424 1 1 0 0 1-.25.138q.069.034.126.084a.5.5 0 0 1 .104.122l.62 1.014h-.612q-.17 0-.244-.128l-.484-.846a.2.2 0 0 0-.076-.08.25.25 0 0 0-.12-.024zm0-.466h.272q.138 0 .234-.034a.4.4 0 0 0 .16-.098.4.4 0 0 0 .09-.144.6.6 0 0 0 .028-.18.37.37 0 0 0-.126-.3q-.123-.108-.386-.108h-.272z"
    />
  </svg>
);

export const ProfileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      fill="url(#ProfileIcon)"
      d="m25.538 6.88-.537-.305a2.6 2.6 0 0 0 0-.993l.537-.304a.9.9 0 0 0 .43-.55.9.9 0 0 0-.092-.689.92.92 0 0 0-.56-.422.94.94 0 0 0-.7.09l-.539.306a2.8 2.8 0 0 0-.874-.497v-.61c0-.24-.097-.47-.27-.64a.93.93 0 0 0-1.305 0c-.173.17-.27.4-.27.64v.61a2.8 2.8 0 0 0-.875.497l-.538-.306a.935.935 0 0 0-1.26.332.895.895 0 0 0 .337 1.239l.537.304a2.6 2.6 0 0 0 0 .993l-.537.305a.9.9 0 0 0-.391.438.89.89 0 0 0 .29 1.066.93.93 0 0 0 1.024.066l.538-.306c.258.217.554.386.875.497v.61c0 .24.097.47.27.64a.93.93 0 0 0 1.305 0c.173-.17.27-.4.27-.64v-.61c.32-.111.616-.28.874-.497l.539.306a.933.933 0 0 0 1.023-.066.892.892 0 0 0 .29-1.066.9.9 0 0 0-.39-.438m-3.258.105a.94.94 0 0 1-.513-.153.9.9 0 0 1-.34-.407.89.89 0 0 1 .2-.987.93.93 0 0 1 1.006-.197.9.9 0 0 1 .414.334.895.895 0 0 1-.114 1.144.93.93 0 0 1-.653.266m-8.304 1.36a5.14 5.14 0 0 1 2.82.84 5 5 0 0 1 1.869 2.237 4.9 4.9 0 0 1 .288 2.88 4.96 4.96 0 0 1-1.389 2.552 5.1 5.1 0 0 1-2.598 1.364 5.16 5.16 0 0 1-2.932-.283 5.06 5.06 0 0 1-2.277-1.836 4.92 4.92 0 0 1-.855-2.77 4.94 4.94 0 0 1 1.486-3.525 5.12 5.12 0 0 1 3.588-1.46m11.829 3.928a11.588 11.588 0 0 1-1.102 7.223 11.88 11.88 0 0 1-5.225 5.195 12.17 12.17 0 0 1-7.34 1.168 12.06 12.06 0 0 1-6.628-3.307 11.7 11.7 0 0 1-3.367-6.511 11.6 11.6 0 0 1 1.19-7.21A11.9 11.9 0 0 1 8.62 3.698a12.18 12.18 0 0 1 7.353-1.082c.24.042.452.175.593.37a.894.894 0 0 1-.215 1.258.94.94 0 0 1-.683.16 10.3 10.3 0 0 0-4.37.217 10.2 10.2 0 0 0-3.871 2.002 10 10 0 0 0-2.655 3.416 9.8 9.8 0 0 0-.946 4.197 9.83 9.83 0 0 0 2.565 6.617 9.1 9.1 0 0 1 2.51-2.414.47.47 0 0 1 .557.036 6.97 6.97 0 0 0 4.513 1.652 6.97 6.97 0 0 0 4.514-1.652.47.47 0 0 1 .558-.036 9.1 9.1 0 0 1 2.513 2.414 9.83 9.83 0 0 0 2.428-8.28.9.9 0 0 1 .155-.681.92.92 0 0 1 .601-.371.94.94 0 0 1 .692.158.91.91 0 0 1 .372.594"
    />
    <defs>
      <linearGradient id="ProfileIcon" x1={2} x2={38.822} y1={14} y2={13.865} gradientUnits="userSpaceOnUse">
        <stop stopColor="#38B49D" />
        <stop offset={1} stopColor="#2F413D" />
      </linearGradient>
    </defs>
  </svg>
);
export const SecurityIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 23 24"
    fill="none"
    {...props}
  >
    <path
      fill="url(#SecurityIcon)"
      fillRule="evenodd"
      d="M12.086.245a.877.877 0 0 0-1.215 0 13.12 13.12 0 0 1-9.273 3.667.88.88 0 0 0-.525.166.9.9 0 0 0-.325.447A15.3 15.3 0 0 0 0 9.27c0 7.075 4.784 13.017 11.258 14.702a.9.9 0 0 0 .44 0c6.474-1.685 11.258-7.627 11.258-14.702 0-1.655-.262-3.25-.747-4.745a.9.9 0 0 0-.325-.448.88.88 0 0 0-.525-.166l-.168.001c-3.527 0-6.73-1.393-9.105-3.667m3.642 9.544a.898.898 0 0 0-.512-1.407.87.87 0 0 0-.924.369l-3.81 5.393-1.912-1.933a.877.877 0 0 0-1.226.022.9.9 0 0 0-.021 1.24l2.648 2.679a.88.88 0 0 0 .697.258.88.88 0 0 0 .645-.37z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient id="SecurityIcon" x1={0} x2={35.221} y1={12} y2={11.877} gradientUnits="userSpaceOnUse">
        <stop stopColor="#38B49D" />
        <stop offset={1} stopColor="#2F413D" />
      </linearGradient>
    </defs>
  </svg>
);
export const FAQIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      fill="url(#FAQIcon)"
      d="M14 2a12 12 0 1 0 12 12A12.013 12.013 0 0 0 14 2m0 19.385a1.385 1.385 0 1 1 0-2.77 1.385 1.385 0 0 1 0 2.77m.923-5.622v.083a.923.923 0 0 1-1.846 0v-.923A.923.923 0 0 1 14 14c1.527 0 2.77-1.039 2.77-2.308S15.526 9.385 14 9.385s-2.77 1.038-2.77 2.307v.462a.923.923 0 0 1-1.845 0v-.462c0-2.29 2.07-4.154 4.615-4.154s4.615 1.864 4.615 4.154c0 2.006-1.587 3.685-3.692 4.071"
    />
    <defs>
      <linearGradient id="FAQIcon" x1={2} x2={38.822} y1={14} y2={13.865} gradientUnits="userSpaceOnUse">
        <stop stopColor="#38B49D" />
        <stop offset={1} stopColor="#2F413D" />
      </linearGradient>
    </defs>
  </svg>
);
export const SupportIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || 'currentColor'}
      fillRule="evenodd"
      d="M8.473 2.526a5.21 5.21 0 0 0-5.176 3.752.85.85 0 0 0-.336.03c-.492.14-.862.544-1.028.899-.216.463-.307 1.075-.211 1.707.095.63.361 1.149.694 1.471.334.323.711.428 1.085.35.558-.12.835-.209.756-.728L3.88 7.489A4.428 4.428 0 0 1 11 4.223a4.43 4.43 0 0 1 1.726 3.271l-.264 1.762a4.43 4.43 0 0 1-3.742 2.89H7.592a.523.523 0 0 0-.524.524v.276c0 .29.234.525.524.525h1.42c.29 0 .524-.234.524-.525v-.144a5.23 5.23 0 0 0 3.113-2.188l.455.12c.37.096.752-.026 1.086-.348.332-.323.598-.842.694-1.472.096-.632.002-1.243-.21-1.707-.215-.464-.534-.759-.902-.864a2 2 0 0 0-.466-.065 5.205 5.205 0 0 0-4.833-3.752"
      clipRule="evenodd"
    />
    <path
      fill={props.color || 'currentColor'}
      fillRule="evenodd"
      d="M10.136 7.056a.681.681 0 1 1-.002 1.362.681.681 0 0 1 .002-1.362m-1.833 0a.68.68 0 1 1 0 1.36.68.68 0 0 1 0-1.36m-1.832 0a.68.68 0 1 1 0 1.36.68.68 0 0 1 0-1.36m1.832-2.923C6.307 4.133 4.7 5.688 4.7 7.736c0 .984.372 1.854.978 2.492l-.215.964c-.07.317.15.53.434.372l.942-.525c.447.194.942.301 1.465.301 1.996 0 3.603-1.554 3.603-3.604 0-2.048-1.607-3.603-3.603-3.603"
      clipRule="evenodd"
    />
  </svg>
);

export const UnlockIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <g clipPath="url(#UnlockIcon)">
      <path
        fill="#71A7AC"
        d="M13.874 2.884a12.4 12.4 0 0 1-5.22-1.785 1.25 1.25 0 0 0-1.309 0 12.423 12.423 0 0 1-5.22 1.785A1.254 1.254 0 0 0 1 4.132v3.73a7.72 7.72 0 0 0 3.97 6.747l2.42 1.344a1.25 1.25 0 0 0 1.22 0l2.42-1.344A7.72 7.72 0 0 0 15 7.862v-3.73a1.254 1.254 0 0 0-1.126-1.248"
      />
      <path
        fill="#fff"
        d="M9.519 7.518C9.519 6.676 8.843 6 8.001 6a1.514 1.514 0 0 0-.925 2.719l-.58 2.181c-.027.083 0 .166.042.235.055.069.138.11.22.11h2.485a.29.29 0 0 0 .22-.11.24.24 0 0 0 .042-.235l-.58-2.18c.373-.29.594-.732.594-1.202"
      />
    </g>
    <defs>
      <clipPath id="UnlockIcon">
        <path fill="#fff" d="M0 .5h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const BayutAppLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 43 44"
    fill="none"
    {...props}
  >
    <path
      fill="url(#a)"
      d="M32.961.984H10.039C4.495.984 0 5.417 0 10.884v23.2c0 5.468 4.495 9.9 10.039 9.9h22.922c5.544 0 10.039-4.432 10.039-9.9v-23.2c0-5.467-4.495-9.9-10.039-9.9"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M22.168 24.664a7.6 7.6 0 0 0 4.231-1.284 7.63 7.63 0 0 0 2.807-3.425 7.65 7.65 0 0 0-1.649-8.322 7.593 7.593 0 0 0-8.3-1.653 7.6 7.6 0 0 0-3.415 2.814 7.65 7.65 0 0 0-1.28 4.243c0 2.023.801 3.963 2.228 5.393a7.6 7.6 0 0 0 5.378 2.234m2.484-16.921a9.6 9.6 0 0 1 3.936 2.15 9.647 9.647 0 0 1 1.605 12.4 9.6 9.6 0 0 1-3.259 3.086 9.58 9.58 0 0 1-12.254-2.313h-.048l-5.268 3.05a.83.83 0 0 1-1.148-.308L7.59 24.72a.84.84 0 0 1 .313-1.124l5.267-3.049h.05a9.65 9.65 0 0 1 1.79-9.927 9.6 9.6 0 0 1 4.415-2.806 9.6 9.6 0 0 1 5.227-.071m-2.484 9.294a1.62 1.62 0 0 0-1.607 1.612v2.01a.6.6 0 0 1-.592.6h-2.143a.737.737 0 0 1-.731-.74v-4.375c0-1.088 0-1.193.41-1.437l3.765-2.177c.264-.191.574-.31.898-.342.324.032.634.15.897.342l3.765 2.177c.417.244.417.349.417 1.437v4.375a.747.747 0 0 1-.737.74h-2.137a.597.597 0 0 1-.591-.6v-2.01a1.63 1.63 0 0 0-.477-1.138 1.62 1.62 0 0 0-1.137-.474m-12.15 10.56a.245.245 0 0 0-.264-.225.24.24 0 0 0-.119.043l-.654.377a.43.43 0 0 0-.257.384v4.933a.7.7 0 0 0 .201.496 2.7 2.7 0 0 0 1.99.795c1.538 0 2.638-.956 2.638-2.372a2.1 2.1 0 0 0-.565-1.655 2.09 2.09 0 0 0-1.62-.648 2.6 2.6 0 0 0-1.35.321zm8.733 3.244a.49.49 0 0 0-.174-.46 3 3 0 0 0-2.032-.656c-1.496 0-2.617.907-2.617 2.358a2.16 2.16 0 0 0 1.332 2.158c.28.115.58.169.881.16a1.44 1.44 0 0 0 1.322-.629v.175a.3.3 0 0 0 .3.32h.695a.3.3 0 0 0 .3-.32zm12.838.084h1.879a.285.285 0 0 0 .306-.293v-.447a.28.28 0 0 0-.306-.306h-1.88v-1.522a.25.25 0 0 0-.262-.226.25.25 0 0 0-.12.038l-.696.377a.42.42 0 0 0-.25.384v3.237a2.1 2.1 0 0 0 1.346 2.103c.278.105.576.15.874.13.392.007.777-.097 1.113-.3a.49.49 0 0 0 .25-.412v-.53a.19.19 0 0 0-.052-.135.18.18 0 0 0-.135-.053.6.6 0 0 0-.307.153c-.204.14-.447.214-.695.21a1 1 0 0 1-1.079-1.117zm-8.788 1.78a1.01 1.01 0 0 1-.947.628c-.696 0-1.057-.426-1.057-1.152v-1.967a.3.3 0 0 0-.182-.29.3.3 0 0 0-.118-.024h-.696a.3.3 0 0 0-.28.194.3.3 0 0 0-.019.12v1.988a1.97 1.97 0 0 0 .524 1.595 1.96 1.96 0 0 0 1.564.603 1.39 1.39 0 0 0 1.21-.593v.81c0 .739-.508 1.06-1.21 1.06-.33.005-.657-.07-.954-.216a1 1 0 0 0-.348-.16.23.23 0 0 0-.236.23v.516a.46.46 0 0 0 .23.37c.417.256.903.375 1.391.342a2.24 2.24 0 0 0 2.24-1.304c.128-.281.197-.586.203-.894v-4.327a.3.3 0 0 0-.3-.314h-.695a.29.29 0 0 0-.3.314zm5.406 0a1.02 1.02 0 0 1-.946.628c-.696 0-1.058-.426-1.058-1.152v-1.967a.3.3 0 0 0-.3-.314h-.695a.3.3 0 0 0-.28.194.3.3 0 0 0-.02.12v1.988a1.96 1.96 0 0 0 1.238 2.076c.27.103.561.145.85.122a1.39 1.39 0 0 0 1.239-.628v.175a.3.3 0 0 0 .3.32h.695a.3.3 0 0 0 .3-.32v-3.734a.3.3 0 0 0-.3-.314h-.696a.29.29 0 0 0-.292.314zM10.017 31.1a1.48 1.48 0 0 1 .975-.328 1.13 1.13 0 0 1 1.16.786c.05.16.066.33.044.498a1.18 1.18 0 0 1-.779 1.253 1.2 1.2 0 0 1-.522.058 1.346 1.346 0 0 1-.877-.314zm7.446 1.611a1.07 1.07 0 0 1-1.009.622c-.695 0-1.169-.447-1.169-1.305a1.2 1.2 0 0 1 .747-1.22c.159-.064.329-.093.499-.085.332-.027.663.067.932.265z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M25.577 35.613h-.118a.13.13 0 0 0-.063 0h-.083a.2.2 0 0 0-.126.035.14.14 0 0 0-.041.105.1.1 0 0 0 0 .063.1.1 0 0 0 .062.042l.084.035h.104l.098.041q.048.023.083.063a.2.2 0 0 1 .063.084.3.3 0 0 1 0 .125q.015.077 0 .154a.3.3 0 0 1-.077.126.5.5 0 0 1-.132.083.5.5 0 0 1-.181 0h-.243l-.098-.049-.076-.062.07-.119h.103l.077.035a.2.2 0 0 0 .097 0 .2.2 0 0 0 .133-.042.13.13 0 0 0 .048-.118.12.12 0 0 0 0-.07.2.2 0 0 0-.062-.05h-.188l-.098-.034-.083-.063a.24.24 0 0 1-.063-.097.43.43 0 0 1 0-.266.4.4 0 0 1 .077-.111.4.4 0 0 1 .125-.077.5.5 0 0 1 .174 0 .6.6 0 0 1 .195 0 .5.5 0 0 1 .16.098zm.195.238a.5.5 0 0 1 .167-.105q.097-.015.195 0a.4.4 0 0 1 .132 0 .4.4 0 0 1 .104.07q.044.045.063.105a.4.4 0 0 1 0 .132v.53h-.132v-.09l-.063.049h-.062a.12.12 0 0 1-.07 0h-.077a.24.24 0 0 1-.104 0 .14.14 0 0 1-.076-.042.16.16 0 0 1-.056-.077.2.2 0 0 1 0-.098.2.2 0 0 1 0-.09.2.2 0 0 1 .02-.077l.154-.063h.243v-.042a.2.2 0 0 0 0-.118.14.14 0 0 0-.097-.035.13.13 0 0 0-.077 0h-.187zm.466.377H26.1a.3.3 0 0 0-.09 0 .07.07 0 0 0-.042.035.05.05 0 0 0 0 .041v.07a.1.1 0 0 0 .076 0h.098l.083-.062zm1.134-.496v.844h-.167s-.049 0-.056-.035v-.063a.3.3 0 0 1-.048.05h-.202a.3.3 0 0 1-.125 0 .3.3 0 0 1-.09-.07.5.5 0 0 1-.056-.098.4.4 0 0 1 0-.133v-.537h.222v.537a.18.18 0 0 0 0 .112h.181a.3.3 0 0 0 .084-.056v-.607zm.94-.376v1.22h-.14s-.048 0-.055-.034v-.077a.2.2 0 0 1-.056.049.1.1 0 0 1-.063.042h-.167a.24.24 0 0 1-.125 0 .3.3 0 0 1-.097-.084.6.6 0 0 1-.07-.133.8.8 0 0 1 0-.188.5.5 0 0 1 0-.175.38.38 0 0 1 .188-.237.3.3 0 0 1 .146 0 .3.3 0 0 1 .118 0q.048.018.084.056v-.44zm-.23.6a.2.2 0 0 0-.07-.056h-.153a.2.2 0 0 0-.055.049.3.3 0 0 0 0 .083.4.4 0 0 0 0 .126.6.6 0 0 0 0 .118q.009.046.034.084a.08.08 0 0 0 .05.042h.062a.2.2 0 0 0 .097 0 .4.4 0 0 0 .077-.07zm.675-.496a.08.08 0 0 1 0 .056v.042h-.16a.3.3 0 0 1-.077-.076.1.1 0 0 1 0-.056.1.1 0 0 1 0-.049.1.1 0 0 1 0-.049h.195a.1.1 0 0 1 0 .049.07.07 0 0 1 .042.084m0 .245v.872h-.223v-.844zm1.573.873h-.189a.08.08 0 0 1-.055 0l-.098-.28h-.487l-.076.231h-.244l.466-1.186h.25zm-.411-.419-.133-.37v-.062a.4.4 0 0 1 0-.084v.146l-.125.37zm.703-.287a.4.4 0 0 1 .09-.112.2.2 0 0 1 .126-.042.13.13 0 0 1 .09 0v.168h-.202a.1.1 0 0 0-.034.035.2.2 0 0 0 0 .056v.516h-.286v-.76h.133a.07.07 0 0 1 .048 0v.041zm.375-.022a.5.5 0 0 1 .167-.104.6.6 0 0 1 .195 0 .4.4 0 0 1 .132 0 .4.4 0 0 1 .105.07.4.4 0 0 1 .062.104.4.4 0 0 1 0 .133v.53h-.153a.1.1 0 0 1 0-.035v-.056l-.056.05h-.062a.13.13 0 0 1-.07 0h-.083a.3.3 0 0 1-.105 0 .2.2 0 0 1-.076-.043.15.15 0 0 1-.049-.077.2.2 0 0 1 0-.097.15.15 0 0 1 0-.09.23.23 0 0 1 .077-.092l.153-.062h.243v-.042a.15.15 0 0 0 0-.119.17.17 0 0 0-.174 0h-.181zm.46.377h-.223a.1.1 0 0 0-.05.035.1.1 0 0 0 0 .042.08.08 0 0 0 0 .07.14.14 0 0 0 .078 0h.097l.083-.063zm.619-.398a.4.4 0 0 1 .111-.084.33.33 0 0 1 .265 0q.061.03.104.084a.6.6 0 0 1 .063.133.7.7 0 0 1 0 .174q.015.094 0 .188a.4.4 0 0 1-.07.14.4.4 0 0 1-.118.098.3.3 0 0 1-.146 0h-.125a.1.1 0 0 1-.05 0l-.034-.077v.049a.1.1 0 0 1 0 .035h-.188v-1.215h.188zm0 .523a.2.2 0 0 0 .07.056h.153a.2.2 0 0 0 .055-.049.3.3 0 0 0 .042-.09 1 1 0 0 0 0-.126.6.6 0 0 0 0-.119.3.3 0 0 0 0-.076.1.1 0 0 0-.049-.042h-.07a.2.2 0 0 0-.09 0 .4.4 0 0 0-.076.07zm.974-.894a.1.1 0 0 1 0 .056v.042h-.194l-.035-.042a.13.13 0 0 1-.049-.056l.035-.049h.195v.049a.1.1 0 0 1 .048 0m0 .244v.872h-.278v-.844zm.147.148a.6.6 0 0 1 .167-.105q.097-.015.195 0a.4.4 0 0 1 .132 0 .4.4 0 0 1 .104.07q.043.045.063.105a.4.4 0 0 1 0 .132v.53h-.153v-.09l-.063.049h-.063a.12.12 0 0 1-.07 0h-.076a.24.24 0 0 1-.104 0 .2.2 0 0 1-.077-.042.16.16 0 0 1-.055-.077.2.2 0 0 1 0-.098.2.2 0 0 1 0-.09.2.2 0 0 1 .083-.091l.153-.063h.244v-.042a.18.18 0 0 0-.035-.118.14.14 0 0 0-.097-.035.13.13 0 0 0-.077 0h-.187zm.466.377h-.14a.3.3 0 0 0-.09 0 .07.07 0 0 0-.041.035.05.05 0 0 0 0 .041v.07a.1.1 0 0 0 .076 0h.097a.3.3 0 0 0 .084-.062z"
    />
    <defs>
      <linearGradient id="a" x1={21.5} x2={21.5} y1={75.668} y2={33.271} gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#28B16D" />
      </linearGradient>
    </defs>
  </svg>
);
export const BayutAppArabicLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 44 44"
    fill="none"
    {...props}
  >
    <g clipPath="url(#bayutArabicLogo)">
      <path
        fill="url(#bayutArabicLogo1)"
        d="M32.961 1H10.039C4.495 1 0 5.432 0 10.9v23.2C0 39.568 4.495 44 10.039 44h22.922C38.505 44 43 39.568 43 34.1V10.9C43 5.432 38.505 1 32.961 1"
      />
      <path
        fill="#fff"
        d="M10.944 36.22v.257h-.693a.7.7 0 0 1-.486-.146.5.5 0 0 1-.18-.41.56.56 0 0 1 .083-.297.6.6 0 0 1 .243-.188.9.9 0 0 1 .354-.069h.062v-.11h.347v.963zm-.624 0v-.575h-.062a.31.31 0 0 0-.236.076.28.28 0 0 0-.083.215.3.3 0 0 0 .076.215.36.36 0 0 0 .243.07zm-.215-1.103a.15.15 0 0 1-.11-.048.19.19 0 0 1 0-.236.15.15 0 0 1 .17-.035q.03.012.051.035a.19.19 0 0 1 0 .236.15.15 0 0 1-.11.048m.388 0a.15.15 0 0 1-.11-.048.19.19 0 0 1 0-.236.15.15 0 0 1 .17-.035q.03.012.051.035a.166.166 0 0 1-.11.284"
      />
      <path
        fill="#fff"
        d="M10.917 36.49v-.256h.381v-.867h.333v1.124zm.187.57a.14.14 0 0 1-.111-.042.19.19 0 0 1 0-.236.13.13 0 0 1 .11-.048.13.13 0 0 1 .105.041.18.18 0 0 1 .041.125.17.17 0 0 1-.041.118.14.14 0 0 1-.104.014zm.381 0a.16.16 0 0 1-.11-.042.19.19 0 0 1 0-.236.15.15 0 0 1 .17-.035q.03.012.051.035a.19.19 0 0 1 0 .236.14.14 0 0 1-.11.014zm.465-.84h.735a1.5 1.5 0 0 0-.111-.339.8.8 0 0 0-.174-.222.9.9 0 0 0-.25-.152l.126-.32c.197.072.366.203.485.375.141.208.234.445.27.694v.263H11.95zm2.767 0v.257h-.291a.54.54 0 0 1-.16.41.65.65 0 0 1-.444.138 1.5 1.5 0 0 1-.263 0 .8.8 0 0 1-.215-.09l.132-.243a1 1 0 0 0 .173.062h.166a.26.26 0 0 0 .202-.07.26.26 0 0 0 .069-.193h-.222a.49.49 0 0 1-.375-.132.55.55 0 0 1-.131-.395.53.53 0 0 1 .09-.312.57.57 0 0 1 .25-.209.9.9 0 0 1 .374-.076h.347v.853zm-.624 0v-.575h-.07a.34.34 0 0 0-.228.076.38.38 0 0 0 0 .437.22.22 0 0 0 .173.062z"
      />
      <path
        fill="#fff"
        d="M16.09 36.222v.256h-.298a.7.7 0 0 1-.222 0 .7.7 0 0 1-.194-.09.83.83 0 0 1-.423.125h-.278v-.257h.243a.4.4 0 0 0 .111 0h.097a.7.7 0 0 1-.139-.166 1 1 0 0 1-.131-.243 1 1 0 0 1-.077-.256 1 1 0 0 1 .306-.174.85.85 0 0 1 .332-.07c.199-.003.395.045.57.14 0 .155-.033.31-.098.45a.8.8 0 0 1-.27.32.45.45 0 0 0 .2.041zm-.693-.18a.56.56 0 0 0 .29-.451.7.7 0 0 0-.256-.042h-.16a.6.6 0 0 0-.131.062q.03.125.097.236a.7.7 0 0 0 .146.194z"
      />
      <path
        fill="#fff"
        d="M18.462 36.22v.257h-.77a.5.5 0 0 1-.353-.167.45.45 0 0 1-.382.167h-.901v-.257h.298v-.693h.333v.693h.194a.2.2 0 0 0 .166-.062c.041-.06.06-.13.056-.201v-.41h.34v.542a.3.3 0 0 0 .11.104.3.3 0 0 0 .14 0h.145v-.826h.333v.853z"
      />
      <path fill="#fff" d="M18.441 36.49v-.256h.299v-1.457h.34v1.727zm1.076-1.724h.34v1.727h-.34z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M33.526 29.931h-.693a.285.285 0 0 0-.292.298v1.762c0 .693-.326 1.116-1.02 1.116h-.97a1.06 1.06 0 0 1-.999-.568 3 3 0 0 0 .042-.52v-1.79a.277.277 0 0 0-.285-.298h-.672a.277.277 0 0 0-.285.298v1.762c0 .693-.326 1.116-1.02 1.116h-2.655V30.84a.46.46 0 0 0-.174-.444 2.87 2.87 0 0 0-1.949-.638c-1.442 0-2.517.818-2.517 2.212a2.01 2.01 0 0 0 2.129 2.157h1.255v.333c0 .693-.492 1.02-1.165 1.02-.32 0-.634-.08-.915-.23a1 1 0 0 0-.34-.152.216.216 0 0 0-.23.222v.492a.44.44 0 0 0 .223.354c.4.245.864.36 1.331.333a2.16 2.16 0 0 0 2.352-2.08v-.257h2.912a1.88 1.88 0 0 0 1.7-.826 1.54 1.54 0 0 0 1.428.791h1.075a1.88 1.88 0 0 0 2.019-2.08v-1.818a.286.286 0 0 0-.292-.298M13.2 31.249a.304.304 0 0 0 .443 0l.486-.486a.306.306 0 0 0 0-.444l-.514-.513a.297.297 0 0 0-.437 0l-.492.486a.31.31 0 0 0-.07.342q.024.059.07.101zm1.99 0a.297.297 0 0 0 .437 0l.492-.486a.306.306 0 0 0 0-.444l-.52-.513a.297.297 0 0 0-.437 0l-.485.486a.31.31 0 0 0-.071.342q.024.059.07.101zm3.738-1.318h-.694a.277.277 0 0 0-.284.298v1.762c0 .693-.326 1.116-1.02 1.116h-5.25a1.303 1.303 0 0 1-.846-.305v-2.65a.236.236 0 0 0-.367-.172l-.631.36a.39.39 0 0 0-.243.368v2.164a.7.7 0 0 0 .187.478 2.62 2.62 0 0 0 1.914.763h5.549a1.873 1.873 0 0 0 2.011-2.08v-1.804a.278.278 0 0 0-.326-.298m14.28 5.021a.3.3 0 0 0-.409 0l-.492.486a.29.29 0 0 0 0 .437l.513.52a.3.3 0 0 0 .437 0l.492-.493a.297.297 0 0 0 0-.437zm-4.21 0a.3.3 0 0 0-.437 0l-.492.486a.3.3 0 0 0 0 .437l.513.52a.304.304 0 0 0 .444 0l.486-.493a.3.3 0 0 0 0-.437zm-1.983 0a.305.305 0 0 0-.458 0l-.485.486a.297.297 0 0 0 0 .437l.513.52a.3.3 0 0 0 .437 0l.492-.493a.297.297 0 0 0 0-.437zm-5.694-3.03a1.11 1.11 0 0 1 1.206-1.2c.319-.022.635.066.895.25v2.135h-.97a1.038 1.038 0 0 1-1.131-1.185m2.009-7.214a7.58 7.58 0 1 0 0-15.161 7.58 7.58 0 0 0 0 15.161m2.477-16.804a9.565 9.565 0 1 1-9.932 15.258h-.048l-5.223 3.024a.846.846 0 0 1-1.144-.306l-.624-1.088a.84.84 0 0 1 .305-1.145l5.25-3.03h.056a9.557 9.557 0 0 1 11.36-12.713m-2.476 9.224a1.61 1.61 0 0 0-1.63 1.602v2.004a.59.59 0 0 1-.59.59h-2.108a.736.736 0 0 1-.728-.729v-4.369c0-1.082 0-1.179.416-1.422l3.745-2.164c.261-.194.57-.314.895-.346.325.03.634.15.895.346l3.752 2.2c.423.242.416.339.416 1.42v4.336a.736.736 0 0 1-.694.728h-2.17a.59.59 0 0 1-.59-.59V18.73a1.61 1.61 0 0 0-1.61-1.602"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient id="bayutArabicLogo1" x1={21.5} x2={21.5} y1={75.684} y2={33.287} gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#28B16D" />
      </linearGradient>
      <clipPath id="bayutArabicLogo">
        <path fill="#fff" d="M.201.969h43v43h-43z" />
      </clipPath>
    </defs>
  </svg>
);
export const IconZameenMobileApp = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 62 62"
      {...props}
    >
      <g transform="translate(1689 327)">
        <rect width={62} height={62} fill="#00AA45" rx={15} transform="translate(-1689 -327)" />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M-1639.96-302.86v-7.04h-9.96l-7.86-5.57-21.05 15.01v9.93l3.24-2.4v17.02h7.13a3.94 3.94 0 0 1 .28-3.4l8.27-14.29-7.63 1.94a3.74 3.74 0 0 1-4.52-2.7 3.7 3.7 0 0 1 2.72-4.48l16.14-3.97h.87a4.02 4.02 0 0 1 .67 0h.08a3.51 3.51 0 0 1 .5.1 3.7 3.7 0 0 1 1.02.4 4 4 0 0 1 1.89 2.44 3.96 3.96 0 0 1-.42 3.04l-7.87 13.47 8.45-2.14a3.76 3.76 0 0 1 3.69.95 3.67 3.67 0 0 1 .92 3.65 3.72 3.72 0 0 1-2.8 2.56l-9.58 2.43h15.83v-17.03l3.28 2.4v-9.94z"
        />
      </g>
    </svg>
  );
};

export const EmptyListing = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '164'}
      height={props.size || '89'}
      viewBox="0 0 164 89"
      fill="none"
      {...props}
    >
      <path
        style={{ fill: tenantTheme['primary-light'] }}
        d="M17.357 15.687c0-8.666 7.025-15.69 15.69-15.69h90.982c8.665 0 15.689 7.024 15.689 15.69 0 8.664-7.024 15.688-15.689 15.688H33.047c-8.665 0-15.69-7.024-15.69-15.688m18.811 57.631c0-8.664 7.024-15.688 15.69-15.688h82.924c8.664 0 15.689 7.024 15.689 15.688 0 8.666-7.025 15.69-15.689 15.69H51.857c-8.665 0-15.689-7.024-15.689-15.69"
      />
      <path
        style={{ fill: tenantTheme['primary-light'] }}
        d="M.586 53.193c0-8.664 7.024-15.689 15.69-15.689h131.449c8.666 0 15.69 7.025 15.69 15.69s-7.024 15.689-15.69 15.689H16.275c-8.665 0-15.69-7.024-15.69-15.69"
      />
      <path
        fill={props.color || '#C1D9DA'}
        d="M89.392 24.57a18.7 18.7 0 0 1 6.058-4.053V8.952a5.78 5.78 0 0 0-5.78-5.78H49.206a5.78 5.78 0 0 0-5.78 5.78v11.562a5.78 5.78 0 0 0 5.78 5.78h38.678c.466-.595.96-1.175 1.508-1.723"
      />
      <circle cx={50.426} cy={12.008} r={4} fill="#fff" />
      <rect width={26} height={2.1} x={57.426} y={8.008} fill="#fff" rx={1.05} />
      <rect width={32} height={2.1} x={57.426} y={13.109} fill="#fff" rx={1.05} />
      <rect width={21} height={2.1} x={57.426} y={18.211} fill="#fff" rx={1.05} />
      <path
        fill={props.color || '#C1D9DA'}
        d="M104.119 29.188H63.656a5.78 5.78 0 0 0-5.781 5.78v11.561a5.78 5.78 0 0 0 5.78 5.78h40.464a5.78 5.78 0 0 0 5.78-5.78V34.968a5.78 5.78 0 0 0-5.78-5.78"
      />
      <circle cx={66.426} cy={38.008} r={4} fill="#fff" />
      <rect width={26} height={2.1} x={73.426} y={34.008} fill="#fff" rx={1.05} />
      <rect width={32} height={2.1} x={73.426} y={39.109} fill="#fff" rx={1.05} />
      <rect width={21} height={2.1} x={73.426} y={44.211} fill="#fff" rx={1.05} />
      <path
        fill={props.color || '#C1D9DA'}
        d="M89.67 55.195H49.206a5.78 5.78 0 0 0-5.78 5.78v11.562a5.78 5.78 0 0 0 5.78 5.78H89.67a5.78 5.78 0 0 0 5.781-5.78V60.976a5.78 5.78 0 0 0-5.78-5.78"
      />
      <circle cx={50.426} cy={64.008} r={4} fill="#fff" />
      <rect width={26} height={2.1} x={57.426} y={60.008} fill="#fff" rx={1.05} />
      <rect width={32} height={2.1} x={57.426} y={65.109} fill="#fff" rx={1.05} />
      <rect width={21} height={2.1} x={57.426} y={70.211} fill="#fff" rx={1.05} />
      <mask
        id="EmptyListing"
        width={39}
        height={38}
        x={83}
        y={19}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M115.961 24.565c7.336 7.336 7.336 19.231 0 26.568s-19.231 7.337-26.568 0-7.337-19.231 0-26.568 19.231-7.337 26.568 0"
        />
      </mask>
      <g mask="url(#EmptyListing)">
        <path
          fill="url(#EmptyListing1)"
          d="M108.456 26.29H62.212a5.78 5.78 0 0 0-5.78 5.78v23.12a5.78 5.78 0 0 0 5.78 5.78h46.244a5.78 5.78 0 0 0 5.78-5.78V32.07a5.78 5.78 0 0 0-5.78-5.78"
        />
        <path
          fill={props.color || '#C1D9DA'}
          d="M98.34 37.85H72.327a2.89 2.89 0 0 1 0-5.78H98.34a2.89 2.89 0 0 1 0 5.78m7.225 8.664H72.328a2.89 2.89 0 0 1 0-5.78h33.237a2.89 2.89 0 0 1 0 5.78m-14.451 8.68H72.327a2.89 2.89 0 0 1 0-5.78h18.787a2.89 2.89 0 0 1 0 5.78"
          style={{
            mixBlendMode: 'multiply',
          }}
        />
      </g>
      <path
        fill="#fff"
        d="M86.207 38.532c0-12.172 9.867-22.04 22.038-22.04 12.172 0 22.04 9.868 22.04 22.04 0 12.17-9.868 22.038-22.04 22.038-12.17 0-22.038-9.867-22.038-22.038"
      />
      <path
        fill={props.color || '#C1D9DA'}
        d="M108.245 63.195a24.5 24.5 0 0 1-17.442-7.224 24.5 24.5 0 0 1-7.225-17.442c0-6.59 2.566-12.783 7.225-17.442s10.853-7.225 17.442-7.225 12.783 2.566 17.442 7.225a24.5 24.5 0 0 1 7.225 17.442 24.6 24.6 0 0 1-6.541 16.73 2.628 2.628 0 0 1-3.861-3.565 19.35 19.35 0 0 0 5.146-13.165c0-10.704-8.708-19.412-19.411-19.412s-19.411 8.708-19.411 19.412S97.54 57.94 108.245 57.94c2.415 0 4.77-.437 7-1.3a2.628 2.628 0 1 1 1.896 4.902 24.6 24.6 0 0 1-8.896 1.653"
      />
      <path
        fill={props.color || '#C1D9DA'}
        d="M142.002 74.063a2.62 2.62 0 0 1-1.858-.77l-17.718-17.719a2.628 2.628 0 0 1 3.715-3.716l17.719 17.719a2.628 2.628 0 0 1-1.858 4.486"
      />
      <path
        fill="#fff"
        d="m142.709 78.981-12.777-12.776a4.36 4.36 0 0 1 0-6.164l.67-.67a4.36 4.36 0 0 1 6.163 0l12.777 12.778a4.356 4.356 0 0 1 0 6.163l-.669.67a4.36 4.36 0 0 1-6.164 0"
      />
      <path
        fill={props.color || '#C1D9DA'}
        d="M133.687 60.72c-.443 0-.886.169-1.224.506l-.67.67a1.72 1.72 0 0 0-.507 1.223c0 .463.18.897.507 1.224l12.778 12.777c.327.327.761.507 1.224.507s.896-.18 1.223-.507l.67-.67c.327-.326.506-.76.506-1.223a1.72 1.72 0 0 0-.506-1.224L134.91 61.227a1.72 1.72 0 0 0-1.223-.506m12.108 22.163a6.94 6.94 0 0 1-4.94-2.046L128.077 68.06a6.94 6.94 0 0 1-2.046-4.94c0-1.865.726-3.62 2.046-4.94l.67-.669a6.99 6.99 0 0 1 9.879 0l12.778 12.777a6.994 6.994 0 0 1 0 9.88l-.67.67a6.94 6.94 0 0 1-4.939 2.046"
      />
      <path
        fill="#fff"
        d="M132.966 38.528c0 2.18-.284 4.293-.815 6.305a13.46 13.46 0 0 1-3.545.472c-7.444 0-13.477-6.035-13.477-13.478 0-5.713 3.552-10.593 8.568-12.555 5.65 4.513 9.269 11.462 9.269 19.256"
      />
      <path
        fill={props.color || '#C1D9DA'}
        d="M115.047 28.327c0-7.443 6.034-13.477 13.478-13.477 7.443 0 13.478 6.034 13.478 13.477s-6.035 13.478-13.478 13.478c-7.444 0-13.478-6.035-13.478-13.478"
      />
      <path
        fill="#fff"
        d="M128.544 33.778q.792 0 1.252-.503.46-.502.674-1.702t.215-3.317q0-2.14-.215-3.34-.213-1.198-.674-1.7-.46-.504-1.252-.504t-1.263.503q-.47.503-.674 1.701-.204 1.2-.204 3.34 0 2.118.204 3.317t.674 1.702 1.263.503m0 2.183q-1.712 0-2.676-.856-.963-.855-1.359-2.569-.396-1.712-.396-4.28t.396-4.292 1.359-2.58q.965-.855 2.676-.856 1.713.001 2.665.856.952.857 1.349 2.58.396 1.724.396 4.292t-.396 4.28q-.397 1.714-1.349 2.569t-2.665.856"
      />
      <path
        fill={props.color || '#C1D9DA'}
        d="M94.91 40.54c-.82 0-1.484-.666-1.484-1.484 0-8.209 6.678-14.886 14.885-14.886a1.482 1.482 0 1 1 0 2.967c-6.572 0-11.918 5.346-11.918 11.919 0 .819-.665 1.483-1.484 1.483"
      />
      <defs>
        <radialGradient
          id="EmptyListing1"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(96.144 26.396) scale(32.4114)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F2F2" />
          <stop offset={1} stopColor="#D3D3D3" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const EmptyCreditUsagePlaceholder = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '149'}
      height={props.size || '103'}
      viewBox="0 0 149 103"
      fill="none"
      {...props}
    >
      <path
        fill="#F2FAFA"
        d="M133.097 101.398H26.101s-33.807-32.2-11.47-76.611C23.713 6.733 52.677-7.443 73.043 5.871c7.91 5.17 18.072 18.889 31.342 18.889 37.837 0 44.616 23.1 44.616 41.512 0 30.643-15.903 35.126-15.903 35.126"
        opacity={0.67}
      />
      <g opacity={0.32}>
        <path fill="#5E9499" d="M60.326 39.941h5.182c9.87 0 17.89 8.002 17.89 17.89s-8.002 17.89-17.89 17.89h-4.935" />
        <path
          fill="#C1D9DA"
          d="M61.015 75.71c9.88 0 17.89-8.01 17.89-17.89s-8.01-17.89-17.89-17.89-17.89 8.01-17.89 17.89 8.01 17.89 17.89 17.89"
        />
        <path
          fill="#fff"
          d="M67.136 50.396a15.13 15.13 0 0 0-10.261 0 4.35 4.35 0 0 0-2.877 4.09v7.008a4.35 4.35 0 0 0 2.877 4.09 15.14 15.14 0 0 0 10.26 0c.447-.16.864-.393 1.235-.689-6.118-1.118-6.968-1.035-8.315-2.379a4.751 4.751 0 1 1 6.725-6.713c1.345 1.34 1.263 2.19 2.379 8.276a4.34 4.34 0 0 0 .853-2.585v-7.008a4.35 4.35 0 0 0-2.876-4.09"
        />
        <path fill="#fff" d="M63.419 61.139a1.982 1.982 0 1 0 0-3.963 1.982 1.982 0 0 0 0 3.963" />
        <path
          fill="#5E9499"
          d="M75.237 52.762s-2.08 5.587-2.38 6.398c-.704 1.904 5.976 6.151 14.93 9.483 8.954 3.33 16.797 4.494 17.502 2.59l2.38-6.398"
        />
        <path
          fill="#C1D9DA"
          d="M75.24 52.759c-.704 1.903 5.976 6.151 14.93 9.483 8.953 3.33 16.797 4.494 17.502 2.59s-5.975-6.15-14.947-9.482c-8.954-3.331-16.797-4.495-17.502-2.591z"
        />
        <path
          fill="#5E9499"
          d="M113.871 52.434H109.8c-7.756 0-14.066 8.002-14.066 17.89s6.293 17.89 14.066 17.89h3.877"
        />
        <path
          fill="#C1D9DA"
          d="M113.347 88.171c7.768 0 14.065-8.01 14.065-17.89s-6.297-17.89-14.065-17.89-14.066 8.01-14.066 17.89 6.298 17.89 14.066 17.89"
        />
        <path
          fill="#5E9499"
          d="M65.285 77.66v6.821c0 2.027 7.755 3.684 17.309 3.684 9.553 0 17.308-1.64 17.308-3.684v-6.82"
        />
        <path
          fill="#C1D9DA"
          d="M82.594 81.348c9.559 0 17.308-1.65 17.308-3.684s-7.75-3.683-17.308-3.683c-9.56 0-17.309 1.649-17.309 3.683 0 2.035 7.75 3.684 17.309 3.684"
        />
        <path
          fill="#5E9499"
          d="M82.116 67.004s.247.317 2.344 3.331c4.425 6.38 1.446 16.11-6.662 21.75s-18.278 5.041-22.702-1.34l-2.221-3.19"
        />
        <path
          fill="#C1D9DA"
          d="M75.77 89.18c-8.108 5.64-18.278 5.04-22.702-1.34s-1.446-16.11 6.662-21.75 18.278-5.041 22.702 1.34c4.424 6.38 1.446 16.11-6.662 21.75"
        />
        <path
          fill="#5E9499"
          d="M25.377 85.447s2.485 5.429 2.838 6.204c.846 1.851 8.583.124 17.273-3.86s15.052-8.69 14.206-10.54c-.423-.916-2.837-6.204-2.837-6.204"
        />
        <path
          fill="#95B8E0"
          d="M25.376 85.467c.846 1.85 8.584.124 17.274-3.86 8.689-3.983 15.052-8.69 14.206-10.54s-8.584-.123-17.273 3.86-15.053 8.69-14.207 10.54"
        />
        <path
          fill="#5E9499"
          d="M45.624 56.066s.247.318 2.344 3.332c4.424 6.38 1.445 16.11-6.662 21.75-8.108 5.64-18.278 5.04-22.702-1.34l-2.221-3.19"
        />
        <path
          fill="#C1D9DA"
          d="M39.283 78.262c-8.108 5.64-18.277 5.04-22.702-1.34-4.424-6.38-1.445-16.11 6.663-21.75s18.278-5.041 22.702 1.34c4.424 6.38 1.445 16.11-6.663 21.75"
        />
      </g>
      <path
        fill="#5E9499"
        d="M17.479 66.98h5.182c9.87 0 17.89 8.003 17.89 17.89 0 9.889-8.002 17.891-17.89 17.891h-4.936"
      />
      <path
        fill="#C1D9DA"
        d="M17.89 102.749c9.88 0 17.89-8.01 17.89-17.89s-8.01-17.89-17.89-17.89S0 74.979 0 84.859s8.01 17.89 17.89 17.89"
      />
      <path
        fill="#fff"
        d="M22.888 77.1a15.13 15.13 0 0 0-10.261 0 4.35 4.35 0 0 0-2.877 4.09v7.007a4.35 4.35 0 0 0 2.877 4.09 15.14 15.14 0 0 0 10.26 0 4.33 4.33 0 0 0 1.235-.688c-6.118-1.12-6.968-1.035-8.315-2.38a4.751 4.751 0 0 1 6.725-6.713c1.345 1.34 1.263 2.19 2.379 8.276a4.34 4.34 0 0 0 .854-2.585V81.19a4.35 4.35 0 0 0-2.877-4.09"
      />
      <path fill="#fff" d="M19.171 87.842a1.982 1.982 0 1 0 0-3.963 1.982 1.982 0 0 0 0 3.963" />
      <path
        fill="#5E9499"
        d="M54.068 66.98h4.072c7.755 0 14.065 8.003 14.065 17.89 0 9.889-6.292 17.891-14.065 17.891h-3.878"
      />
      <path
        fill="#C1D9DA"
        d="M54.6 102.749c7.769 0 14.066-8.01 14.066-17.89s-6.297-17.89-14.065-17.89c-7.769 0-14.066 8.01-14.066 17.89s6.297 17.89 14.066 17.89"
      />
      <path
        fill="#5E9499"
        d="M102.666 92.238v6.822c0 2.026-7.755 3.683-17.309 3.683-9.553 0-17.308-1.639-17.308-3.683v-6.822"
      />
      <path
        fill="#C1D9DA"
        d="M85.357 95.926c9.56 0 17.309-1.65 17.309-3.684s-7.75-3.683-17.309-3.683-17.308 1.649-17.308 3.683c0 2.035 7.75 3.684 17.308 3.684"
      />
      <path
        fill="#5E9499"
        d="M128.418 94.299s-2.485 5.428-2.837 6.204c-.847 1.851-8.584.123-17.274-3.86-8.69-3.984-15.052-8.69-14.206-10.54.423-.917 2.838-6.205 2.838-6.205"
      />
      <path
        fill="#C1D9DA"
        d="M128.416 94.3c-.846 1.85-8.583.123-17.273-3.86-8.689-3.984-15.052-8.69-14.206-10.541.846-1.85 8.584-.124 17.273 3.86s15.052 8.69 14.206 10.54"
      />
      <path
        fill="#fff"
        d="M133.092 62.132a1.826 1.826 0 0 1-1.825 1.825h-2.796v-3.65h2.796c1.008 0 1.825.817 1.825 1.825"
      />
      <path
        fill="#A6C8CA"
        d="M69.116 18.672c6.876 1.967 15.074 3.02 22.828.757 6.495-1.897 10.427-5.255 10.013-8.557-.19-1.522-1.298-2.885-3.206-3.94-2.178-1.206-5.257-1.91-8.906-2.04-11.172-.395-19.426 5.424-20.665 11.043a6.9 6.9 0 0 0-.064 2.737m23.329 12.754-.061-.003c-6.018-.536-11.245-1.724-15.532-3.53-3.525-1.484-6.086-3.357-7.613-5.564a9 9 0 0 1-1.245-2.567c-5.41-1.617-10.006-3.771-13.132-5.439a.676.676 0 1 1 .637-1.194c2.61 1.393 6.96 3.485 12.199 5.118a8.3 8.3 0 0 1 .16-2.603c.724-3.28 3.411-6.46 7.373-8.721 4.148-2.37 9.356-3.57 14.662-3.383 3.86.137 7.15.9 9.513 2.208 2.268 1.255 3.652 3.016 3.894 4.956.243 1.937-.615 3.889-2.479 5.642-1.915 1.803-4.853 3.317-8.497 4.381-6.043 1.765-12.94 1.78-20.498.047q-1.134-.259-2.23-.557.3.683.756 1.342c1.378 1.992 3.741 3.704 7.025 5.088 4.159 1.75 9.248 2.905 15.127 3.429a.677.677 0 0 1-.059 1.35M59.56 20.879a.4.4 0 0 1-.095-.013c-6.294-1.672-13.26-6.76-13.329-6.811a.372.372 0 1 1 .44-.6c.07.05 6.924 5.057 13.08 6.692a.372.372 0 0 1-.095.732"
      />
      <path
        fill="#5E9499"
        d="M48.278 4.29c.087-1.997-.806-3.658-1.994-3.71s-2.222 1.525-2.31 3.522c-.086 1.996.806 3.658 1.995 3.71 1.188.05 2.222-1.525 2.31-3.522"
      />
      <path
        fill="#71A7AC"
        d="M50.468 7.73c0-1.072-1.818-1.942-4.06-1.942s-4.06.87-4.06 1.942 1.818 1.942 4.06 1.942 4.06-.87 4.06-1.942"
      />
      <path
        fill="#71A7AC"
        d="M48.948 5.435c1.15-1.634 1.293-3.514.32-4.198s-2.693.086-3.843 1.72c-1.15 1.635-1.294 3.515-.32 4.2.972.684 2.693-.087 3.843-1.722"
      />
      <path fill="#5E9499" d="M43.754 6.975a.755.755 0 1 0-1.51 0 .755.755 0 0 0 1.51 0" />
      <path
        fill="#71A7AC"
        d="M49.428 9.977h-.014a10.8 10.8 0 0 1-3.773-.912.248.248 0 0 1 .2-.452c1.142.507 2.354.8 3.601.87a.247.247 0 0 1-.014.494m-1.349 1.265a.3.3 0 0 1-.073-.01 8.35 8.35 0 0 1-3.232-1.865.247.247 0 1 1 .337-.362 7.84 7.84 0 0 0 3.04 1.753.247.247 0 0 1-.072.484"
      />
    </svg>
  );
};
export const AnalyticsPlaceholder = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '92'}
      height={props.size || '76'}
      viewBox="0 0 92 76"
      fill="none"
      {...props}
    >
      <path
        fill={props.color || '#F2FAFA'}
        d="M72.163 72.013 7.275 75.15a4.037 4.037 0 0 1-4.228-3.837L.505 18.749a4.037 4.037 0 0 1 3.837-4.228l64.89-3.139a4.037 4.037 0 0 1 4.226 3.838l2.543 52.565a4.037 4.037 0 0 1-3.838 4.228"
      />
      <path
        fill="#fff"
        d="M11.26 66.572a3.25 3.25 0 0 1-3.246-3.245V10.699a3.25 3.25 0 0 1 3.246-3.246h64.964a3.25 3.25 0 0 1 3.246 3.246v52.628a3.25 3.25 0 0 1-3.246 3.245z"
      />
      <path
        style={{ fill: tenantTheme['primary-color'] }}
        d="M76.224 6.662H11.26a4.04 4.04 0 0 0-4.038 4.037v52.627a4.037 4.037 0 0 0 4.037 4.037h64.965a4.037 4.037 0 0 0 4.037-4.037V10.7a4.037 4.037 0 0 0-4.037-4.037m0 1.583c1.354 0 2.455 1.1 2.455 2.454v52.627a2.46 2.46 0 0 1-2.455 2.455H11.26a2.46 2.46 0 0 1-2.455-2.455V10.7a2.457 2.457 0 0 1 2.454-2.454z"
      />
      <path
        fill={props.color || '#F2FAFA'}
        d="M69.889 19.283H17.538v-.418h52.35zm0 7.102H17.538v-.419h52.35zm0 7.101H17.538v-.418h52.35zm0 7.098H17.538v-.418h52.35zm0 7.1H17.538v-.419h52.35zm0 7.097H17.538v-.418h52.35z"
      />
      <path
        fill={props.color || '#F2FAFA'}
        d="M60.429 30.117v24.836h9.518V30.117zM46.15 23.322v31.631h9.52v-31.63zm-4.76 6.795h-9.516v24.836h9.517zM17.597 22.53v32.423h9.517V22.53z"
      />
      <path
        style={{ fill: tenantTheme['primary-color'] }}
        d="m51.122 35.967 14.255 4.57 4.57-3.602v-1.818L65 39.017 50.7 34.43 36.677 46.477 22.74 32.571h-5.143v1.3h4.375l14.615 14.582z"
      />
      <path
        fill="#fff"
        d="M80.263 10.7v15.598h-.142c-8.241 0-14.92-6.68-14.92-14.919 0-1.649.266-3.234.76-4.716h10.265a4.037 4.037 0 0 1 4.037 4.038"
      />
      <path
        style={{ fill: tenantTheme['primary-color'] }}
        d="M68.742 11.378c0 6.285 5.094 11.38 11.379 11.38S91.5 17.663 91.5 11.378C91.5 5.094 86.405 0 80.12 0c-6.285 0-11.38 5.095-11.38 11.38"
      />
      <path
        fill="#fff"
        d="M80.128 15.73q.6 0 .945-.38t.494-1.324.15-2.64q0-1.694-.15-2.648-.15-.952-.494-1.332t-.945-.38-.953.38q-.353.38-.503 1.332-.15.954-.15 2.649t.15 2.64q.15.944.503 1.323.353.38.953.38m0 2.012q-1.447 0-2.26-.723-.81-.724-1.13-2.137-.317-1.412-.317-3.495 0-2.1.318-3.514.317-1.412 1.13-2.136.81-.724 2.26-.724 1.448 0 2.241.724.795.724 1.122 2.136.326 1.413.326 3.514 0 2.084-.326 3.495-.327 1.413-1.122 2.137-.793.723-2.242.723"
      />
    </svg>
  );
};
export const RequestedStateIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 15 14"
    fill="none"
    {...props}
  >
    <g clipPath="url(#RequestedStateIcon1)">
      <path fill="currentColor" d="M14.544 6.855a6.855 6.855 0 1 0-13.71 0 6.855 6.855 0 0 0 13.71 0" />
    </g>
    <g clipPath="url(#RequestedStateIcon2)">
      <path
        fill="#fff"
        d="M10.82 4.525a1.31 1.31 0 0 0-.307-1.052 1.34 1.34 0 0 0-1.015-.465h-3.33c-.39 0-.76.17-1.014.466a1.31 1.31 0 0 0-.306 1.052c.136.9.629 1.733 1.467 2.481-.839.75-1.332 1.582-1.467 2.482-.056.377.055.76.306 1.052.255.297.625.466 1.014.466h3.33c.39 0 .76-.17 1.015-.466.25-.29.363-.674.306-1.05-.134-.898-.628-1.731-1.469-2.484.841-.753 1.335-1.586 1.47-2.482m-1.011-.06c-.328.811-1.017 1.475-1.537 1.888l-.23.184a.334.334 0 0 1-.415 0l-.234-.186c-.52-.41-1.207-1.07-1.535-1.885a.334.334 0 0 1 .309-.458H9.5a.332.332 0 0 1 .309.458M7.857 5.833l-.023.018-.028-.021c-.349-.276-.783-.677-1.09-1.154H8.95c-.308.476-.743.878-1.093 1.157"
      />
    </g>
    <defs>
      <clipPath id="RequestedStateIcon1">
        <path fill="currentColor" d="M.834 0h14v14h-14z" />
      </clipPath>
      <clipPath id="RequestedStateIcon2">
        <path fill="#fff" d="M3.834 3h8v8h-8z" />
      </clipPath>
    </defs>
  </svg>
);
export const TimelineIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 12 13"
    fill="none"
    {...props}
  >
    <g fill="#71A8AC" fillRule="evenodd" clipPath="url(#TimelineIcon)" clipRule="evenodd">
      <path d="M11.7 6.5c0 3.147-2.554 5.7-5.7 5.7A5.702 5.702 0 0 1 .3 6.5C.3 3.355 2.853.8 6 .8c1.283 0 2.467.426 3.42 1.142v-.76a.38.38 0 0 1 .76 0V2.78a.38.38 0 0 1-.65.265 4.93 4.93 0 0 0-3.53-1.485A4.943 4.943 0 0 0 1.06 6.5 4.943 4.943 0 0 0 6 11.442a4.943 4.943 0 0 0 4.94-4.94.38.38 0 1 1 .76 0Z" />
      <path d="M6 2.902a3.602 3.602 0 0 0-3.6 3.6c0 1.987 1.613 3.6 3.6 3.6 1.986 0 3.6-1.613 3.6-3.6 0-1.986-1.614-3.6-3.6-3.6Zm1.54 5.141a.329.329 0 0 1-.463 0l-1.31-1.31a.329.329 0 0 1-.095-.23V4.538a.328.328 0 0 1 .655 0v1.828L7.54 7.58a.329.329 0 0 1 0 .463Z" />
    </g>
  </svg>
);
export const PropertyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 52 52"
    fill="none"
    {...props}
  >
    <path fill="url(#aPropertyIcon)" d="M18.688 29.25h4v4.063h-4z" />
    <path
      fill="url(#bPropertyIcon)"
      d="M38.188 29.25h-9.75v17.875h9.75zm-7.313 8.938a.813.813 0 1 1 0-1.627.813.813 0 0 1 0 1.627"
    />
    <path fill="url(#cPropertyIcon)" d="M13.813 34.938h4V39h-4z" />
    <path fill="url(#dPropertyIcon)" d="M18.688 34.938h4V39h-4z" />
    <path fill="url(#ePropertyIcon)" d="M13.813 29.25h4v4.063h-4z" />
    <path
      fill="url(#fPropertyIcon)"
      d="M44.007 22.417 25.872 9.164 7.736 22.417l1.737 1.302 15.96-11.607a.75.75 0 0 1 .877 0l15.96 11.607z"
    />
    <path
      stroke="url(#gPropertyIcon)"
      strokeWidth={2}
      d="M40.53 25.531v19.737h-.982V29.116a1.746 1.746 0 0 0-1.746-1.745h-10.44a1.746 1.746 0 0 0-1.745 1.745v16.152H11.21V25.53l14.66-10.66z"
    />
    <path
      fill="url(#hPropertyIcon)"
      d="M45.283 43.288h-.002a2 2 0 0 1-.115.012.746.746 0 0 1-.748-.999c.062-.161.095-.332.097-.505a1.493 1.493 0 0 0-1.492-1.491v5.965h2.238a1.491 1.491 0 1 0 .022-2.983"
    />
    <path fill="url(#iPropertyIcon)" d="m33.258 12.713 4.545 3.321v-7.05h-4.475v3.729z" />
    <path fill="url(#jPropertyIcon)" d="M32.584 6h5.966v1.491h-5.966z" />
    <path
      fill="url(#kPropertyIcon)"
      d="M6.576 43.3a2 2 0 0 1-.115-.012H6.46a1.491 1.491 0 0 0 .023 2.982H8.72v-5.965a1.493 1.493 0 0 0-1.491 1.491q.003.262.096.505a.746.746 0 0 1-.748 1"
    />
    <defs>
      <linearGradient id="aPropertyIcon" x1={19.875} x2={20.375} y1={36.5} y2={28.974} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="bPropertyIcon" x1={33} x2={32.56} y1={49.5} y2={29.51} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="cPropertyIcon" x1={15} x2={15.5} y1={42.188} y2={34.662} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="dPropertyIcon" x1={19.875} x2={20.375} y1={42.188} y2={34.662} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="ePropertyIcon" x1={15} x2={15.5} y1={36.5} y2={28.974} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="fPropertyIcon" x1={49.754} x2={-2.224} y1={17.334} y2={16.604} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="gPropertyIcon" x1={29.5} x2={25.611} y1={52} y2={8.034} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="hPropertyIcon" x1={47.356} x2={41.995} y1={43.653} y2={43.634} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="iPropertyIcon" x1={35} x2={36.271} y1={19} y2={5.978} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="jPropertyIcon" x1={34.5} x2={35.172} y1={12} y2={3.013} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="kPropertyIcon" x1={9.308} x2={3.978} y1={43.653} y2={43.634} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
    </defs>
  </svg>
);
export const PropertyInformationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 52 52"
    fill="none"
    {...props}
  >
    <path
      fill="#F7F7F7"
      d="M42 0H10C4.477 0 0 4.477 0 10v32c0 5.523 4.477 10 10 10h32c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10"
    />
    <path
      fill="#ACC9CB"
      fillRule="evenodd"
      d="M22.91 8h-1.192v2.393h1.192zm-5.379 3.888h2.393v1.191h-2.393zm6.879 0h2.392v1.191H24.41z"
      clipRule="evenodd"
    />
    <g clipPath="url(#a)">
      <path
        fill="#006169"
        d="M23.068 22.457h1.407v1.406h-1.407zm0 3.227h1.407v1.406h-1.407zm6.457 0h1.407v1.406h-1.407zm3.227 0h1.406v1.406h-1.406zm-3.227 3.226h1.407v1.406h-1.407zm3.227 0h1.406v1.406h-1.406zm-3.227 3.227h1.407v1.406h-1.407zm3.227 0h1.406v1.406h-1.406zm-3.227 3.23h1.407v1.406h-1.407zm3.227 0h1.406v1.406h-1.406zm-12.91-9.683h1.406v1.406h-1.406zm3.226 3.226h1.407v1.406h-1.407zm-3.226 0h1.406v1.406h-1.406zm3.226 3.227h1.407v1.406h-1.407zm-3.226 0h1.406v1.406h-1.406z"
      />
      <path
        fill="#E8E8E8"
        d="M38.386 38.594V22.455h-9.683v-3.354l-1.614.269V16h-7.861v4.68l-1.614.269v17.645H16V40h24v-1.406zM36.98 23.862v14.732h-8.277V23.862zm-16.346-6.456h5.049v2.198l-5.05.842zM19.02 22.14l8.277-1.38v17.834h-1.822v-3.228h-4.634v3.228h-1.82zm5.05 16.454h-1.822v-1.822h1.821z"
      />
      <path
        fill="#D0D0D0"
        d="M37.386 38.594V22.455h-9.683v-3.354l-1.614.269V16h-7.861v4.68l-1.614.269v17.645H15V40h24v-1.406zM35.98 23.862v14.732h-8.277V23.862zm-16.346-6.456h5.049v2.198l-5.05.842zM18.02 22.14l8.277-1.38v17.834h-1.822v-3.228h-4.634v3.228h-1.82zm5.05 16.454h-1.822v-1.822h1.821z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M15 16h24v24H15z" />
      </clipPath>
    </defs>
  </svg>
);

export const RentalIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 52 52"
    fill="none"
    {...props}
  >
    <path
      fill="#D9D9D9"
      d="m19.866 39.471-.133.025c-.844-5.83-2.39-11.6-4.491-16.712l-.497-1.208-1.036.794c-2.257 1.73-3.275 4.324-3.738 6.38q-.102.46-.173.887c-.331-3.672.557-6.612 1.132-8.048l.68-1.7-1.798.347c-1.435.276-2.734 1.056-3.847 1.992-1.12.94-2.105 2.085-2.917 3.176a29 29 0 0 0-2.028 3.145c-.144-3.384 1.038-5.633 2.52-7.15 1.702-1.74 3.873-2.586 5.162-2.943l1.925-.533-1.58-1.222c-1.384-1.07-3.232-1.319-4.593-1.346-.554-.011-1.06.014-1.47.048 1.494-1.21 3.011-1.548 4.365-1.498 1.631.06 3.08.691 3.98 1.2l1.37.772.119-1.568c.079-1.043.353-2.603 1.202-3.997.703-1.156 1.82-2.233 3.653-2.806-.264.335-.57.75-.867 1.223-.729 1.154-1.542 2.835-1.41 4.564l.15 1.975 1.5-1.294c1.012-.873 2.918-2.212 5.312-2.67 2.111-.402 4.68-.136 7.466 1.91q-.167-.014-.356-.026a30 30 0 0 0-3.516-.023c-1.356.074-2.853.262-4.253.675-1.393.41-2.76 1.062-3.78 2.108l-1.266 1.299 1.774.377c1.494.318 4.407 1.2 7.278 3.484q-.404-.18-.852-.35c-2.004-.757-4.773-1.34-7.489-.354l-.925.336.321.93.015.043c.752 2.178 3.338 9.673 5.283 17.358l-.19.035z"
    />
    <path
      fill="url(#aRentalIcon)"
      d="m19.866 39.471-.133.025c-.844-5.83-2.39-11.6-4.491-16.712l-.497-1.208-1.036.794c-2.257 1.73-3.275 4.324-3.738 6.38q-.102.46-.173.887c-.331-3.672.557-6.612 1.132-8.048l.68-1.7-1.798.347c-1.435.276-2.734 1.056-3.847 1.992-1.12.94-2.105 2.085-2.917 3.176a29 29 0 0 0-2.028 3.145c-.144-3.384 1.038-5.633 2.52-7.15 1.702-1.74 3.873-2.586 5.162-2.943l1.925-.533-1.58-1.222c-1.384-1.07-3.232-1.319-4.593-1.346-.554-.011-1.06.014-1.47.048 1.494-1.21 3.011-1.548 4.365-1.498 1.631.06 3.08.691 3.98 1.2l1.37.772.119-1.568c.079-1.043.353-2.603 1.202-3.997.703-1.156 1.82-2.233 3.653-2.806-.264.335-.57.75-.867 1.223-.729 1.154-1.542 2.835-1.41 4.564l.15 1.975 1.5-1.294c1.012-.873 2.918-2.212 5.312-2.67 2.111-.402 4.68-.136 7.466 1.91q-.167-.014-.356-.026a30 30 0 0 0-3.516-.023c-1.356.074-2.853.262-4.253.675-1.393.41-2.76 1.062-3.78 2.108l-1.266 1.299 1.774.377c1.494.318 4.407 1.2 7.278 3.484q-.404-.18-.852-.35c-2.004-.757-4.773-1.34-7.489-.354l-.925.336.321.93.015.043c.752 2.178 3.338 9.673 5.283 17.358l-.19.035z"
    />
    <path
      stroke="url(#bRentalIcon)"
      strokeWidth={2}
      d="m19.866 39.471-.133.025c-.844-5.83-2.39-11.6-4.491-16.712l-.497-1.208-1.036.794c-2.257 1.73-3.275 4.324-3.738 6.38q-.102.46-.173.887c-.331-3.672.557-6.612 1.132-8.048l.68-1.7-1.798.347c-1.435.276-2.734 1.056-3.847 1.992-1.12.94-2.105 2.085-2.917 3.176a29 29 0 0 0-2.028 3.145c-.144-3.384 1.038-5.633 2.52-7.15 1.702-1.74 3.873-2.586 5.162-2.943l1.925-.533-1.58-1.222c-1.384-1.07-3.232-1.319-4.593-1.346-.554-.011-1.06.014-1.47.048 1.494-1.21 3.011-1.548 4.365-1.498 1.631.06 3.08.691 3.98 1.2l1.37.772.119-1.568c.079-1.043.353-2.603 1.202-3.997.703-1.156 1.82-2.233 3.653-2.806-.264.335-.57.75-.867 1.223-.729 1.154-1.542 2.835-1.41 4.564l.15 1.975 1.5-1.294c1.012-.873 2.918-2.212 5.312-2.67 2.111-.402 4.68-.136 7.466 1.91q-.167-.014-.356-.026a30 30 0 0 0-3.516-.023c-1.356.074-2.853.262-4.253.675-1.393.41-2.76 1.062-3.78 2.108l-1.266 1.299 1.774.377c1.494.318 4.407 1.2 7.278 3.484q-.404-.18-.852-.35c-2.004-.757-4.773-1.34-7.489-.354l-.925.336.321.93.015.043c.752 2.178 3.338 9.673 5.283 17.358l-.19.035z"
    />
    <path
      fill="#D9D9D9"
      d="M49.506 43.152c.885.573 1.295 1.117 1.433 1.575h-3.46a2.96 2.96 0 0 0 2.027-1.575m-24.641-1.364a3.02 3.02 0 0 0 2.395 2.939H10.758c.108-.37.391-.78.953-1.225.753-.598 1.892-1.16 3.354-1.658 2.654-.903 6.164-1.522 9.8-1.834z"
    />
    <path
      fill="url(#cRentalIcon)"
      d="M49.506 43.152c.885.573 1.295 1.117 1.433 1.575h-3.46a2.96 2.96 0 0 0 2.027-1.575m-24.641-1.364a3.02 3.02 0 0 0 2.395 2.939H10.758c.108-.37.391-.78.953-1.225.753-.598 1.892-1.16 3.354-1.658 2.654-.903 6.164-1.522 9.8-1.834z"
    />
    <path
      stroke="url(#dRentalIcon)"
      strokeWidth={2}
      d="M49.506 43.152c.885.573 1.295 1.117 1.433 1.575h-3.46a2.96 2.96 0 0 0 2.027-1.575Zm-24.641-1.364a3.02 3.02 0 0 0 2.395 2.939H10.758c.108-.37.391-.78.953-1.225.753-.598 1.892-1.16 3.354-1.658 2.654-.903 6.164-1.522 9.8-1.834z"
    />
    <path
      stroke="url(#eRentalIcon)"
      strokeWidth={2}
      d="M21.505 29.876v-1.958l12.266-12.27L45.93 27.854v13.575h-6.68v-8.232a2.627 2.627 0 0 0-2.658-2.658h-5.748a2.627 2.627 0 0 0-2.658 2.658v8.232h-6.68zm-2.285.328Zm16.427 10.89H31.85l.04-6.898h3.758z"
    />
    <path
      stroke="url(#fRentalIcon)"
      strokeWidth={2}
      d="m39.976 16.52 1.45-1.45 1.79 1.846v2.858zm1.579-1.58-.002.002zm-.102-.095.018.018z"
    />
    <defs>
      <linearGradient id="aRentalIcon" x1={37.103} x2={-5.703} y1={49.824} y2={3.703} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="bRentalIcon" x1={37.103} x2={-5.703} y1={49.824} y2={3.703} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="cRentalIcon" x1={59.349} x2={57.103} y1={47.467} y2={30.945} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="dRentalIcon" x1={59.349} x2={57.103} y1={47.467} y2={30.945} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="eRentalIcon" x1={54.606} x2={21.453} y1={49.547} y2={5.9} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="fRentalIcon" x1={45.182} x2={35.283} y1={24.293} y2={16.362} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
    </defs>
  </svg>
);

export const PackageSuccessIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '191'}
    height={props.height || '142'}
    viewBox="0 0 191 142"
    fill="none"
    {...props}
  >
    <path
      fill="#CEEDF0"
      d="M151.192 53.317c-2.282-4.451-4.196-9.037-5.018-14.057-1.489-9.105.851-18.923-2.456-27.74C139.937 1.463 130.955-1.13 121.044.413c-12.763 1.985-24.636 8.42-36.78 12.988-8.693 3.275-18.178 5.202-27.48 3.796-11.39-1.725-23.127-5.858-34.633-2.553C4.01 19.855-2.428 38.277.8 55.475c2.256 11.996 10.89 21.468 17.32 31.441 4.834 7.505 8.054 15.367 8.093 24.366.029 8.094-2.224 17.94 4.293 23.827 10.964 9.915 23.215 7.834 34.73 1.87 1.683-.868 3.317-1.802 4.893-2.717 13.256-6.764 28.098-16.813 43.433-10.117a78 78 0 0 0 4.892 1.821c14.919 4.971 31.511 4.548 40.958-10.223 7.309-11.437 6.468-26.428 3.036-39.05-2.282-8.392-7.31-15.676-11.255-23.384z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="M21.263 20.57H152.18a4.16 4.16 0 0 1 4.167 4.153v96.879a4.16 4.16 0 0 1-4.167 4.153H21.263a4.16 4.16 0 0 1-4.167-4.153V24.723a4.16 4.16 0 0 1 4.167-4.153"
    />
    <path
      fill="#BDDDF9"
      d="M152.18 20.823a3.9 3.9 0 0 1 3.906 3.893v96.879a3.9 3.9 0 0 1-3.906 3.893H21.262a3.9 3.9 0 0 1-3.906-3.893v-96.87a3.9 3.9 0 0 1 3.906-3.892H152.18m0-.52H21.262c-2.436 0-4.418 1.975-4.418 4.403v96.879c0 2.428 1.982 4.403 4.418 4.403H152.18c2.436 0 4.418-1.975 4.418-4.403v-96.87c0-2.428-1.982-4.403-4.418-4.403z"
    />
    <path
      fill="#CEEDF0"
      d="M21.262 20.313H152.18c2.436 0 4.418 1.975 4.418 4.403v6.002H16.844v-6.002c0-2.428 1.982-4.404 4.418-4.404"
    />
    <path
      fill="#fff"
      d="M125.857 26.264a1.47 1.47 0 0 0-2.861-.674 1.47 1.47 0 0 0 2.861.674m9.317.693a1.46 1.46 0 0 0 0-2.07 1.473 1.473 0 0 0-2.078 0 1.46 1.46 0 0 0 0 2.07 1.473 1.473 0 0 0 2.078 0m9.744-.007a1.46 1.46 0 0 0 0-2.072 1.473 1.473 0 0 0-2.078 0 1.46 1.46 0 0 0 0 2.072 1.473 1.473 0 0 0 2.078 0"
    />
    <path
      fill="#CEEDF0"
      d="M51.67 93.04h63.854c.593 0 1.074-.48 1.074-1.07V72.96c0-.59-.481-1.07-1.074-1.07H51.671c-.593 0-1.073.48-1.073 1.07v19.01c0 .59.48 1.07 1.073 1.07m-.376-48.68h96.94a.696.696 0 0 0 .697-.694V39.34a.695.695 0 0 0-.697-.694h-96.94a.695.695 0 0 0-.696.694v4.326c0 .383.312.693.696.693m22.247 5.029v18.249c0 .424-.242.77-.532.77H51.274c-.29 0-.532-.346-.532-.77V49.388c0-.424.242-.77.532-.77H73.01c.29 0 .531.346.531.77m20.625-.771h-18.39a.763.763 0 0 0-.764.761v18.259c0 .42.342.76.764.76h18.39c.422 0 .764-.34.764-.76V49.378a.763.763 0 0 0-.764-.76m21.93-.001h-18.39a.763.763 0 0 0-.765.761v18.259c0 .42.342.76.764.76h18.391c.421 0 .763-.34.763-.76V49.378a.76.76 0 0 0-.763-.76"
      opacity={0.4}
    />
    <path
      fill="#CBE3F7"
      d="M113.726 75.36H53.498v.192h60.228zm0 3.71H53.498v.193h60.228zm0 3.72H53.498v.192h60.228zm0 3.71H53.498v.193h60.228zm0 3.719H53.498v.192h60.228z"
    />
    <path
      fill="#74A3FD"
      d="M60.072 89.317c-3.016 0-4.602-1.88-4.68-1.966l.32-.26c.019.02 1.914 2.264 5.453 1.725 1.721-.26 2.93-1.918 4.206-3.671 1.48-2.023 3.017-4.124 5.473-4.124s3.422 1.185 4.534 2.332c1.15 1.175 2.234 2.293 4.506 2.293s3.81-1.937 5.54-3.98c1.837-2.187 3.742-4.441 6.488-4.441s3.81.896 4.95 1.753c1.151.877 2.244 1.696 4.825 1.696 5.096 0 8.528-6.108 8.557-6.166l.368.202c-.145.26-3.578 6.388-8.925 6.388s-3.925-.906-5.076-1.782c-1.131-.858-2.204-1.667-4.699-1.667s-4.39 2.177-6.169 4.287c-1.711 2.033-3.48 4.124-5.86 4.124-2.378 0-3.654-1.233-4.804-2.418-1.103-1.137-2.137-2.207-4.235-2.207s-3.723 2.004-5.144 3.95c-1.277 1.745-2.592 3.546-4.487 3.835a8 8 0 0 1-1.16.087z"
    />
    <path
      fill="url(#a)"
      d="M40.503 42.572H30.099a1.823 1.823 0 0 1-1.828-1.821c0-1.012.822-1.821 1.828-1.821h10.404c1.015 0 1.827.819 1.827 1.82a1.823 1.823 0 0 1-1.827 1.822"
    />
    <path
      fill="url(#b)"
      d="M39.778 52.617h-8.953a.714.714 0 0 0-.716.713v.01c0 .394.32.713.716.713h8.953c.395 0 .716-.32.716-.713v-.01a.714.714 0 0 0-.716-.713"
    />
    <path fill="url(#c)" d="M39.778 61.043h-8.943a.713.713 0 1 1 0-1.426h8.943a.713.713 0 1 1 0 1.426" />
    <path fill="url(#d)" d="M39.778 68.028h-8.943a.713.713 0 1 1 0-1.426h8.943a.713.713 0 1 1 0 1.425" />
    <path fill="url(#e)" d="M39.778 75.004h-8.943a.713.713 0 1 1 0-1.426h8.943a.713.713 0 1 1 0 1.426" />
    <path fill="url(#f)" d="M39.778 81.989h-8.943a.713.713 0 1 1 0-1.427h8.943a.713.713 0 1 1 0 1.427" />
    <path
      fill="url(#g)"
      d="M151.744 71.64h-29.819c-.56 0-1.015.454-1.015 1.012V92.28c0 .558.455 1.011 1.015 1.011h29.819c.561 0 1.016-.453 1.016-1.011V72.652c0-.558-.455-1.011-1.016-1.011"
      opacity={0.45}
    />
    <path
      fill="url(#h)"
      d="M151.744 95.844h-29.819c-.56 0-1.015.453-1.015 1.011v19.627c0 .559.455 1.011 1.015 1.011h29.819c.561 0 1.016-.452 1.016-1.011V96.855c0-.558-.455-1.011-1.016-1.011"
      opacity={0.45}
    />
    <path fill="#fff" d="M142.134 83.256h-10.597a.8.8 0 1 1 0-1.6h10.597a.8.8 0 1 1 0 1.6" />
    <path fill="url(#i)" d="M142.134 107.459h-10.597a.8.8 0 1 1 0-1.6h10.597a.8.8 0 1 1 0 1.6" />
    <path
      fill="url(#j)"
      d="M42.07 118.734h68.369c.636 0 1.151-.513 1.151-1.146v-20.35c0-.632-.515-1.146-1.151-1.146H42.07c-.635 0-1.15.514-1.15 1.147v20.349c0 .633.515 1.146 1.15 1.146"
      opacity={0.4}
    />
    <path fill="url(#k)" d="M52.56 100.133c3.868 0 7.01 3.122 7.01 6.985s-.783 3.671-2.05 4.933l-4.95-4.933v-6.985z" />
    <path fill="#fff" d="M49.488 101.073a7 7 0 0 0-3.597 2.689l5.782 3.95v-6.985c-.764 0-1.499.125-2.176.346z" />
    <path
      fill="url(#l)"
      d="m51.662 107.716-5.782-3.95a6.95 6.95 0 0 0-1.228 3.95c0 1.464.58 3.179 1.547 4.374a7.02 7.02 0 0 0 5.463 2.611c2.205 0 3.684-.78 4.95-2.042l-4.95-4.933z"
    />
    <path fill="url(#m)" d="M75.468 103.433h-6.682a.463.463 0 1 1 0-.925h6.682a.463.463 0 1 1 0 .925" />
    <path fill="#fff" d="M105.857 103.433H79.945a.463.463 0 1 1 0-.925h25.912a.463.463 0 1 1 0 .925" />
    <path fill="url(#n)" d="M75.468 107.878h-6.682a.463.463 0 1 1 0-.925h6.682a.463.463 0 1 1 0 .925" />
    <path fill="#fff" d="M105.857 107.878H79.945a.463.463 0 1 1 0-.925h25.912a.463.463 0 1 1 0 .925" />
    <path fill="url(#o)" d="M75.468 112.316h-6.682a.463.463 0 1 1 0-.925h6.682a.463.463 0 1 1 0 .925" />
    <path fill="#fff" d="M105.857 112.316H79.945a.463.463 0 1 1 0-.925h25.912a.463.463 0 1 1 0 .925" />
    <path
      fill="url(#p)"
      d="M62.143 55.024v-1.368a4.85 4.85 0 0 0-4.864 4.847 4.85 4.85 0 0 0 4.864 4.846v-1.368a3.483 3.483 0 0 1-3.49-3.478 3.49 3.49 0 0 1 3.49-3.479"
    />
    <path
      fill="url(#q)"
      d="M67.006 58.503a4.85 4.85 0 0 1-4.863 4.846v-1.368a3.483 3.483 0 0 0 3.49-3.478 3.49 3.49 0 0 0-3.49-3.479v-1.368a4.85 4.85 0 0 1 4.863 4.847"
    />
    <path
      fill="url(#r)"
      d="M88.461 58.503a3.483 3.483 0 0 1-3.49 3.478 3.49 3.49 0 0 1-3.49-3.478 3.49 3.49 0 0 1 3.49-3.479v-1.368a4.85 4.85 0 0 0-4.864 4.847 4.85 4.85 0 0 0 4.864 4.846 4.85 4.85 0 0 0 4.863-4.846z"
    />
    <path fill="url(#s)" d="M89.834 58.503h-1.373a3.483 3.483 0 0 0-3.49-3.479v-1.368a4.85 4.85 0 0 1 4.863 4.847" />
    <path
      fill="url(#t)"
      d="M106.901 53.656v1.368a3.483 3.483 0 0 1 3.49 3.479 3.49 3.49 0 0 1-3.49 3.478 3.49 3.49 0 0 1-3.491-3.478h-1.373c0 2.678 2.176 4.846 4.864 4.846a4.85 4.85 0 0 0 4.863-4.846 4.85 4.85 0 0 0-4.863-4.847"
    />
    <path fill="url(#u)" d="M106.901 53.656v1.368a3.483 3.483 0 0 0-3.491 3.479h-1.373a4.853 4.853 0 0 1 4.864-4.847" />
    <path
      fill="url(#v)"
      d="M28.263 67.063H6.875c-.652 0-1.18.526-1.18 1.175v21.313c0 .649.528 1.175 1.18 1.175h21.388c.651 0 1.18-.526 1.18-1.175V68.238c0-.65-.529-1.175-1.18-1.175"
    />
    <path
      fill="#E0E0E0"
      d="M17.568 71.445c-4.129 0-7.474 3.334-7.474 7.448s3.345 7.448 7.474 7.448 7.484-3.334 7.484-7.448-3.346-7.448-7.484-7.448m0 12.323c-2.698 0-4.893-2.177-4.893-4.875a4.877 4.877 0 0 1 4.893-4.875 4.877 4.877 0 0 1 4.892 4.875 4.877 4.877 0 0 1-4.892 4.875"
    />
    <path
      fill="#fff"
      d="M25.052 78.895a7.4 7.4 0 0 1-2.127 5.203l-1.827-1.821a4.84 4.84 0 0 0 1.373-3.382 4.883 4.883 0 0 0-4.893-4.875v-2.582c4.129 0 7.484 3.333 7.484 7.447z"
    />
    <g clipPath="url(#w)">
      <path
        fill="url(#x)"
        d="M156.318 27.182c-2.216 1.481-5.663-.058-8.016-3.581s-2.457-7.296-.24-8.777 5.663.06 8.016 3.582c2.354 3.522 2.457 7.295.24 8.776m-1.753-2.625c.314-.21.42-2.104-1.112-4.398s-3.323-2.92-3.637-2.71-.421 2.104 1.111 4.398 3.323 2.92 3.638 2.71"
      />
      <path
        fill="url(#y)"
        d="M150.927 21.847c-1.532-2.293-1.426-4.188-1.111-4.398l-3.22 2.151c.239 1.276.808 2.657 1.706 4 .755 1.13 1.622 2.055 2.526 2.743l1.285-3.061a8.8 8.8 0 0 1-1.186-1.435"
      />
      <path
        fill="url(#z)"
        d="m169.454 59.191-19.465 2.995a2.88 2.88 0 0 1-3.285-2.409l-4.158-27.023a2.88 2.88 0 0 1 .851-2.514l8.679-8.345a2.88 2.88 0 0 1 3.276-.504l10.786 5.35a2.88 2.88 0 0 1 1.567 2.142l4.158 27.023a2.88 2.88 0 0 1-2.409 3.285"
      />
      <path
        fill="url(#A)"
        d="m144.804 47.433 1.9 12.346a2.88 2.88 0 0 0 3.285 2.41l19.464-2.996a2.88 2.88 0 0 0 2.409-3.285l-1.899-12.346z"
      />
      <path
        fill="url(#B)"
        d="m166.138 26.74-10.786-5.35a2.88 2.88 0 0 0-3.276.504l-2.068 1.988 5.757 37.415 13.689-2.106a2.88 2.88 0 0 0 2.409-3.285l-4.158-27.024a2.88 2.88 0 0 0-1.567-2.142"
      />
      <path
        fill="url(#C)"
        d="m182.725 48.987-16.375 10.94a2.88 2.88 0 0 1-3.996-.795l-15.188-22.734a2.88 2.88 0 0 1-.292-2.638l4.339-11.231a2.88 2.88 0 0 1 2.756-1.842l12.036.291a2.88 2.88 0 0 1 2.326 1.28l15.189 22.734a2.88 2.88 0 0 1-.795 3.995"
      />
      <path
        fill="url(#D)"
        d="m155.414 48.742 6.94 10.387a2.88 2.88 0 0 0 3.995.795l16.375-10.94a2.88 2.88 0 0 0 .795-3.995l-6.94-10.387z"
      />
      <path
        fill="url(#E)"
        d="m166.005 20.98-12.036-.29a2.88 2.88 0 0 0-2.756 1.842l-1.034 2.675 21.029 31.476 11.517-7.694a2.88 2.88 0 0 0 .795-3.995L168.331 22.26a2.88 2.88 0 0 0-2.326-1.28"
      />
      <path fill="url(#F)" d="m154.904 28.13 20.009 3.98-6.583-9.852a2.88 2.88 0 0 0-2.325-1.28l-9.632-.232z" />
      <path fill="url(#G)" d="M156.666 27.708a2.61 2.61 0 1 0-3.603-3.648l.686 3.638a2.61 2.61 0 0 0 2.917.01" />
      <path fill="url(#H)" d="M156.666 27.708a2.61 2.61 0 1 0-3.603-3.648l.686 3.638a2.61 2.61 0 0 0 2.917.01" />
      <path
        fill="url(#I)"
        d="M156.319 27.187c.747-.5 1.231-1.26 1.453-2.185.438-1.814-.134-4.258-1.694-6.592l-.128-.188a13 13 0 0 0-.858-1.103l-2.659 1.776a8.7 8.7 0 0 1 1.02 1.269c.715 1.07 1.073 2.051 1.221 2.817.167.877.059 1.469-.109 1.58-.168.113-.757-.013-1.502-.504a2.61 2.61 0 0 0 .686 3.637c.937.148 1.823-.008 2.57-.507"
      />
      <path
        fill="url(#J)"
        d="M156.319 27.187c.747-.5 1.231-1.26 1.453-2.185.438-1.814-.134-4.258-1.694-6.592l-.128-.188a13 13 0 0 0-.858-1.103l-2.659 1.776a8.7 8.7 0 0 1 1.02 1.269c.715 1.07 1.073 2.051 1.221 2.817.167.877.059 1.469-.109 1.58-.168.113-.757-.013-1.502-.504a2.61 2.61 0 0 0 .686 3.637c.937.148 1.823-.008 2.57-.507"
      />
      <path
        fill="url(#K)"
        d="M154.629 24.482c.256-.417.243-2.198-1.176-4.323s-3.061-2.819-3.545-2.742l-1.765-2.644c2.218-1.391 5.609.152 7.935 3.632s2.452 7.203.317 8.72z"
      />
      <path
        fill="url(#L)"
        d="M154.725 23.311c.086.694-.014 1.153-.16 1.251-.169.113-.758-.014-1.503-.505a2.61 2.61 0 0 0 .686 3.637c.938.148 1.823-.008 2.57-.508.747-.499 1.231-1.26 1.453-2.184.249-1.032.171-2.268-.23-3.572z"
      />
      <path
        fill="url(#M)"
        d="M161.387 44.35c1.005-.673.971-2.49-.078-4.059s-2.713-2.296-3.719-1.625c-1.005.672-.971 2.489.078 4.058 1.048 1.57 2.713 2.297 3.719 1.625"
      />
      <path
        fill="url(#N)"
        d="M161.387 44.35c1.005-.673.971-2.49-.078-4.059s-2.713-2.296-3.719-1.625c-1.005.672-.971 2.489.078 4.058 1.048 1.57 2.713 2.297 3.719 1.625"
      />
      <path
        fill="url(#O)"
        d="m166.485 47.637-7.06-1.404 1.841-1.23a3.166 3.166 0 0 0 .873-4.39l-2.557-3.828 5.672 1.129z"
      />
      <path
        fill="url(#P)"
        d="m183.519 44.984-7.678-11.493-10.639-2.117 1.766 20.57 8.723 1.735 7.033-4.7a2.88 2.88 0 0 0 .795-3.995"
      />
      <path
        fill="url(#Q)"
        d="M174.352 44.601c.922-.615.831-2.37-.204-3.918s-2.62-2.304-3.542-1.689c-.921.616-.83 2.37.205 3.919s2.62 2.304 3.541 1.688"
      />
      <path
        fill="url(#R)"
        d="M174.352 44.601c.922-.615.831-2.37-.204-3.918s-2.62-2.304-3.542-1.689c-.921.616-.83 2.37.205 3.919s2.62 2.304 3.541 1.688"
      />
      <path
        fill="url(#S)"
        d="m179.105 38.38-6.512-1.295 2.313 3.46a3.515 3.515 0 0 1-.847 4.788l-1.636 1.196 10.701 2.13a2.88 2.88 0 0 0 .394-3.672z"
      />
      <path
        fill="url(#T)"
        d="M160.434 37.142a2.5 2.5 0 0 0-1.158-.397q-.6-.044-1.221.175a5.5 5.5 0 0 0-1.217.617 5.6 5.6 0 0 0-1.056.902q-.44.489-.62 1.054a2.5 2.5 0 0 0-.065 1.215q.112.649.588 1.362l1.828 2.736q.477.713 1.033 1.066t1.148.403q.591.052 1.211-.167a5.6 5.6 0 0 0 1.237-.632 5.5 5.5 0 0 0 1.037-.888q.44-.489.628-1.061.19-.572.077-1.221-.114-.649-.59-1.362l-1.828-2.736q-.477-.712-1.032-1.066m.933 5.09q.321.48.21.877-.112.395-.555.69-.945.631-1.562-.294l-1.828-2.736q-.618-.924.326-1.555.443-.296.851-.248t.73.53z"
      />
      <path
        fill="url(#U)"
        d="m159.959 40.12 1.408 2.108q.321.48.21.877-.112.396-.555.69-.945.633-1.562-.293l-1.408-2.107-1.947 1.3 1.408 2.107q.477.713 1.034 1.066.555.353 1.147.404.591.051 1.211-.168a5.6 5.6 0 0 0 1.237-.632 5.5 5.5 0 0 0 1.037-.887q.44-.489.628-1.062.19-.571.077-1.22-.114-.65-.59-1.363l-1.408-2.107z"
      />
      <path
        fill="url(#V)"
        d="m159.959 40.12 1.408 2.108q.321.48.21.877-.112.396-.555.69-.945.633-1.562-.293l-1.408-2.107-1.947 1.3 1.408 2.107q.477.713 1.034 1.066.555.353 1.147.404.591.051 1.211-.168a5.6 5.6 0 0 0 1.237-.632 5.5 5.5 0 0 0 1.037-.887q.44-.489.628-1.062.19-.571.077-1.22-.114-.65-.59-1.363l-1.408-2.107z"
      />
      <path
        fill="url(#W)"
        d="M159.277 36.748q-.6-.043-1.221.176a5.5 5.5 0 0 0-1.217.617 5.8 5.8 0 0 0-.884.722l1.677 2.51q-.617-.924.327-1.556.443-.295.85-.248.41.049.73.53l1.828 2.736q.323.482.21.877-.112.396-.555.691-.945.632-1.562-.294l1.678 2.51q.503-.206 1.004-.54a5.5 5.5 0 0 0 1.037-.887q.44-.49.629-1.061.19-.572.076-1.221-.113-.65-.59-1.363l-1.827-2.736q-.477-.713-1.033-1.065a2.5 2.5 0 0 0-1.157-.398"
      />
      <path
        fill="url(#X)"
        d="M164.036 31.58q.405-.27.957-.236.553.036.862.498.142.212.168.417l2.499 18.423a.92.92 0 0 1-.115.58 1.3 1.3 0 0 1-.431.481q-.501.335-1.008.2-.508-.135-.753-.5a1 1 0 0 1-.148-.43l-2.519-18.41a.93.93 0 0 1 .083-.586q.135-.257.405-.437"
      />
      <path
        fill="url(#Y)"
        d="M164.036 31.58q.405-.27.957-.236.553.036.862.498.142.212.168.417l2.499 18.423a.92.92 0 0 1-.115.58 1.3 1.3 0 0 1-.431.481q-.501.335-1.008.2-.508-.135-.753-.5a1 1 0 0 1-.148-.43l-2.519-18.41a.93.93 0 0 1 .083-.586q.135-.257.405-.437"
      />
      <path
        fill="url(#Z)"
        d="m165.543 47.183.524 3.831a1 1 0 0 0 .148.43q.244.367.753.501.507.135 1.009-.2.268-.18.43-.482a.9.9 0 0 0 .115-.58l-.406-2.988z"
      />
      <path
        fill="url(#aa)"
        d="M173.422 37.44a2.5 2.5 0 0 0-1.158-.398q-.6-.044-1.22.175-.621.22-1.218.617a5.6 5.6 0 0 0-1.056.902 2.9 2.9 0 0 0-.619 1.054q-.18.566-.066 1.215.112.649.588 1.362l1.828 2.736q.477.713 1.034 1.066.555.353 1.147.403.591.051 1.211-.168a5.6 5.6 0 0 0 1.237-.631 5.5 5.5 0 0 0 1.037-.888q.44-.488.629-1.061.189-.572.076-1.221t-.59-1.362l-1.828-2.736q-.476-.712-1.032-1.066m.933 5.088q.323.482.21.878-.113.395-.555.69-.945.632-1.562-.294l-1.828-2.736q-.619-.924.326-1.555.443-.296.851-.248t.73.53z"
      />
      <path
        fill="url(#ab)"
        d="m172.947 40.418 1.408 2.107q.323.48.21.877-.113.395-.555.69-.945.632-1.562-.293l-1.408-2.107-1.946 1.3 1.407 2.107q.477.713 1.034 1.066.555.353 1.147.403.591.052 1.211-.167a5.6 5.6 0 0 0 1.237-.632 5.5 5.5 0 0 0 1.037-.887q.44-.489.629-1.062.189-.571.076-1.22-.113-.65-.59-1.363l-1.408-2.107z"
      />
      <path
        fill="url(#ac)"
        d="m172.947 40.418 1.408 2.107q.323.48.21.877-.113.395-.555.69-.945.632-1.562-.293l-1.408-2.107-1.946 1.3 1.407 2.107q.477.713 1.034 1.066.555.353 1.147.403.591.052 1.211-.167a5.6 5.6 0 0 0 1.237-.632 5.5 5.5 0 0 0 1.037-.887q.44-.489.629-1.062.189-.571.076-1.22-.113-.65-.59-1.363l-1.408-2.107z"
      />
      <path
        fill="url(#ad)"
        d="M172.265 37.045q-.6-.043-1.221.175a5.5 5.5 0 0 0-1.217.618 5.7 5.7 0 0 0-.883.722l1.677 2.51q-.619-.924.326-1.556.443-.296.851-.248.408.049.73.53l1.828 2.736q.321.481.21.877t-.555.691q-.944.63-1.562-.294l1.677 2.51q.503-.206 1.005-.54a5.5 5.5 0 0 0 1.037-.887q.44-.489.628-1.062.19-.571.077-1.22-.114-.65-.59-1.363l-1.828-2.736q-.477-.712-1.032-1.065a2.5 2.5 0 0 0-1.158-.398"
      />
    </g>
    <defs>
      <linearGradient id="a" x1={28.271} x2={42.33} y1={40.751} y2={40.751} gradientUnits="userSpaceOnUse">
        <stop stopColor="#59B5C3" />
        <stop offset={1} stopColor="#1292A6" />
      </linearGradient>
      <linearGradient id="b" x1={30.109} x2={40.494} y1={53.34} y2={53.34} gradientUnits="userSpaceOnUse">
        <stop stopColor="#E2F4FF" />
        <stop offset={1} stopColor="#D7ECFF" />
      </linearGradient>
      <linearGradient id="c" x1={30.11} x2={40.494} y1={60.321} y2={60.321} gradientUnits="userSpaceOnUse">
        <stop stopColor="#E2F4FF" />
        <stop offset={1} stopColor="#D7ECFF" />
      </linearGradient>
      <linearGradient id="d" x1={30.11} x2={40.494} y1={67.305} y2={67.305} gradientUnits="userSpaceOnUse">
        <stop stopColor="#E2F4FF" />
        <stop offset={1} stopColor="#D7ECFF" />
      </linearGradient>
      <linearGradient id="e" x1={30.11} x2={40.494} y1={74.291} y2={74.291} gradientUnits="userSpaceOnUse">
        <stop stopColor="#E2F4FF" />
        <stop offset={1} stopColor="#D7ECFF" />
      </linearGradient>
      <linearGradient id="f" x1={30.11} x2={40.494} y1={81.275} y2={81.275} gradientUnits="userSpaceOnUse">
        <stop stopColor="#E2F4FF" />
        <stop offset={1} stopColor="#D7ECFF" />
      </linearGradient>
      <linearGradient id="g" x1={120.91} x2={152.76} y1={82.466} y2={82.466} gradientUnits="userSpaceOnUse">
        <stop stopColor="#59B5C3" />
        <stop offset={1} stopColor="#1292A6" />
      </linearGradient>
      <linearGradient id="h" x1={120.91} x2={152.76} y1={106.669} y2={106.669} gradientUnits="userSpaceOnUse">
        <stop stopColor="#59B5C3" />
        <stop offset={1} stopColor="#1292A6" />
      </linearGradient>
      <linearGradient id="i" x1={130.744} x2={142.937} y1={106.659} y2={106.659} gradientUnits="userSpaceOnUse">
        <stop stopColor="#374492" />
        <stop offset={1} stopColor="#014DAE" />
      </linearGradient>
      <linearGradient id="j" x1={111.59} x2={40.92} y1={107.413} y2={107.413} gradientUnits="userSpaceOnUse">
        <stop stopColor="#59B5C3" />
        <stop offset={1} stopColor="#1292A6" />
      </linearGradient>
      <linearGradient id="k" x1={56.061} x2={56.061} y1={100.836} y2={110.23} gradientUnits="userSpaceOnUse">
        <stop stopColor="#9972FF" />
        <stop offset={1} stopColor="#7F85FF" />
      </linearGradient>
      <linearGradient id="l" x1={44.652} x2={56.623} y1={109.229} y2={109.229} gradientUnits="userSpaceOnUse">
        <stop stopColor="#294698" />
        <stop offset={1} stopColor="#0E4BA6" />
      </linearGradient>
      <linearGradient id="m" x1={68.322} x2={75.932} y1={102.97} y2={102.97} gradientUnits="userSpaceOnUse">
        <stop stopColor="#294698" />
        <stop offset={1} stopColor="#0E4BA6" />
      </linearGradient>
      <linearGradient id="n" x1={68.322} x2={75.932} y1={107.416} y2={107.416} gradientUnits="userSpaceOnUse">
        <stop stopColor="#294698" />
        <stop offset={1} stopColor="#0E4BA6" />
      </linearGradient>
      <linearGradient id="o" x1={68.322} x2={75.932} y1={111.853} y2={111.853} gradientUnits="userSpaceOnUse">
        <stop stopColor="#294698" />
        <stop offset={1} stopColor="#0E4BA6" />
      </linearGradient>
      <linearGradient id="p" x1={57.279} x2={62.143} y1={58.503} y2={58.503} gradientUnits="userSpaceOnUse">
        <stop stopColor="#E2F4FF" />
        <stop offset={1} stopColor="#D7ECFF" />
      </linearGradient>
      <linearGradient id="q" x1={62.143} x2={67.006} y1={58.503} y2={58.503} gradientUnits="userSpaceOnUse">
        <stop stopColor="#294698" />
        <stop offset={1} stopColor="#0E4BA6" />
      </linearGradient>
      <linearGradient id="r" x1={80.107} x2={89.834} y1={58.503} y2={58.503} gradientUnits="userSpaceOnUse">
        <stop stopColor="#E2F4FF" />
        <stop offset={1} stopColor="#D7ECFF" />
      </linearGradient>
      <linearGradient id="s" x1={84.971} x2={89.834} y1={56.084} y2={56.084} gradientUnits="userSpaceOnUse">
        <stop stopColor="#9972FF" />
        <stop offset={1} stopColor="#7F85FF" />
      </linearGradient>
      <linearGradient id="t" x1={102.037} x2={111.764} y1={58.503} y2={58.503} gradientUnits="userSpaceOnUse">
        <stop stopColor="#8AD3FF" />
        <stop offset={1} stopColor="#5F9CFF" />
      </linearGradient>
      <linearGradient id="u" x1={102.037} x2={106.901} y1={56.084} y2={56.084} gradientUnits="userSpaceOnUse">
        <stop stopColor="#E2F4FF" />
        <stop offset={1} stopColor="#D7ECFF" />
      </linearGradient>
      <linearGradient id="v" x1={5.695} x2={29.442} y1={78.894} y2={78.894} gradientUnits="userSpaceOnUse">
        <stop stopColor="#59B5C3" />
        <stop offset={1} stopColor="#1292A6" />
      </linearGradient>
      <linearGradient id="x" x1={147.751} x2={155.004} y1={20.458} y2={21.349} gradientUnits="userSpaceOnUse">
        <stop stopColor="#F5FBFF" />
        <stop offset={1} stopColor="#DBD5EF" />
      </linearGradient>
      <linearGradient id="y" x1={148.55} x2={151.573} y1={21.105} y2={22.455} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <linearGradient id="z" x1={144.234} x2={161.86} y1={43.808} y2={40.091} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFA1AE" />
        <stop offset={1} stopColor="#FF4565" />
      </linearGradient>
      <linearGradient id="A" x1={159.089} x2={159.648} y1={56.735} y2={60.381} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="B" x1={163.577} x2={168.842} y1={39.855} y2={39.048} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="C" x1={155.629} x2={175.808} y1={41.13} y2={37.963} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFA1AE" />
        <stop offset={1} stopColor="#FF4565" />
      </linearGradient>
      <linearGradient id="D" x1={172.308} x2={174.357} y1={51.118} y2={54.186} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="E" x1={169.234} x2={173.664} y1={33.931} y2={30.972} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="F" x1={163.169} x2={153.51} y1={25.32} y2={22.401} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="G" x1={160.029} x2={151.961} y1={27.94} y2={23.912} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFA1AE" />
        <stop offset={1} stopColor="#FF4565" />
      </linearGradient>
      <linearGradient id="H" x1={159.91} x2={152.385} y1={24.144} y2={26.378} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="I" x1={147.615} x2={154.869} y1={21.572} y2={22.463} gradientUnits="userSpaceOnUse">
        <stop stopColor="#F5FBFF" />
        <stop offset={1} stopColor="#DBD5EF" />
      </linearGradient>
      <linearGradient id="J" x1={155.166} x2={157.998} y1={23.058} y2={25.492} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <linearGradient id="K" x1={152.398} x2={156.254} y1={20.863} y2={18.287} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <linearGradient id="L" x1={156.134} x2={152.832} y1={24.666} y2={26.852} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <linearGradient id="M" x1={160.621} x2={157.856} y1={40.751} y2={42.598} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="N" x1={159.01} x2={157.976} y1={40.791} y2={39.244} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="O" x1={166.387} x2={159.031} y1={41.962} y2={42.508} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="P" x1={172.923} x2={165.766} y1={42.183} y2={43.175} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="Q" x1={173.996} x2={171.333} y1={40.785} y2={42.564} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="R" x1={171.966} x2={170.984} y1={41.029} y2={39.56} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="S" x1={180.173} x2={173.345} y1={42.975} y2={42.669} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE0364" stopOpacity={0} />
        <stop offset={0.234} stopColor="#F90362" stopOpacity={0.234} />
        <stop offset={0.517} stopColor="#EA035B" stopOpacity={0.517} />
        <stop offset={0.824} stopColor="#D20250" stopOpacity={0.824} />
        <stop offset={1} stopColor="#C00148" />
      </linearGradient>
      <linearGradient id="T" x1={155.55} x2={162.313} y1={41.912} y2={41.225} gradientUnits="userSpaceOnUse">
        <stop stopColor="#F5FBFF" />
        <stop offset={1} stopColor="#DBD5EF" />
      </linearGradient>
      <linearGradient id="U" x1={160.153} x2={162.209} y1={42.497} y2={45.574} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <linearGradient id="V" x1={161.11} x2={163.605} y1={42.782} y2={43.948} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <linearGradient id="W" x1={160.14} x2={162.367} y1={41.077} y2={39.588} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <linearGradient id="X" x1={165.166} x2={166.503} y1={41.759} y2={41.61} gradientUnits="userSpaceOnUse">
        <stop stopColor="#F5FBFF" />
        <stop offset={1} stopColor="#DBD5EF" />
      </linearGradient>
      <linearGradient id="Y" x1={164.796} x2={167.188} y1={41.828} y2={41.507} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <linearGradient id="Z" x1={166.786} x2={167.829} y1={48.348} y2={51.881} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <linearGradient id="aa" x1={168.539} x2={175.301} y1={42.209} y2={41.521} gradientUnits="userSpaceOnUse">
        <stop stopColor="#F5FBFF" />
        <stop offset={1} stopColor="#DBD5EF" />
      </linearGradient>
      <linearGradient id="ab" x1={173.142} x2={175.198} y1={42.794} y2={45.871} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <linearGradient id="ac" x1={174.098} x2={176.593} y1={43.079} y2={44.245} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <linearGradient id="ad" x1={173.128} x2={175.356} y1={41.373} y2={39.885} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBD5EF" stopOpacity={0} />
        <stop offset={0.285} stopColor="#D9D2EE" stopOpacity={0.285} />
        <stop offset={0.474} stopColor="#D4C9E9" stopOpacity={0.474} />
        <stop offset={0.635} stopColor="#CBBAE2" stopOpacity={0.635} />
        <stop offset={0.779} stopColor="#BFA5D7" stopOpacity={0.78} />
        <stop offset={0.913} stopColor="#AF8ACA" stopOpacity={0.913} />
        <stop offset={1} stopColor="#A274BF" />
      </linearGradient>
      <clipPath id="w">
        <path fill="#fff" d="m122 32.242 40.78-27.245 27.245 40.78-40.78 27.245z" />
      </clipPath>
    </defs>
  </svg>
);
export const FalLicenseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      fill="#19D3C5"
      d="M15.03 3.836 3.832 14.996l11.198 11.22 11.137-11.22zm0 20.04-8.863-8.88 8.863-8.88 8.802 8.88z"
    />
    <path
      fill="#02858E"
      d="m21.557 10.376-3.473 3.48 1.137 1.14 2.336-2.34 2.335 2.34-2.335 2.34-2.336-2.34-1.137 1.14 3.473 3.48 4.61-4.62zm-11.198-1.92 3.473 3.48 1.138-1.14-2.336-2.34 2.336-2.34 2.335 2.34-2.335 2.34 1.138 1.14 3.473-3.48-4.611-4.62zm-1.916 11.16 3.473-3.48-1.138-1.14-2.335 2.34-2.336-2.34 2.336-2.34 2.335 2.34 1.138-1.14-3.473-3.48-4.611 4.62zm11.197 1.92-3.473-3.48-1.137 1.14 2.335 2.34-2.335 2.34-2.336-2.34 2.336-2.34-1.138-1.14-3.473 3.48 4.61 4.62z"
    />
    <path fill="#19D3C5" d="m16.948 14.998-1.917-1.92-1.916 1.92 1.916 1.92z" />
    <path
      fill="#025459"
      d="M27.665 14.16H30L15.808 0v2.34zm-11.857 13.5V30L29.94 15.84h-2.335zm-1.616 0L2.335 15.84H0L14.192 30zm0-25.32V0L.06 14.16h2.335z"
    />
  </svg>
);
export const ContractIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 31 30"
    fill="none"
    {...props}
  >
    <g clipPath="url(#ContractIcon)">
      <path
        fill="#005257"
        d="m29.874 15.331-4.112-8.248a1.365 1.365 0 0 0-1.832-.61l-1.396.697a1.36 1.36 0 0 0-.661 1.705c-1.032.513-2.257.688-3.268.45-1.584-.375-2.884-.51-4.477.355l-1.288.7-3.672-1.312.17-.308c.358-.66.111-1.49-.55-1.85l-1.372-.744a1.365 1.365 0 0 0-1.85.546l-4.399 8.097a1.36 1.36 0 0 0 .547 1.85l1.372.745a1.36 1.36 0 0 0 1.85-.546l.036-.067.88.486a1.353 1.353 0 0 0 1.53 1.297 1.363 1.363 0 0 0 1.518 1.52c-.045.402.078.825.39 1.132.28.28.669.44 1.13.386-.054.459.103.848.387 1.135a1.38 1.38 0 0 0 1.946 0l.045-.045.353.368a1.466 1.466 0 0 0 2.181-.07l.073-.084c.193-.227.304-.495.338-.767l.337.323c.67.607 1.717.477 2.224-.262.238-.347.305-.764.22-1.153h.045a1.488 1.488 0 0 0 .975-2.416c.09-.021.12-.042 6.07-2.236l.42.842a1.37 1.37 0 0 0 1.83.612l1.397-.7a1.36 1.36 0 0 0 .613-1.828M6.676 17.76a.77.77 0 0 1 0-1.093l.429-.428a.77.77 0 0 1 1.092 0 .776.776 0 0 1 0 1.095l-.428.426a.79.79 0 0 1-1.093 0m1.518 1.52a.78.78 0 0 1 0-1.092l.971-.971a.772.772 0 1 1 1.092 1.092l-.968.971a.776.776 0 0 1-1.095 0m1.52 1.52a.776.776 0 0 1 0-1.094l1.446-1.446a.776.776 0 0 1 1.095 0 .777.777 0 0 1 0 1.092l-1.448 1.449a.78.78 0 0 1-1.093 0m2.613 1.518a.772.772 0 1 1-1.092-1.092l1.596-1.596a.772.772 0 1 1 1.092 1.092zm2.619.208-.072.085a.866.866 0 0 1-1.289.042l-.362-.377c1.198-1.213 1.104-1.08 1.261-1.291l.374.332a.865.865 0 0 1 .088 1.21m4.866-4.703a.87.87 0 0 1-1.155.063l-.006-.003-.006-.006-.01-.006-.002-.003q-.01-.009-.012-.009l-2.96-2.284a.302.302 0 1 0-.368.48c.03.021 3.27 2.534 3.65 2.83.362.287.44.811.178 1.195-.24.356-.615.522-1.116.126l-3.852-3.17c-.133-.11-.326-.07-.42.033v.006c-.009.03-.187.244.036.428l3.86 3.171a.89.89 0 0 1 .177 1.195.885.885 0 0 1-1.315.163 40 40 0 0 1-.414-.39v-.003q-.001-.004-.003-.003L14.732 20.4a1.368 1.368 0 0 0-1.653-1.563 1.38 1.38 0 0 0-.399-1.004 1.37 1.37 0 0 0-1.608-.238 1.37 1.37 0 0 0-.389-.803 1.364 1.364 0 0 0-1.677-.205 1.37 1.37 0 0 0-.384-.772 1.377 1.377 0 0 0-1.946 0l-.428.428c-.12.12-.211.263-.277.41l-.685-.377C7.874 11.47 8.63 10.06 8.825 9.707c0-.003.006-.009.015-.027v-.003a.1.1 0 0 0 .012-.02q.005-.015.015-.028v-.003q.004-.003.003-.006a.02.02 0 0 0 .006-.012q.004-.002.003-.003l3.25 1.161-.695.38a1.477 1.477 0 0 0 1.2 2.688l2.78-.989c1.668 1.421 3.164 2.694 4.347 3.705a.865.865 0 0 1 .051 1.273m.794-.214a1.44 1.44 0 0 0-.453-1.518l-4.48-3.82-.006-.002a.32.32 0 0 0-.293-.052l-2.941 1.05a.876.876 0 0 1-1.101-.491.87.87 0 0 1 .392-1.098l2.694-1.47c1.433-.778 2.613-.636 4.049-.298 1.155.274 2.5.093 3.662-.483l3.144 6.46zm5.014-6.583a.299.299 0 0 1-.404-.136L24.172 8.8l-.196.096a.305.305 0 0 1-.405-.136.303.303 0 0 1 .136-.404l.465-.232a.3.3 0 0 1 .229-.016.3.3 0 0 1 .175.151l1.18 2.362a.304.304 0 0 1-.136.405"
        opacity={0.99}
      />
    </g>
  </svg>
);
export const AdLicenseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 31 30"
    fill="none"
    {...props}
  >
    <g clipPath="url(#AdLicenseIcon)">
      <path
        fill="#005257"
        d="m27.854 4.871-4.22 23.532c-.187.843-.937 1.312-1.687 1.218l-17.25-3.093c-.843-.188-1.312-.938-1.218-1.688L7.79 1.215C7.98.37 8.73-.098 9.48-.004L26.635 3.09c.844.187 1.312.937 1.219 1.781"
      />
      <path
        fill="#F2FAFA"
        stroke="#5ECCC8"
        d="M24.635 4.594V28.5c0 .568-.433 1-1 1H6.197c-.567 0-1-.432-1-1V4.594c0-.568.433-1 1-1h17.438c.567 0 1 .432 1 1Z"
      />
      <path
        fill="#02858E"
        d="M7.604 6.094h14.53v1.312H7.605zm0 3.281h14.53v1.313H7.605zm0 3.281h14.53v1.313H7.605zm9.281 3.188h5.343v1.312h-5.343zm0 3.281h5.343v1.313h-5.343zm0 3.281h5.343v1.313h-5.343zm-9.281 3.282h14.53V27H7.605z"
      />
      <path fill="#00A488" d="m10.322 22.969 1.969 5.25 1.031-1.313 1.688.282-1.594-4.22z" />
      <path fill="#00A488" d="m8.541 22.969-1.594 4.218 1.782-.28 1.03 1.312 1.876-5.25z" />
      <path fill="#00A488" d="M10.979 24.469a4.313 4.313 0 1 0 0-8.625 4.313 4.313 0 0 0 0 8.625" />
    </g>
  </svg>
);
export const LicenseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 70 70"
    fill="none"
    {...props}
  >
    <g clipPath="url(#aLicenseIcon)">
      <path
        fill="url(#bLicenseIcon)"
        d="M52.5 46.667C52.5 40.22 47.28 35 40.835 35s-11.667 5.22-11.667 11.667c0 4.316 2.363 8.079 5.834 10.091V70l5.833-5.833L46.667 70V56.758c3.471-2.012 5.834-5.804 5.834-10.091M40.835 52.5c-3.208 0-5.833-2.625-5.833-5.833s2.625-5.834 5.833-5.834 5.833 2.625 5.833 5.834-2.625 5.833-5.833 5.833M42.03 0H14.584c-4.813 0-8.75 3.938-8.75 8.75V70h23.333v-5.833h-17.5V8.75a2.925 2.925 0 0 1 2.917-2.917h23.333V26.25h20.417v37.917h-5.833V70h11.666V22.138zm1.72 9.946 10.471 10.47h-10.47z"
      />
    </g>
    <defs>
      <linearGradient id="bLicenseIcon" x1={74.312} x2={-12.324} y1={87.923} y2={2.555} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <clipPath id="aLicenseIcon">
        <path fill="#fff" d="M0 0h70v70H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const IDCardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 70 70"
    fill="none"
    {...props}
  >
    <rect width={64} height={47} x={3} y={12} stroke="url(#aIDCardIcon)" strokeWidth={4} rx={6} />
    <path
      fill="url(#bIDCardIcon)"
      stroke="url(#cIDCardIcon)"
      strokeWidth={1.333}
      d="M21.876 34.33c-3.652 0-6.625-2.973-6.625-6.624s2.973-6.625 6.624-6.625 6.625 2.974 6.625 6.625-2.973 6.625-6.625 6.625Zm0-10.208a3.59 3.59 0 0 0-3.584 3.584 3.59 3.59 0 0 0 3.583 3.583 3.59 3.59 0 0 0 3.584-3.583 3.59 3.59 0 0 0-3.584-3.584Z"
    />
    <path
      fill="url(#dIDCardIcon)"
      stroke="url(#eIDCardIcon)"
      strokeWidth={1.333}
      d="M32.813 48.914a1.52 1.52 0 0 1-1.521-1.52v-1.459a4.32 4.32 0 0 0-4.313-4.313H16.771a4.32 4.32 0 0 0-4.313 4.313v1.459a1.522 1.522 0 0 1-3.041 0v-1.459a7.36 7.36 0 0 1 7.354-7.354h10.208a7.36 7.36 0 0 1 7.354 7.354v1.459a1.52 1.52 0 0 1-1.52 1.52Z"
    />
    <path
      fill="url(#fIDCardIcon)"
      stroke="url(#gIDCardIcon)"
      strokeWidth={1.333}
      d="M59.063 25.583H43.022a1.522 1.522 0 0 1 0-3.041h16.041a1.522 1.522 0 0 1 0 3.041Z"
    />
    <path
      fill="url(#hIDCardIcon)"
      stroke="url(#iIDCardIcon)"
      strokeWidth={1.333}
      d="M59.063 37.247H43.022a1.522 1.522 0 0 1 0-3.041h16.041a1.522 1.522 0 0 1 0 3.041Z"
    />
    <path
      fill="url(#jIDCardIcon)"
      stroke="url(#kIDCardIcon)"
      strokeWidth={1.333}
      d="M59.063 48.92H43.022a1.522 1.522 0 0 1 0-3.042h16.041a1.522 1.522 0 0 1 0 3.041Z"
    />
    <defs>
      <linearGradient id="aIDCardIcon" x1={80.826} x2={23.72} y1={74.058} y2={-15.975} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="bIDCardIcon" x1={31.703} x2={13.902} y1={38.731} y2={17.684} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="cIDCardIcon" x1={31.703} x2={13.902} y1={38.731} y2={17.684} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="dIDCardIcon" x1={39.565} x2={30.053} y1={52.568} y2={27.261} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="eIDCardIcon" x1={39.565} x2={30.053} y1={52.568} y2={27.261} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="fIDCardIcon" x1={64.801} x2={62.901} y1={27.37} y2={16.884} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="gIDCardIcon" x1={64.801} x2={62.901} y1={27.37} y2={16.884} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="hIDCardIcon" x1={64.801} x2={62.901} y1={39.034} y2={28.548} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="iIDCardIcon" x1={64.801} x2={62.901} y1={39.034} y2={28.548} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="jIDCardIcon" x1={64.801} x2={62.901} y1={50.706} y2={40.22} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="kIDCardIcon" x1={64.801} x2={62.901} y1={50.706} y2={40.22} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
    </defs>
  </svg>
);
export const BuildingIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 70 70"
    fill="none"
    {...props}
  >
    <g clipPath="url(#aBuildingIcon)">
      <path
        fill="url(#bBuildingIcon)"
        d="M62.968 65.897v-50.3H52.36V0L17.64 9.735v13.942H7.033v42.22H2.725V70h64.551v-4.103zm-51.833 0V27.78h17.23v38.118zm21.333 0v-42.22H21.742V12.846L48.258 5.41 48.2 65.898zm19.893 0V19.7h6.504v46.198z"
      />
      <path fill="url(#cBuildingIcon)" d="M17.699 34.259H21.8v8.251h-4.1z" />
      <path fill="url(#dBuildingIcon)" d="M17.699 49.329H21.8v8.252h-4.1z" />
      <path fill="url(#eBuildingIcon)" d="M37.533 34.259h4.103v8.251h-4.103z" />
      <path fill="url(#fBuildingIcon)" d="M37.533 19.188h4.103v8.252h-4.103z" />
      <path fill="url(#gBuildingIcon)" d="M37.533 49.329h4.103v8.252h-4.103z" />
    </g>
    <defs>
      <linearGradient id="bBuildingIcon" x1={78.502} x2={-7.819} y1={87.923} y2={-6.202} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="cBuildingIcon" x1={78.502} x2={-7.819} y1={87.923} y2={-6.202} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="dBuildingIcon" x1={78.502} x2={-7.819} y1={87.923} y2={-6.202} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="eBuildingIcon" x1={78.502} x2={-7.819} y1={87.923} y2={-6.202} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="fBuildingIcon" x1={78.502} x2={-7.819} y1={87.923} y2={-6.202} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <linearGradient id="gBuildingIcon" x1={78.502} x2={-7.819} y1={87.923} y2={-6.202} gradientUnits="userSpaceOnUse">
        <stop stopColor="#7ECCA5" />
        <stop offset={1} stopColor="#005960" />
      </linearGradient>
      <clipPath id="aBuildingIcon">
        <path fill="#fff" d="M0 0h70v70H0z" />
      </clipPath>
    </defs>
  </svg>
);

//listing-icons:

export const ResortIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 15 15"
    fill="none"
    {...props}
  >
    <g fill={props.color || 'currentColor'} clipPath="url(#ResortIcon)">
      <path d="M14.707 14.384h-.24c-.02-1.714-.213-3.349-.575-4.864a17 17 0 0 0-1.283-3.597c-.178-.36-.37-.71-.571-1.04a1.06 1.06 0 0 0-.083-.87h2.752a.293.293 0 0 0 .244-.455c-.541-.819-1.567-1.348-2.614-1.348a3 3 0 0 0-.43.031L13.573.575a.293.293 0 0 0-.148-.494c-.962-.196-2.062.155-2.802.896a3.29 3.29 0 0 0-.656.953A3.3 3.3 0 0 0 9.31.977C8.57.237 7.47-.115 6.509.08a.293.293 0 0 0-.149.494L8.026 2.24a3 3 0 0 0-.43-.03c-1.046 0-2.072.53-2.614 1.348a.293.293 0 0 0 .245.455h3.242a1.066 1.066 0 0 0 .952 1.553c.252 0 .483-.088.666-.234 1 1.437 2.438 4.318 2.496 9.052H10.36V13.27a.293.293 0 0 0-.585 0v1.113H5.322v-2.432c0-.872-.71-1.582-1.582-1.582s-1.582.71-1.582 1.582v2.432h-.703V9.52h8.32v1.113a.293.293 0 0 0 .586 0V9.52h.537a.293.293 0 0 0 .253-.442C9.94 7.026 7.937 5.59 5.652 5.144a.3.3 0 0 0-.113 0C3.254 5.59 1.25 7.026.041 9.079a.293.293 0 0 0 .252.442h.576v4.863H.293a.293.293 0 0 0 0 .586h14.414a.293.293 0 0 0 0-.586m-4.341-5.45H7.537c-.18-.883-.507-2.11-1.044-2.961a7.7 7.7 0 0 1 3.873 2.962m-4.77-3.14c.529.46 1.016 1.598 1.343 3.14H4.252c.327-1.542.815-2.68 1.344-3.14m-.898.179c-.536.85-.864 2.078-1.044 2.962H.826a7.7 7.7 0 0 1 3.872-2.962m-1.954 8.41v-2.43a.997.997 0 0 1 1.992 0v2.43zM9.381 3.28a.484.484 0 1 1 .968 0 .484.484 0 0 1-.968 0m1.16 1.26a.484.484 0 1 1 .969.001.484.484 0 0 1-.968 0m1.796-1.744c.626 0 1.258.24 1.718.63h-3.131a1 1 0 0 0 .008-.21l.043-.042c.41-.242.895-.378 1.362-.378m-1.3-1.405a2.72 2.72 0 0 1 1.66-.769l-1.994 1.995a1.1 1.1 0 0 0-.283-.25c.136-.368.35-.708.617-.976m-2.14 0c.246.247.448.556.584.891q-.204.08-.357.228L7.236.622c.6.05 1.218.326 1.66.769m-1.3 1.405c.413 0 .837.105 1.215.297a1 1 0 0 0-.006.334H5.879c.46-.39 1.092-.63 1.718-.63M9.42 4.98a.484.484 0 0 1-.257-.893c.188.163.433.262.7.262h.018a.484.484 0 0 1-.46.63m3.748 9.404c-.027-2.295-.38-4.41-1.048-6.288a14 14 0 0 0-1.16-2.489q.03.002.064.002c.239 0 .46-.078.637-.21q.221.38.422.784a16.36 16.36 0 0 1 1.238 3.473c.351 1.47.539 3.06.558 4.728z" />
      <path d="M10.068 11.66a.295.295 0 0 0-.293.293.296.296 0 0 0 .293.293.295.295 0 0 0 .293-.293.294.294 0 0 0-.293-.293" />
    </g>
  </svg>
);
export const GuestHouseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 15 15"
    fill="none"
    {...props}
  >
    <g
      fill={props.color || 'currentColor'}
      stroke={props.color || 'currentColor'}
      strokeWidth={0.15}
      clipPath="url(#GuestHouseIcon)"
    >
      <path d="M14.545 7.679h-2.206V3.915l.823.55a.227.227 0 1 0 .252-.377L7.703.265a.23.23 0 0 0-.253 0L1.74 4.088a.227.227 0 1 0 .253.377l.67-.448v3.662H.453a.227.227 0 0 0 0 .454h.826v6.412c0 .125.101.227.227.227h11.985a.227.227 0 0 0 .227-.227V8.133h.826a.227.227 0 0 0 0-.454ZM3.115 3.713 7.578.727l4.307 2.883v4.07H3.116zM8.87 14.318H6.13v-3.934h2.74zm4.396-5.514h-3.102a.227.227 0 0 0 0 .455h3.101v5.059h-3.94v-4.161a.227.227 0 0 0-.228-.227H5.902a.227.227 0 0 0-.227.227v4.16h-3.94V9.26h3.137a.227.227 0 0 0 0-.455H1.734v-.67h11.53z" />
      <path d="M9.79 6.136h-.168V4.318h.168a.227.227 0 0 0 0-.455H5.364a.227.227 0 0 0 0 .455h.168v1.818h-.168a.227.227 0 0 0 0 .454H9.79a.227.227 0 0 0 0-.454Zm-.623 0H7.804V4.318h1.363zm-3.18-1.818h1.362v1.818H5.986zm.795-1.43h.227a.227.227 0 0 0 0-.454h-.227a.227.227 0 0 0 0 .454Zm1.363 0h.228a.227.227 0 0 0 0-.454h-.228a.227.227 0 0 0 0 .454ZM6.893 12.58h.228a.227.227 0 0 0 0-.455h-.228a.227.227 0 0 0 0 .454Z" />
    </g>
  </svg>
);

export const ChaletIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 15 15"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || 'currentColor'}
      d="M3.717 7.931h3.218V4.793H3.717zm.88-2.258h1.458v1.379H4.597zm4.575 5.524h3.218V8.06H9.172zm.88-2.258h1.458v1.378h-1.458z"
    />
    <path
      fill={props.color || 'currentColor'}
      d="M15 5.691h-4.472L9.107 4.493V2.316h-.88v1.435L5.325 1.305 0 5.795l.567.673.295-.249v7.475H14.15V6.57H15zM4.634 12.814v-2.327h1.383v2.326zm8.635 0H6.897V9.607H3.754v3.207H1.742V5.477l3.583-3.021 4.882 4.115h3.062z"
    />
  </svg>
);
export const VillaIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || 'currentColor'}
      d="M10.293 14.899c.157-.091.315-.176.47-.273.842-.527 1.707-.794 2.57-.794H14.4v-1.066h-1.066c-1.067 0-2.122.32-3.136.955-.75.469-1.517.856-2.296 1.178zM5.867 9.035h1.6v1.6h-1.6zm0-2.668h1.6v1.6h-1.6zm2.666 0h1.6v1.6h-1.6zM7.467 4.234h1.066v1.067H7.467z"
    />
    <path
      fill={props.color || 'currentColor'}
      d="M14.2 10.6q-.607 0-1.2.088V4.742l1.2.6V4l-6-3-6 3v1.342l1.2-.6v6.154A10.2 10.2 0 0 0 1 10.6v1.2c1.92 0 3.744.607 5.268 1.718A12.9 12.9 0 0 1 2.2 14.2H1v1.2h1.202c2.717-.006 5.352-.793 7.834-2.342 1.335-.835 2.736-1.258 4.164-1.258h1.2v-1.2zm-9.6.668V4.142l3.6-1.8 3.6 1.8v6.81q-.612.179-1.2.445V8.8H8.8v3.589c-.405.228-.813.439-1.227.625A10.2 10.2 0 0 0 4.6 11.268"
    />
  </svg>
);
export const ApartmentIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 15 15"
    fill="none"
    {...props}
  >
    <g fill={props.color || 'currentColor'} clipPath="url(#ApartmentIcon)">
      <path d="M3.213 3.004h.879v1.25h-.88zm2.187 0h.88v1.25H5.4zm-2.187 2.5h.879v1.25h-.88zm2.187 0h.88v1.25H5.4zm-2.187 2.5h.879v1.25h-.88zm2.187 0h.88v1.25H5.4zm-2.187 2.5h.879v1.25h-.88zm2.187 0h.88v1.25H5.4zm4.2-5h.879v1.25h-.88zm0 2.5h.879v1.25h-.88z" />
      <path d="M12.503 13.342a1.921 1.921 0 0 0 1.48-1.867c0-.908-.635-1.67-1.483-1.869V2.993H8.471V1.251h-.713V0h-6.02v1.25h-.713V15l12.94-.005v-.879h-1.462zM2.618.88h4.261v1.25h.713v11.987H1.904V2.13h.714zM8.47 3.872h3.15v5.736a1.92 1.92 0 0 0-1.477 1.867c0 .906.631 1.666 1.477 1.867v.774H8.47zm4.632 7.603a1.041 1.041 0 0 1-2.08 0 1.041 1.041 0 0 1 2.08 0" />
    </g>
  </svg>
);
export const IconRental = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || 'currentColor'}
      d="M10.198 6.438H4.6a.6.6 0 0 0-.6.6v9.594a.6.6 0 0 0 .6.6h1.5V14.17c0-.2.16-.36.36-.36h1.877c.199 0 .36.16.36.36v3.06h2.1V7.037a.6.6 0 0 0-.599-.6m-3.727 4.05h-.962a.3.3 0 0 1 0-.599h.962a.3.3 0 0 1 0 .6m0-1.9h-.962a.3.3 0 1 1 0-.6h.962a.3.3 0 0 1 0 .6m2.818 1.9h-.962a.3.3 0 0 1 0-.599h.962a.3.3 0 0 1 0 .6m0-1.9h-.962a.3.3 0 1 1 0-.6h.962a.3.3 0 0 1 0 .6"
    />
    <path
      fill={props.color || 'currentColor'}
      d="M13.577 9.945H10.66v7.294h2.917a.6.6 0 0 0 .6-.6v-6.094a.6.6 0 0 0-.6-.6"
    />
    <path
      fill={props.color || 'currentColor'}
      fillRule="evenodd"
      d="M13.219 5.518c.236.174.804.696 1.029 1.826.082.411.616.266.534-.154-.24-1.198-.83-1.846-1.176-2.135.251-.212.843-.6 1.81-.57.375.008.396-.552.014-.566-1.068-.033-1.78.38-2.137.66a3.05 3.05 0 0 0-1.334-1.542c-.304-.174-.55.32-.246.493.734.422 1.02 1.014 1.126 1.326a3.36 3.36 0 0 0-2.05.43c-.31.175-.02.596.292.427.651-.368 1.23-.404 1.586-.375-.969 1.725-1.086 4.907-1.092 5.154a.275.275 0 0 0 .548.023c0-.14.12-3.475 1.096-4.997"
      clipRule="evenodd"
    />
  </svg>
);

export const IconNavigate = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g clipPath="url(#aIconNavigate)">
      <g mask="url(#bIconNavigate)">
        <g mask="url(#cIconNavigate)">
          <path
            fill={props.color || 'currentColor'}
            d="M12.223 5.621a.51.51 0 0 0-.508.508v6.043c0 .28-.228.508-.508.508h-.948a10 10 0 0 1-.402.494q-.248.284-.48.521h1.83c.84 0 1.523-.683 1.523-1.523V6.129a.51.51 0 0 0-.507-.508m-7.08 7.553a10 10 0 0 1-.402-.494h-.948a.51.51 0 0 1-.508-.508V6.129a.508.508 0 1 0-1.015 0v6.043c0 .84.683 1.523 1.523 1.523h1.83a12 12 0 0 1-.48-.521"
          />
          <path
            stroke="#767676"
            strokeLinecap="square"
            strokeMiterlimit={10}
            strokeWidth={1.016}
            d="M13.29 6.992 7.5 1.965 1.71 6.992"
          />
          <path fill="#767676" d="M6.738 9.602a.762.762 0 1 1 1.524 0 .762.762 0 0 1-1.524 0" />
          <path
            stroke="#767676"
            strokeMiterlimit={10}
            strokeWidth={1.016}
            d="M9.91 9.76c0 1.64-2.41 3.603-2.41 3.603S5.087 11.4 5.087 9.76v-.152a2.412 2.412 0 1 1 4.823 0z"
          />
        </g>
      </g>
    </g>
  </svg>
);
export const DebitCardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#3555A2"
      d="m22.45 15.846-16.506 2.91a1.875 1.875 0 0 1-2.173-1.52L1.955 6.932a1.875 1.875 0 0 1 1.52-2.172l16.507-2.91a1.875 1.875 0 0 1 2.172 1.52l1.817 10.304a1.875 1.875 0 0 1-1.521 2.172"
    />
    <path
      fill="#1B3555"
      d="m19.982 1.85-8.253 1.454 2.468 13.997 8.253-1.455a1.875 1.875 0 0 0 1.52-2.172L22.154 3.37a1.875 1.875 0 0 0-2.172-1.52"
    />
    <path
      fill="#53D8E3"
      d="M18.281 22.174H1.875A1.875 1.875 0 0 1 0 20.3V10.094c0-1.036.84-1.875 1.875-1.875h16.406c1.036 0 1.875.84 1.875 1.875v10.205c0 1.036-.84 1.875-1.875 1.875"
    />
    <path
      fill="#18A8C9"
      d="M18.281 8.219h-8.203v13.955h8.203c1.036 0 1.875-.84 1.875-1.875V10.094c0-1.036-.84-1.875-1.875-1.875"
    />
    <path fill="#ECF6FD" d="M0 11.414h20.156v3.19H0z" />
    <path fill="#EAF6FF" d="M5.582 19.078h-3.19a.703.703 0 0 0 0 1.406h3.19a.703.703 0 0 0 0-1.406" />
    <path fill="#D6E8FE" d="M10.078 11.414h10.078v3.19H10.078z" />
  </svg>
);
export const GooglePayIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.height || 'auto'}
    viewBox="0 0 52 24"
    fill="none"
    {...props}
  >
    <rect width={49.624} height={22.444} x={1.579} y={0.778} stroke="#C1BFBF" strokeWidth={1.556} rx={11.222} />
    <path
      fill="#4285F4"
      d="M20.453 11.61q0-.54-.09-1.07h-4.965v2.027h2.843a2.44 2.44 0 0 1-1.05 1.6v1.315h1.696c.994-.916 1.566-2.27 1.566-3.872"
    />
    <path
      fill="#34A853"
      d="M15.399 16.754c1.42 0 2.616-.466 3.488-1.27l-1.697-1.316c-.472.32-1.08.503-1.791.503-1.373 0-2.539-.926-2.955-2.173h-1.749v1.356a5.26 5.26 0 0 0 4.704 2.9"
    />
    <path fill="#FBBC04" d="M12.443 12.497a3.15 3.15 0 0 1 0-2.015V9.126h-1.748a5.26 5.26 0 0 0 0 4.728z" />
    <path
      fill="#EA4335"
      d="M15.399 8.31a2.86 2.86 0 0 1 2.019.79l1.502-1.502a5.06 5.06 0 0 0-3.52-1.371 5.26 5.26 0 0 0-4.704 2.9l1.749 1.356c.416-1.247 1.582-2.172 2.955-2.172"
    />
    <path
      fill="#000"
      d="M23.453 6.239v9.101h1.456v-3.136h1.951a2.873 2.873 0 0 0 3.034-2.987 2.857 2.857 0 0 0-2.987-2.987zm1.456 1.186h1.587a1.69 1.69 0 0 1 1.923 1.792 1.71 1.71 0 0 1-1.932 1.81h-1.578zm7.524 7.915a2.33 2.33 0 0 0 2.072-1.157v1.157h1.307v-4.546c0-1.316-1.045-2.156-2.66-2.156s-2.576.859-2.642 2.035h1.27a1.24 1.24 0 0 1 1.335-.933c.858 0 1.344.41 1.344 1.148v.495l-1.765.112c-1.633.093-2.52.765-2.52 1.932a1.997 1.997 0 0 0 2.26 1.913m.374-1.073c-.747 0-1.223-.364-1.223-.933s.457-.934 1.335-.934l1.568-.103v.514a1.53 1.53 0 0 1-1.68 1.493zm4.779 3.473c1.372 0 2.016-.523 2.586-2.11l2.473-6.908h-1.428l-1.661 5.368-1.662-5.368h-1.503l2.39 6.618-.13.402a1.13 1.13 0 0 1-1.186.933h-.42v1.092q.27.02.541.01z"
    />
  </svg>
);
export const ApplePayIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.height || 'auto'}
    viewBox="0 0 49 25"
    fill="none"
    {...props}
  >
    <rect width={46.072} height={22.709} x={1.363} y={0.764} stroke="#C1BFBF" strokeWidth={1.527} rx={11.354} />
    <path
      fill="#000"
      d="M15.108 7.658a1.83 1.83 0 0 1-1.439.678 2.08 2.08 0 0 1 .513-1.493c.365-.42.877-.683 1.43-.734a2.13 2.13 0 0 1-.504 1.55m.504.788c-.797-.046-1.475.45-1.833.45s-.916-.422-1.594-.413a2.37 2.37 0 0 0-2.016 1.21c-.853 1.475-.22 3.665.614 4.866.403.586.916 1.246 1.53 1.218.614-.027.843-.394 1.576-.394s.917.394 1.586.385c.668-.009 1.08-.595 1.493-1.191.285-.421.507-.88.66-1.366a2.14 2.14 0 0 1-1.292-1.96 2.2 2.2 0 0 1 1.045-1.833 2.3 2.3 0 0 0-1.769-.963m4.582-1.658v8.935h1.43v-3.08h1.915a2.824 2.824 0 0 0 2.978-2.932 2.804 2.804 0 0 0-2.932-2.932zm1.43 1.164h1.558a1.66 1.66 0 0 1 1.887 1.759 1.677 1.677 0 0 1-1.897 1.778h-1.548zm7.386 7.77a2.29 2.29 0 0 0 2.034-1.136v1.137h1.283V11.27c0-1.292-1.026-2.117-2.612-2.117-1.585 0-2.529.843-2.593 1.998h1.246a1.22 1.22 0 0 1 1.31-.917c.844 0 1.32.403 1.32 1.127v.486l-1.732.11c-1.603.092-2.474.752-2.474 1.897a1.96 1.96 0 0 0 2.218 1.879m.366-1.053c-.733 0-1.2-.358-1.2-.917s.449-.916 1.31-.916l1.54-.1v.503a1.503 1.503 0 0 1-1.65 1.466zm4.692 3.409c1.348 0 1.98-.513 2.539-2.071l2.428-6.782h-1.402l-1.631 5.27-1.631-5.27h-1.476l2.346 6.498-.128.394a1.11 1.11 0 0 1-1.164.916h-.412v1.072q.266.02.531.01z"
    />
  </svg>
);

export const VerificationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 29 29"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M19.032 22.65a.45.45 0 0 1-.25-.075L15.34 20.28c-1.487-.99-2.652-3.168-2.652-4.955V8.814c0-.195.125-.368.31-.43l5.89-1.963a.46.46 0 0 1 .286 0L23.79 7.96a.453.453 0 1 1-.286.86L19.03 7.33l-5.437 1.812v6.184c0 1.465 1.03 3.39 2.248 4.202l3.19 2.126 3.188-2.126c1.22-.813 2.249-2.737 2.249-4.202v-2.644a.453.453 0 0 1 .906 0v2.643c0 1.788-1.165 3.965-2.653 4.957l-3.439 2.294a.46.46 0 0 1-.25.075"
    />
    <path
      fill="#000"
      d="M19.032 16.312a.46.46 0 0 1-.321-.133l-2.72-2.718a.454.454 0 0 1 .642-.641l2.399 2.398 6.022-6.023a.453.453 0 0 1 .641.64l-6.344 6.345a.45.45 0 0 1-.32.132M16.219 3.625h-.907a.453.453 0 0 1 0-.906h.907a.453.453 0 0 1 0 .906"
    />
    <rect width={9.232} height={0.906} x={4.607} y={2.719} fill="#000" rx={0.453} />
    <path stroke="#000" d="M20 5V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v23a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2v-1.5" />
  </svg>
);
export const TabbyLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={props.size || '1em'}
    height={props.height || '25px'}
    viewBox="0 0 46 18"
    fill="none"
    {...props}
  >
    <path fill="url(#TabbyLogo)" d="M.4.281h45.4v17.434H.4z" />
    <defs>
      <pattern id="TabbyLogo" width={1} height={1} patternContentUnits="objectBoundingBox">
        <use xlinkHref="#TabbyLogo1" transform="matrix(.00676 0 0 .0176 -.46 -2.034)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,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"
        id="TabbyLogo1"
        width={364}
        height={285}
      />
    </defs>
  </svg>
);
export const TamaraLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={props.size || '1em'}
    height={props.height || '25px'}
    viewBox="0 0 55 24"
    fill="none"
    {...props}
  >
    <path fill="url(#TamaraLogo)" d="M.199 3.43h54.4v17.144H.199z" />
    <defs>
      <pattern id="TamaraLogo" width={1} height={1} patternContentUnits="objectBoundingBox">
        <use xlinkHref="#TamaraLogo1" transform="matrix(.00303 0 0 .00962 -.145 -.654)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,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"
        id="TamaraLogo1"
        width={420}
        height={240}
      />
    </defs>
  </svg>
);
export const CashBackLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g fill="#006169" clipPath="url(#CashBackLogo)">
      <path d="M12 6.023A5.98 5.98 0 0 0 6.025 12 5.98 5.98 0 0 0 12 17.974a5.98 5.98 0 0 0 5.975-5.975A5.98 5.98 0 0 0 12 6.023m0 10.544A4.574 4.574 0 0 1 7.432 12c0-2.52 2.05-4.57 4.568-4.57 2.52 0 4.57 2.05 4.57 4.57A4.574 4.574 0 0 1 12 16.568" />
      <path d="m12.19 1.509.308-.309a.703.703 0 1 0-.995-.994L9.997 1.712a.703.703 0 0 0 0 .995l1.506 1.506a.7.7 0 0 0 .995 0 .703.703 0 0 0 0-.995l-.304-.303c4.922.103 8.894 4.139 8.894 9.085a.703.703 0 0 0 1.406 0c0-5.723-4.605-10.39-10.305-10.491m-1.558 9.459a.2.2 0 0 1-.056.063.12.12 0 0 1-.073.021.2.2 0 0 1-.088-.024l-.105-.058a1 1 0 0 0-.133-.056.5.5 0 0 0-.171-.026q-.166 0-.249.072a.24.24 0 0 0-.08.19q0 .078.049.128a.4.4 0 0 0 .127.088q.081.036.182.068.105.03.21.068.106.037.209.087t.181.13a.6.6 0 0 1 .13.193.7.7 0 0 1 .049.27q0 .178-.061.332a.78.78 0 0 1-.466.45 1.1 1.1 0 0 1-.386.064q-.119 0-.244-.024a1.442 1.442 0 0 1-.455-.175 1 1 0 0 1-.176-.137l.175-.277a.154.154 0 0 1 .13-.07q.051 0 .104.034l.12.073q.069.04.156.074a.6.6 0 0 0 .207.033q.16 0 .25-.07.09-.072.09-.226a.2.2 0 0 0-.05-.145.4.4 0 0 0-.129-.093 1 1 0 0 0-.18-.065l-.208-.06a2 2 0 0 1-.209-.085.7.7 0 0 1-.182-.131.6.6 0 0 1-.127-.203.8.8 0 0 1 .008-.581.7.7 0 0 1 .17-.243.8.8 0 0 1 .275-.17q.162-.065.373-.065a1.3 1.3 0 0 1 .439.074 1 1 0 0 1 .341.197zM13.305 13h-.458a.22.22 0 0 1-.128-.035.2.2 0 0 1-.069-.093l-.15-.444h-.97l-.15.444a.2.2 0 0 1-.193.128h-.461l.986-2.55h.606zm-1.638-.975h.697l-.235-.698-.054-.156q-.03-.09-.06-.196a4 4 0 0 1-.114.356zm2.262.032V13h-.591v-2.55h.829q.276 0 .47.058.197.056.32.158a.6.6 0 0 1 .18.24.8.8 0 0 1 .056.3.8.8 0 0 1-.034.235.7.7 0 0 1-.26.37.8.8 0 0 1-.22.121.5.5 0 0 1 .111.074q.052.044.091.107l.543.887h-.536q-.15 0-.213-.112l-.424-.74a.2.2 0 0 0-.066-.07.2.2 0 0 0-.106-.021zm0-.408h.238q.12 0 .205-.03a.4.4 0 0 0 .14-.085.3.3 0 0 0 .079-.127.5.5 0 0 0 .024-.157q0-.168-.11-.262-.109-.095-.338-.095h-.238zm-1.432 8.138a.703.703 0 1 0-.995.995l.304.303C6.884 20.981 2.912 16.946 2.912 12a.703.703 0 0 0-1.406 0c0 5.723 4.605 10.39 10.305 10.491l-.309.309a.703.703 0 0 0 .995.994l1.506-1.506a.703.703 0 0 0 0-.994z" />
    </g>
  </svg>
);
export const EuroSignLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g fill="#006169" clipPath="url(#EuroSignLogo)">
      <path d="M9.311 10.937a.4.4 0 0 1-.112.126.24.24 0 0 1-.147.041.4.4 0 0 1-.175-.048 7 7 0 0 0-.21-.116 1.6 1.6 0 0 0-.266-.112 1 1 0 0 0-.343-.053q-.333 0-.497.144a.48.48 0 0 0-.161.381q0 .154.098.256a.9.9 0 0 0 .255.175q.163.074.364.136.207.06.42.137.214.073.417.175.207.102.364.259.161.157.259.385.098.224.098.543 0 .353-.123.661-.121.308-.357.539a1.7 1.7 0 0 1-.574.36 2.2 2.2 0 0 1-.773.13q-.238 0-.486-.049a3 3 0 0 1-.476-.136 3 3 0 0 1-.434-.214 1.9 1.9 0 0 1-.354-.273l.35-.553a.34.34 0 0 1 .259-.14q.105 0 .21.066l.242.148q.135.08.311.147.175.066.413.066.322 0 .5-.14.18-.144.179-.451a.43.43 0 0 0-.098-.291.75.75 0 0 0-.259-.186 2.3 2.3 0 0 0-.36-.129 13 13 0 0 1-.417-.122 3 3 0 0 1-.417-.168 1.4 1.4 0 0 1-.364-.263 1.3 1.3 0 0 1-.255-.406 1.6 1.6 0 0 1-.098-.602q0-.287.116-.56t.339-.487q.225-.213.55-.339.324-.13.745-.13a2.6 2.6 0 0 1 .878.148q.2.069.371.171.176.098.312.224zm3.287 2.114-.472-1.397a6 6 0 0 1-.112-.312 10 10 0 0 1-.12-.392 6 6 0 0 1-.223.711l-.47 1.39zM14.478 15h-.917a.4.4 0 0 1-.249-.07.5.5 0 0 1-.143-.185l-.301-.89h-1.94l-.3.89a.43.43 0 0 1-.14.178.4.4 0 0 1-.245.077h-.924l1.974-5.1h1.21zm1.71-2.702q.242 0 .41-.06a.8.8 0 0 0 .28-.171.65.65 0 0 0 .158-.252 1 1 0 0 0 .049-.315q0-.336-.22-.525-.217-.189-.676-.189h-.476v1.512zM18.703 15H17.63q-.297 0-.427-.224l-.847-1.48a.4.4 0 0 0-.133-.137.4.4 0 0 0-.21-.046h-.301V15H14.53V9.9h1.659q.553 0 .941.116.393.112.637.315.249.203.36.48.114.276.113.601 0 .248-.067.47a1.5 1.5 0 0 1-.196.409 1.5 1.5 0 0 1-.322.332 1.7 1.7 0 0 1-.437.242q.116.06.217.15a1 1 0 0 1 .182.21z" />
      <path d="M12 24a12 12 0 1 1 7.056-21.708.75.75 0 0 1-.883 1.213 10.485 10.485 0 1 0 3.07 3.507.75.75 0 0 1 1.32-.712A12.003 12.003 0 0 1 12 24" />
      <path d="M20.562 5.45a.75.75 0 0 1-.572-.264l-.135-.156a.75.75 0 1 1 1.124-.993l.153.176a.75.75 0 0 1-.57 1.236" />
    </g>
    <defs>
      <clipPath id="EuroSignLogo">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const CompliantIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 25 16"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M17.46 12.846q0 .76-.164 1.32a2.7 2.7 0 0 1-.452.928q-.288.364-.684.544a2.05 2.05 0 0 1-.848.176q-.456 0-.848-.176a1.8 1.8 0 0 1-.676-.544 2.8 2.8 0 0 1-.448-.928 4.8 4.8 0 0 1-.16-1.32q0-.76.16-1.316a2.7 2.7 0 0 1 .448-.924q.285-.368.676-.544.392-.18.848-.18t.848.18q.396.176.684.544.288.364.452.924.165.556.164 1.316m-1.14 0q0-.616-.088-1.016a2 2 0 0 0-.224-.632.8.8 0 0 0-.324-.324.81.81 0 0 0-.744 0 .84.84 0 0 0-.316.324q-.135.232-.22.632a5 5 0 0 0-.084 1.016q0 .62.084 1.02t.22.632a.84.84 0 0 0 .316.324.81.81 0 0 0 .744 0 .8.8 0 0 0 .324-.324q.14-.232.224-.632.088-.4.088-1.02m4.34-1.496q0 .324-.111.588a1.4 1.4 0 0 1-.304.456q-.189.188-.436.292-.249.1-.516.1-.297 0-.544-.1a1.3 1.3 0 0 1-.432-.292 1.4 1.4 0 0 1-.284-.456 1.7 1.7 0 0 1-.1-.588q0-.336.1-.604.104-.272.284-.46.183-.192.432-.296.247-.105.544-.104.296 0 .548.104t.432.296q.183.188.284.46.104.268.104.604m-.847 0q0-.216-.04-.36a.6.6 0 0 0-.112-.236.37.37 0 0 0-.164-.124.52.52 0 0 0-.408 0 .4.4 0 0 0-.16.124.7.7 0 0 0-.104.236 1.5 1.5 0 0 0-.036.36q0 .212.036.352.04.14.104.228a.4.4 0 0 0 .16.12.58.58 0 0 0 .408 0 .4.4 0 0 0 .164-.12.6.6 0 0 0 .112-.228q.04-.14.04-.352m2.728-1.236a.7.7 0 0 1 .132-.116.4.4 0 0 1 .22-.052h.804l-4.34 5.644a.5.5 0 0 1-.136.116.4.4 0 0 1-.196.044h-.82zm1.424 4.272q0 .324-.112.588a1.4 1.4 0 0 1-.304.456q-.189.188-.436.292-.249.1-.516.1-.297 0-.544-.1a1.3 1.3 0 0 1-.432-.292 1.4 1.4 0 0 1-.284-.456 1.7 1.7 0 0 1-.1-.588q0-.336.1-.604.104-.272.284-.46.183-.192.432-.292.247-.105.544-.104.296 0 .548.104.252.1.432.292.183.188.284.46.104.268.104.604m-.848 0q0-.216-.04-.36a.6.6 0 0 0-.112-.236.37.37 0 0 0-.164-.124.52.52 0 0 0-.408 0 .4.4 0 0 0-.16.124.7.7 0 0 0-.104.236 1.5 1.5 0 0 0-.036.36q0 .212.036.352.04.14.104.228a.4.4 0 0 0 .16.12.58.58 0 0 0 .408 0 .4.4 0 0 0 .164-.12.6.6 0 0 0 .112-.228q.04-.14.04-.352"
    />
    <path stroke="#000" strokeLinecap="round" d="M22 8.25v-5a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8.5" />
    <path fill="#000" d="M1 4.25h21v2H1z" />
  </svg>
);
export const MasterVisaIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={75} height={20} viewBox="0 0 75 20" fill="none" {...props}>
    <path
      fill="#F79410"
      d="M25.75 14.959v-.31h-.08l-.094.213-.093-.214h-.081v.311h.057v-.234l.088.202h.06l.087-.202v.234zm-.513 0v-.257h.104v-.053h-.265v.053h.104v.257z"
    />
    <path fill="#FF5F00" d="M16.556 16.29h-7V3.71h7z" />
    <path
      fill="#EB001B"
      d="M10 10a7.99 7.99 0 0 1 3.056-6.29A8 8 0 0 0 .114 10a8 8 0 0 0 12.942 6.29A7.99 7.99 0 0 1 10 10"
    />
    <path
      fill="#F79E1B"
      d="M26 10a8 8 0 0 1-12.943 6.29A7.99 7.99 0 0 0 16.112 10a7.99 7.99 0 0 0-3.055-6.29A8 8 0 0 1 26 10"
    />
    <path
      fill="#2566AF"
      d="M54.04 15.8h-3.017l1.886-11.593h3.019zM48.485 4.207l-2.878 7.974-.34-1.717-1.016-5.213s-.122-1.044-1.431-1.044h-4.757l-.056.196s1.455.303 3.157 1.326L43.785 15.8h3.145l4.802-11.593zM72.224 15.8h2.77L72.58 4.207h-2.427c-1.12 0-1.393.864-1.393.864L64.257 15.8h3.147l.629-1.722h3.837zm-3.322-4.1 1.586-4.34.892 4.34zm-4.409-4.705.431-2.49S63.595 4 62.21 4c-1.498 0-5.055.655-5.055 3.838 0 2.995 4.175 3.032 4.175 4.605s-3.745 1.291-4.98.3l-.45 2.602s1.348.655 3.407.655 5.167-1.066 5.167-3.969c0-3.014-4.212-3.295-4.212-4.605s2.94-1.143 4.231-.431"
    />
    <path
      fill="#E6A540"
      d="M45.266 10.46 44.25 5.247s-.122-1.044-1.431-1.044h-4.757l-.056.196s2.286.474 4.48 2.25c2.096 1.696 2.78 3.811 2.78 3.811"
    />
  </svg>
);
export const IconFavouriteProperties = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 48 48"
    {...props}
  >
    <defs>
      <linearGradient id="IconFavouriteProperties" x1={0.8} x2={0.5} y1={0.1} y2={1} gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#ef3d3d" />
        <stop offset={1} stopColor="#bf1212" />
      </linearGradient>
    </defs>
    <path fill="none" d="M0 0h48v48H0z" />
    <path
      fill="url(#IconFavouriteProperties)"
      d="m24 45.4-3.2-3.1C9.5 31.5 2 24.3 2 15.7 2 8.7 7.3 3 14.1 3A13 13 0 0 1 24 7.8 13 13 0 0 1 34 3c6.7 0 12 5.6 12 12.7 0 8.7-7.5 15.8-18.8 26.6z"
    />
  </svg>
);
export const IconTrashCan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 15}
    height={props.height || 19.89}
    viewBox=" 0 0 15 19.89"
    className="_61d7ea94"
    {...props}
  >
    <path
      fill="none"
      stroke="#222"
      d="M1.5 17.39a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-12h-12zm9.34-.33V7.28m-3.33 9.78V7.28m-3.33 9.78V7.28M14.5 1.5H11l-1-1H5l-1 1H.5v2h14v-2z"
      className="cls-1"
    />
  </svg>
);
export const IconSavedSearched = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    viewBox="0 0 48 48"
    data-name="24px-star-fill"
    {...props}
  >
    <defs>
      <linearGradient id="IconSavedSearched" x1={0.5} x2={0.5} y2={1} gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#1deb85" />
        <stop offset={1} stopColor="#28b16d" />
      </linearGradient>
    </defs>
    <path
      fill="url(#IconSavedSearched)"
      d="M24 36.6 37.6 45 34 29l12-10.6L30.2 17 24 2l-6.2 15L2 18.4 14 29l-3.6 16z"
    />
  </svg>
);
export const IconStar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size}
    height={props.size}
    viewBox="0 0 24 24"
    className="_55e4529d"
    {...props}
  >
    <path fill="#F7C800" d="m12 17.3 6.2 3.7-1.7-7L22 9.2l-7.2-.6L12 2 9.2 8.6 2 9.2 7.5 14l-1.7 7z" />
  </svg>
);
export const TotalLeads = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || '#71A8AC'}
      fillRule="evenodd"
      d="M9.764 7.916h9.526l-5.658 3.879-3.849-2.639a1.7 1.7 0 0 0-.02-1.24m-2.492 2.251 1.389-.845a.89.89 0 0 0 .308-1.204L7.715 5.946a.86.86 0 0 0-.574-.422.86.86 0 0 0-.7.135L4.154 7.233c-1.088 3.834 3.802 12.135 7.553 13.081l2.506-1.193a.86.86 0 0 0 .467-.539.86.86 0 0 0-.079-.708l-1.253-2.171a.89.89 0 0 0-1.197-.336l-1.426.78c-1.411-1.255-3.071-4.13-3.453-5.98m12.71-1.752-6.124 4.198a.4.4 0 0 1-.46-.006L9.332 9.82q-.115.105-.253.189l-.878.534c.461 1.49 1.603 3.467 2.662 4.611l.902-.493a1.695 1.695 0 0 1 2.28.64l.777 1.346h4.528c.357 0 .65-.293.65-.65V8.566a.7.7 0 0 0-.018-.151"
      clipRule="evenodd"
    />
  </svg>
);

export const TruCheckIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size}
    height={props.size}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g fill={props.color || 'currentColor'} mask="url(#TruCheckIcon)">
      <path d="M17.578 5.268a.355.355 0 0 0-.046-.503l-1.988-1.6a.366.366 0 0 0-.503.046l-5.943 7.086a.343.343 0 0 1-.503.034l-3.131-2.8a.366.366 0 0 0-.503.023l-1.772 1.92a.354.354 0 0 0 .023.503l5.692 5.108a.344.344 0 0 0 .491-.045z" />
      <path d="m12.549 13.832-.309.377c1.68.251 2.8.731 2.8 1.28 0 .811-2.537 1.486-5.68 1.486s-5.691-.675-5.691-1.486c0-.572 1.257-1.074 3.085-1.326l-.4-.343C3.794 14.095 2 14.77 2 15.557c0 1.063 3.291 1.92 7.349 1.92s7.348-.857 7.348-1.92c0-.765-1.68-1.417-4.148-1.725" />
    </g>
  </svg>
);
export const EligibleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size}
    height={props.size}
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <rect width={14} height={14} fill={props.color || 'currentColor'} rx={7} />
    <path
      fill="#fff"
      d="M8.5 5.401h-3v-.3a1.5 1.5 0 0 1 2.813-.727.3.3 0 0 0 .524-.29A2.1 2.1 0 0 0 4.9 5.1v.427A1.5 1.5 0 0 0 4 6.901v1.8a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-1.8a1.5 1.5 0 0 0-1.5-1.5m-1.2 2.7a.3.3 0 1 1-.6 0v-.6a.3.3 0 1 1 .6 0z"
    />
  </svg>
);
// export const ExpiredIcon = (props) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width={props.size}
//     height={props.size}
//     viewBox="0 0 38 40"
//     fill="none"
//     {...props}
//   >
//     <rect width={34} height={34} fill="#fff" rx={17} transform="matrix(-1 0 0 1 34 0)" />
//     <path
//       fill="#F3B662"
//       d="M17 0A17 17 0 1 1 0 17 17.02 17.02 0 0 1 17 0m-1.417 16.829a1.42 1.42 0 0 0 .665 1.2l5.44 3.4a1.42 1.42 0 1 0 1.504-2.407l-4.775-2.978V9.917a1.417 1.417 0 0 0-2.834 0z"
//     />
//     <rect width={16} height={16.243} x={22} y={23} fill="#F73131" rx={8} />
//     <path
//       fill="#fff"
//       d="M30.036 32.519h-.074a.444.444 0 0 1-.443-.406l-.36-4.135a.843.843 0 1 1 1.679 0l-.36 4.135a.444.444 0 0 1-.442.406m.854 1.776a.889.889 0 1 1-1.779 0 .889.889 0 0 1 1.778 0"
//     />
//   </svg>
// );

export const SvgBuildTrust = (props) => (
  <svg width={props.size || '36px'} height={props.size || '36px'} viewBox="0 0 36 36" fill="none" {...props}>
    <path
      d="M33.66 6.46a2.81 2.81 0 0 0-1.93-1 27.32 27.32 0 0 1-12.26-4.02 2.78 2.78 0 0 0-2.94 0A27.32 27.32 0 0 1 4.25 5.46a2.81 2.81 0 0 0-1.93 1 2.68 2.68 0 0 0-.65 2.04l.77 9.34a17.28 17.28 0 0 0 8.45 13.45l5.67 3.34a2.84 2.84 0 0 0 2.86 0l5.68-3.34a17.28 17.28 0 0 0 8.45-13.45l.77-9.34a2.69 2.69 0 0 0-.66-2.04Z"
      fill="#0DB561"
    />
    <path
      d="M16.79 21.62a1.2 1.2 0 0 1-.85-.36l-3.22-3.21a1.2 1.2 0 0 1 1.7-1.66l2.37 2.37 5.57-5.58a1.2 1.2 0 0 1 1.7 1.6l-6.42 6.43a1.2 1.2 0 0 1-.85.4Z"
      fill="#fff"
    />
    <path
      d="M18 35.02c-.5 0-1-.14-1.43-.39l-5.68-3.34a17.32 17.32 0 0 1-8.45-13.45L1.67 8.5a2.75 2.75 0 0 1 .66-2.06 2.86 2.86 0 0 1 1.93-.98 27.32 27.32 0 0 0 12.27-4.02 2.78 2.78 0 0 1 2.95 0A27.32 27.32 0 0 0 24.83 4c2.72.98 5.58 1.53 8.47 1.6a1.2 1.2 0 1 1 0 2.42c-3.14-.05-6.25-.6-9.21-1.61a30.87 30.87 0 0 1-5.9-2.88.4.4 0 0 0-.39 0A30.87 30.87 0 0 1 4.45 7.9a.39.39 0 0 0-.3.14.39.39 0 0 0-.09.32l.79 9.34a14.87 14.87 0 0 0 7.28 11.56l5.66 3.34a.48.48 0 0 0 .42 0l5.65-3.34a14.87 14.87 0 0 0 7.28-11.57l.49-5.82a1.2 1.2 0 0 1 2.4.2l-.48 5.8a17.33 17.33 0 0 1-8.45 13.46l-5.67 3.34c-.44.24-.93.37-1.43.36Z"
      fill="#02974D"
    />
  </svg>
);

export const SvgMaximise = (props) => (
  <svg width={props.size || '36px'} height={props.size || '36px'} viewBox="0 0 36 36" fill="none" {...props}>
    <g>
      <path
        d="M25.38 11.88H4.22A4.22 4.22 0 0 0 0 16.09v8.58a4.22 4.22 0 0 0 4.22 4.22h1.12v6.62c0 .33.41.48.62.23l5.7-6.85h9.5a4.22 4.22 0 0 0 4.22-4.22v-12.8Z"
        fill="#FD5"
      />
      <path d="M25.38 11.88v12.8a4.22 4.22 0 0 1-4.22 4.21H12.7V11.87h12.7Z" fill="#FD5" />
      <path
        d="M20.46 21.3H4.99a1.05 1.05 0 0 0 0 2.1h15.47a1.05 1.05 0 1 0 0-2.1ZM4.99 19.19h11.95a1.05 1.05 0 1 0 0-2.11H5a1.05 1.05 0 0 0 0 2.1Z"
        fill="#FFB555"
      />
      <path d="M24.33 19.12a7.38 7.38 0 1 0 0-14.77 7.38 7.38 0 0 0 0 14.77Z" fill="#F25A3C" />
      <path
        d="m24.03 8.63-1.05.35c-.56.18-.86.78-.67 1.33.24.74 1 .72 1 .72v2.8a1.05 1.05 0 0 0 2.1 0v-4.2c0-.72-.7-1.23-1.38-1Z"
        fill="#E9F3FB"
      />
      <path d="M25.42 9.63v4.2c0 .59-.47 1.06-1.06 1.06h-.03V8.57c.57-.02 1.09.44 1.09 1.06Z" fill="#D6E9F8" />
      <path
        d="M24.33.13c-.58 0-1.05.48-1.05 1.06v1.13a1.05 1.05 0 0 0 2.1 0V1.19c0-.58-.47-1.06-1.05-1.06Z"
        fill="#F25A3C"
      />
      <path d="M25.39 1.19v1.13c0 .58-.48 1.05-1.06 1.05V.13c.58 0 1.06.48 1.06 1.06Z" fill="#E43539" />
      <path d="M17.52 3.57a1.05 1.05 0 1 0-1.5 1.49l.8.8a1.05 1.05 0 1 0 1.5-1.5l-.8-.8Z" fill="#F25A3C" />
      <path
        d="M31.82 17.89a1.05 1.05 0 0 0-1.49 1.49l.8.8a1.05 1.05 0 1 0 1.5-1.5l-.8-.8Zm3.12-7.06h-1.12a1.05 1.05 0 1 0 0 2.1h1.12a1.05 1.05 0 1 0 0-2.1Zm-3.1-4.97.8-.8a1.05 1.05 0 1 0-1.5-1.49l-.8.8a1.05 1.05 0 1 0 1.5 1.5Z"
        fill="#E43539"
      />
    </g>
  </svg>
);

export const SvgListingRank = (props) => (
  <svg width={props.size || '36px'} height={props.size || '36px'} viewBox="0 0 36 36" fill="none" {...props}>
    <path
      d="M6.8 12.35H.85a.85.85 0 0 1-.84-.84V5.55c0-.47.38-.85.84-.85h5.97c.46 0 .84.38.84.85v5.96c0 .46-.38.84-.84.84Zm0 10.32H.85a.85.85 0 0 1-.84-.85v-5.96c0-.46.38-.84.84-.84h5.97c.46 0 .84.38.84.84v5.96c0 .47-.38.85-.84.85Zm0 10.31H.85a.85.85 0 0 1-.84-.84v-5.97c0-.46.38-.84.84-.84h5.97c.46 0 .84.38.84.84v5.97c0 .46-.38.84-.84.84Z"
      fill="#85C2EF"
    />
    <path
      d="M6.78 11.04H.87a.87.87 0 0 1-.87-.87v1.32c0 .47.4.86.87.86h5.91c.48 0 .87-.39.87-.86v-1.32c0 .48-.39.87-.87.87Zm0 10.31H.87a.87.87 0 0 1-.87-.87v1.32c0 .48.4.87.87.87h5.91c.48 0 .87-.4.87-.87v-1.32c0 .48-.39.87-.87.87Zm0 10.32H.87A.87.87 0 0 1 0 30.8v1.31c0 .48.4.87.87.87h5.91c.48 0 .87-.4.87-.87V30.8c0 .47-.39.87-.87.87Z"
      fill="#69AFEB"
    />
    <path
      d="M34.43 4.7H14.94c-.86 0-1.57.7-1.57 1.57v4.52c0 .86.7 1.56 1.57 1.56h19.49c.86 0 1.57-.7 1.57-1.56V6.27c0-.86-.7-1.57-1.57-1.57Zm0 20.63H14.94c-.86 0-1.57.7-1.57 1.57v4.51c0 .86.7 1.57 1.57 1.57h19.49c.86 0 1.57-.7 1.57-1.57V26.9c0-.87-.7-1.57-1.57-1.57Zm0-10.31H14.94c-.86 0-1.57.7-1.57 1.57v4.5c0 .87.7 1.58 1.57 1.58h19.49c.86 0 1.57-.7 1.57-1.57v-4.51c0-.87-.7-1.57-1.57-1.57Z"
      fill="#EFEFEF"
    />
    <path
      d="M34.43 10.88H14.94c-.86 0-1.57-.7-1.57-1.57v1.47c0 .87.7 1.57 1.57 1.57h19.49c.86 0 1.57-.7 1.57-1.57V9.31c0 .87-.7 1.57-1.57 1.57Zm0 20.62H14.94c-.86 0-1.57-.7-1.57-1.56v1.47c0 .86.7 1.57 1.57 1.57h19.49c.86 0 1.57-.7 1.57-1.57v-1.47c0 .86-.7 1.57-1.57 1.57Zm0-10.3H14.94c-.86 0-1.57-.71-1.57-1.57v1.47c0 .86.7 1.57 1.57 1.57h19.49c.86 0 1.57-.71 1.57-1.57v-1.48c0 .87-.7 1.57-1.57 1.57Z"
      fill="#E2E2E2"
    />
    <path
      d="M32.84 9.07h-16.3a.54.54 0 0 1 0-1.09h16.3a.54.54 0 0 1 0 1.1Zm0 10.31h-16.3a.54.54 0 0 1 0-1.08h16.3a.54.54 0 0 1 0 1.08Zm0 10.32h-16.3a.54.54 0 0 1 0-1.1h16.3a.54.54 0 0 1 0 1.1Z"
      fill="#fff"
    />
  </svg>
);
export const SvgStarGradient = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '32px'}
    height={props.size || '33px'}
    viewBox="0 0 32 33"
    fill="none"
    {...props}
  >
    <g fillRule="evenodd" clipPath="url(#aStarGradient)" clipRule="evenodd">
      <path
        fill="url(#bStarGradient)"
        d="M14.503 3.026a1.692 1.692 0 0 1 3.031 0l2.953 5.949 6.57.97a1.693 1.693 0 0 1 .936 2.883l-4.745 4.646 1.108 6.547a1.692 1.692 0 0 1-2.453 1.782l-5.884-3.077-5.885 3.077a1.692 1.692 0 0 1-2.453-1.782l1.108-6.547-4.745-4.646a1.692 1.692 0 0 1 .937-2.884l6.57-.97z"
      />

      <path fill="url(#fStarGradient)" d="M15.61 25.73v5.7a.418.418 0 0 0 .835 0v-5.7a.418.418 0 0 0-.836 0" />
      <path
        fill="url(#gStarGradient)"
        d="m26.098 18.633 5.387 1.863a.418.418 0 0 0 .274-.79l-5.388-1.863a.418.418 0 0 0-.273.79"
      />
      <path
        fill="url(#hStarGradient)"
        d="M5.669 17.843.281 19.706a.418.418 0 0 0 .274.79l5.387-1.863a.418.418 0 0 0-.273-.79"
      />
      <path
        fill="url(#iStarGradient)"
        d="m23.153 6.351 3.231-4.696a.418.418 0 0 0-.689-.474l-3.23 4.696a.418.418 0 0 0 .688.474"
      />
      <path
        fill="url(#jStarGradient)"
        d="M9.993 5.851 6.328 1.485a.418.418 0 0 0-.64.537L9.353 6.39a.418.418 0 0 0 .64-.538"
      />
    </g>
    <defs>
      <radialGradient
        id="fStarGradient"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(18.851 -37.844 55.886) scale(16.3964)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--svg-color, #FFA501)" />
        <stop offset={0.57} stopColor="var(--svg-color, #FFAF0E)" />
        <stop offset={1} stopColor="var(--svg-color, #FFD541)" />
      </radialGradient>
      <radialGradient
        id="gStarGradient"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(18.851 -37.836 55.862) scale(16.3964)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--svg-color, #FFA501)" />
        <stop offset={0.57} stopColor="var(--svg-color, #FFAF0E)" />
        <stop offset={1} stopColor="var(--svg-color, #FFD541)" />
      </radialGradient>
      <radialGradient
        id="hStarGradient"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(18.851 -37.836 55.863) scale(16.3964)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--svg-color, #FFA501)" />
        <stop offset={0.57} stopColor="var(--svg-color, #FFAF0E)" />
        <stop offset={1} stopColor="var(--svg-color, #FFD541)" />
      </radialGradient>
      <radialGradient
        id="iStarGradient"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(18.851 -37.82 55.881) scale(16.3964)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--svg-color, #FFA501)" />
        <stop offset={0.57} stopColor="var(--svg-color, #FFAF0E)" />
        <stop offset={1} stopColor="var(--svg-color, #FFD541)" />
      </radialGradient>
      <radialGradient
        id="jStarGradient"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(18.851 -37.84 55.865) scale(16.3964)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--svg-color,#FFA501)" />
        <stop offset={0.57} stopColor="var(--svg-color, #FFAF0E)" />
        <stop offset={1} stopColor="var(--svg-color, #FFD541)" />
      </radialGradient>
      <linearGradient id="bStarGradient" x1={16.018} x2={16.018} y1={11.705} y2={23.948} gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--svg-color, #FFB541)" />
        <stop offset={1} stopColor="var(--svg-color, #F59500)" />
      </linearGradient>

      <clipPath id="aStarGradient">
        <path fill="var(--svg-color, #fff)" d="M0 .336h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const SvgLeaderBoardGradient = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '33px'}
    height={props.size || '33px'}
    viewBox="0 0 33 33"
    fill="none"
    {...props}
  >
    <path
      fill="url(#aSvgLeaderBoardGradient)"
      fillRule="evenodd"
      d="M17.135 2.953c-.2-.614-1.068-.614-1.268 0l-.209.644a.67.67 0 0 1-.634.46h-.677c-.646 0-.914.827-.392 1.206l.548.398c.234.17.331.47.242.745l-.209.644c-.2.614.503 1.125 1.026.745l.547-.397c.234-.17.55-.17.784 0l.548.397c.522.38 1.225-.13 1.026-.745l-.21-.644a.67.67 0 0 1 .243-.745l.547-.398c.523-.38.254-1.206-.392-1.206h-.677a.67.67 0 0 1-.634-.46zm-1.967 8.049a2.667 2.667 0 0 0-2.667 2.666v13.333a2.667 2.667 0 0 0 2.667 2.667h2.667a2.667 2.667 0 0 0 2.666-2.667V13.668a2.667 2.667 0 0 0-2.666-2.666zm9.333 8a2.667 2.667 0 0 0-2.666 2.666v5.333a2.667 2.667 0 0 0 2.666 2.667h2.667a2.667 2.667 0 0 0 2.667-2.667v-5.333a2.667 2.667 0 0 0-2.667-2.667zm-21.333 0a2.667 2.667 0 0 1 2.667-2.667H8.5A2.667 2.667 0 0 1 11.168 19v8a2.667 2.667 0 0 1-2.667 2.667H5.835A2.667 2.667 0 0 1 3.168 27z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aSvgLeaderBoardGradient"
        x1={16.501}
        x2={16.501}
        y1={2.492}
        y2={29.668}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--svg-color, #FD6700)" />
        <stop offset={1} stopColor="var(--svg-color, #FFCE00)" />
      </linearGradient>
    </defs>
  </svg>
);
export const SvgThunderGradient = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" fill="none" {...props}>
    <path
      fill="url(#aSvgThunderGradient)"
      d="M11.47 5.154a.41.41 0 0 0-.369-.232H8.483L10.648.594A.412.412 0 0 0 10.28 0H5.359a.41.41 0 0 0-.384.266l-2.46 6.562a.411.411 0 0 0 .383.555h2.756L4.14 13.49a.41.41 0 0 0 .718.355l6.563-8.258a.41.41 0 0 0 .049-.434Z"
    />
    <defs>
      <linearGradient id="aSvgThunderGradient" x1={7} x2={7} y1={14} y2={0} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FD5900" />
        <stop offset={1} stopColor="#FFDE00" />
      </linearGradient>
    </defs>
  </svg>
);
export const SvgTruBrokerBg = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={496} height={83} fill="none" {...props}>
    <g clipPath="url(#aSvgTruBrokerBg)">
      <g clipPath="url(#bSvgTruBrokerBg)">
        <path
          fill="url(#cSvgTruBrokerBg)"
          d="M873.563-11.085v78.036l-598.75-56.466h-551.015l-.991-.209-9.507-1.982-58.417-12.232-35.437-7.407-1.307-.287-.104-.026v-53.389h.104L26.725-31.245h493.563z"
          opacity={0.7}
        />
        <path
          fill="url(#dSvgTruBrokerBg)"
          d="M876.698-8.167v78.035l-.652-.052-598.101-56.414h-551.012l-.994-.209-1.643-.339-3.865-.808-77.222-16.17-25.07-5.243-.104-.026v-52.998h.104l411.72 34.063h493.562L873.563-8.35l2.483.156z"
        />
        <path
          fill="url(#eSvgTruBrokerBg)"
          d="M876.697 66.716v58.814l-.652-.079-.183-.026-215.027-28.637-89.676-11.945L34.637 13.406l-13.92-1.852H-139.1l-6.606-1.07-.707-.104-.731-.13h425.09l88.424 8.346 507.193 47.833 2.483.235z"
          opacity={0.7}
        />
        <path
          fill="url(#fSvgTruBrokerBg)"
          d="M876.697 69.872v58.814l-.652-.078-.183-.027-366.776-48.85L33.359 16.38l-12.641-1.67h-159.819l-8.044-1.304h425.09l598.1 56.414z"
        />
        <path
          fill="#2F776B"
          d="M875.862 124.639v89.798H-382.801l.837-225.414-.002-.007h.104l34.055 6.99 59.723 12.258 1.383.026 148.199 2.19 158.384 2.348 4.387.574 18.672 2.451z"
          opacity={0.1}
        />
        <path
          fill="url(#gSvgTruBrokerBg)"
          d="M876.698 128.688v51.119l-.652-.104-.182-.026-998.381-162.096-16.844-2.738-8.88-1.435-8.2-1.33h1.854l7.105.026 84.114 1.304 84.087 1.304 12.641 1.67 475.727 63.351 366.777 48.851.182.026z"
        />
        <path fill="url(#hSvgTruBrokerBg)" d="M783.205 213.023-265.419 14.682l-8.231-.17-108.311-21.887v220.398z" />
        <path
          fill="#052120"
          d="M876.698 179.803v33.227h-95.737L-257.322 16.377h-.052l-8.8-1.67-5.456-1.043h-.052l-1.333-.26h-.052l-.994-.21-6.111-1.147h.603l122.866-.313 2.115.34 8.148 1.33 8.018 1.304.967.156 16.818 2.739 996.5 162.069.183.026z"
        />
        <path
          fill="url(#iSvgTruBrokerBg)"
          d="M876.698-8.166v78.035l-.652-.052-598.101-56.414h-551.012l-.994-.208-1.643-.34-3.865-.808-77.222-16.17-25.07-5.243-.104-.026v-57.405h.104l411.72 34.062 166.48 1.487 327.082 2.921L873.563-8.349l2.483.157z"
        />
        <path
          fill="url(#jSvgTruBrokerBg)"
          d="M55.712-9.394 24.636 1.665l-369.753-5.608-2.689-.052-8.985-.13-1.148-.027-8.88-.13-2.689-.026-10.237-.156-2.116-.053h-.062v-6.65l-.042.182V-24.39h.104l366.647 2.087L53.622-9.785z"
          opacity={0.6}
        />
        <path
          fill="url(#kSvgTruBrokerBg)"
          d="m-381.98-10.397.015-.587v-.391h.105l1.306.026L50.751-10.07l2.871.287 195.415 20.265 28.178 2.921 2.507.261-236.78 2.19-18.306.157-65.861-.287-224.793-.99-7.049-.027-10.498-1.877-96.18-17.292-2.115-.392-.105-.026"
        />
        <g opacity={0.06}>
          <path
            fill="#3A7E74"
            d="m-381.965-6.687.104.026 12.353 2.347 32.2 6.103.73.13 61.813 11.71 3.083.027h.052l132.269 1.174 1.906.026 96.23.86 74.585.652 7.389.079 620.086 80.33 215.028 27.855.183.026.652.078v2.609l-.652-.079-.183-.026-366.777-47.52L40.54 19.029l-161.178-1.435-1.88-.026-134.804-1.2h-.052l-17.652-.156-106.835-20.24h-.104"
            opacity={0.5}
          />
        </g>
        <path
          fill="url(#lSvgTruBrokerBg)"
          d="M876.697 18.62v46.294l-.652-.053-2.483-.234-507.194-46.034-91.843-8.346L50.75-10.07l438.722 6.52 384.09 21.987 2.483.156z"
          opacity={0.1}
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="dSvgTruBrokerBg"
        x1={246.937}
        x2={251.228}
        y1={8.877}
        y2={-42.605}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#024041" />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="fSvgTruBrokerBg"
        x1={367.341}
        x2={373.113}
        y1={53.733}
        y2={14.765}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#024041" />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="gSvgTruBrokerBg"
        x1={358.597}
        x2={364.492}
        y1={107.812}
        y2={62.133}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#024041" />
        <stop offset={1} stopColor="#00151A" />
      </linearGradient>
      <linearGradient
        id="hSvgTruBrokerBg"
        x1={-599.886}
        x2={86.76}
        y1={-83.827}
        y2={170.8}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#024041" />
        <stop offset={1} stopColor="#000408" />
      </linearGradient>
      <linearGradient
        id="iSvgTruBrokerBg"
        x1={-461.917}
        x2={796.745}
        y1={1.536}
        y2={1.536}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#65A18C" />
        <stop offset={0.295} stopColor="#24726E" />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="jSvgTruBrokerBg"
        x1={-361.074}
        x2={-46.741}
        y1={78.273}
        y2={-72.847}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.001} stopColor="#559680" />
        <stop offset={1} stopColor="#216360" stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="kSvgTruBrokerBg"
        x1={-354.579}
        x2={214.664}
        y1={20.444}
        y2={-15.762}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#65A18C" />
        <stop offset={0.295} stopColor="#24726E" />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="lSvgTruBrokerBg"
        x1={142.924}
        x2={802.602}
        y1={181.651}
        y2={-135.501}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.001} stopColor="#559680" />
        <stop offset={1} stopColor="#216360" stopOpacity={0.5} />
      </linearGradient>
      <radialGradient
        id="c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(474.587 0 0 473.971 445.735 164.255)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#90C0AE" />
        <stop offset={0.295} stopColor="#24726E" />
        <stop offset={0.528} stopColor="#1C6660" />
        <stop offset={1} />
      </radialGradient>
      <radialGradient
        id="eSvgTruBrokerBg"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(758.779 0 0 757.794 549.133 445.159)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#90C0AE" />
        <stop offset={0.295} stopColor="#24726E" />
        <stop offset={0.528} stopColor="#1C6660" />
        <stop offset={0.746} stopColor="#07403F" />
        <stop offset={1} />
      </radialGradient>
      <clipPath id="aSvgTruBrokerBg">
        <path fill="#fff" d="M0 0h496v83H0z" />
      </clipPath>
      <clipPath id="bSvgTruBrokerBg">
        <path fill="#fff" d="M-381-168.68H877v381.362H-381z" />
      </clipPath>
    </defs>
  </svg>
);
export const SvgHealth = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '24px'}
    height={props.size || '24px'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect width={24} height={14.4} y={4.797} fill="#71A7AC" rx={3.2} />
    <path fill="#006169" d="M0 7.997a3.2 3.2 0 0 1 3.2-3.2h13.6v14.4H3.2a3.2 3.2 0 0 1-3.2-3.2z" />
  </svg>
);
export const TruBrokerStarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '16px'}
    height={props.size || '16px'}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill="url(#aTruBrokerStarIcon)"
      d="M7.873 1.081a.502.502 0 0 1 .906 0l1.935 3.906a.5.5 0 0 0 .377.273l4.33.628a.502.502 0 0 1 .278.858l-3.131 3.04a.5.5 0 0 0-.143.446l.736 4.287a.504.504 0 0 1-.727.533l-3.876-2.027a.5.5 0 0 0-.464 0l-3.876 2.027a.503.503 0 0 1-.731-.533l.736-4.287a.5.5 0 0 0-.143-.446L.953 6.746a.502.502 0 0 1 .277-.858l4.33-.628a.5.5 0 0 0 .378-.273z"
    />
    <defs>
      <linearGradient
        id="aTruBrokerStarIcon"
        x1={19.64}
        x2={9.359}
        y1={3.437}
        y2={-4.674}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.2} stopColor="#053940" />
        <stop offset={0.49} stopColor="#00745F" />
        <stop offset={0.75} stopColor="#033F46" />
      </linearGradient>
    </defs>
  </svg>
);

export const SvgIconCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '16px'}
    height={props.size || '16px'}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#aSvgIconCheck)">
      <path
        fill="#CCDFE1"
        d="M5.344 15.818c2.95 0 5.343-2.208 5.343-4.932 0-2.725-2.392-4.933-5.343-4.933C2.392 5.953 0 8.161 0 10.886c0 2.724 2.392 4.932 5.344 4.932Z"
      />
      <path
        fill="#006169"
        d="m5.52 13.857-.084-.144C4.138 11.502.69 6.81.656 6.763l-.05-.068 1.174-1.16L5.5 8.13c2.34-3.039 4.525-5.125 5.95-6.344C13.009.454 14.023-.16 14.034-.166l.022-.014h1.993l-.19.17C10.963 4.35 5.657 13.618 5.604 13.712l-.083.145Z"
      />
    </g>
    <defs>
      <clipPath id="aSvgIconCheck">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const SvgRadio = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '16px'}
    height={props.size || '16px'}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path fill="#fff" stroke="#DEDEDE" d="M7.855 1.5a6.355 6.355 0 1 1 0 12.71 6.355 6.355 0 0 1 0-12.71Z" />
    <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.4} d="m10.524 6-3.798 4L5 8.182" />
  </svg>
);
export const UnitFloorPlan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 13 12"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.834 1.5h-4.5v9h9v-9h-3v1h2V5h-2v1h2v3.5h-3.5v-1h-1v1h-2.5V6h2.5v1h1V5h-3.5V2.5h3.5v-1Z"
      clipRule="evenodd"
    />
  </svg>
);
